webpackJsonp([11],{

/***/ "+2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("5fo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("xp4f");
function injectStyle (ssrContext) {
  __webpack_require__("vIES")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+S4p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__("c3eM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c678f9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__("YW5e");
function injectStyle (ssrContext) {
  __webpack_require__("/raC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c678f9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+VxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("18Zw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365d158_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("9TgA");
function injectStyle (ssrContext) {
  __webpack_require__("4JrB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365d158_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+WI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[(_vm.values.length === 0)?_c('div',{staticClass:"progress-bar",class:("progress-bar-" + _vm.type),style:(("width: " + _vm.value + "%;")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._t("default")],2)]):_vm._l((_vm.values),function(progress){return _c('div',{staticClass:"progress-bar",class:("progress-bar-" + (progress.type)),style:(("width: " + (progress.value) + "%;"))},[_c('span',{staticClass:"sr-only"})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+lQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+m/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['requiredText', 'email', 'number', 'url', 'idSource', 'idDestination'])),
  data: function data() {
    return {
      model: {
        requiredText: '',
        email: '',
        number: '',
        url: '',
        idSource: '',
        idDestination: ''
      },
      modelValidations: {
        requiredText: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        number: {
          required: true,
          decimal: true
        },
        url: {
          required: true,
          url: true
        },
        idSource: {
          required: true
        },
        idDestination: {
          required: true,
          confirmed: 'idSource'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "+mNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Paper Dashboard Headings")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Created using "),_c('a',{attrs:{"href":"https://www.google.com/fonts/specimen/Muli"}},[_vm._v("Muli")]),_vm._v(" Font Family\n          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"typo-line"},[_c('h1',[_c('p',{staticClass:"category"},[_vm._v("Header 1")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Header 2")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h3',[_c('p',{staticClass:"category"},[_vm._v("Header 3")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h4',[_c('p',{staticClass:"category"},[_vm._v("Header 4")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h5',[_c('p',{staticClass:"category"},[_vm._v("Header 5")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h6',[_c('p',{staticClass:"category"},[_vm._v("Header 6")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',[_c('span',{staticClass:"category"},[_vm._v("Paragraph")]),_vm._v("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("\n                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n              ")]),_vm._v(" "),_c('small',[_vm._v("\n                Steve Jobs, CEO Apple\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Muted Text")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Coloured Text")]),_vm._v(" "),_c('p',{staticClass:"text-primary"},[_vm._v("\n              Text Primary - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-info"},[_vm._v("\n              Text Info - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_vm._v("\n              Text Success - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("\n              Text Warning - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_vm._v("\n              Text Danger - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Small Tag")]),_vm._v("Header with small subtitle "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\".small\" is a tag for the headers")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Lists")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unordered List")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',{staticClass:"list-unstyled"},[_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Ordered List")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unstyled List")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Inline List")]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Blockquotes")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Default Blockquote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Blockquote with Citation")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]),_vm._v(" "),_c('small',[_vm._v("Someone famous in\n                    "),_c('cite',{attrs:{"title":"Source Title"}},[_vm._v("Source Title")])])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Code")]),_vm._v(" "),_c('p',[_vm._v("This is "),_c('code',[_vm._v(".css-class-as-code")]),_vm._v(", an example of an inline code element. Wrap inline code within a "),_c('code',[_vm._v("\n              <code>...</code>")]),_vm._v("tag.")]),_vm._v(" "),_c('pre',[_vm._v("1. #This is an example of preformatted text. 2. #Here is another line of code")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+pYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5Bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_functions__ = __webpack_require__("p/MD");
















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email', 'birthday', 'address1', 'address2', 'city', 'state', 'zip', 'country'])),
  data: function data() {
    return {
      myvariable: 4,
      modelValidations: {
        email: {
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        country: {
          required: true
        }
      },
      loading: false,
      step: 1,
      complete: false,
      model: {
        firstName: '',
        lastName: '',
        email: '',
        birthday: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        goals: {
          healthyVagina: false,
          postpartumRecovery: false,
          bladderLeakage: false,
          organProlapse: false,
          sexualHealth: false,
          vaginalRejuvenation: false
        },
        sendShowerHolder: false,
        optIn: true
      },
      code: false,
      codeData: false
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__["Card"] },

  methods: {
    init: function init() {
      this.loading = true;
      this.checkCode();
    },
    checkCode: function checkCode() {
      var _this = this;

      var checkCode = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('checkCode');
      checkCode({ code: this.code, doNotValidate: true }).then(function (result) {
        console.log(result);
        if (!result.data.valid) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: 'Not Authentic!',
            text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(function () {
            _this.$router.replace('/authenticate?code=' + _this.model.code);
          });
        } else if (result.data.type === 'external') {
          console.log('external');
        } else {
          console.log('primary');
          _this.codeData = result.data;
          console.log(_this.codeData);
        }
        _this.loading = false;
      }).catch(function (err) {
        console.error(err.message);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Not Authentic!',
          text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this.$router.replace('/authenticate?code=' + _this.model.code);
        });
        _this.loading = false;
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, registerAuthCode, result, msg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = {
                  contactDetails: _this2.model,
                  code: _this2.code
                };
                registerAuthCode = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('registerAuthCode');

                registerAuthCode(data);
                _context.next = 6;
                return registerAuthCode(data);

              case 6:
                result = _context.sent;

                if (!result.data.success) {
                  _this2.$router.replace('/authenticate?code=' + _this2.code);
                }
                console.log(result);
                msg = '';

                if (!_this2.model.sendShowerHolder) msg = 'You will now be sent to the Kegelbell instructions video.';else msg = 'We will send your Kegelbell Shower Holder ASAP! You will now be sent to the Kegelbell instructions video.';
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                  title: 'Thank you!',
                  text: msg,
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                }).then(function () {
                  console.log('sending to kegelbelll.com');
                  location.replace('https://www.kegelbell.com/pages/instructions');
                });
                _this2.loading = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                  title: 'Error',
                  text: 'Sorry! There was an error with your submission. Please contact us at orders@kegelbell.com and let us know.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                }).then(function () {
                  location.replace('https://www.kegelbell.com/pages/instructions');
                });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 15]]);
      }))();
    },
    signup: function signup() {
      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
      }).catch(function (err) {
        console.error(err.message);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this3 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.submit();
        } else {
          _this3.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.params.code) this.code = this.$route.params.code;else if (this.$route.query.code) this.code = this.$route.query.code;
      if (!this.code) this.$router.replace('/authenticate');
      this.init();
    });
  }
});

/***/ }),

/***/ "/LT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('img',{attrs:{"src":_vm.imageUrl,"width":"140","height":"140"}})])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.name),expression:"product.data.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.product.data.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('name'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Size")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.size),expression:"product.data.size"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.size),expression:"modelValidations.size"}],staticClass:"form-control",attrs:{"type":"text","name":"size"},domProps:{"value":(_vm.product.data.size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "size", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.size.invalid),expression:"size.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('size'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.color),expression:"product.data.color"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.color),expression:"modelValidations.color"}],staticClass:"form-control",attrs:{"type":"text","name":"color"},domProps:{"value":(_vm.product.data.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "color", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.color.invalid),expression:"color.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('color'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Style")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.style),expression:"product.data.style"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.style),expression:"modelValidations.style"}],staticClass:"form-control",attrs:{"type":"text","name":"style"},domProps:{"value":(_vm.product.data.style)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "style", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.style.invalid),expression:"style.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('style'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("SKU")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.sku),expression:"product.data.sku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.sku),expression:"modelValidations.sku"}],staticClass:"form-control",attrs:{"type":"text","name":"sku"},domProps:{"value":(_vm.product.data.sku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "sku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.sku.invalid),expression:"sku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('sku'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("UPC")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.upc),expression:"product.data.upc"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.upc),expression:"modelValidations.upc"}],staticClass:"form-control",attrs:{"type":"text","name":"upc"},domProps:{"value":(_vm.product.data.upc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "upc", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.upc.invalid),expression:"upc.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('upc'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Amazon FNSKUs")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonComFnsku),expression:"product.data.amazonComFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComFnsku),expression:"modelValidations.amazonComFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComFnsku"},domProps:{"value":(_vm.product.data.amazonComFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonComFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComFnsku.invalid),expression:"amazonComFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.ca")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonCaFnsku),expression:"product.data.amazonCaFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCaFnsku),expression:"modelValidations.amazonCaFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCaFnsku"},domProps:{"value":(_vm.product.data.amazonCaFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonCaFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCaFnsku.invalid),expression:"amazonCaFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCaFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.mx")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonComMxFnsku),expression:"product.data.amazonComMxFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComMxFnsku),expression:"modelValidations.amazonComMxFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComMxFnsku"},domProps:{"value":(_vm.product.data.amazonComMxFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonComMxFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComMxFnsku.invalid),expression:"amazonComMxFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComMxFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.cn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonCnFnsku),expression:"product.data.amazonCnFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCnFnsku),expression:"modelValidations.amazonCnFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCnFnsku"},domProps:{"value":(_vm.product.data.amazonCnFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonCnFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCnFnsku.invalid),expression:"amazonCnFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCnFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.in")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonInFnsku),expression:"product.data.amazonInFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonInFnsku),expression:"modelValidations.amazonInFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonInFnsku"},domProps:{"value":(_vm.product.data.amazonInFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonInFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonInFnsku.invalid),expression:"amazonInFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonInFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.co.jp")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonCoJpFnsku),expression:"product.data.amazonCoJpFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCoJpFnsku),expression:"modelValidations.amazonCoJpFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCoJpFnsku"},domProps:{"value":(_vm.product.data.amazonCoJpFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonCoJpFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCoJpFnsku.invalid),expression:"amazonCoJpFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCoJpFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.sg")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonComSgFnsku),expression:"product.data.amazonComSgFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComSgFnsku),expression:"modelValidations.amazonComSgFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComSgFnsku"},domProps:{"value":(_vm.product.data.amazonComSgFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonComSgFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComSgFnsku.invalid),expression:"amazonComSgFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComSgFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.tr")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonComTrFnsku),expression:"product.data.amazonComTrFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComTrFnsku),expression:"modelValidations.amazonComTrFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComTrFnsku"},domProps:{"value":(_vm.product.data.amazonComTrFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonComTrFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComTrFnsku.invalid),expression:"amazonComTrFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComTrFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.ae")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonAeFnsku),expression:"product.data.amazonAeFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonAeFnsku),expression:"modelValidations.amazonAeFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonAeFnsku"},domProps:{"value":(_vm.product.data.amazonAeFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonAeFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonAeFnsku.invalid),expression:"amazonAeFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonAeFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.fr")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonFrFnsku),expression:"product.data.amazonFrFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonFrFnsku),expression:"modelValidations.amazonFrFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonFrFnsku"},domProps:{"value":(_vm.product.data.amazonFrFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonFrFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonFrFnsku.invalid),expression:"amazonFrFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonFrFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.de")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonDeFnsku),expression:"product.data.amazonDeFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonDeFnsku),expression:"modelValidations.amazonDeFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonDeFnsku"},domProps:{"value":(_vm.product.data.amazonDeFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonDeFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonDeFnsku.invalid),expression:"amazonDeFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonDeFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.it")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonItFnsku),expression:"product.data.amazonItFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonItFnsku),expression:"modelValidations.amazonItFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonItFnsku"},domProps:{"value":(_vm.product.data.amazonItFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonItFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonItFnsku.invalid),expression:"amazonItFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonItFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.nl")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonNlFnsku),expression:"product.data.amazonNlFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonNlFnsku),expression:"modelValidations.amazonNlFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonNlFnsku"},domProps:{"value":(_vm.product.data.amazonNlFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonNlFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonNlFnsku.invalid),expression:"amazonNlFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonNlFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.es")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonEsFnsku),expression:"product.data.amazonEsFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonEsFnsku),expression:"modelValidations.amazonEsFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonEsFnsku"},domProps:{"value":(_vm.product.data.amazonEsFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonEsFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonEsFnsku.invalid),expression:"amazonEsFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonEsFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.co.uk")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonCoUkFnsku),expression:"product.data.amazonCoUkFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCoUkFnsku),expression:"modelValidations.amazonCoUkFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCoUkFnsku"},domProps:{"value":(_vm.product.data.amazonCoUkFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonCoUkFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCoUkFnsku.invalid),expression:"amazonCoUkFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCoUkFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.au")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonComAuFnsku),expression:"product.data.amazonComAuFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComAuFnsku),expression:"modelValidations.amazonComAuFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComAuFnsku"},domProps:{"value":(_vm.product.data.amazonComAuFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonComAuFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComAuFnsku.invalid),expression:"amazonComAuFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComAuFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.br")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.amazonComBrFnsku),expression:"product.data.amazonComBrFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComBrFnsku),expression:"modelValidations.amazonComBrFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComBrFnsku"},domProps:{"value":(_vm.product.data.amazonComBrFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "amazonComBrFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComBrFnsku.invalid),expression:"amazonComBrFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComBrFnsku'))+"\n                    ")])])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.prodLandingUrlTip),expression:"prodLandingUrlTip"}],staticClass:"ti-help",staticStyle:{"font-size":"1em"}}),_vm._v("\n                  Redirect URL\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.data.redirectUrl),expression:"product.data.redirectUrl"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.redirectUrl),expression:"modelValidations.redirectUrl"}],staticClass:"form-control",attrs:{"type":"text","name":"redirectUrl"},domProps:{"value":(_vm.product.data.redirectUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.data, "redirectUrl", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.redirectUrl.invalid),expression:"redirectUrl.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('redirectUrl'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("New Image")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{ref:"imageFile",attrs:{"type":"file","name":"imageFile","accept":"image/*"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.image),expression:"modelValidations.image"}],staticClass:"form-control",attrs:{"type":"text","name":"image"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.image.invalid),expression:"image.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('image'))+"\n                  ")]),_vm._v(" "),_c('p-progress',{attrs:{"value":_vm.uploadProgress,"type":"info"}})],1)])]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateSaveProduct()}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n              Save\n            ")]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Edit Product")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/PBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Add Retailer")]),_vm._v(" "),(!_vm.maxReached)?_c('p',{staticClass:"category"},[_vm._v("You can add up to "+_vm._s(_vm.retailerSlotsRemaining)+" more retailers on your "+_vm._s(_vm.accountData.authDetails.account.data.planName)+" Plan.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.maxReached)?_c('p',{staticClass:"text-danger"},[_vm._v("Please upgrade your Authentic.net plan if you wish to add more retailers.")]):_vm._e(),_vm._v(" "),(!_vm.maxReached)?_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newRetailer.name),expression:"newRetailer.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"title"},domProps:{"value":(_vm.newRetailer.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newRetailer, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('name'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Logo")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{ref:"imageFile",attrs:{"type":"file","name":"imageFile","accept":"image/*"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.newRetailer.logoUrl),expression:"newRetailer.logoUrl"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.logoUrl),expression:"modelValidations.logoUrl"}],staticClass:"form-control",attrs:{"type":"text","name":"logoUrl"},domProps:{"value":(_vm.newRetailer.logoUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newRetailer, "logoUrl", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.logoUrl.invalid),expression:"logoUrl.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('logoUrl'))+"\n                  ")]),_vm._v(" "),_c('p-progress',{attrs:{"value":_vm.uploadProgress,"type":"info"}})],1)])]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateAddRetailer()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(0),_vm._v("\n              Submit\n            ")]):_vm._e()]):_vm._e()])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showingAmazon),expression:"showingAmazon"}],staticClass:"row"},[_c('div',{staticStyle:{"padding":"20px"}},[_c('button',{staticClass:"btn btn-fill btn-info",on:{"click":function($event){$event.preventDefault();_vm.getRetailers()}}},[_vm._v("Back to All Retailers")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showingAmazon),expression:"!showingAmazon"}],staticClass:"col-lg-3"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getGloAmazonRetailers()}}},[_vm._v("View All Variations")])])])]),_vm._v(" "),_vm._l((_vm.retailersTable),function(retailer){return _c('div',{key:retailer.key,staticClass:"col-lg-3"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"text-center"},[_c('h3',[_vm._v(_vm._s(retailer.name))])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"140px","display":"flex","align-items":"center"}},[_c('div',{staticClass:"img-container"},[(retailer.logoUrl)?_c('img',{attrs:{"src":retailer.logoUrl,"alt":retailer.name}}):_vm._e(),_vm._v(" "),(!retailer.logoUrl)?_c('span',[_vm._v("{NO RETAILER LOGO}")]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),(retailer.isPermanent)?_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[_vm._v("\n          Permanent Retailer\n        ")]):_vm._e(),_vm._v(" "),(!retailer.isPermanent)?_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[(!retailer.deleting)?_c('button',{staticClass:"btn btn-fill btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.deleteRetailer(retailer)}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(retailer.deleting)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(3,true),_vm._v("\n            Deleting...\n          ")]):_vm._e()]):_vm._e()])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h3',[_vm._v("Amazon")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"height":"140px","display":"flex","align-items":"center"}},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/authentic-net-dev.appspot.com/o/global-retailers%2Famz%2Famz_140x140.png?alt=media&token=90d16dd3-61f2-4e5c-a2f9-c2c418b5ad39","alt":"Amazon"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/V9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__eventBus__ = __webpack_require__("O6e2");


























__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_21__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData', 'pathDymoAuthLabel', 'pathDymoFbaLabel', 'dymoPrinterName', 'showComplete'],
  computed: {
    queriedData: function queriedData() {
      return this.tableData;
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      return this.pagination.total;
    },
    watchPerPage: function watchPerPage() {
      return this.pagination.perPage * this.pagination.currentPage;
    }
  },
  data: function data() {
    return {
      user: {},
      initialized: false,
      pagination: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [3, 6, 12, 24, 48],
        total: 0,
        startAfter: false
      },
      tableData: [],
      prodImageMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      batchIdIndexMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      retailers: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      authBarcodeBaseUrl: "https://appdev.authentic.net/authenticate?code="
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getCurrentUser();

              case 2:
                _this.user = _context.sent;

                _this.queryData();
                console.log('pathDymoAuthLabel', _this.pathDymoAuthLabel);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    batchStatus: function batchStatus(batch) {
      if (batch.status === 'Processed') return 'Ready to Print';
      return batch.status;
    },
    getAuthCodeBatchesTable: function getAuthCodeBatchesTable(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var accountId, accountDoc, qtyAuthCodeBatches, perPage, pageNum, offset, batchDocs, qs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, reg, retVal;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accountId = _this2.user.accountId;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('accounts').doc(accountId).get();

              case 3:
                accountDoc = _context2.sent;
                qtyAuthCodeBatches = accountDoc.data().qtyAuthCodeBatches;

                console.log('qty account auth code batches', qtyAuthCodeBatches);
                perPage = parseInt(data.perPage);
                pageNum = parseInt(data.pageNum);
                offset = perPage * (pageNum - 1);
                batchDocs = [];
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this2.accountData.activeBrand.id + '/authCodeBatches').orderBy('createdAt', 'desc').limit(perPage).get();

              case 12:
                qs = _context2.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 16;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  doc = _step.value;

                  console.log('doc', doc.data());
                  reg = {
                    id: doc.id,
                    data: doc.data()
                  };

                  reg.data.createdAtMillis = doc.data().createdAt.toMillis();
                  batchDocs.push(reg);
                }
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](16);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context2.prev = 27;

                if (!_didIteratorError) {
                  _context2.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context2.finish(27);

              case 31:
                return _context2.finish(24);

              case 32:
                retVal = {
                  data: {
                    success: true,
                    qtyAuthCodeBatches: qtyAuthCodeBatches,
                    authCodeBatches: batchDocs
                  }
                };

                console.log('returning', retVal);
                return _context2.abrupt('return', retVal);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[16, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    getAuthCodeBatches: function getAuthCodeBatches() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var qs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, batchDoc;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this3.accountData.activeBrand.id + '/authCodeBatches').get();

              case 2:
                qs = _context3.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 6;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  batchDoc = _step2.value;
                }
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 14:
                _context3.prev = 14;
                _context3.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 17:
                _context3.prev = 17;

                if (!_didIteratorError2) {
                  _context3.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context3.finish(17);

              case 21:
                return _context3.finish(14);

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    },
    getAuthCodeBatchesTableData: function getAuthCodeBatchesTableData(data) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var brandDoc, qtyAuthCodeBatches, perPage, pageNum, offset, includeComplete, brandIds, ojbDocs, products, _qs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, doc, obj, prodDoc, i, _qs2, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _doc, _obj, _prodDoc;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('getting brand for id', _this4.accountData.activeBrand.id);
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands').doc(_this4.accountData.activeBrand.id).get();

              case 3:
                brandDoc = _context4.sent;
                qtyAuthCodeBatches = brandDoc.data().qtyAuthCodeBatches;
                perPage = parseInt(data.perPage);
                pageNum = parseInt(data.pageNum);
                offset = perPage * (pageNum - 1);
                includeComplete = data.includeComplete;
                brandIds = [];
                ojbDocs = [];
                products = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();

                if (!includeComplete) {
                  _context4.next = 53;
                  break;
                }

                _context4.next = 15;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this4.accountData.activeBrand.id + '/authCodeBatches').orderBy('createdAt', 'desc').offset(offset).limit(perPage).get();

              case 15:
                _qs = _context4.sent;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 19;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_qs.docs);

              case 21:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context4.next = 37;
                  break;
                }

                doc = _step3.value;
                obj = {
                  id: doc.id,
                  data: doc.data()
                };

                obj.data.createdAtMillis = doc.data().createdAt.toMillis();
                obj.data.createdAtFriendly = __WEBPACK_IMPORTED_MODULE_16_moment___default()(obj.data.createdAtMillis).format('LL');
                if (obj.data.printedAt === undefined || obj.data.printedAt === '') obj.data.printedAtFriendly = 'Never';else obj.data.printedAtFriendly = __WEBPACK_IMPORTED_MODULE_16_moment___default()(obj.data.printedAt.toMillis()).format('LL');

                if (products.get(obj.data.productId)) {
                  _context4.next = 32;
                  break;
                }

                _context4.next = 30;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + doc.data().brandId + '/products').doc(obj.data.productId).get();

              case 30:
                prodDoc = _context4.sent;

                products.set(prodDoc.id, {
                  id: prodDoc.id,
                  data: prodDoc.data()
                });

              case 32:
                obj.data.product = products.get(obj.data.productId);
                ojbDocs.push(obj);

              case 34:
                _iteratorNormalCompletion3 = true;
                _context4.next = 21;
                break;

              case 37:
                _context4.next = 43;
                break;

              case 39:
                _context4.prev = 39;
                _context4.t0 = _context4['catch'](19);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t0;

              case 43:
                _context4.prev = 43;
                _context4.prev = 44;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 46:
                _context4.prev = 46;

                if (!_didIteratorError3) {
                  _context4.next = 49;
                  break;
                }

                throw _iteratorError3;

              case 49:
                return _context4.finish(46);

              case 50:
                return _context4.finish(43);

              case 51:
                _context4.next = 97;
                break;

              case 53:
                i = 0;
                _context4.next = 56;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this4.accountData.activeBrand.id + '/authCodeBatches').orderBy('createdAt', 'desc').get();

              case 56:
                _qs2 = _context4.sent;
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context4.prev = 60;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_qs2.docs);

              case 62:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context4.next = 82;
                  break;
                }

                _doc = _step4.value;

                if (!(_doc.data().status === 'Complete')) {
                  _context4.next = 66;
                  break;
                }

                return _context4.abrupt('continue', 79);

              case 66:
                i = i + 1;
                _obj = {
                  id: _doc.id,
                  data: _doc.data()
                };

                _obj.data.createdAtMillis = _doc.data().createdAt.toMillis();
                _obj.data.createdAtFriendly = __WEBPACK_IMPORTED_MODULE_16_moment___default()(_obj.data.createdAtMillis).format('LL');
                if (_obj.data.printedAt === undefined || _obj.data.printedAt === '') _obj.data.printedAtFriendly = 'Never';else _obj.data.printedAtFriendly = __WEBPACK_IMPORTED_MODULE_16_moment___default()(_obj.data.printedAt.toMillis()).format('LL');

                if (products.get(_obj.data.productId)) {
                  _context4.next = 76;
                  break;
                }

                _context4.next = 74;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _doc.data().brandId + '/products').doc(_obj.data.productId).get();

              case 74:
                _prodDoc = _context4.sent;

                products.set(_prodDoc.id, {
                  id: _prodDoc.id,
                  data: _prodDoc.data()
                });

              case 76:
                _obj.data.product = products.get(_obj.data.productId);
                console.log('i, offset, perpage', [i, offset, perPage]);
                if (i > offset && i <= offset + perPage) {
                  console.log('pushing', _obj);
                  ojbDocs.push(_obj);
                }

              case 79:
                _iteratorNormalCompletion4 = true;
                _context4.next = 62;
                break;

              case 82:
                _context4.next = 88;
                break;

              case 84:
                _context4.prev = 84;
                _context4.t1 = _context4['catch'](60);
                _didIteratorError4 = true;
                _iteratorError4 = _context4.t1;

              case 88:
                _context4.prev = 88;
                _context4.prev = 89;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 91:
                _context4.prev = 91;

                if (!_didIteratorError4) {
                  _context4.next = 94;
                  break;
                }

                throw _iteratorError4;

              case 94:
                return _context4.finish(91);

              case 95:
                return _context4.finish(88);

              case 96:
                qtyAuthCodeBatches = i;

              case 97:
                return _context4.abrupt('return', {
                  success: true,
                  qtyAuthCodeBatches: qtyAuthCodeBatches,
                  authCodeBatches: ojbDocs
                });

              case 98:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[19, 39, 43, 51], [44,, 46, 50], [60, 84, 88, 96], [89,, 91, 95]]);
      }))();
    },
    queryData: function queryData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, result, authCodeBatches, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, batchDoc, img, obj, retailerDoc;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.isEmpty(_this5.user)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return', []);

              case 2:

                _this5.tableData = [];

                data = {};

                data.perPage = _this5.pagination.perPage;
                data.pageNum = _this5.pagination.currentPage;
                data.includeComplete = _this5.showComplete;
                console.log('calling getAuthCodeBatchesTableData', data);

                result = {};
                _context5.next = 11;
                return _this5.getAuthCodeBatchesTableData(data);

              case 11:
                result.data = _context5.sent;


                console.log('getAuthCodeBatchesTableData', result);
                _this5.pagination.total = result.data.qtyAuthCodeBatches;
                console.log('pagination data', _this5.pagination);
                authCodeBatches = result.data.authCodeBatches;
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context5.prev = 19;
                _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(authCodeBatches);

              case 21:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context5.next = 89;
                  break;
                }

                batchDoc = _step5.value;

                if (!(_this5.prodImageMap.get(batchDoc.data.productId) === undefined)) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 26;
                return _this5.prodImgUrl(batchDoc.data.product.id, batchDoc.data.product.data, '140x140x');

              case 26:
                img = _context5.sent;

                _this5.prodImageMap.set(batchDoc.data.productId, img);

              case 28:
                obj = batchDoc.data;

                obj.id = batchDoc.id;
                obj.imageUrl = _this5.prodImageMap.get(batchDoc.data.productId);

                if (!batchDoc.data.retailerId) {
                  _context5.next = 83;
                  break;
                }

                obj.amzFnsku = '';
                _context5.t0 = batchDoc.data.retailerId;
                _context5.next = _context5.t0 === 'glo_L3ItcLEw7lsUjCiQEXOH' ? 36 : _context5.t0 === 'glo_nF5xYARYPDGMCK1PF0O9' ? 38 : _context5.t0 === 'glo_EHHSqB0I4r7LxWDjyida' ? 40 : _context5.t0 === 'glo_FCFuI44LQACPMs7rL126' ? 42 : _context5.t0 === 'glo_GPDGgMmu4cVst8aN9qbq' ? 44 : _context5.t0 === 'glo_HF3CaF2a6IfuzF7au8pM' ? 46 : _context5.t0 === 'glo_LxXsa3LCKg5BlTNZnt38' ? 48 : _context5.t0 === 'glo_PeGF9QEH1m8AfjEpk0pL' ? 50 : _context5.t0 === 'glo_Q6LtxzYrvB8NHLTYgKm2' ? 52 : _context5.t0 === 'glo_Uc1QUTcjrY7pe03Xz0mC' ? 54 : _context5.t0 === 'glo_UeA0kQ6NlxsQPhV0K9C9' ? 56 : _context5.t0 === 'glo_cijPxc5dl3QqVyNBk15u' ? 58 : _context5.t0 === 'glo_iq4zGbl9B6gcI6VQR0iW' ? 60 : _context5.t0 === 'glo_kisMBpmKIada8O8bpz7C' ? 62 : _context5.t0 === 'glo_on46LxTzF4vlnsIRaw8I' ? 64 : _context5.t0 === 'glo_pKJnjyemmc4DBizTBXMv' ? 66 : 68;
                break;

              case 36:
                obj.amzFnsku = batchDoc.data.product.data.amazonCaFnsku;
                return _context5.abrupt('break', 70);

              case 38:
                obj.amzFnsku = batchDoc.data.product.data.amazonComMxFnsku;
                return _context5.abrupt('break', 70);

              case 40:
                obj.amzFnsku = batchDoc.data.product.data.amazonDeFnsku;
                return _context5.abrupt('break', 70);

              case 42:
                obj.amzFnsku = batchDoc.data.product.data.amazonComAuFnsku;
                return _context5.abrupt('break', 70);

              case 44:
                obj.amzFnsku = batchDoc.data.product.data.amazonCoJpFnsku;
                return _context5.abrupt('break', 70);

              case 46:
                obj.amzFnsku = batchDoc.data.product.data.amazonCoUkFnsku;
                return _context5.abrupt('break', 70);

              case 48:
                obj.amzFnsku = batchDoc.data.product.data.amazonComSgFnsku;
                return _context5.abrupt('break', 70);

              case 50:
                trobj.amzFnsku = batchDoc.data.product.data.amazonNlFnskuue;
                return _context5.abrupt('break', 70);

              case 52:
                obj.amzFnsku = batchDoc.data.product.data.amazonInFnsku;
                return _context5.abrupt('break', 70);

              case 54:
                obj.amzFnsku = batchDoc.data.product.data.amazonCnFnsku;
                return _context5.abrupt('break', 70);

              case 56:
                obj.amzFnsku = batchDoc.data.product.data.amazonEsFnsku;
                return _context5.abrupt('break', 70);

              case 58:
                obj.amzFnsku = batchDoc.data.product.data.amazonAeFnsku;
                return _context5.abrupt('break', 70);

              case 60:
                obj.amzFnsku = batchDoc.data.product.data.amazonFrFnsku;
                return _context5.abrupt('break', 70);

              case 62:
                obj.amzFnsku = batchDoc.data.product.data.amazonItFnsku;
                return _context5.abrupt('break', 70);

              case 64:
                obj.amzFnsku = batchDoc.data.product.data.amazonComBrFnsku;
                return _context5.abrupt('break', 70);

              case 66:
                obj.amzFnsku = batchDoc.data.product.data.amazonComTrFnsku;
                return _context5.abrupt('break', 70);

              case 68:
                obj.amzFnsku = batchDoc.data.product.data.amazonComFnsku;
                return _context5.abrupt('break', 70);

              case 70:
                if (!(_this5.retailers.get(batchDoc.data.retailerId) === undefined)) {
                  _context5.next = 82;
                  break;
                }

                retailerDoc = null;

                if (!(batchDoc.data.retailerId.substring(0, 4) === 'glo_')) {
                  _context5.next = 78;
                  break;
                }

                _context5.next = 75;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('globalRetailers').doc(batchDoc.data.retailerId).get();

              case 75:
                retailerDoc = _context5.sent;
                _context5.next = 81;
                break;

              case 78:
                _context5.next = 80;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('accounts/' + _this5.user.accountId + '/retailers').doc(batchDoc.data.retailerId).get();

              case 80:
                retailerDoc = _context5.sent;

              case 81:
                _this5.retailers.set(batchDoc.data.retailerId, {
                  id: retailerDoc.id,
                  data: retailerDoc.data()
                });

              case 82:
                obj.retailerName = _this5.retailers.get(batchDoc.data.retailerId).data.name;

              case 83:
                _this5.tableData.push(obj);
                _this5.batchIdIndexMap.set(obj.id, _this5.tableData.length - 1);
                if (obj.status === 'Requested' || obj.status === 'Processing') _this5.monitorAuthCodeBatch(obj);

              case 86:
                _iteratorNormalCompletion5 = true;
                _context5.next = 21;
                break;

              case 89:
                _context5.next = 95;
                break;

              case 91:
                _context5.prev = 91;
                _context5.t1 = _context5['catch'](19);
                _didIteratorError5 = true;
                _iteratorError5 = _context5.t1;

              case 95:
                _context5.prev = 95;
                _context5.prev = 96;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 98:
                _context5.prev = 98;

                if (!_didIteratorError5) {
                  _context5.next = 101;
                  break;
                }

                throw _iteratorError5;

              case 101:
                return _context5.finish(98);

              case 102:
                return _context5.finish(95);

              case 103:
                _this5.pagination.startAfter = result.data.lastDoc;
                console.log(_this5.tableData);
                _this5.initialized = true;

              case 106:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[19, 91, 95, 103], [96,, 98, 102]]);
      }))();
    },
    queryData2: function queryData2() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data, getAuthCodeBatchesTableData, result, authCodeBatches, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, batchDoc, img, obj, retailerDoc;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.isEmpty(_this6.user)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return', []);

              case 2:

                _this6.tableData = [];

                data = {};
                _context6.next = 6;
                return __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.auth().currentUser.getIdToken();

              case 6:
                data.userToken = _context6.sent;

                data.accountId = _this6.user.accountId;
                data.perPage = _this6.pagination.perPage;
                data.pageNum = _this6.pagination.currentPage;
                data.includeComplete = _this6.showComplete;
                console.log('calling getAuthCodeBatchesTableData', data);

                getAuthCodeBatchesTableData = __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.functions().httpsCallable('getAuthCodeBatchesTableData');
                _context6.next = 15;
                return getAuthCodeBatchesTableData(data);

              case 15:
                result = _context6.sent;


                console.log('getAuthCodeBatchesTableData', result);
                _this6.pagination.total = result.data.qtyAuthCodeBatches;
                console.log('pagination data', _this6.pagination);
                authCodeBatches = result.data.authCodeBatches;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context6.prev = 23;
                _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(authCodeBatches);

              case 25:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context6.next = 86;
                  break;
                }

                batchDoc = _step6.value;

                if (!(_this6.prodImageMap.get(batchDoc.data.productId) === undefined)) {
                  _context6.next = 32;
                  break;
                }

                _context6.next = 30;
                return _this6.prodImgUrl(batchDoc.data.product.id, batchDoc.data.product.data, '140x140x');

              case 30:
                img = _context6.sent;

                _this6.prodImageMap.set(batchDoc.data.productId, img);

              case 32:
                obj = batchDoc.data;

                obj.id = batchDoc.id;
                obj.imageUrl = _this6.prodImageMap.get(batchDoc.data.productId);

                if (!batchDoc.data.retailerId) {
                  _context6.next = 80;
                  break;
                }

                obj.amzFnsku = '';
                _context6.t0 = batchDoc.data.retailerId;
                _context6.next = _context6.t0 === 'L3ItcLEw7lsUjCiQEXOH' ? 40 : _context6.t0 === 'nF5xYARYPDGMCK1PF0O9' ? 42 : _context6.t0 === 'EHHSqB0I4r7LxWDjyida' ? 44 : _context6.t0 === 'FCFuI44LQACPMs7rL126' ? 46 : _context6.t0 === 'GPDGgMmu4cVst8aN9qbq' ? 48 : _context6.t0 === 'HF3CaF2a6IfuzF7au8pM' ? 50 : _context6.t0 === 'LxXsa3LCKg5BlTNZnt38' ? 52 : _context6.t0 === 'PeGF9QEH1m8AfjEpk0pL' ? 54 : _context6.t0 === 'Q6LtxzYrvB8NHLTYgKm2' ? 56 : _context6.t0 === 'Uc1QUTcjrY7pe03Xz0mC' ? 58 : _context6.t0 === 'UeA0kQ6NlxsQPhV0K9C9' ? 60 : _context6.t0 === 'cijPxc5dl3QqVyNBk15u' ? 62 : _context6.t0 === 'iq4zGbl9B6gcI6VQR0iW' ? 64 : _context6.t0 === 'kisMBpmKIada8O8bpz7C' ? 66 : _context6.t0 === 'on46LxTzF4vlnsIRaw8I' ? 68 : _context6.t0 === 'pKJnjyemmc4DBizTBXMv' ? 70 : 72;
                break;

              case 40:
                obj.amzFnsku = batchDoc.data.product.data.amazonCaFnsku;
                return _context6.abrupt('break', 74);

              case 42:
                obj.amzFnsku = batchDoc.data.product.data.amazonComMxFnsku;
                return _context6.abrupt('break', 74);

              case 44:
                obj.amzFnsku = batchDoc.data.product.data.amazonDeFnsku;
                return _context6.abrupt('break', 74);

              case 46:
                obj.amzFnsku = batchDoc.data.product.data.amazonComAuFnsku;
                return _context6.abrupt('break', 74);

              case 48:
                obj.amzFnsku = batchDoc.data.product.data.amazonCoJpFnsku;
                return _context6.abrupt('break', 74);

              case 50:
                obj.amzFnsku = batchDoc.data.product.data.amazonCoUkFnsku;
                return _context6.abrupt('break', 74);

              case 52:
                obj.amzFnsku = batchDoc.data.product.data.amazonComSgFnsku;
                return _context6.abrupt('break', 74);

              case 54:
                trobj.amzFnsku = batchDoc.data.product.data.amazonNlFnskuue;
                return _context6.abrupt('break', 74);

              case 56:
                obj.amzFnsku = batchDoc.data.product.data.amazonInFnsku;
                return _context6.abrupt('break', 74);

              case 58:
                obj.amzFnsku = batchDoc.data.product.data.amazonCnFnsku;
                return _context6.abrupt('break', 74);

              case 60:
                obj.amzFnsku = batchDoc.data.product.data.amazonEsFnsku;
                return _context6.abrupt('break', 74);

              case 62:
                obj.amzFnsku = batchDoc.data.product.data.amazonAeFnsku;
                return _context6.abrupt('break', 74);

              case 64:
                obj.amzFnsku = batchDoc.data.product.data.amazonFrFnsku;
                return _context6.abrupt('break', 74);

              case 66:
                obj.amzFnsku = batchDoc.data.product.data.amazonItFnsku;
                return _context6.abrupt('break', 74);

              case 68:
                obj.amzFnsku = batchDoc.data.product.data.amazonComBrFnsku;
                return _context6.abrupt('break', 74);

              case 70:
                obj.amzFnsku = batchDoc.data.product.data.amazonComTrFnsku;
                return _context6.abrupt('break', 74);

              case 72:
                obj.amzFnsku = batchDoc.data.product.data.amazonComFnsku;
                return _context6.abrupt('break', 74);

              case 74:
                if (!(_this6.retailers.get(batchDoc.data.retailerId) === undefined)) {
                  _context6.next = 79;
                  break;
                }

                _context6.next = 77;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('accounts/' + _this6.user.accountId + '/retailers').doc(batchDoc.data.retailerId).get();

              case 77:
                retailerDoc = _context6.sent;

                _this6.retailers.set(batchDoc.data.retailerId, {
                  id: retailerDoc.id,
                  data: retailerDoc.data()
                });

              case 79:
                obj.retailerName = _this6.retailers.get(batchDoc.data.retailerId).data.name;

              case 80:
                _this6.tableData.push(obj);
                _this6.batchIdIndexMap.set(obj.id, _this6.tableData.length - 1);
                if (obj.status === 'Requested' || obj.status === 'Processing') _this6.monitorAuthCodeBatch(obj);

              case 83:
                _iteratorNormalCompletion6 = true;
                _context6.next = 25;
                break;

              case 86:
                _context6.next = 92;
                break;

              case 88:
                _context6.prev = 88;
                _context6.t1 = _context6['catch'](23);
                _didIteratorError6 = true;
                _iteratorError6 = _context6.t1;

              case 92:
                _context6.prev = 92;
                _context6.prev = 93;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 95:
                _context6.prev = 95;

                if (!_didIteratorError6) {
                  _context6.next = 98;
                  break;
                }

                throw _iteratorError6;

              case 98:
                return _context6.finish(95);

              case 99:
                return _context6.finish(92);

              case 100:
                _this6.pagination.startAfter = result.data.lastDoc;
                console.log(_this6.tableData);
                _this6.initialized = true;

              case 103:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[23, 88, 92, 100], [93,, 95, 99]]);
      }))();
    },
    monitorAuthCodeBatch: function monitorAuthCodeBatch(authCodeBatch) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + this.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).onSnapshot(function (doc) {
        _this7.tableData[_this7.batchIdIndexMap.get(doc.id)].status = doc.data().status;
        _this7.tableData[_this7.batchIdIndexMap.get(doc.id)].qtyCreated = doc.data().qtyCreated;
      });
    },
    prettyAddress: function prettyAddress(regRecord) {
      var address = '';
      if (regRecord.address1) address += regRecord.address1;
      if (regRecord.address2) address += '<br>' + regRecord.address2;
      if (regRecord.city || regRecord.state || regRecord.zip || regRecord.country) {
        var region = '';
        if (regRecord.city) region += regRecord.city;
        if (regRecord.state) {
          if (region === '') region += regRecord.state;else region += ', ' + regRecord.state;
        }
        if (regRecord.zip) {
          if (region === '') region += regRecord.zip;else region += ' ' + regRecord.zip;
        }
        if (regRecord.country) {
          if (region === '') region += regRecord.country;else region += ' ' + regRecord.country;
        }
        if (region !== '') region = '<br>' + region;
        address += region;
      }
      return address;
    },
    friendlyDateTime: function friendlyDateTime(timestamp) {
      if (timestamp === undefined || timestamp === '') return 'Never';else return __WEBPACK_IMPORTED_MODULE_16_moment___default()(timestamp.seconds * 1000).format('LLL');
    },
    formatLastPrinted: function formatLastPrinted(timestamp) {
      if (timestamp === undefined || timestamp === '') return 'Never';else return __WEBPACK_IMPORTED_MODULE_16_moment___default()(timestamp.seconds * 1000).format('l');
    },
    showPrintBtn: function showPrintBtn(authCodeBatch) {
      return authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed';
    },
    showPrintBtnLoading: function showPrintBtnLoading(authCodeBatch) {
      return authCodeBatch.status === 'Requested' || authCodeBatch.stats === 'Processing' || authCodeBatch.status === 'Printing' || authCodeBatch.loading;
    },
    showPrintFbaBtn: function showPrintFbaBtn(authCodeBatch) {
      if (authCodeBatch.status !== 'Processed' && authCodeBatch.status !== 'Printed' || authCodeBatch.loading) return false;
      return authCodeBatch.amzFnsku !== undefined && authCodeBatch.amzFnsku !== '';
    },
    showPrintConfirmBtn: function showPrintConfirmBtn(authCodeBatch) {
      return authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed';
    },
    showPrintConfirmBtnLoading: function showPrintConfirmBtnLoading(authCodeBatch) {
      return authCodeBatch.confirmingPrint && authCodeBatch.status === 'Printed';
    },
    hasAmazonComFnsku: function hasAmazonComFnsku(authCodeBatch) {
      return !!authCodeBatch.product.data.amazonComFnsku;
    },
    getKey: function getKey(authCodeBatch) {
      return 'batch' + authCodeBatch.id;
    },
    perPageLabel: function perPageLabel(item) {
      return item + ' per page';
    },
    confirmPrint: function confirmPrint(authCodeBatch) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
        title: 'Did this batch print correctly?',
        text: 'For security your raw Authentic.net codes for this batch will be removed from our system and printing this batch will be permanently disabled.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, disable printing!',
        buttonsStyling: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this8.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).update({ printConfirmed: true, status: 'Complete' }).then(function (result) {
          authCodeBatch.printConfirmed = true;
          authCodeBatch.status = 'Complete';
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
            title: 'Confirmed!',
            text: 'Printing for this batch has been confirmed and your Authentic.net codes have been fully secured.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
          __WEBPACK_IMPORTED_MODULE_22__eventBus__["a" /* EventBus */].$emit('batch-closed');
        });
      });
    },
    printAuthCodeBatch: function printAuthCodeBatch(authCodeBatch) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var userToken, data, getAccountAuthCodesByBatchId, _result, response, labelXml, label, labelSet, labelParams, records, i, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, authCode, code, printResult;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                authCodeBatch.status = 'Printing';

                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.auth().currentUser.getIdToken();

              case 4:
                userToken = _context7.sent;
                data = {
                  userToken: userToken,
                  authCodeBatchId: authCodeBatch.id,
                  brandId: _this9.accountData.activeBrand.id
                };
                getAccountAuthCodesByBatchId = __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.functions().httpsCallable('getAccountAuthCodesByBatchId');
                _context7.next = 9;
                return getAccountAuthCodesByBatchId(data);

              case 9:
                _result = _context7.sent;

                console.log(_result);
                _context7.next = 13;
                return __WEBPACK_IMPORTED_MODULE_18_axios___default.a.get(_this9.pathDymoAuthLabel);

              case 13:
                response = _context7.sent;
                labelXml = response.data;
                label = dymo.label.framework.openLabelXml(labelXml);
                labelSet = new dymo.label.framework.LabelSetBuilder();
                labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({ printQuality: dymo.label.framework.LabelWriterPrintQuality.Text });
                records = [];
                i = 0;
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context7.prev = 23;

                for (_iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_result.data.authCodes); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  authCode = _step7.value;
                  code = _this9.prettyV2Code(authCode.data.code);

                  records[i] = labelSet.addRecord();
                  records[i].setText('BARCODE', 'URL:' + _this9.authBarcodeBaseUrl + code);
                  if (_this9.user.accountId !== 'ABHVeLLQ4zCxNUiqOfyG') {
                    records[i].setText('TEXT_PRODUCT', _this9.productNameForLabel(authCodeBatch.product.data));
                    records[i].setText('TEXT_CODE', code);
                  }

                  i++;
                }
                _context7.next = 31;
                break;

              case 27:
                _context7.prev = 27;
                _context7.t0 = _context7['catch'](23);
                _didIteratorError7 = true;
                _iteratorError7 = _context7.t0;

              case 31:
                _context7.prev = 31;
                _context7.prev = 32;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 34:
                _context7.prev = 34;

                if (!_didIteratorError7) {
                  _context7.next = 37;
                  break;
                }

                throw _iteratorError7;

              case 37:
                return _context7.finish(34);

              case 38:
                return _context7.finish(31);

              case 39:
                console.log(records);
                _context7.next = 42;
                return label.printAsync(_this9.dymoPrinterName, labelParams, labelSet);

              case 42:
                printResult = _context7.sent;
                _context7.next = 45;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this9.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).update({ status: 'Printed', printedAt: __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.firestore.FieldValue.serverTimestamp() });

              case 45:
                authCodeBatch.status = 'Printed';
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
                  title: 'Print Job Submitted',
                  text: 'Be sure to print and use these labels 1 time only then close this batch. If you re-print due to Dymo error or otherwise, be sure to destroy any labels that were printed previously in order to avoid duplicates.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                });
                _context7.next = 56;
                break;

              case 49:
                _context7.prev = 49;
                _context7.t1 = _context7['catch'](0);

                console.log(_context7.t1);
                _context7.next = 54;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this9.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).update({ status: 'Printed', printedAt: __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.firestore.FieldValue.serverTimestamp() });

              case 54:
                authCodeBatch.status = 'Printed';
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
                  title: 'Print Job Submitted',
                  text: 'Be sure to print and use these labels 1 time only then close this batch. If you re-print due to Dymo error or otherwise, be sure to destroy any labels that were printed previously in order to avoid duplicates.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                });

              case 56:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 49], [23, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    getFbaLabelPrintQty: function getFbaLabelPrintQty(batchQty) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var qtyResult, printQty, isInt;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
                  title: 'Quantity',
                  text: 'This batch consists of ' + batchQty + ' units, but you can change the quantity of Amazon FBA labels to print below:',
                  type: 'question',
                  input: 'text',
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false,
                  inputValue: batchQty
                });

              case 3:
                qtyResult = _context8.sent;

                if (!qtyResult.value) {
                  _context8.next = 16;
                  break;
                }

                printQty = batchQty;
                isInt = /^[0-9]+$/;

                if (!isInt.test(qtyResult.value)) {
                  _context8.next = 11;
                  break;
                }

                printQty = Number(qtyResult.value);

                if (!(printQty >= 1 && printQty <= 500)) {
                  _context8.next = 11;
                  break;
                }

                return _context8.abrupt('return', printQty);

              case 11:
                _context8.next = 13;
                return __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
                  title: 'Invalid Value',
                  text: 'Sorry, the value must be an integer between 1 and 500.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                });

              case 13:
                return _context8.abrupt('return', _this10.getFbaLabelPrintQty(batchQty));

              case 16:
                if (!(result.dismiss === Swal.DismissReason.cancel)) {
                  _context8.next = 18;
                  break;
                }

                return _context8.abrupt('return', false);

              case 18:
                _context8.next = 23;
                break;

              case 20:
                _context8.prev = 20;
                _context8.t0 = _context8['catch'](0);

                _this10.showNotify('Print failed to to cancellation or error.', 'danger', 'Cancelled');

              case 23:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[0, 20]]);
      }))();
    },
    printBatchFbaLabels: function printBatchFbaLabels(authCodeBatch) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var printQty, response, labelXml, label, labelSet, labelParams, records, i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                authCodeBatch.loading = true;

                _context9.next = 3;
                return _this11.getFbaLabelPrintQty(authCodeBatch.qty);

              case 3:
                printQty = _context9.sent;

                if (printQty) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt('return', false);

              case 6:
                _context9.next = 8;
                return __WEBPACK_IMPORTED_MODULE_18_axios___default.a.get(_this11.pathDymoFbaLabel);

              case 8:
                response = _context9.sent;
                labelXml = response.data;
                label = dymo.label.framework.openLabelXml(labelXml);
                labelSet = new dymo.label.framework.LabelSetBuilder();
                labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({ printQuality: dymo.label.framework.LabelWriterPrintQuality.Text });
                records = [];

                for (i = 0; i < printQty; i++) {
                  records[i] = labelSet.addRecord();
                  records[i].setText('BARCODE', authCodeBatch.amzFnsku);

                  records[i].setText('TEXT_PRODUCT', _this11.productNameForLabel(authCodeBatch.product.data));
                }

                console.log('records to be printed', records);
                console.log('dymoPrinterName', _this11.dymoPrinterName);
                _context9.next = 19;
                return label.printAsync(_this11.dymoPrinterName, labelParams, labelSet);

              case 19:
                authCodeBatch.loading = false;
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire({
                  title: 'Print Job Submitted',
                  text: 'Apply these labels per Amazon\'s instructions.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                });

              case 21:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    }
  },
  watch: {
    watchPerPage: function watchPerPage(newFrom, oldFrom) {
      this.queryData();
    },
    showComplete: function showComplete(newFrom, oldFrom) {
      this.queryData();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "/YGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__ = __webpack_require__("37ho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__ = __webpack_require__("Pfw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__ = __webpack_require__("DfKf");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RegisterForm: __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__["a" /* default */],
    TypeValidationForm: __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      registerModel: {},
      loginModel: {},
      typeValidationModel: {}
    };
  },

  methods: {
    onRegisterSubmit: function onRegisterSubmit(model, isValid) {
      this.registerModel = model;
    },
    onLoginSubmit: function onLoginSubmit(model, isValid) {
      this.loginModel = model;
    },
    onTypeValidationSubmit: function onTypeValidationSubmit(model, isValid) {
      this.typeValidationModel = model;
    }
  }
});

/***/ }),

/***/ "/ZBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showSwal: function showSwal(type) {
      if (type === 'basic') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Here\'s a message!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
      } else if (type === 'title-and-text') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Here\'s a message!',
          text: 'It\'s pretty, isn\'t it?',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info btn-fill'
        });
      } else if (type === 'success-message') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Good job!',
          text: 'You clicked the button!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      } else if (type === 'warning-message-and-confirmation') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        });
      } else if (type === 'warning-message-and-cancel') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this imaginary file!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            });
          }
        });
      } else if (type === 'custom-html') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'HTML example',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          html: 'You can use <b>bold text</b>, ' + '<a href="http://github.com">links</a> ' + 'and other HTML tags'
        });
      } else if (type === 'auto-close') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Auto close alert!',
          text: 'I will close in 2 seconds.',
          timer: 2000,
          showConfirmButton: false
        });
      } else if (type === 'input-field') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Input something',
          html: '<div class="form-group">' + '<input id="input-field" type="text" class="form-control" />' + '</div>',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function (result) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
            type: 'success',
            html: 'You entered',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false

          });
        }).catch(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.noop);
      }
    }
  }
});

/***/ }),

/***/ "/agt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/onm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B","title":"Authentic.net","subtitle":"Submit Fraud Report"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"title":"Product","before-change":_vm.validateFirstStep,"icon":"ti-bag"}},[_c('first-step',{ref:"firstStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Store / Seller Info","before-change":_vm.validateSecondStep,"icon":"ti-shopping-cart"}},[_c('second-step',{ref:"secondStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Contact Info","icon":"ti-user"}},[_c('h5',{staticClass:"text-center"},[_vm._v("Please let us know how to reach you.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.buyerName),expression:"modelValidations.buyerName"},{name:"model",rawName:"v-model",value:(_vm.model.buyerName),expression:"model.buyerName"}],staticClass:"form-control",attrs:{"type":"text","name":"buyerName"},domProps:{"value":(_vm.model.buyerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "buyerName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.buyerEmail),expression:"modelValidations.buyerEmail"},{name:"model",rawName:"v-model",value:(_vm.model.buyerEmail),expression:"model.buyerEmail"}],staticClass:"form-control",attrs:{"type":"text","name":"buyerEmail"},domProps:{"value":(_vm.model.buyerEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "buyerEmail", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.buyerEmail.invalid),expression:"buyerEmail.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('buyerEmail'))+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    Phone\n                  ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.buyerPhone),expression:"modelValidations.buyerPhone"},{name:"model",rawName:"v-model",value:(_vm.model.buyerPhone),expression:"model.buyerPhone"}],staticClass:"form-control",attrs:{"type":"text","name":"buyerPhone"},domProps:{"value":(_vm.model.buyerPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "buyerPhone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    City\n                  ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.buyerCity),expression:"modelValidations.buyerCity"},{name:"model",rawName:"v-model",value:(_vm.model.buyerCity),expression:"model.buyerCity"}],staticClass:"form-control",attrs:{"type":"text","name":"buyerCity"},domProps:{"value":(_vm.model.buyerCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "buyerCity", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.buyerCity.invalid),expression:"buyerCity.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('buyerCity'))+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    State\n                  ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.buyerState),expression:"modelValidations.buyerState"},{name:"model",rawName:"v-model",value:(_vm.model.buyerState),expression:"model.buyerState"}],staticClass:"form-control",attrs:{"type":"text","name":"buyerState"},domProps:{"value":(_vm.model.buyerState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "buyerState", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.buyerState.invalid),expression:"buyerState.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('buyerState'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    Country\n                  ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.buyerCountry),expression:"modelValidations.buyerCountry"},{name:"model",rawName:"v-model",value:(_vm.model.buyerCountry),expression:"model.buyerCountry"}],staticClass:"form-control",attrs:{"type":"text","name":"buyerCountry"},domProps:{"value":(_vm.model.buyerCountry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "buyerCountry", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.buyerCountry.invalid),expression:"buyerCountry.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('buyerCountry'))+"\n                  ")])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finish")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/raC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/vUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterCodeConfirmation_vue__ = __webpack_require__("Qc+W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f5ea357_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterCodeConfirmation_vue__ = __webpack_require__("A5XH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterCodeConfirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f5ea357_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterCodeConfirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");























__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_19__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData', 'pathDymoAuthLabel', 'pathDymoFbaLabel'],
  computed: {
    queriedData: function queriedData() {
      return this.tableData;
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      return this.pagination.total;
    },
    watchPerPage: function watchPerPage() {
      return this.pagination.perPage * this.pagination.currentPage;
    }
  },
  data: function data() {
    return {
      user: {},
      initialized: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
        startAfter: false
      },
      tableData: [],
      prodImageMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      batchIdIndexMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getCurrentUser();

              case 2:
                _this.user = _context.sent;

                _this.queryData();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAuthCodeBatchesTable: function getAuthCodeBatchesTable(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var accountId, accountDoc, qtyAuthCodeBatches, perPage, pageNum, offset, batchDocs, qs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, reg, retVal;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accountId = _this2.user.accountId;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection('accounts').doc(accountId).get();

              case 3:
                accountDoc = _context2.sent;
                qtyAuthCodeBatches = accountDoc.data().qtyAuthCodeBatches;

                console.log('qty account auth code batches', qtyAuthCodeBatches);
                perPage = parseInt(data.perPage);
                pageNum = parseInt(data.pageNum);
                offset = perPage * (pageNum - 1);
                batchDocs = [];
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection('brands/' + _this2.accountData.activeBrand.id + '/authCodeBatches').orderBy('createdAt', 'desc').limit(perPage).get();

              case 12:
                qs = _context2.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 16;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  doc = _step.value;

                  console.log('doc', doc.data());
                  reg = {
                    id: doc.id,
                    data: doc.data()
                  };

                  reg.data.createdAtMillis = doc.data().createdAt.toMillis();
                  batchDocs.push(reg);
                }
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](16);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context2.prev = 27;

                if (!_didIteratorError) {
                  _context2.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context2.finish(27);

              case 31:
                return _context2.finish(24);

              case 32:
                retVal = {
                  data: {
                    success: true,
                    qtyAuthCodeBatches: qtyAuthCodeBatches,
                    authCodeBatches: batchDocs
                  }
                };

                console.log('returning', retVal);
                return _context2.abrupt('return', retVal);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[16, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    queryData: function queryData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, getAuthCodeBatchesTableData, result, authCodeBatches, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, batchDoc, img, obj;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.isEmpty(_this3.user)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', []);

              case 2:

                _this3.tableData = [];

                data = {};
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_17_firebase___default.a.auth().currentUser.getIdToken();

              case 6:
                data.userToken = _context3.sent;

                data.accountId = _this3.user.accountId;
                data.perPage = _this3.pagination.perPage;
                data.pageNum = _this3.pagination.currentPage;
                console.log('calling getAuthCodeBatchesTableData', data);

                getAuthCodeBatchesTableData = __WEBPACK_IMPORTED_MODULE_17_firebase___default.a.functions().httpsCallable('getAuthCodeBatchesTableData');
                _context3.next = 14;
                return getAuthCodeBatchesTableData(data);

              case 14:
                result = _context3.sent;


                console.log('getAuthCodeBatchesTableData', result);
                _this3.pagination.total = result.data.qtyAuthCodeBatches;
                console.log('pagination data', _this3.pagination);
                authCodeBatches = result.data.authCodeBatches;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 22;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(authCodeBatches);

              case 24:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 40;
                  break;
                }

                batchDoc = _step2.value;

                if (!(_this3.prodImageMap.get(batchDoc.data.productId) === undefined)) {
                  _context3.next = 31;
                  break;
                }

                _context3.next = 29;
                return _this3.prodImgUrl(batchDoc.data.product.id, batchDoc.data.product.data, '140x140x');

              case 29:
                img = _context3.sent;

                _this3.prodImageMap.set(batchDoc.data.productId, img);

              case 31:
                obj = batchDoc.data;

                obj.id = batchDoc.id;
                obj.imageUrl = _this3.prodImageMap.get(batchDoc.data.productId);
                _this3.tableData.push(obj);
                _this3.batchIdIndexMap.set(obj.id, _this3.tableData.length - 1);
                if (obj.status === 'Requested' || obj.status === 'Processing') _this3.monitorAuthCodeBatch(obj);

              case 37:
                _iteratorNormalCompletion2 = true;
                _context3.next = 24;
                break;

              case 40:
                _context3.next = 46;
                break;

              case 42:
                _context3.prev = 42;
                _context3.t0 = _context3['catch'](22);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 46:
                _context3.prev = 46;
                _context3.prev = 47;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 49:
                _context3.prev = 49;

                if (!_didIteratorError2) {
                  _context3.next = 52;
                  break;
                }

                throw _iteratorError2;

              case 52:
                return _context3.finish(49);

              case 53:
                return _context3.finish(46);

              case 54:
                _this3.pagination.startAfter = result.data.lastDoc;
                console.log(_this3.tableData);
                _this3.initialized = true;

              case 57:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[22, 42, 46, 54], [47,, 49, 53]]);
      }))();
    },
    monitorAuthCodeBatch: function monitorAuthCodeBatch(authCodeBatch) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection('brands/' + this.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).onSnapshot(function (doc) {
        _this4.tableData[_this4.batchIdIndexMap.get(doc.id)].status = doc.data().status;
        _this4.tableData[_this4.batchIdIndexMap.get(doc.id)].qtyCreated = doc.data().qtyCreated;
      });
    },
    prettyAddress: function prettyAddress(regRecord) {
      var address = '';
      if (regRecord.address1) address += regRecord.address1;
      if (regRecord.address2) address += '<br>' + regRecord.address2;
      if (regRecord.city || regRecord.state || regRecord.zip || regRecord.country) {
        var region = '';
        if (regRecord.city) region += regRecord.city;
        if (regRecord.state) {
          if (region === '') region += regRecord.state;else region += ', ' + regRecord.state;
        }
        if (regRecord.zip) {
          if (region === '') region += regRecord.zip;else region += ' ' + regRecord.zip;
        }
        if (regRecord.country) {
          if (region === '') region += regRecord.country;else region += ' ' + regRecord.country;
        }
        if (region !== '') region = '<br>' + region;
        address += region;
      }
      return address;
    },
    friendlyDateTime: function friendlyDateTime(timestamp) {
      if (timestamp === undefined || timestamp === '') return 'Never';else return __WEBPACK_IMPORTED_MODULE_16_moment___default()(timestamp.seconds * 1000).format('LLL');
    },
    formatLastPrinted: function formatLastPrinted(timestamp) {
      if (timestamp === undefined || timestamp === '') return 'Never';else return __WEBPACK_IMPORTED_MODULE_16_moment___default()(timestamp.seconds * 1000).format('l');
    },
    printBatchFbaLabels: function printBatchFbaLabels(authCodeBatch) {
      console.log('dymo paths', [this.pathDymoAuthLabel, this.pathDymoFbaLabel]);
    },
    showPrintBtn: function showPrintBtn(authCodeBatch) {
      return authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed';
    },
    showPrintBtnLoading: function showPrintBtnLoading(authCodeBatch) {
      return authCodeBatch.status === 'Requested' || authCodeBatch.stats === 'Processin' || authCodeBatch.status === 'Printing';
    },
    showPrintConfirmBtn: function showPrintConfirmBtn(authCodeBatch) {
      return authCodeBatch.status === 'Printed';
    },
    showPrintConfirmBtnLoading: function showPrintConfirmBtnLoading(authCodeBatch) {
      return authCodeBatch.confirmingPrint && authCodeBatch.status === 'Printed';
    },
    hasAmazonComFnsku: function hasAmazonComFnsku(authCodeBatch) {
      return !!authCodeBatch.product.data.amazonComFnsku;
    }
  },
  watch: {
    watchPerPage: function watchPerPage(newFrom, oldFrom) {
      this.queryData();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0Bz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0YV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])(['email'])),
  data: function data() {
    return {
      loading: false,
      model: {
        email: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        }
      }
    };
  },

  methods: {
    init: function init() {},
    submit: function submit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().sendPasswordResetEmail(this.model.email).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
          title: 'Success!',
          text: 'Please check your email for instructions on how to reset your password.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(function () {
          _this.loading = false;
          _this.$router.replace('/login');
        });
      }).catch(function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
          title: 'Oops!',
          text: error,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'error'
        }).then(function () {
          _this.loading = false;
        });
      });
    },
    validateThenSubmit: function validateThenSubmit() {
      var _this2 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.submit();
        } else {
          _this2.loading = false;
        }
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "0xa1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "10X6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[(!!_vm.authDetails.userAuth.email)?_c('v-gravatar',{staticClass:"avatar border-white",attrs:{"email":_vm.authDetails.userAuth.email,"size":34,"alt":"..."}}):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.user.data.firstName),expression:"authDetails.user.data.firstName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"firstName","placeholder":"First Name"},domProps:{"value":(_vm.authDetails.user.data.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.user.data, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('firstName'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.user.data.lastName),expression:"authDetails.user.data.lastName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"lastName","placeholder":"Last Name"},domProps:{"value":(_vm.authDetails.user.data.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.user.data, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('lastName'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("\n            Save\n          ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit","disabled":"disabled"}},[_vm._m(1),_vm._v("\n            Save\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n        "+_vm._s(_vm.authDetails.userAuth.email)),_c('br'),_c('button',{staticClass:"btn btn-sm",attrs:{"id":"update-email"},on:{"click":function($event){$event.preventDefault();_vm.updateEmail()}}},[_vm._v("change")]),_c('br'),_c('br'),_vm._v("\n        "+_vm._s(_vm.authDetails.userAuth.phoneNumber)),_c('br'),_c('button',{staticClass:"btn btn-sm",attrs:{"id":"update-phone"}},[_vm._v("change")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title",staticStyle:{"text-align":"center"}},[_vm._v("User Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "18Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }
    };
  },

  methods: {
    notifyVue: function notifyVue(verticalAlign, horizontalAlign) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: '<span>Welcome to <b>Paper Dashboard</b> - a beautiful freebie for every web developer.</span>'
        },
        icon: 'ti-gift',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color]
      });
    }
  }
});

/***/ }),

/***/ "1EQp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1Nqp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");








var BrandOverviewStats = function BrandOverviewStats() {
  return {
    component: __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "Coyb"))
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BrandOverviewStats: BrandOverviewStats
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData'],
  data: function data() {
    return {
      user: {},
      brandValidationData: [],
      brandRegistrationData: [],
      totalBrandValidations: 0,
      totalBrandRegistrations: 0,
      brands: []
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('getting current user in overview');
                _this.getCurrentUser().then(function (result) {
                  console.log('got current user in overview');
                  console.log(result);
                  _this.user = result;
                  console.log(_this.user);
                  _this.getBrandsAndStats();
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrandsAndStats: function getBrandsAndStats() {
      var brand = {
        data: this.accountData.activeBrand.data,
        id: this.accountData.activeBrand.id,
        validationData: [],
        totalValidations: 0,
        registrationData: [],
        totalRegistrations: 0,
        validationDataReady: false,
        registrationDataReady: false,
        isArchived: this.accountData.activeBrand.data.isArchived
      };
      this.brands.push(brand);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "1gfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    authDetails: {
      type: Object,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: {
    thisMonth: function thisMonth() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MMMM');
    },
    thisYear: function thisYear() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY');
    },
    planUsageQtyCodesThisMonth: function planUsageQtyCodesThisMonth() {
      if (!this.authDetails.account.data.lastBatchCreatedAt) return 0;
      var lastBatchCreatedAt = this.authDetails.account.data.lastBatchCreatedAt.toDate();

      if (!__WEBPACK_IMPORTED_MODULE_0_moment___default()().isSame(lastBatchCreatedAt, 'year') || !__WEBPACK_IMPORTED_MODULE_0_moment___default()().isSame(lastBatchCreatedAt, 'month')) return 0;
      var remaining = this.authDetails.account.data.planConstraints.maxCodesPerMonth - this.authDetails.account.data.planUsageQtyCodesThisMonth;
      remaining = Math.max(remaining, 0);
      return remaining;
    }
  },
  methods: {
    goChangePlan: function goChangePlan() {
      this.$router.replace({ name: 'Change Plan' });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      console.log('authDetails in plan details card', this.authDetails);
    });
  }
});

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "20JI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Add Brand")]),_vm._v(" "),(!_vm.maxReached)?_c('p',{staticClass:"category"},[_vm._v("You can add up to "+_vm._s(_vm.brandSlotsRemaining)+" more brands on your "+_vm._s(_vm.accountData.authDetails.account.data.planName)+" Plan.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.maxReached)?_c('p',{staticClass:"text-danger"},[_vm._v("Please upgrade your Authentic.net plan if you wish to add more brands.")]):_vm._e(),_vm._v(" "),(!_vm.maxReached)?_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBrand.name),expression:"newBrand.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"title"},domProps:{"value":(_vm.newBrand.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBrand, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('name'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Image")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{ref:"imageFile",attrs:{"type":"file","name":"imageFile","accept":"image/*"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.newBrand.logoUrl),expression:"newBrand.logoUrl"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.logoUrl),expression:"modelValidations.logoUrl"}],staticClass:"form-control",attrs:{"type":"text","name":"logoUrl"},domProps:{"value":(_vm.newBrand.logoUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBrand, "logoUrl", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.logoUrl.invalid),expression:"logoUrl.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('logoUrl'))+"\n                  ")]),_vm._v(" "),_c('p-progress',{attrs:{"value":_vm.uploadProgress,"type":"info"}})],1)])]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateAddBrand()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(0),_vm._v("\n              Submit\n            ")]):_vm._e()]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.brandsTable),function(brand){return _c('div',{key:brand.key,staticClass:"col-lg-3"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"text-center"},[_c('h3',[_vm._v(_vm._s(brand.name))])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"140px","display":"flex","align-items":"center"}},[_c('div',{staticClass:"img-container"},[(brand.logoUrl)?_c('img',{attrs:{"src":brand.logoUrl,"alt":brand.name}}):_vm._e(),_vm._v(" "),(!brand.logoUrl)?_c('span',[_vm._v("{NO BRAND LOGO}")]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[(!brand.isArchived && !brand.deleting)?_c('button',{staticClass:"btn btn-fill btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.deleteBrand(brand)}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(!brand.isArchived && brand.deleting)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1,true),_vm._v("\n            Deleting...\n          ")]):_vm._e(),_vm._v(" "),(brand.isArchived && !brand.unarchiving)?_c('button',{staticClass:"btn btn-fill btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.unArchiveBrand(brand)}}},[_vm._v("Un-Archive")]):_vm._e(),_vm._v(" "),(brand.unarchiving)?_c('button',{staticClass:"btn btn-fill btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2,true),_vm._v("\n            Un-Archiving...\n          ")]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 pull-right"},[_c('div',{staticStyle:{"float":"right"}},[_c('p',{staticClass:"category"},[_vm._v("Show Archived Brands")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.showArchived),callback:function ($$v) {_vm.showArchived=$$v},expression:"showArchived"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2SCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('time-line',[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n        11 hours ago via Twitter\n      ")])]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"success","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"info","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n          Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n          What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","href":"#","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"warning","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-warning",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim’s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2TG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus__ = __webpack_require__("O6e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      authDetails: {},
      initialized: false,
      amzProducts: [],
      importAll: false,
      brands: [],
      brandNameIndexMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      loading: true,
      existingProductSkus: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getAuthDetails();

              case 2:
                _this.authDetails = _context.sent;
                _context.next = 5;
                return _this.getBrands();

              case 5:
                _context.next = 7;
                return _this.getExistingProductSkus();

              case 7:
                _this.initialized = true;
                _this.loading = false;
                _this.getAmzProducts();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrands: function getBrands() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var qs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, brand;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.brands = [];
                _this2.brands.push({
                  id: 0,
                  name: 'Please Select'
                });
                _this2.brandNameIndexMap.set('Please Select', 0);
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__components_firebase_init__["a" /* default */].collection('brands').where('accountId', '==', _this2.authDetails.account.id).orderBy('name').get();

              case 5:
                qs = _context2.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 9;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  doc = _step.value;
                  brand = doc.data();

                  brand.id = doc.id;
                  console.log('brand', brand);
                  _this2.brands.push(brand);
                  _this2.brandNameIndexMap.set(brand.name, _this2.brands.length - 1);
                }
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 17:
                _context2.prev = 17;
                _context2.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 20:
                _context2.prev = 20;

                if (!_didIteratorError) {
                  _context2.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context2.finish(20);

              case 24:
                return _context2.finish(17);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[9, 13, 17, 25], [18,, 20, 24]]);
      }))();
    },
    getBrandIndex: function getBrandIndex(brandName) {
      console.log('getting brand index for', brandName);
      var index = 0;
      if (!this.brandNameIndexMap.get(brandName)) index = 0;else index = this.brandNameIndexMap.get(brandName);
      console.log('index is', index);
      return index;
    },
    getAmzProducts: function getAmzProducts() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__components_firebase_init__["a" /* default */].collection('accounts/' + this.authDetails.account.id + '/amzProducts').onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          if (change.type === 'added') {
            var doc = change.doc;
            var prod = {
              id: doc.id,
              data: doc.data(),
              brandIndex: 0
            };
            prod.import = false;
            _this3.applyFirstMatchingBrand(prod);
            if (_this3.existingProductSkus.get(prod.id)) {
              prod.imported = true;
              prod.loading = true;
              prod.status = 'Already imported';
            }
            _this3.amzProducts.push(prod);
          }
        });
      });
    },
    applyFirstMatchingBrand: function applyFirstMatchingBrand(amzProd) {
      var brandStr = amzProd.data.AttributeSets.ItemAttributes.Brand;
      if (brandStr.includes(',')) {
        var brands = brandStr.split(',');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(brands), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var brand = _step2.value;

            var str = brand.trim();
            if (this.getBrandIndex(str) !== 0) {
              amzProd.brandIndex = this.getBrandIndex(str);
              return;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      amzProd.brandIndex = this.getBrandIndex(amzProd.data.AttributeSets.ItemAttributes.Brand);
      if (amzProd.brandIndex === 0) {
        amzProd.loading = true;
        amzProd.status = 'Please select brand';
      }
    },
    getExistingProductSkus: function getExistingProductSkus() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userToken, data, getAccountProducts, result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, prod, product;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('getting products');
                _this4.existingProductSkus = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().currentUser.getIdToken();

              case 4:
                userToken = _context3.sent;
                data = {
                  userToken: userToken,
                  accountId: _this4.authDetails.account.id,
                  archivedOnly: false
                };
                getAccountProducts = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.functions().httpsCallable('getAccountProducts');
                _context3.next = 9;
                return getAccountProducts(data);

              case 9:
                result = _context3.sent;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context3.prev = 13;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.data.products); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  prod = _step3.value;
                  product = prod.data;

                  product.id = prod.id;
                  _this4.existingProductSkus.set(product.sku, product);
                }
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](13);
                _didIteratorError3 = true;
                _iteratorError3 = _context3.t0;

              case 21:
                _context3.prev = 21;
                _context3.prev = 22;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 24:
                _context3.prev = 24;

                if (!_didIteratorError3) {
                  _context3.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context3.finish(24);

              case 28:
                return _context3.finish(21);

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[13, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    brandChanged: function brandChanged(amzProd) {
      if (amzProd.imported) {} else if (amzProd.brandIndex === 0) {
        amzProd.loading = true;
        amzProd.status = 'Please select brand';
      } else {
        amzProd.loading = false;
      }
    },
    limitChars: function limitChars(x) {
      if (x.length > 30) return x.substring(0, 30) + '...';
      return x;
    },
    importSelected: function importSelected() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var hasErrors, qtyImport, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, aprod;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;
                hasErrors = false;
                qtyImport = 0;
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context4.prev = 6;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this5.amzProducts);

              case 8:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context4.next = 16;
                  break;
                }

                aprod = _step4.value;

                if (!aprod.import) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 13;
                return _this5.importAmazonProduct(aprod);

              case 13:
                _iteratorNormalCompletion4 = true;
                _context4.next = 8;
                break;

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4['catch'](6);
                _didIteratorError4 = true;
                _iteratorError4 = _context4.t0;

              case 22:
                _context4.prev = 22;
                _context4.prev = 23;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 25:
                _context4.prev = 25;

                if (!_didIteratorError4) {
                  _context4.next = 28;
                  break;
                }

                throw _iteratorError4;

              case 28:
                return _context4.finish(25);

              case 29:
                return _context4.finish(22);

              case 30:
                _this5.loading = false;
                _this5.$router.replace({ name: 'Products' });

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[6, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    importAmazonProduct: function importAmazonProduct(amzProd) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, accountImportAmazonProduct, _result;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                amzProd.loading = true;
                amzProd.status = 'loading';
                data = {
                  sellerSku: amzProd.id,
                  brandId: _this6.brands[amzProd.brandIndex].id,
                  amzProdData: amzProd.data
                };
                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().currentUser.getIdToken();

              case 6:
                data.userToken = _context5.sent;
                accountImportAmazonProduct = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.functions().httpsCallable('accountImportAmazonProduct');
                _context5.next = 10;
                return accountImportAmazonProduct(data);

              case 10:
                _result = _context5.sent;

                amzProd.status = 'imported';
                _this6.showNotify('Imported: ' + amzProd.data.AttributeSets.ItemAttributes.Title, 'success', 'Success');
                _context5.next = 19;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](0);

                amzProd.status = 'failed';
                _this6.showNotify(_context5.t0, 'danger', 'Failed');

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 15]]);
      }))();
    }
  },
  watch: {
    importAll: function importAll(newVal, oldVal) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.amzProducts), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var amzProd = _step5.value;

          amzProd.import = newVal;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "2TRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Wizard_FirstStep_vue__ = __webpack_require__("KmoX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Wizard_SecondStep_vue__ = __webpack_require__("kEU6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__ = __webpack_require__("S85j");











/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['buyerName', 'buyerEmail', 'buyerPhone', 'buyerCity', 'buyerState', 'buyerCountry'])),
  data: function data() {
    return {
      wizardModel: {},
      model: {
        buyerName: '',
        buyerEmail: '',
        buyerPhone: '',
        buyerCity: '',
        buyerState: '',
        buyerCountry: '',
        code: ''
      },
      modelValidations: {
        buyerEmail: {
          email: true
        },
        buyerCity: {
          required: true
        },
        buyerState: {
          required: true
        },
        buyerCountry: {
          required: true
        }
      }
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["TabContent"],
    FirstStep: __WEBPACK_IMPORTED_MODULE_4__Wizard_FirstStep_vue__["a" /* default */],
    SecondStep: __WEBPACK_IMPORTED_MODULE_5__Wizard_SecondStep_vue__["a" /* default */]
  },
  methods: {
    init: function init() {
      if (this.$route.params.code) this.model.code = this.$route.params.code;else if (this.$route.query.code) this.model.code = this.$route.query.code;
    },
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.validate();

      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model, this.$refs.secondStep.model, this.model);
      console.log(this.wizardModel);
      __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__["a" /* default */].collection('fraudReports').add(this.wizardModel).then(function (result) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire('Thank You!', 'Your report has been submitted. We may update you with research results or reach out to you if we need more info.', 'success');
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_594bfe2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("vVLN");
function injectStyle (ssrContext) {
  __webpack_require__("89QO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_594bfe2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3/Fs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterCode_vue__ = __webpack_require__("Duow");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b02b2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterCode_vue__ = __webpack_require__("CB7h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b02b2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3/nc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_functions__ = __webpack_require__("p/MD");














/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email', 'birthday', 'address1', 'address2', 'city', 'state', 'zip', 'country'])),
  data: function data() {
    return {
      myvariable: 4,
      modelValidations: {
        email: {
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        country: {
          required: true
        }
      },
      loading: false,
      step: 1,
      complete: false,
      model: {
        firstName: '',
        lastName: '',
        email: '',
        birthday: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        goals: {
          healthyVagina: false,
          postpartumRecovery: false,
          bladderLeakage: false,
          organProlapse: false,
          sexualHealth: false,
          vaginalRejuvenation: false
        },
        sendShowerHolder: true,
        optIn: true
      },
      code: false,
      codeData: false
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["Card"] },

  methods: {
    init: function init() {
      this.loading = true;
      this.checkCode();
    },
    checkCode: function checkCode() {
      var _this = this;

      var checkCode = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.functions().httpsCallable('checkCode');
      checkCode({ code: this.code, doNotValidate: true }).then(function (result) {
        console.log(result);
        if (!result.data.valid) {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
            title: 'Not Authentic!',
            text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(function () {
            _this.$router.replace('/authenticate?code=' + _this.model.code);
          });
        } else if (result.data.type === 'external') {
          console.log('external');
        } else {
          console.log('primary');
          _this.codeData = result.data;
          console.log(_this.codeData);
        }
        _this.loading = false;
      }).catch(function (err) {
        console.error(err.message);
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
          title: 'Not Authentic!',
          text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this.$router.replace('/authenticate?code=' + _this.model.code);
        });
        _this.loading = false;
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    submit: function submit() {
      var _this2 = this;

      var data = {
        contactDetails: this.model,
        code: this.code
      };
      var registerAuthCode = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.functions().httpsCallable('registerAuthCode');
      registerAuthCode(data).then(function (result) {
        if (!result.data.success) {
          _this2.$router.replace('/authenticate?code=' + _this2.code);
        }
        console.log(result);
        var msg = '';
        if (!_this2.sendShowerHolder) msg = 'You will now be sent to the Kegelbell instructions video.';else msg = 'We will send your Kegelbell Shower Holder ASAP! You will now be sent to the Kegelbell instructions video.';
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
          title: 'Thank you!',
          text: msg,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(function () {
          location.replace('https://www.kegelbell.com/pages/instructions');
        });
        _this2.loading = false;
      });
    },
    signup: function signup() {
      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
      }).catch(function (err) {
        console.error(err.message);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this3 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.submit();
        } else {
          _this3.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.params.code) this.code = this.$route.params.code;else if (this.$route.query.code) this.code = this.$route.query.code;
      if (!this.code) this.$router.replace('/authenticate');
      this.init();
    });
  }
});

/***/ }),

/***/ "37ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__("tlmh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd9ef7b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__("9bUm");
function injectStyle (ssrContext) {
  __webpack_require__("MR/0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd9ef7b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Cg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('router-link',{attrs:{"to":"/login","tag":"li"}},[_c('a',[_vm._v("Login")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"}],ref:"password",staticClass:"form-control input-no-border",attrs:{"type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.passwordConfirm),expression:"model.passwordConfirm"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordConfirm),expression:"modelValidations.passwordConfirm"}],ref:"passwordConfirm",staticClass:"form-control input-no-border",attrs:{"type":"password","name":"passwordConfirm","placeholder":"Confirm Password"},domProps:{"value":(_vm.model.passwordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "passwordConfirm", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordConfirm.invalid),expression:"passwordConfirm.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('passwordConfirm'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateThenSubmit()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd ",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n                      Submit\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/background-2.jpg)"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Sign Up")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"https://authentic.net"}},[_c('img',{attrs:{"src":"static/img/authentic_net_lt.png","width":"200","alt":"Authentic.net"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Reset your password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3FiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbell_vue__ = __webpack_require__("/5Bd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434d13dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbell_vue__ = __webpack_require__("Cp7z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434d13dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3JE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCompanyForm_vue__ = __webpack_require__("FKHU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d229cabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCompanyForm_vue__ = __webpack_require__("bPcP");
function injectStyle (ssrContext) {
  __webpack_require__("/agt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCompanyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d229cabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCompanyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3MeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3Pfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"text-align":"center"}},[(!_vm.creditCard.update)?_c('div',[_c('h5',[_vm._v(_vm._s(_vm.creditCard.display))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();_vm.updateCard()}}},[_vm._v("Update Card")])]):_vm._e(),_vm._v(" "),(_vm.creditCard.update)?_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.submit()}}},[_c('div',[_c('h6',[_vm._v("New Credit Card")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('card',{staticClass:"stripe-card",class:_vm.stripeSettings.class,style:(_vm.stripeSettings.style),attrs:{"stripe":_vm.stripeSettings.pubKey,"options":_vm.stripeSettings.options},on:{"change":function($event){_vm.complete = $event.complete}}})],1)]),_vm._v(" "),_c('div',[(!_vm.creditCard.loadingSubmit)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.submit()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.creditCard.loadingSubmit)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n            Submit\n          ")]):_vm._e()])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title",staticStyle:{"text-align":"center"}},[_vm._v("Payment Method")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3TKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search records","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-info btn-icon like",on:{"click":function($event){_vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"title"},[_vm._v("Custom table with pagination")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n      We combine "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/quickstart","target":"_blank"}},[_vm._v("Element-UI")]),_vm._v("\n      table functionalities together with a custom pagination component\n      which should provide a very good starting point to integrate tables in your application.\n      Check out more functionalities at "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/table","target":"_blank"}},[_vm._v("Element-UI table documentation")]),_vm._v(".\n     ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Extended tables")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4JrB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4LKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthCodeBatchesTable_vue__ = __webpack_require__("/yqh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc6917c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthCodeBatchesTable_vue__ = __webpack_require__("NWP/");
function injectStyle (ssrContext) {
  __webpack_require__("s5Vg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthCodeBatchesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc6917c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthCodeBatchesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Lu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('register-form',{on:{"on-submit":_vm.onRegisterSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('login-form',{on:{"on-submit":_vm.onLoginSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('type-validation-form',{on:{"on-submit":_vm.onTypeValidationSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4N3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['brand', 'product'])),
  data: function data() {
    return {
      model: {
        brand: '',
        product: ''
      },
      brandSelected: true,
      searchIndex: 0,
      products: [],
      brandName: '',
      brandObjects: [],
      modelValidations: {
        brand: {
          required: true
        },
        product: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "4Urk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4d//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* mapFields */])(['code'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      recaptcha: {
        verifier: null,
        confirmationResult: null,
        widgetId: null
      },
      myvariable: 4,
      modelValidations: {
        code: {
          required: true
        }
      },
      loading: false,
      model: {
        code: '',
        clientIpData: null
      }
    };
  },


  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.setupRecaptcha();
                _context.next = 4;
                return _this.getClientIp();

              case 4:
                _this.model.clientIp = _context.sent;

                console.log('ip address');
                console.log(_this.model.clientIp);
                _this.loading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setupRecaptcha: function setupRecaptcha() {
      var _this2 = this;

      var self = this;

      this.recaptcha.verifier = new __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth.RecaptchaVerifier('validate-submit', {
        size: 'invisible',
        callback: function callback(response) {
          console.log('solved ' + response);
          _this2.validateBeforeSubmit();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'There was a problem validating captcha',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }
      });

      this.recaptcha.verifier.render().then(function (widgetId) {
        _this2.recaptcha.widgetId = widgetId;
      });
    },
    resetRecaptcha: function resetRecaptcha() {
      window.grecaptcha.reset(this.recaptcha.widgetId);
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    handlePriorRegistrationError: function handlePriorRegistrationError(authCode) {
      var text = '';
      if (authCode.retailerName !== '') {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' from ' + authCode.retailerName + ' was already registered in the past.';
      } else {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' was already registered in the past.';
      }
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
        title: 'Previously Registered!',
        text: text,
        type: 'warning',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      }).then(function () {});
      this.loading = false;
    },
    handleExcessValidationError: function handleExcessValidationError(authCode) {
      var qtyPriorValidations = authCode.qtyValidations - 1;
      var text = '';
      if (authCode.retailerName !== '') {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' from ' + authCode.retailerName + ' was already validated ' + qtyPriorValidations + ' times in the past.';
      } else {
        text = 'The Authentic.net Code for this ' + authCode.productName + ' was already validated ' + qtyPriorValidations + ' times in the past.';
      }
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
        title: 'Previously Validated!',
        text: text,
        type: 'warning',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      }).then(function () {});
      this.loading = false;
    },
    handleValidAuthCode: function handleValidAuthCode(authCode) {
      var _this3 = this;

      var text = '';
      if (authCode.retailerName !== '') {
        text = 'Congratulations! This ' + authCode.productName + ' from ' + authCode.retailerName + ' is authentic.';
      } else {
        text = 'Congratulations! This ' + authCode.productName + ' is authentic.';
      }
      var priorValidationQty = authCode.qtyValidations - 1;
      if (priorValidationQty > 0) {
        text += ' It has never been registered, but it has been validated ' + priorValidationQty + ' times prior.';
      }
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
        title: 'Authentic!',
        text: text,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'success'
      }).then(function () {
        if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'T6vlUai6XeGNuH62K5kS') _this3.$router.replace('/kegelbell-amz?code=' + _this3.model.code);else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'oKi6QqY2UGynFOXhweeD') _this3.$router.replace('/kegelbell-basic?code=' + _this3.model.code);else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV') _this3.$router.replace('/kegelbell?code=' + _this3.model.code);else if (authCode.accountStatus === 'setup') _this3.$router.replace({ name: 'Onboarding' });else _this3.$router.replace('/register-code?code=' + _this3.model.code);
      }).catch(function (error) {
        console.log(error);

        if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'T6vlUai6XeGNuH62K5kS') _this3.$router.replace('/kegelbell-amz?code=' + _this3.model.code);else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV' && authCode.retailerId === 'oKi6QqY2UGynFOXhweeD') _this3.$router.replace('/kegelbell-basic?code=' + _this3.model.code);else if (authCode.accountId === 'D3zXQmPabbnZY5wEo8rV') _this3.$router.replace('/kegelbell?code=' + _this3.model.code);else if (authCode.accountStatus === 'setup') _this3.$router.replace({ name: 'Onboarding' });else _this3.$router.replace('/register-code?code=' + _this3.model.code);
      });
    },
    submit: function submit() {
      var _this4 = this;

      var checkCode = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.functions().httpsCallable('checkCode');
      checkCode({ code: this.model.code, clientIp: this.model.clientIp, clientIpData: this.model.clientIpData, doNotValidate: false }).then(function (result) {
        console.log(result);
        if (!result.data.valid) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Not Authentic!',
            text: 'Sorry! The Authentic.net Code "' + _this4.model.code + '" Is Invalid.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(function () {
            _this4.$router.replace('/fraud-report?code=' + _this4.model.code);
          });
        } else if (result.data.type === 'external') {
          var text = '';
          if (result.data.retailerName !== '') {
            text = 'Congratulations! This ' + result.data.productName + ' from ' + result.data.retailerName + ' is authentic.';
          } else {
            text = 'Congratulations! This ' + result.data.productName + ' is authentic.';
          }
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Authentic!',
            text: text,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          });
        } else {
          console.log(result.data);
          if (result.data.qtyRegistrations !== undefined && result.data.qtyRegistrations > 0) {
            _this4.handlePriorRegistrationError(result.data);
          } else {
            _this4.handleValidAuthCode(result.data);
          }
        }
        _this4.loading = false;
      }).catch(function (err) {
        console.error(err.message);
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          title: 'Not Authentic!',
          text: 'Sorry! The Authentic.net Code "' + _this4.model.code + '" Is Invalid.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {});
        _this4.loading = false;
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this5 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.submit();
        } else {
          _this5.resetRecaptcha();
          _this5.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.params.code) this.model.code = this.$route.params.code;else if (this.$route.query.code) this.model.code = this.$route.query.code;
      console.log('code: ' + this.model.code);

      this.init();
    });
  }
});

/***/ }),

/***/ "4d5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__ = __webpack_require__("NmlF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__ = __webpack_require__("2SCm");
function injectStyle (ssrContext) {
  __webpack_require__("G5bo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4nIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMwsForm_vue__ = __webpack_require__("W8O7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7018f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMwsForm_vue__ = __webpack_require__("ZbAH");
function injectStyle (ssrContext) {
  __webpack_require__("IcOH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMwsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7018f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMwsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__ = __webpack_require__("negu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__ = __webpack_require__("yKB+");
function injectStyle (ssrContext) {
  __webpack_require__("H0v/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Bu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__ = __webpack_require__("/YGB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__ = __webpack_require__("4Lu4");
function injectStyle (ssrContext) {
  __webpack_require__("yqcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "5Xkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[(_vm.openBatches)?_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.openBatches && _vm.monthlyMaxReached)?_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.isInitialized && !_vm.selectedProductId && !_vm.openBatches && !_vm.monthlyMaxReached)?_c('div',{staticClass:"card"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('span',{staticStyle:{"padding":"15px"}},[_vm._v("Please "),_c('router-link',{staticClass:"btn btn-info btn-xs",attrs:{"tag":"button","to":{ name: 'Products' }}},[_vm._v("Select a Product")]),_vm._v(" that you want to protect with Authentic.net labels.")],1)])]):_vm._e(),_vm._v(" "),(_vm.isInitialized && _vm.selectedProductId && !_vm.openBatches && !_vm.monthlyMaxReached)?_c('div',{staticClass:"card"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-3"},[(_vm.product.data.image)?_c('img',{attrs:{"src":_vm.product.data.image,"alt":_vm.product.data.name}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',[_c('strong',[_vm._v("Product Name:")]),_vm._v(" "+_vm._s(_vm.product.data.name)+"\n            ")]),_vm._v(" "),(_vm.product.data.size)?_c('div',[_c('strong',[_vm._v("Size:")]),_vm._v(" "+_vm._s(_vm.product.data.size)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.product.data.color)?_c('div',[_c('strong',[_vm._v("Color:")]),_vm._v(" "+_vm._s(_vm.product.data.color)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.product.data.style)?_c('div',[_c('strong',[_vm._v("Style:")]),_vm._v(" "+_vm._s(_vm.product.data.style)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.product.data.sku)?_c('div',[_c('strong',[_vm._v("SKU:")]),_vm._v(" "+_vm._s(_vm.product.data.sku)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.product.data.upc)?_c('div',[_c('strong',[_vm._v("UPC:")]),_vm._v(" "+_vm._s(_vm.product.data.upc)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.product.data.amazonComFnsku)?_c('div',[_c('strong',[_vm._v("AMZ FBA FNSKU:")]),_vm._v(" "+_vm._s(_vm.product.data.amazonComFnsku)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"#"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Retailer")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('el-select',{staticClass:"select-primary",attrs:{"size":"large","placeholder":"Retailer *optional"},model:{value:(_vm.retailerSelect.retailer_id),callback:function ($$v) {_vm.$set(_vm.retailerSelect, "retailer_id", $$v)},expression:"retailerSelect.retailer_id"}},_vm._l((_vm.retailerSelect.retailers),function(option){return _c('el-option',{key:option.name,staticClass:"select-danger",attrs:{"value":option.id,"label":option.name}})}))],1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Batch / Lot Num")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lotNum),expression:"model.lotNum"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lotNum),expression:"modelValidations.lotNum"}],staticClass:"form-control",staticStyle:{"width":"200px"},attrs:{"type":"text","name":"lotNum","placeholder":"*optional"},domProps:{"value":(_vm.model.lotNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lotNum", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lotNum.invalid),expression:"lotNum.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('lotNum'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Quantity")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.qty),expression:"model.qty"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.qty),expression:"modelValidations.qty"}],staticClass:"form-control",staticStyle:{"width":"100px"},attrs:{"type":"text","name":"qty"},domProps:{"value":(_vm.model.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "qty", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.qty.invalid),expression:"qty.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('qty'))+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateRequestCodes()}}},[_vm._v("Generate")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(6),_vm._v("\n                Generate\n              ")]):_vm._e()])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"#"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Printer")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('el-select',{staticClass:"select-primary",attrs:{"size":"large","placeholder":"Select Printer"},model:{value:(_vm.dymoPrinterName),callback:function ($$v) {_vm.dymoPrinterName=$$v},expression:"dymoPrinterName"}},_vm._l((_vm.dymoPrinters),function(option){return _c('el-option',{key:option.name,staticClass:"select-danger",attrs:{"value":option.name,"label":option.name}})}))],1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Label Size")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('el-select',{staticClass:"select-primary",attrs:{"size":"large","placeholder":"Select Label Size"},model:{value:(_vm.dymoLabelSize),callback:function ($$v) {_vm.dymoLabelSize=$$v},expression:"dymoLabelSize"}},_vm._l((_vm.dymoLabelSizes),function(option){return _c('el-option',{key:option,staticClass:"select-danger",attrs:{"value":option,"label":_vm.dymoLabelSizeMap.get(option)}})}))],1)])])])])])])]),_vm._v(" "),(_vm.isInitialized)?_c('auth-code-batches-cards',{key:_vm.addedBatches,attrs:{"account-data":_vm.accountData,"showComplete":_vm.showComplete,"pathDymoAuthLabel":_vm.pathDymoAuthLabel,"pathDymoFbaLabel":_vm.pathDymoFbaLabel,"dymoPrinterName":_vm.dymoPrinterName}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 pull-right"},[_c('div',{staticStyle:{"float":"right"}},[_c('p',{staticClass:"category"},[_vm._v("Show Complete/Closed")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.showComplete),callback:function ($$v) {_vm.showComplete=$$v},expression:"showComplete"}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Generate New Authentic.net Codes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"text-danger"},[_vm._v("Please print and close any open batches before generating another one.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Generate New Authentic.net Codes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"text-danger"},[_vm._v("Please upgrade your Authentic.net plan if you wish to generate more codes this month.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Generate New Authentic.net Codes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Generate New Authentic.net Codes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Printer Settings")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5fo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__ = __webpack_require__("pa/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    TaskList: __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__["a" /* default */]
  },
  data: function data() {
    return {
      salesChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895], [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        }
      },
      usersChart: {
        data: {
          labels: ['9AM', '12AM', '3PM', '6PM', '9PM', '12PM', '3AM', '6AM'],
          series: [[287, 385, 490, 562, 594, 626, 698, 895, 952], [67, 152, 193, 240, 387, 435, 535, 642, 744], [23, 113, 67, 108, 190, 239, 307, 410, 410]]
        },
        options: {
          low: 0,
          high: 1000,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          showLine: true,
          showPoint: false
        }
      },
      subscriptionsChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[60, 50, 30, 50, 70, 60, 90, 100]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-red'
          }
        }
      },
      downloadsChart: {
        data: {
          labels: ['2009', '2010', '2011', '2012', '2013', '2014'],
          series: [[1200, 1000, 3490, 8345, 3256, 2566]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-orange'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "5uDj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5xQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__ = __webpack_require__("V+Sv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b60d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__ = __webpack_require__("OWRr");
function injectStyle (ssrContext) {
  __webpack_require__("u9kn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b60d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "666H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("hfQ+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71212c01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("10X6");
function injectStyle (ssrContext) {
  __webpack_require__("9NyI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71212c01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "671N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__ = __webpack_require__("Q8IL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__ = __webpack_require__("M/tb");
function injectStyle (ssrContext) {
  __webpack_require__("7p7i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6oRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewCard_vue__ = __webpack_require__("lzK2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303e0fb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewCard_vue__ = __webpack_require__("PmzT");
function injectStyle (ssrContext) {
  __webpack_require__("8WUw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303e0fb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "77+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users__ = __webpack_require__("J8BY");
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      var result = this.tableData.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data: function data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      tableColumns: [{
        prop: 'name',
        label: 'Name',
        minWidth: 200
      }, {
        prop: 'email',
        label: 'Email',
        minWidth: 250
      }, {
        prop: 'age',
        label: 'Age',
        minWidth: 100
      }, {
        prop: 'salary',
        label: 'Salary',
        minWidth: 120
      }],
      tableData: __WEBPACK_IMPORTED_MODULE_12__users__["a" /* default */]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your want to like ' + row.name);
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      var indexToDelete = this.tableData.findIndex(function (tableRow) {
        return tableRow.id === row.id;
      });
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  }
});

/***/ }),

/***/ "7K95":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fXD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.firstPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){_vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.lastPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7p7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8+e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_functions__ = __webpack_require__("p/MD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* mapFields */])(['email'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_11__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      user: {},
      myvariable: 4,
      modelValidations: {
        email: {
          required: true,
          email: true
        }
      },
      loading: false,
      model: {
        email: ''
      },
      loginMethod: 'email',
      recaptcha: {
        verifier: null,
        confirmationResult: null
      }
    };
  },

  methods: {
    init: function init() {
      this.setupRecaptcha();
    },
    setupRecaptcha: function setupRecaptcha() {
      var _this = this;

      this.recaptcha.verifier = new __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth.RecaptchaVerifier('submit-btn', {
        size: 'invisible',
        callback: function callback(response) {
          console.log('solved ' + response);
          _this.validateBeforeSubmit();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'There was a problem validating captcha',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }
      });

      this.recaptcha.verifier.render().then(function (widgetId) {
        window.recaptchaWidgetId = widgetId;
        if (_this.model.code !== '') {
          var elem = _this.$refs.btnSubmit;
          elem.click();
        }
      });
    },
    resetRecaptcha: function resetRecaptcha() {
      window.grecaptcha.reset();
    },
    activateLoading: function activateLoading() {
      this.loading = true;
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    signup: function signup() {
      if (this.loginMethod === 'phone') this.signupPhone();else this.signupEmail();
    },
    signupPhone: function signupPhone() {
      var _this2 = this;

      var recaptchaVerifier = this.recaptcha.verifier;

      __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signInWithPhoneNumber(this.model.mobilePhone, recaptchaVerifier).then(function (confirmationResult) {
        console.log('code sent, result:');
        console.log(confirmationResult);
        _this2.requestSmsCode(confirmationResult);
      }).catch(function (error) {
        console.log('error sending phone to firebase');
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
          title: 'Error',
          text: error.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
      });
    },
    requestSmsCode: function requestSmsCode(confirmationResult) {
      var _this3 = this;

      console.log('in requestSmsCode');
      console.log(confirmationResult);
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
        title: 'SMS Verification',
        text: 'Please provide the code sent to your mobile device:',
        type: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false,
        inputPlaceholder: 'Mobile Number'
      }).then(function (inputResult) {
        console.log(inputResult);
        confirmationResult.confirm(inputResult.value).then(function (result) {
          console.log(result);
          console.log(result.user);
          _this3.createAccount(result.user.uid);
        }).catch(function (error) {
          console.log(error);
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
            title: 'Error',
            text: error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        });
      });
    },
    signupEmail: function signupEmail() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var signingMethods, actionCodeSettings;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().fetchSignInMethodsForEmail(_this4.model.email);

              case 2:
                signingMethods = _context.sent;

                if (signingMethods.length > 0) {
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: 'An account with that email address already exists.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                  _this4.loading = false;
                  _this4.resetRecaptcha();
                } else {
                  actionCodeSettings = {
                    url: "http://localhost:8000" + '/finishSignup',

                    handleCodeInApp: true
                  };

                  __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().sendSignInLinkToEmail(_this4.model.email, actionCodeSettings).then(function () {
                    window.localStorage.setItem('emailForSignIn', _this4.model.email);
                    __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                      title: 'Success',
                      text: 'Please check your email and click the link to setup your account.',
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-success btn-fill',
                      type: 'success'
                    });
                  }).catch(function (error) {
                    console.log(error);
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    createAccount: function createAccount(userId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, setupAccount;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  data = {
                    uid: userId,
                    model: _this5.model
                  };
                  setupAccount = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.functions().httpsCallable('setupAccount');

                  setupAccount(data).then(function (result) {
                    if (result.data.success) _this5.$router.replace(_this5.$route.query.redirect || { name: 'Onboarding' });else {
                      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                        title: 'Error',
                        text: 'Sorry, the following error took place: ' + err.message,
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                      });
                      _this5.loading = false;
                      _this5.resetRecaptcha();
                    }
                  }).catch(function (err) {
                    console.error(err.message);
                  });
                } catch (err) {
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: 'Sorry, the following error took place: ' + err.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  }).then(function () {
                    _this5.loading = false;
                    _this5.resetRecaptcha();
                  });
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    signup2: function signup2() {
      var _this6 = this;

      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          title: 'Welcome!',
          text: 'Your account was successfully created! Le\'s get started.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(function () {
          _this6.login(_this6.model.email, _this6.model.password);
        }).catch(function (error) {
          console.log(error);
          _this6.login(_this6.model.email, _this6.model.password);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          title: 'Error',
          text: 'Sorry, the following error took place: ' + err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this6.loading = false;
          _this6.resetRecaptcha();
        });
      });
    },
    login: function login(email, password) {
      var _this7 = this;

      this.loading = true;
      console.log('email and password ' + email + ', ' + password);
      __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signInWithEmailAndPassword(email, password).then(function (cred) {
        _this7.user.email = cred.user.email;
        _this7.user.id = cred.user.uid;
        console.log('signed in now getting user record');
        return __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__["a" /* default */].collection('users').doc(cred.user.uid).get();
      }).then(function (doc) {
        _this7.user.name = doc.data().name;
        _this7.user.accountId = doc.data().accountId;
        return _this7.getClientIpData();
      }).then(function (response) {
        if (!response) return false;else return __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__["a" /* default */].collection('users').doc(_this7.user.id).update({ lastLoginIpData: response });
      }).then(function () {
        _this7.$router.replace({ name: 'Onboarding' });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          title: 'Error',
          text: err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this7.loading = false;
        _this7.resetRecaptcha();
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this8 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this8.signup();
        } else {
          _this8.loading = false;
          _this8.resetRecaptcha();
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "89QO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8S5e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8WUw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ZDc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9597":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("E0D1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad77aee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("v71F");
function injectStyle (ssrContext) {
  __webpack_require__("D/GA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad77aee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9NyI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-buttons"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'left')}}},[_vm._v("Top Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'center')}}},[_vm._v("Top Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'right')}}},[_vm._v("Top Right")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'left')}}},[_vm._v("Bottom Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'center')}}},[_vm._v("Bottom Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'right')}}},[_vm._v("Bottom Right")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Notifications")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Custom Vue notifications plugin")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notifications Style")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("This is a plain notification")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_vm._v("This is a notification with close button.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-bell",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-pie-chart",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon and have many lines.\n            You can see that the icon and the close button are always vertically aligned.\n            This is a beautiful notification. So you don't have to worry about the style.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notification states")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Info - ")]),_vm._v(" This is a regular notification made with \".alert-info\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Success - ")]),_vm._v(" This is a regular notification made with \".alert-success\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Warning - ")]),_vm._v(" This is a regular notification made with \".alert-warning\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Danger - ")]),_vm._v(" This is a regular notification made with \".alert-danger\"")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h5',[_vm._v("Notifications Places\n            "),_c('p',{staticClass:"category"},[_vm._v("Click to view notifications")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9bUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.confirmPassword),expression:"modelValidations.confirmPassword"},{name:"model",rawName:"v-model",value:(_vm.model.confirmPassword),expression:"model.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","name":"confirm"},domProps:{"value":(_vm.model.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirm.invalid),expression:"confirm.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('confirm'))+"\n        ")])]),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"}},[_vm._v("Submit")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("rP9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("KtLi");
function injectStyle (ssrContext) {
  __webpack_require__("ifSS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9l7r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-timeline card-plain"},[_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"timeline",class:{'timeline-simple': _vm.type === 'simple'}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A5XH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Thank you for registering!")]),_vm._v(" "),_c('h4',[_vm._v("Your submission is complete.")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"})])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2018 Authentic.net\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AuCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AwmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text logo-mini",attrs:{"href":"https://authentic.net"}},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('a',{staticClass:"simple-text logo-normal",attrs:{"href":"https://authentic.net"}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}))}))],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B3Sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOverview_vue__ = __webpack_require__("rpQU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f9a666_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOverview_vue__ = __webpack_require__("NoRs");
function injectStyle (ssrContext) {
  __webpack_require__("EUbZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f9a666_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BItS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BN54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('registrations-cards',{attrs:{"account-data":_vm.accountData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("yNZB");
function injectStyle (ssrContext) {
  __webpack_require__("V5Z/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BYD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row buttons-with-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p-pagination',{attrs:{"page-count":10},model:{value:(_vm.defaultPagination),callback:function ($$v) {_vm.defaultPagination=$$v},expression:"defaultPagination"}}),_vm._v(" "),_c('p-pagination',{attrs:{"type":"info","page-count":10},model:{value:(_vm.infoPagination),callback:function ($$v) {_vm.infoPagination=$$v},expression:"infoPagination"}})],1)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Colors")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-default btn-fill btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-fill btn-wd"},[_vm._v("Primary")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd"},[_vm._v("Info")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-wd"},[_vm._v("Success")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-wd"},[_vm._v("Warning")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd"},[_vm._v("Danger")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Styles")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-wd"},[_vm._v("Fill")]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-wd"},[_vm._v("Simple")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Buttons with Label and Animation")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v("\n                Success\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-times"})]),_vm._v("\n                Danger\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-info btn-fill btn-rotate",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-settings"})]),_vm._v("\n                Settings\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-warning btn-fill btn-magnify",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-search"})]),_vm._v("\n                Search\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-left",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v("\n                Back\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-right",attrs:{"type":"button"}},[_vm._v("\n                Next\n                "),_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sizes")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-lg btn-fill"},[_vm._v("Large")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-fill"},[_vm._v("Small")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-fill"},[_vm._v("X-Small")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Button Group")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Left")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Middle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Right")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagination")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Social buttons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Filled")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Simple")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bs4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('img',{attrs:{"src":"static/img/authentic_net_lt_color.png","width":"400","alt":"Authentic.net"}}),_vm._v(" "),_c('h4',[_vm._v("Register now to start protecting your products and customers!")]),_vm._v(" "),(_vm.stripe_plan_fetched)?_c('h5',[_vm._v(_vm._s(this.plan.name)+" - $"+_vm._s(this.plan.amount)+" a "+_vm._s(this.plan.interval))]):_vm._e(),_vm._v(" "),_c('hr')])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.businessName),expression:"model.businessName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.businessName),expression:"modelValidations.businessName"}],staticClass:"form-control",attrs:{"type":"text","name":"businessName","placeholder":"Business Name"},domProps:{"value":(_vm.model.businessName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "businessName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.businessName.invalid),expression:"businessName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('businessName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":"Name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('name'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password_confirmation),expression:"modelValidations.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","name":"password_confirmation","placeholder":"Password Confirmation"},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password_confirmation.invalid),expression:"password_confirmation.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password_confirmation'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('card',{staticClass:"stripe-card",class:{ complete: _vm.complete },attrs:{"stripe":_vm.stripePubKey,"options":_vm.stripeOptions},on:{"change":function($event){_vm.complete = $event.complete}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.coupon),expression:"model.coupon"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Coupon Code"},domProps:{"value":(_vm.model.coupon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "coupon", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._v("Sign Up!")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n                      Sign Up!\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Protect Your Customers!")]),_vm._v("\n                  Give your valued customers the tools they need to verify that the products they purchase are genuine.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-package"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Protect Your Brand & Products")]),_vm._v("\n                  Make it impossible for counterfeiters to pretend their products are authentic.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-info"},[_c('i',{staticClass:"ti-headphone"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Fantastic Support")]),_vm._v("\n                  We love our business customers are are here to help you grow!\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BxWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3H9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"account-data":_vm.accountData}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C85h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Views_Components_RegistrationsCards_vue__ = __webpack_require__("eseW");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RegistrationsCards: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Views_Components_RegistrationsCards_vue__["a" /* default */]
  },
  props: ['accountData']
});

/***/ }),

/***/ "CB7h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"First Name"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('firstName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"Last Name"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('lastName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address1),expression:"model.address1"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address1),expression:"modelValidations.address1"}],staticClass:"form-control",attrs:{"type":"text","name":"address1","placeholder":"Addres Line 1"},domProps:{"value":(_vm.model.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address1", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address1.invalid),expression:"address1.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address1'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address2),expression:"model.address2"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address2),expression:"modelValidations.address2"}],staticClass:"form-control",attrs:{"type":"text","name":"address2","placeholder":"Address Line 2"},domProps:{"value":(_vm.model.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address2", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address2.invalid),expression:"address2.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address2'))+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.city),expression:"model.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":"City"},domProps:{"value":(_vm.model.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "city", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('city'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.state),expression:"model.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.state),expression:"modelValidations.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":"State"},domProps:{"value":(_vm.model.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "state", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.invalid),expression:"state.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('state'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.zip),expression:"model.zip"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.zip),expression:"modelValidations.zip"}],staticClass:"form-control",attrs:{"type":"text","name":"zip","placeholder":"Postal Code"},domProps:{"value":(_vm.model.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "zip", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zip.invalid),expression:"zip.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('zip'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.country),expression:"model.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"form-control",attrs:{"type":"text","name":"country","placeholder":"Country"},domProps:{"value":(_vm.model.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "country", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.country.invalid),expression:"country.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('country'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._v("Submit!")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n                      Sign Up!\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Thank you for authenticating your product!")]),_vm._v(" "),_c('h4',[_vm._v("Please submit your registration.")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2018 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CRWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.task.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('div',{staticClass:"table-icons"},[_c('button',{staticClass:"btn btn-info btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Edit Task"},on:{"click":_vm.handleEditClick}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Remove"},on:{"click":_vm.handleDeleteClick}},[_c('i',{staticClass:"ti-close"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","value":"","data-toggle":"checkbox"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cp7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"Jane"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('firstName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"Doe"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('lastName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"you@domain.com"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.birthday),expression:"model.birthday"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.birthday),expression:"modelValidations.birthday"}],staticClass:"form-control",attrs:{"type":"date","name":"birthday","placeholder":"Birth Day"},domProps:{"value":(_vm.model.birthday)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "birthday", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.birthday.invalid),expression:"birthday.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('birthday'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address1),expression:"model.address1"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address1),expression:"modelValidations.address1"}],staticClass:"form-control",attrs:{"type":"text","name":"address1","placeholder":"123 Main St."},domProps:{"value":(_vm.model.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address1", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address1.invalid),expression:"address1.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address1'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address2),expression:"model.address2"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address2),expression:"modelValidations.address2"}],staticClass:"form-control",attrs:{"type":"text","name":"address2","placeholder":"Apt 2"},domProps:{"value":(_vm.model.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address2", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address2.invalid),expression:"address2.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address2'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.city),expression:"model.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":"Phoenix"},domProps:{"value":(_vm.model.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "city", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('city'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.state),expression:"model.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.state),expression:"modelValidations.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":"AZ"},domProps:{"value":(_vm.model.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "state", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.invalid),expression:"state.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('state'))+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Zip Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.zip),expression:"model.zip"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.zip),expression:"modelValidations.zip"}],staticClass:"form-control",attrs:{"type":"text","name":"zip","placeholder":"85040"},domProps:{"value":(_vm.model.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "zip", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zip.invalid),expression:"zip.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('zip'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.country),expression:"model.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"form-control required",attrs:{"type":"text","name":"country","placeholder":"US"},domProps:{"value":(_vm.model.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "country", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.country.invalid),expression:"country.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('country'))+"\n                      ")])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Which benefit(s) are you most interested in (you can choose more than one):")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.model.goals.healthyVagina),callback:function ($$v) {_vm.$set(_vm.model.goals, "healthyVagina", $$v)},expression:"model.goals.healthyVagina"}},[_vm._v("Maintain Vaginal Health")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.postpartumRecovery),callback:function ($$v) {_vm.$set(_vm.model.goals, "postpartumRecovery", $$v)},expression:"model.goals.postpartumRecovery"}},[_vm._v("Postpartum Recovery (even if years after the fact)")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.bladderLeakage),callback:function ($$v) {_vm.$set(_vm.model.goals, "bladderLeakage", $$v)},expression:"model.goals.bladderLeakage"}},[_vm._v("Treat/Prevent Leakage (urine, gas or fecal)")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.organProlapse),callback:function ($$v) {_vm.$set(_vm.model.goals, "organProlapse", $$v)},expression:"model.goals.organProlapse"}},[_vm._v("Treat/Prevent Pelvic Organ Prolapse")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.vaginalRejuvenation),callback:function ($$v) {_vm.$set(_vm.model.goals, "vaginalRejuvenation", $$v)},expression:"model.goals.vaginalRejuvenation"}},[_vm._v("Vaginal Rejuvenation")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.sexualHealth),callback:function ($$v) {_vm.$set(_vm.model.goals, "sexualHealth", $$v)},expression:"model.goals.sexualHealth"}},[_vm._v("Sexual Health")])],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('fieldset',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.model.optIn),callback:function ($$v) {_vm.$set(_vm.model, "optIn", $$v)},expression:"model.optIn"}},[_vm._v("Yes, I'd like to recieve more information about getting the most out of Kegelbell")])],1)])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._v("Submit & View Instruction Guides")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n                      Submit & View Instruction Guides\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":"https://cdn.shopify.com/s/files/1/2198/4059/files/524996_Logo_Tagline-Blue_0904191_300x300.png?v=1572905596","alt":"Kegelbell"}}),_vm._v(" "),_c('h2',[_vm._v("Thank you for your purchase!"),_c('br'),_c('small',[_vm._v("Welcome to the Kegelbell family")])]),_vm._v(" "),_c('h5',[_vm._v("We'd love to hear from you! Your feedback will help us further educate and inspire other women to start lifting where it counts.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D/GA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D5II":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__ = __webpack_require__("AbOu");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    QrcodeReader: __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__["QrcodeReader"]
  },
  methods: {
    onDecode: function onDecode(content) {
      console.log('on decode: ' + content);
      window.location = content;
    },
    onLocate: function onLocate(points) {
      console.log('on locate: ' + points);
    }
  }
});

/***/ }),

/***/ "DKYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_firebase_init__ = __webpack_require__("S85j");















__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["b" /* mapFields */])(['image', 'name'])),
  data: function data() {
    return {
      user: {
        email: '',
        token: ''
      },
      newProduct: {
        image: '',
        name: ''
      },
      loading: false,
      prodSlotsRemaining: 2,
      modelValidations: {
        image: {
          required: true,
          url: true
        },
        name: {
          required: true
        }
      },
      fraudReportsTable: []
    };
  },

  methods: {
    init: function init() {
      this.user = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getUser();
      console.log('got user from store');
      console.log(this.user);
      this.getFraudReports();
    },
    getFraudReports: function getFraudReports() {
      var _this = this;

      var ref = __WEBPACK_IMPORTED_MODULE_11__components_firebase_init__["a" /* default */].collection('accounts/' + this.user.accountId + '/fraudReports');

      ref.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          if (change.type === 'added') {
            var doc = change.doc;
            var fraudReport = doc.data();
            fraudReport.id = doc.id;
            __WEBPACK_IMPORTED_MODULE_11__components_firebase_init__["a" /* default */].collection('accounts/' + _this.user.accountId + '/products').doc(fraudReport.productId).get().then(function (doc) {
              var product = doc.data();
              product.id = doc.id;
              fraudReport.product = product;
              _this.fraudReportsTable.push(fraudReport);
            });
          }
        });
      });
    },
    pushProduct: function pushProduct() {
      var newProduct = {
        image: this.newProduct.image,
        title: this.newProduct.title,
        certified_qty: 0,
        validated_qty: 0,
        fruad_reports: 0
      };
      this.productsTable.unshift(newProduct);
      this.newProduct.image = '';
      this.newProduct.title = '';
      this.prodSlotsRemaining--;
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
        title: 'Added',
        text: newProduct.title,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'success'
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this2 = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this2.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "DfKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__ = __webpack_require__("+m/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__ = __webpack_require__("lS3b");
function injectStyle (ssrContext) {
  __webpack_require__("psw9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DjVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Duow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_functions__ = __webpack_require__("p/MD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");

















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email', 'address1', 'address2', 'city', 'state', 'zip', 'country'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_12__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      myvariable: 4,
      modelValidations: {
        firstName: {
          required: true
        },
        lastName: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        zip: {
          required: true
        },
        country: {
          required: true
        }
      },
      axios_config: {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'text'
      },
      stripe_plan_fetched: false,
      loading: false,
      step: 1,
      complete: false,
      stripe_customer_id: '',
      model: {
        firstName: '',
        lastName: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      },
      code: false,
      submitData: {}
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__["Card"] },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.submitData.code = _this.code;
                _context.next = 3;
                return _this.getClientIp();

              case 3:
                _this.submitData.clientIp = _context.sent;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    submit: function submit() {
      var _this2 = this;

      this.submitData.contactDetails = this.model;
      console.log(this.submitData);
      var registerAuthCode = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('registerAuthCode');
      registerAuthCode(this.submitData).then(function (result) {
        if (!result.data.success) {
          _this2.$router.replace('/authenticate?code=' + _this2.code);
        }
        console.log('result', result);
        var product = result.data.product;
        console.log('product', product);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Thank you!',
          text: 'Congratulations! You have successfully registered your product.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(function (result) {
          if (product.data.redirectUrl) location.replace(product.data.redirectUrl);else location.replace('https://www.trainingmask.com');
        }).catch(function (err) {
          console.log(err);
          if (product.data.redirectUrl) location.replace(product.data.redirectUrl);else location.replace('https://www.trainingmask.com');
        });
        _this2.loading = false;
      });
    },
    signup: function signup() {
      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
      }).catch(function (err) {
        console.error(err.message);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this3 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.submit();
        } else {
          _this3.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.params.code) this.code = this.$route.params.code;else if (this.$route.query.code) this.code = this.$route.query.code;
      if (!this.code) this.$router.replace('/authenticate');
      this.init();
    });
  }
});

/***/ }),

/***/ "Dwjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__ = __webpack_require__("Peng");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0576b2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__ = __webpack_require__("EQjs");
function injectStyle (ssrContext) {
  __webpack_require__("zmm5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0576b2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E0D1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        company: 'Paper Dashboard',
        username: 'michael23',
        email: '',
        lastName: 'Faker',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        postalCode: '',
        aboutMe: 'Oh so, your weak rhyme. You doubt I\'ll bother, reading into it.I\'ll probably won\'t, left to my own devicesBut that\'s the difference in our opinions.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));
    }
  }
});

/***/ }),

/***/ "E8iM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.showBanner)?_c('notice-banner',{attrs:{"routerLinkTo":_vm.banner.routerLinkTo,"htmlMessage":_vm.banner.message}}):_vm._e(),_vm._v(" "),_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.sidebarLinks}},[_c('user-menu'),_vm._v(" "),_c('form',{staticClass:"navbar-form navbar-left navbar-search-form navbar-search-form-mobile",attrs:{"role":"search"}},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":"Search..."}})])]),_vm._v(" "),_c('mobile-menu')],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[(_vm.initialized)?_c('top-navbar',{key:_vm.keys.topNav,attrs:{"account-data":_vm.accountData}}):_vm._e(),_vm._v(" "),(_vm.initialized)?_c('dashboard-content',{key:_vm.keys.content,attrs:{"account-data":_vm.accountData},on:{"refreshNav":function($event){_vm.refreshNav()}},nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}):_vm._e(),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EQjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Satellite Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map map-big",attrs:{"id":"satelliteMap"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Regular Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map",attrs:{"id":"regularMap"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Custom Skin & Settings Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map",attrs:{"id":"customSkinMap"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ETQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUbZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EZ2z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FG1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("lOEA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af12795_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("zD5V");
function injectStyle (ssrContext) {
  __webpack_require__("TA9i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af12795_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FJG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_Views_Components_AuthCodeBatchesTable_vue__ = __webpack_require__("4LKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Views_Components_AuthCodeBatchesCards_vue__ = __webpack_require__("wnqh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__eventBus__ = __webpack_require__("O6e2");




















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__["a" /* default */],
    AuthCodeBatchesTable: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_Views_Components_AuthCodeBatchesTable_vue__["a" /* default */],
    AuthCodeBatchesCards: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Views_Components_AuthCodeBatchesCards_vue__["a" /* default */]
  },
  props: ['accountData'],
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["b" /* mapFields */])(['lotNum', 'qty']), {
    monthlyMaxReached: function monthlyMaxReached() {
      if (!this.accountData.authDetails.account.data.lastBatchCreatedAt) return false;
      var lastBatchCreatedAt = this.accountData.authDetails.account.data.lastBatchCreatedAt.toDate();

      if (!__WEBPACK_IMPORTED_MODULE_15_moment___default()().isSame(lastBatchCreatedAt, 'year') || !__WEBPACK_IMPORTED_MODULE_15_moment___default()().isSame(lastBatchCreatedAt, 'month')) return false;
      var maxReached = this.accountData.authDetails.account.data.planUsageQtyCodesThisMonth >= this.accountData.authDetails.account.data.planConstraints.maxCodesPerMonth;
      return maxReached;
    },
    isInitialized: function isInitialized() {
      return this.initialized;
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_14__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      user: {},
      model: {
        qty: '',
        lotNum: '',
        accountId: '',
        productId: '',
        status: 'Requested',
        qtyCreated: 0,
        qtyValidated: 0,
        qtyFraudReports: 0
      },
      loading: true,
      initialized: false,
      modelValidations: {
        lotNum: {
          required: false
        },
        qty: {
          required: true,
          integer: true,
          min_value: 1,
          max_value: this.maxPerBatch()
        }
      },
      authCodeBatches: [],
      productSelect: {
        product_id: '',
        products: []
      },
      selectedProductId: '',
      product: {},
      brands: [],
      products: [],
      retailerSelect: {
        retailer_id: '',
        retailers: []
      },
      retailers: [],
      getAuthCodeBatchesInterval: 0,
      labelImgSrc: '',
      label: null,
      dymoPrinters: [],
      dymoPrinterName: '',
      dymoLabelSizes: ['30334'],
      dymoLabelSize: '30334',
      dymoLabelSizeMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      dymoLabelXml: '',
      pathDymoAuthLabel: '',
      pathDymoFbaLabel: '',
      addedBatches: 0,
      authBarcodeBaseUrl: "https://appdev.authentic.net/authenticate?code=",
      showComplete: false,
      openBatches: true
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dymoLabelSizeMap.set('30334', '30334 - 1.25"x2.25"');
                _context.next = 3;
                return _this.getCurrentUser();

              case 3:
                _this.user = _context.sent;

                _this.getRetailers();
                _this.loadExternalJs();
                setTimeout(_this.getDymoPrinters, 3000);
                _this.pathDymoFbaLabel = 'static/dymoLayouts/30334-fba-fnsku.xml';
                _this.getLabelXml('30334');
                _this.selectedProductId = _this.$route.params.productId;

                if (!_this.selectedProductId) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return _this.loadProduct();

              case 13:
                _context.next = 15;
                return _this.checkOpenBatches();

              case 15:
                _this.initialized = true;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadExternalJs: function loadExternalJs() {
      var dymoScript = document.createElement('script');
      dymoScript.setAttribute('src', './static/js/dymo.js');
      document.head.appendChild(dymoScript);
    },
    checkOpenBatches: function checkOpenBatches() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, openBatchesExist, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('checking open batches');
                data = {
                  brandId: _this2.accountData.activeBrand.id
                };
                openBatchesExist = __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.functions().httpsCallable('openBatchesExist');
                _context2.next = 5;
                return openBatchesExist(data);

              case 5:
                result = _context2.sent;

                console.log('result', result);
                _this2.openBatches = result.data;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    maxPerBatch: function maxPerBatch() {
      var max = this.accountData.authDetails.account.data.planConstraints.maxCodesPerMonth;
      if (!this.accountData.authDetails.account.data.lastBatchCreatedAt) return max;
      var lastBatchCreatedAt = this.accountData.authDetails.account.data.lastBatchCreatedAt.toDate();

      if (!__WEBPACK_IMPORTED_MODULE_15_moment___default()().isSame(lastBatchCreatedAt, 'year') || !__WEBPACK_IMPORTED_MODULE_15_moment___default()().isSame(lastBatchCreatedAt, 'month')) return max;
      var used = this.accountData.authDetails.account.data.planUsageQtyCodesThisMonth;
      var amount = max - used;
      amount = Math.max(amount, 0);
      amount = Math.min(amount, 1000);
      return amount;
    },
    loadProduct: function loadProduct() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var prodDoc;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + _this3.accountData.activeBrand.id + '/products').doc(_this3.selectedProductId).get();

              case 2:
                prodDoc = _context3.sent;

                _this3.product = {
                  id: prodDoc.id,
                  data: prodDoc.data()
                };
                _context3.next = 6;
                return _this3.prodImgUrl(prodDoc.id, prodDoc.data(), '140x140');

              case 6:
                _this3.product.data.image = _context3.sent;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getBrandsAndProductsAndBatches: function getBrandsAndProductsAndBatches() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands').where('accountId', '==', this.user.accountId).get().then(function (qs) {
        qs.forEach(function (doc) {
          var brand = doc.data();
          brand.id = doc.id;
          _this4.brands.push(brand);
          _this4.getBrandProducts(brand.id, brand.name);
        });
      });
    },
    getBrandProducts: function getBrandProducts(brandId, brandName) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + brandId + '/products').get().then(function (qs) {
        qs.forEach(function (doc) {
          var product = doc.data();
          product.id = doc.id;
          product.brandName = brandName;
          product.brandId = brandId;

          _this5.products.push(product);
        });
      });
    },
    getRetailers: function getRetailers() {
      var _this6 = this;

      var gloRef = __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('globalRetailers');
      gloRef.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          if (change.type === 'added') {
            var _doc = change.doc;
            var data = _doc.data();
            data.id = _doc.id;
            _this6.retailerSelect.retailers.push(data);
            _this6.retailerSelect.retailers = _this6.retailerSelect.retailers.sort();
            _this6.retailers[data.id] = data;
          }
        });
      });

      var ref = __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('accounts/' + this.user.accountId + '/retailers');
      ref.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          if (change.type === 'added') {
            var _doc2 = change.doc;
            var data = _doc2.data();
            data.id = _doc2.id;
            _this6.retailerSelect.retailers.push(data);
            _this6.retailerSelect.retailers = _this6.retailerSelect.retailers.sort();
            _this6.retailers[data.id] = data;
          }
        });
      });
    },
    getDymoPrinters: function getDymoPrinters() {
      var _this7 = this;

      this.loading = false;
      dymo.label.framework.getPrintersAsync().then(function (result) {
        console.log('Printers:');
        console.log(result);
        _this7.dymoPrinters = result;
        _this7.dymoPrinterName = result[0].name;
        console.log(_this7.dymoPrinterName);
      });
    },
    getLabelXml: function getLabelXml(dymoSizeCode) {
      if (this.user.accountId === 'D3zXQmPabbnZY5wEo8rV') {
        this.pathDymoAuthLabel = 'static/dymoLayouts/' + dymoSizeCode + '-kegelbell-3.xml';
      } else {
        this.pathDymoAuthLabel = 'static/dymoLayouts/' + dymoSizeCode + '.xml';
      }
    },
    getAuthCodeBatches: function getAuthCodeBatches() {
      var _this8 = this;

      this.openBatches = true;
      __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + this.accountData.activeBrand.id + '/authCodeBatches').orderBy('createdAt', 'desc').limit(5).onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          if (change.type === 'added') {
            var _doc3 = change.doc;
            var data = _doc3.data();
            data.id = _doc3.id;
            _this8.applyBatchProductInfo(data);
          }
          if (change.type === 'modified') {
            var _doc4 = change.doc;
            var _data = _doc4.data();
            _data.id = _doc4.id;
            var arr = [];
            for (var i in _this8.authCodeBatches) {
              if (_this8.authCodeBatches[i].id === _data.id) {
                var productName = _this8.authCodeBatches[i].productName;
                var productImageUrl = _this8.authCodeBatches[i].productImageUrl;
                _this8.authCodeBatches[i] = _data;
                _this8.authCodeBatches[i].productName = productName;
                _this8.authCodeBatches[i].productImageUrl = productImageUrl;
              }
              arr.push(_this8.authCodeBatches[i]);
            }
            _this8.authCodeBatches = arr;
          }
        });
      });
    },
    applyBatchProductInfo: function applyBatchProductInfo(batchObject) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + this.accountData.activeBrand.id + '/products').doc(batchObject.productId).get().then(function (doc) {
        if (doc.exists) {
          batchObject.productName = doc.data().name;
          batchObject.productImageUrl = doc.data().imageUrl;
          batchObject.amazonComFnsku = doc.data().amazonComFnsku;
          batchObject.loading = false;
          _this9.authCodeBatches.unshift(batchObject);
        } else {}
      });
    },
    friendlyDateTime: function friendlyDateTime(timestamp) {
      if (timestamp === undefined || timestamp === '') return 'Never';else return __WEBPACK_IMPORTED_MODULE_15_moment___default()(timestamp.seconds * 1000).format('LLL');
    },
    formatLastPrinted: function formatLastPrinted(timestamp) {
      if (timestamp === undefined || timestamp === '') return 'Never';else return __WEBPACK_IMPORTED_MODULE_15_moment___default()(timestamp.seconds * 1000).format('l');
    },
    getFbaLabelPrintQty: function getFbaLabelPrintQty(batchQty) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var qtyResult, printQty, isInt;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Quantity',
                  text: 'This batch consists of ' + batchQty + ' units, but you can change the quantity of Amazon FBA labels to print below:',
                  type: 'question',
                  input: 'text',
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false,
                  inputValue: batchQty
                });

              case 3:
                qtyResult = _context4.sent;

                if (!qtyResult.value) {
                  _context4.next = 16;
                  break;
                }

                printQty = batchQty;
                isInt = /^[0-9]+$/;

                if (!isInt.test(qtyResult.value)) {
                  _context4.next = 11;
                  break;
                }

                printQty = Number(qtyResult.value);

                if (!(printQty >= 1 && printQty <= 500)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt('return', printQty);

              case 11:
                _context4.next = 13;
                return __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Invalid Value',
                  text: 'Sorry, the value must be an integer between 1 and 500.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                });

              case 13:
                return _context4.abrupt('return', _this10.getFbaLabelPrintQty(batchQty));

              case 16:
                if (!(result.dismiss === Swal.DismissReason.cancel)) {
                  _context4.next = 18;
                  break;
                }

                return _context4.abrupt('return', false);

              case 18:
                _context4.next = 23;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4['catch'](0);

                _this10.showNotify('Print failed to to cancellation or error.', 'danger', 'Cancelled');

              case 23:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10, [[0, 20]]);
      }))();
    },
    printBatchFbaLabels: function printBatchFbaLabels(authCodeBatch) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var printQty, response, labelXml, productDoc, label, labelSet, labelParams, records, i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                authCodeBatch.loading = true;

                _context5.next = 3;
                return _this11.getFbaLabelPrintQty(authCodeBatch.qty);

              case 3:
                printQty = _context5.sent;

                if (printQty) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt('return', false);

              case 6:
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(_this11.pathDymoFbaLabel);

              case 8:
                response = _context5.sent;
                labelXml = response.data;
                _context5.next = 12;
                return __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + authCodeBatch.brandId + '/products').doc(authCodeBatch.productId).get();

              case 12:
                productDoc = _context5.sent;
                label = dymo.label.framework.openLabelXml(labelXml);
                labelSet = new dymo.label.framework.LabelSetBuilder();
                labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({ printQuality: dymo.label.framework.LabelWriterPrintQuality.Text });
                records = [];

                for (i = 0; i < printQty; i++) {
                  records[i] = labelSet.addRecord();
                  records[i].setText('BARCODE', productDoc.data().amazonComFnsku);
                  records[i].setText('TEXT_PRODUCT', productDoc.data().name);
                }

                _context5.next = 20;
                return label.printAsync(_this11.dymoPrinterName, labelParams, labelSet);

              case 20:
                authCodeBatch.loading = false;
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Print Job Submitted',
                  text: 'Apply these labels per Amazon\'s instructions.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                });

              case 22:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    confirmPrint: function confirmPrint(authCodeBatch) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
        title: 'Did this batch print correctly?',
        text: 'For security your raw Authentic.net codes for this batch will be removed from our system and printing this batch will be permanently disabled.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, disable printing!',
        buttonsStyling: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + _this12.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).update({ printConfirmed: true, status: 'Complete' }).then(function (result) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
            title: 'Confirmed!',
            text: 'Printing for this batch has been confirmed and your Authentic.net codes have been fully secured.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        });
      });
    },
    makeAuthCodes: function makeAuthCodes() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var prodDoc, product;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this13.model.accountId = _this13.user.accountId;
                _this13.model.productId = _this13.selectedProductId;
                _this13.model.status = 'Requested';
                _this13.model.qtyCreated = 0;
                _this13.model.createdAt = __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.firestore.FieldValue.serverTimestamp();
                if (_this13.retailerSelect.retailer_id !== '') {
                  _this13.model.retailerId = _this13.retailerSelect.retailer_id;
                } else {
                  _this13.model.retailerId = '';
                }
                _context6.next = 8;
                return __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + _this13.accountData.activeBrand.id + '/products').doc(_this13.selectedProductId).get();

              case 8:
                prodDoc = _context6.sent;
                product = prodDoc.data();

                product.id = prodDoc.id;
                _this13.model.brandId = product.brandId;
                console.log(_this13.model);
                __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + _this13.accountData.activeBrand.id + '/authCodeBatches').add(_this13.model).then(function (response) {
                  _this13.addedBatches++;
                  _this13.loading = false;
                  setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_16__eventBus__["a" /* EventBus */].$emit('reload-account-data-silent');
                  }, 1000);

                  _this13.openBatches = true;
                }).catch(function (err) {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: err,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                  _this13.loading = false;
                });

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this13);
      }))();
    },
    getLabelData: function getLabelData(authCodeDoc) {
      var data = {
        code: prettyV2Code('0002-' + authCodeDoc.data().code)
      };
      records[i] = labelSet.addRecord();
      records[i].setText('BARCODE', 'URL:https://scan.authentic.net/' + code);
      records[i].setText('TEXT_PRODUCT', doc.data().productName);
      records[i].setText('TEXT_CODE', code);
    },
    consoleLogAuthCodeBatch: function consoleLogAuthCodeBatch(authCodeBatch) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var userToken, data, getAccountAuthCodesByBatchId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log(authCodeBatch);
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.auth().currentUser.getIdToken();

              case 3:
                userToken = _context7.sent;
                data = {
                  userToken: userToken,
                  authCodeBatchId: authCodeBatch.id
                };
                getAccountAuthCodesByBatchId = __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.functions().httpsCallable('getAccountAuthCodesByBatchId');

                getAccountAuthCodesByBatchId(data).then(function (result) {
                  console.log(authCodeBatch);
                  console.log(result);
                }).catch(function (err) {
                  console.log(err);
                });

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this14);
      }))();
    },
    printAuthCodeBatch: function printAuthCodeBatch(authCodeBatch) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var userToken, data, getAccountAuthCodesByBatchId, _result, label, labelSet, labelParams, records, _i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, authCode, _code, printResult;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                authCodeBatch.status = 'Printing';
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('brands/' + _this15.accountData.activeBrand.id + '/authCodeBatches').doc(authCodeBatch.id).update({ status: 'Printed', printedAt: __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.firestore.FieldValue.serverTimestamp() });

              case 4:
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Print Job Submitting',
                  text: 'Allow at least 10 seconds for the Dymo to start printing. Be sure to print and use these labels 1 time only then close this batch. If you re-print then be sure to destroy any labels that were printed previously in order to avoid duplicates.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                });

                _context8.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.auth().currentUser.getIdToken();

              case 7:
                userToken = _context8.sent;
                data = {
                  userToken: userToken,
                  authCodeBatchId: authCodeBatch.id
                };
                getAccountAuthCodesByBatchId = __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.functions().httpsCallable('getAccountAuthCodesByBatchId');
                _context8.next = 12;
                return getAccountAuthCodesByBatchId(data);

              case 12:
                _result = _context8.sent;

                console.log(_result);
                label = dymo.label.framework.openLabelXml(_this15.dymoLabelXml);
                labelSet = new dymo.label.framework.LabelSetBuilder();
                labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({ printQuality: dymo.label.framework.LabelWriterPrintQuality.Text });
                records = [];
                _i = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context8.prev = 22;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_result.data.authCodes); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  authCode = _step.value;
                  _code = _this15.prettyV2Code(authCode.data.code);

                  records[_i] = labelSet.addRecord();
                  records[_i].setText('BARCODE', 'URL:' + _this15.authBarcodeBaseUrl + _code);
                  if (_this15.user.accountId !== 'ABHVeLLQ4zCxNUiqOfyG') {
                    records[_i].setText('TEXT_PRODUCT', authCodeBatch.productName);
                    records[_i].setText('TEXT_CODE', _code);
                  }

                  _i++;
                }
                _context8.next = 30;
                break;

              case 26:
                _context8.prev = 26;
                _context8.t0 = _context8['catch'](22);
                _didIteratorError = true;
                _iteratorError = _context8.t0;

              case 30:
                _context8.prev = 30;
                _context8.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 33:
                _context8.prev = 33;

                if (!_didIteratorError) {
                  _context8.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context8.finish(33);

              case 37:
                return _context8.finish(30);

              case 38:
                console.log(records);
                _context8.next = 41;
                return label.printAsync(_this15.dymoPrinterName, labelParams, labelSet);

              case 41:
                printResult = _context8.sent;
                _context8.next = 48;
                break;

              case 44:
                _context8.prev = 44;
                _context8.t1 = _context8['catch'](0);

                console.log(_context8.t1);
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Error',
                  text: 'An error took place while attempting to print. If all labels printed then the error can be ignored and the batch should be closed. If you must re-print then please destroy all labels already printed to avoid duplicates.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                });

              case 48:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this15, [[0, 44], [22, 26, 30, 38], [31,, 33, 37]]);
      }))();
    },
    printAuthCodeBatchBack: function printAuthCodeBatchBack(authCodeBatch) {
      var _this16 = this;

      authCodeBatch.status = 'Printing';
      __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('authCodes').where('authCodeBatchId', '==', authCodeBatch.id).get().then(function (snapshot) {
        var label = dymo.label.framework.openLabelXml(_this16.dymoLabelXml);
        var labelSet = new dymo.label.framework.LabelSetBuilder();
        var labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({ printQuality: dymo.label.framework.LabelWriterPrintQuality.Text });
        var records = [];
        var i = 0;
        snapshot.forEach(function (doc) {
          var code = _this16.prettyV2Code(doc.data().code);
          records[i] = labelSet.addRecord();
          records[i].setText('BARCODE', 'URL:' + _this16.authBarcodeBaseUrl + code);
          records[i].setText('TEXT_PRODUCT', authCodeBatch.productName);
          records[i].setText('TEXT_CODE', code);

          i++;
        });
        console.log(records);
        label.printAsync(_this16.dymoPrinterName, labelParams, labelSet).then(function (result) {
          __WEBPACK_IMPORTED_MODULE_13__components_firebase_init__["a" /* default */].collection('accounts/' + _this16.user.accountId + '/authCodeBatches').doc(authCodeBatch.id).update({ status: 'Printed', printedAt: __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.firestore.FieldValue.serverTimestamp() }).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
              title: 'Print Job Submitted',
              text: 'Be sure to use these labels 1 time only then Confirm Print. If you re-print then be sure to destroy any labels that were printed previously.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
            });
          });
        });
      });
    },
    downloadAuthCodeBatch: function downloadAuthCodeBatch(authCodeBatch) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var userToken, data, getAccountAuthCodesByBatchId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.auth().currentUser.getIdToken();

              case 2:
                userToken = _context9.sent;
                data = {
                  userToken: userToken,
                  authCodeBatchId: authCodeBatch.id
                };
                getAccountAuthCodesByBatchId = __WEBPACK_IMPORTED_MODULE_12_firebase___default.a.functions().httpsCallable('getAccountAuthCodesByBatchId');

                getAccountAuthCodesByBatchId(data).then(function (result) {
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.data.authCodes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var authCode = _step2.value;

                      console.log(authCode.data);
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this17);
      }))();
    },
    showPrintBtn: function showPrintBtn(authCodeBatch) {
      return !this.loading && (authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed');
    },
    showPrintBtnLoading: function showPrintBtnLoading(authCodeBatch) {
      return authCodeBatch.status === 'Requested' || authCodeBatch.status === 'Processing' || authCodeBatch.status === 'Printing' || this.loading && (authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed');
    },
    showPrintConfirmBtn: function showPrintConfirmBtn(authCodeBatch) {
      return !this.loading && authCodeBatch.status === 'Printed';
    },
    showPrintConfirmBtnLoading: function showPrintConfirmBtnLoading(authCodeBatch) {
      return this.loading && authCodeBatch.status === 'Printed';
    },
    makeQrcode: function makeQrcode() {
      this.code_value = this.proposed_code_value;
    },
    validateRequestCodes: function validateRequestCodes() {
      var _this18 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this18.makeAuthCodes();
        } else {
          _this18.loading = false;
        }
      });
    },
    requestCodes: function requestCodes() {
      var _this19 = this;

      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://amz.trainingmask.com/qr/' + this.model.qty, this.axios_config_2).then(function (response) {
        _this19.download_link = response.data.zip;
        _this19.requested = true;
        _this19.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    hasAmazonComFnsku: function hasAmazonComFnsku(authCodeBatch) {
      return !!authCodeBatch.amazonComFnsku;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this20 = this;

      this.init();
      __WEBPACK_IMPORTED_MODULE_16__eventBus__["a" /* EventBus */].$on('batch-closed', function () {
        _this20.checkOpenBatches();
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    clearInterval(this.getAuthCodeBatchesInterval);
    this.getAuthCodeBatchesInterval = 0;
    next();
  }
});

/***/ }),

/***/ "FKHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    authDetails: {
      type: Object,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* mapFields */])(['businessName', 'address', 'address2', 'city', 'state', 'postalCode', 'country'])),
  data: function data() {
    return {
      modelValidations: {
        businessName: {
          required: true
        },
        address: {
          required: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        postalCode: {
          required: true,
          numeric: true
        },
        country: {
          required: true
        }
      },
      loading: false
    };
  },

  methods: {
    updateBusiness: function updateBusiness() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__components_firebase_init__["a" /* default */].collection('accounts').doc(this.authDetails.account.id).update(this.authDetails.account.data).then(function () {
        _this.showNotify('Businesss information saved.', 'success', 'Success');
        _this.loading = false;
      }).catch(function (error) {
        _this.showNotify(error, 'danger', 'Failed');
        _this.loading = false;
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.updateBusiness();
        } else {
          _this2.loading = false;
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
});

/***/ }),

/***/ "FPsb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validations_vue__ = __webpack_require__("C85h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942aa63c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validations_vue__ = __webpack_require__("BN54");
function injectStyle (ssrContext) {
  __webpack_require__("mi5c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942aa63c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FQVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},_vm._l((_vm.details),function(info,index){return _c('div',{class:_vm.getClasses(index)},[_c('h5',[_vm._v(_vm._s(info.title)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(info.subTitle))])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"static/img/background.jpg","alt":"..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Chet Faker\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("@chetfaker")])])])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_vm._v("\n      \"I like the way you work it\n      "),_c('br'),_vm._v(" No diggity\n      "),_c('br'),_vm._v(" I wanna bag it up\"\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FfnH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Dashboard',
  icon: 'ti-home',
  path: '/admin/dashboard'
}, {
  name: 'My Brands',
  icon: 'ti-stamp',
  path: '/admin/brands'
}, {
  name: 'Retailers',
  icon: 'ti-agenda',
  path: '/admin/retailers'
}, {
  name: 'Products',
  icon: 'ti-package',
  path: '/admin/products'
}, {
  name: 'Label Creator',
  icon: 'ti-lock',
  path: '/admin/make-auth-codes'
}, {
  name: 'Registrations',
  icon: 'ti-shield',
  path: '/admin/validations'
}, {
  name: 'Account',
  icon: 'ti-user',
  path: '/admin/account'
}, {
  name: 'Log Out',
  icon: 'ti-power-off',
  path: '/login?logout=true'
}]);

/***/ }),

/***/ "FqSx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Onboarding_vue__ = __webpack_require__("XBX7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398e00b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Onboarding_vue__ = __webpack_require__("edqR");
function injectStyle (ssrContext) {
  __webpack_require__("wSR+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Onboarding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398e00b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Onboarding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G5bo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GD9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GX5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");






















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */],
    PProgress: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Progress_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_17__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData'],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* mapFields */])(['logoUrl', 'name']), {
    maxReached: function maxReached() {
      console.log('accountData', this.accountData);
      var reached = this.accountData.authDetails.account.data.planUsageQtyCustomRetailers >= this.accountData.authDetails.account.data.planConstraints.maxCustomRetailers;
      return reached;
    },
    retailerSlotsRemaining: function retailerSlotsRemaining() {
      var maxRetailers = this.accountData.authDetails.account.data.planConstraints.maxCustomRetailers;
      var qtyRetailers = this.accountData.authDetails.account.data.planUsageQtyCustomRetailers;
      var remaining = maxRetailers - qtyRetailers;
      remaining = Math.max(remaining, 0);
      console.log('accountData, maxRetailers, qtyRetailers, remaining', this.accountData, maxRetailers, qtyRetailers, remaining);
      return remaining;
    }
  }),
  data: function data() {
    return {
      user: {
        email: '',
        token: ''
      },
      retailerIdIndexMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
      newRetailer: {
        logoUrl: '',
        name: ''
      },
      imageFile: '',
      uploadProgress: 0,
      loading: false,
      modelValidations: {
        logoUrl: {
          required: true,
          url: true
        },
        name: {
          required: true,
          max: 30
        }
      },
      retailersTable: [],
      selects: {
        simple: '',
        multiple: 'ARS'
      },
      showingAmazon: false
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      this.getCurrentUser().then(function (result) {
        _this.user = result;
        console.log('got user from store');
        console.log(_this.user);
        _this.getRetailers();
      });
    },
    selectFile: function selectFile() {
      this.imageFile = this.$refs.imageFile.files[0];
      this.uploadFile();
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      this.loading = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage().ref();
      var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop();
      var uploadTask = storageRef.child('accounts/' + this.user.accountId + '/retailers/' + filename).put(this.imageFile);

      uploadTask.on(__WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this2.uploadProgress = progress;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage.TaskState.PAUSED:
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage.TaskState.RUNNING:
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
          title: 'Error Uploading Image',
          text: 'Please try a different image and contact support if the problem persists',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this2.loading = false;
        });
        switch (error.code) {
          case 'storage/unauthorized':
            break;

          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          _this2.newRetailer.logoUrl = downloadURL;
          _this2.loading = false;
        });
      });
    },
    getRetailers: function getRetailers() {
      var _this3 = this;

      this.showingAmazon = false;
      this.retailersTable = [];
      this.retailerIdIndexMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();

      var ref = __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('accounts/' + this.user.accountId + '/retailers');
      ref.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(change) {
            var doc, data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(change.type === 'added')) {
                      _context.next = 12;
                      break;
                    }

                    doc = change.doc;
                    _context.t0 = doc.id;
                    _context.t1 = doc.data().name;
                    _context.next = 6;
                    return _this3.retailerImgUrl(doc.id, doc.data(), '140x140');

                  case 6:
                    _context.t2 = _context.sent;
                    _context.t3 = _this3.$uuid.v4();
                    _context.t4 = doc.data().isPermanent;
                    data = {
                      id: _context.t0,
                      name: _context.t1,
                      logoUrl: _context.t2,
                      key: _context.t3,
                      isPermanent: _context.t4
                    };

                    _this3.retailersTable.push(data);
                    _this3.retailerIdIndexMap.set(doc.id, _this3.retailersTable.length - 1);

                  case 12:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    getGloAmazonRetailers: function getGloAmazonRetailers() {
      var _this4 = this;

      this.showingAmazon = true;
      this.retailersTable = [];
      this.retailerIdIndexMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();

      var gloRef = __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('globalRetailers');
      gloRef.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(change) {
            var doc, data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(change.type === 'added')) {
                      _context2.next = 11;
                      break;
                    }

                    doc = change.doc;
                    _context2.t0 = doc.id;
                    _context2.t1 = doc.data().name;
                    _context2.next = 6;
                    return _this4.retailerImgUrl(doc.id, doc.data(), '140x140');

                  case 6:
                    _context2.t2 = _context2.sent;
                    _context2.t3 = _this4.$uuid.v4();
                    data = {
                      id: _context2.t0,
                      name: _context2.t1,
                      logoUrl: _context2.t2,
                      key: _context2.t3,
                      isPermanent: true
                    };

                    _this4.retailersTable.push(data);
                    _this4.retailerIdIndexMap.set(doc.id, _this4.retailersTable.length - 1);

                  case 11:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this4);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    },
    addRetailer: function addRetailer() {
      var _this5 = this;

      var retailer = {
        name: this.newRetailer.name,
        logoUrl: this.newRetailer.logoUrl,
        isPermanent: false
      };
      __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('accounts/' + this.user.accountId + '/retailers').add(retailer).then(function (response) {
        _this5.loading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
          title: 'Error',
          text: err,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this5.loading = false;
      });
    },
    validateAddRetailer: function validateAddRetailer() {
      var _this6 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this6.addRetailer();
        } else {
          _this6.loading = false;
        }
      });
    },
    deleteRetailer: function deleteRetailer(retailer) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var retailerId, data, accountDeleteRetailer, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                retailerId = retailer.id;

                retailer.deleting = true;
                retailer.key = _this7.$uuid.v4();
                data = {};
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.auth().currentUser.getIdToken();

              case 7:
                data.userToken = _context3.sent;

                data.accountId = _this7.user.accountId;
                data.retailerId = retailerId;
                accountDeleteRetailer = __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.functions().httpsCallable('accountDeleteRetailer');
                _context3.next = 13;
                return accountDeleteRetailer(data);

              case 13:
                result = _context3.sent;

                retailer.deleting = false;
                retailer.key = _this7.$uuid.v4();
                _this7.showNotify('Retailer ' + retailer.name + ' deleted.', 'success', 'Success');
                _this7.retailersTable.splice(_this7.retailerIdIndexMap.get(retailerId), 1);
                _context3.next = 25;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](0);

                retailer.deleting = false;
                retailer.key = _this7.$uuid.v4();
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Error',
                  text: _context3.t0,
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                });

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 20]]);
      }))();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GdNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");


var VectorMap = function VectorMap() {
  return {
    component: __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "jrBO")),
    loading: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 200
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VectorMap: VectorMap
  }
});

/***/ }),

/***/ "H0v/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HApj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validate_vue__ = __webpack_require__("Qkzw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1009a6ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validate_vue__ = __webpack_require__("i5GK");
function injectStyle (ssrContext) {
  __webpack_require__("xXKw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1009a6ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HHnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0998b84a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("xHTj");
function injectStyle (ssrContext) {
  __webpack_require__("7K95")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0998b84a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hyh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('vue-tabs',{staticClass:"row",attrs:{"direction":"vertical","value":"Description"}},[_c('v-tab',{attrs:{"title":"Info"}},[_c('p',[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")]),_vm._v(" "),_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Description"}},[_c('p',[_vm._v("\n                The first thing you notice when you hold the phone is how great it feels in your hand. The cover glass curves down around the sides to meet the anodized aluminum enclosure in a remarkable, simplified design.")]),_vm._v(" "),_c('p',[_vm._v("\n                There are no distinct edges. No gaps. Just a smooth, seamless bond of metal and glass that feels like one continuous surface.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")]),_vm._v(" "),_c('p',[_vm._v("\n                Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Support"}},[_c('p',[_vm._v("\n                From the seamless transition of glass and metal to the streamlined profile, every detail was carefully considered to enhance your experience. So while its display is larger, the phone feels just right.")]),_vm._v("\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Extra"}},[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('vue-tabs',{staticClass:"card-content"},[_c('v-tab',{attrs:{"title":"Home"}},[_vm._v("\n            Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n          ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Profile"}},[_vm._v("Here is your profile.")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_vm._v("Here are your messages.")])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion on Plain Card")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Vertical tabs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Plain text tabs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IWrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcOH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  user: {
    email: '',
    token: ''
  },

  setUser: function setUser(user) {
    this.user = user;
    localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));
  },
  getUser: function getUser() {
    this.user = JSON.parse(localStorage.getItem('user'));
    return this.user;
  }
});

/***/ }),

/***/ "IsOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J0Sr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4xn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J8BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 2,
  'name': 'Mr. Enid Von PhD',
  'nickname': 'alias',
  'email': 'pollich.cecilia@example.com',
  'salary': '35978.00',
  'age': 26
}, {
  'id': 3,
  'name': 'Colton Koch',
  'nickname': 'id',
  'email': 'little.myrna@example.net',
  'salary': '26278.00',
  'age': 48
}, {
  'id': 4,
  'name': 'Gregory Vandervort',
  'nickname': 'vel',
  'email': 'dock47@example.org',
  'salary': '25537.00',
  'age': 27
}, {
  'id': 5,
  'name': 'Miss Rahsaan Heaney IV',
  'nickname': 'qui',
  'email': 'ugrady@example.org',
  'salary': '49003.00',
  'age': 21
}, {
  'id': 6,
  'name': 'Ms. Crystel Zemlak IV',
  'nickname': 'reiciendis',
  'email': 'amari.rau@example.com',
  'salary': '12383.00',
  'age': 48
}, {
  'id': 7,
  'name': 'Nona McDermott',
  'nickname': 'quaerat',
  'email': 'adrien.baumbach@example.org',
  'salary': '18512.00',
  'age': 31
}, {
  'id': 8,
  'name': 'Miss Genoveva Murazik V',
  'nickname': 'rerum',
  'email': 'ohettinger@example.net',
  'salary': '31209.00',
  'age': 28
}, {
  'id': 9,
  'name': 'Beulah Huels',
  'nickname': 'non',
  'email': 'stefan99@example.com',
  'salary': '36920.00',
  'age': 53
}, {
  'id': 10,
  'name': 'Zoe Klein',
  'nickname': 'ex',
  'email': 'ejacobson@example.org',
  'salary': '35616.00',
  'age': 27
}, {
  'id': 11,
  'name': 'Vickie Kiehn',
  'nickname': 'assumenda',
  'email': 'ayost@example.com',
  'salary': '30790.00',
  'age': 29
}, {
  'id': 12,
  'name': 'Elwyn Herzog',
  'nickname': 'praesentium',
  'email': 'ckassulke@example.net',
  'salary': '35785.00',
  'age': 27
}, {
  'id': 13,
  'name': 'Selena Hettinger',
  'nickname': 'et',
  'email': 'bashirian.hyman@example.net',
  'salary': '31836.00',
  'age': 35
}, {
  'id': 14,
  'name': 'Edwin Beier',
  'nickname': 'eos',
  'email': 'janis71@example.org',
  'salary': '11902.00',
  'age': 38
}, {
  'id': 15,
  'name': 'Lexi Braun MD',
  'nickname': 'autem',
  'email': 'dusty74@example.net',
  'salary': '11927.00',
  'age': 45
}, {
  'id': 16,
  'name': 'Jovany Spencer',
  'nickname': 'fugit',
  'email': 'gbogisich@example.org',
  'salary': '44686.00',
  'age': 43
}, {
  'id': 17,
  'name': 'Prof. Maci Anderson DVM',
  'nickname': 'dolorem',
  'email': 'btorp@example.com',
  'salary': '25055.00',
  'age': 29
}, {
  'id': 18,
  'name': 'Joel Kulas MD',
  'nickname': 'sed',
  'email': 'phoebe.sauer@example.org',
  'salary': '11650.00',
  'age': 24
}, {
  'id': 19,
  'name': 'Mr. Dawson Greenholt',
  'nickname': 'nostrum',
  'email': 'asawayn@example.org',
  'salary': '46962.00',
  'age': 53
}, {
  'id': 20,
  'name': 'Prof. Lloyd Green',
  'nickname': 'velit',
  'email': 'laila.hintz@example.org',
  'salary': '12928.00',
  'age': 46
}, {
  'id': 21,
  'name': 'Shayna Morar',
  'nickname': 'rerum',
  'email': 'wfay@example.org',
  'salary': '22638.00',
  'age': 26
}, {
  'id': 22,
  'name': 'Krista Schulist',
  'nickname': 'qui',
  'email': 'gregoria.jakubowski@example.com',
  'salary': '49345.00',
  'age': 42
}, {
  'id': 23,
  'name': 'Leone Lemke',
  'nickname': 'repellat',
  'email': 'ltorphy@example.com',
  'salary': '17560.00',
  'age': 42
}, {
  'id': 24,
  'name': 'Dr. Willie Kemmer II',
  'nickname': 'quasi',
  'email': 'ivy51@example.net',
  'salary': '35370.00',
  'age': 30
}, {
  'id': 25,
  'name': 'Deonte Lebsack',
  'nickname': 'nesciunt',
  'email': 'alisa83@example.net',
  'salary': '32725.00',
  'age': 24
}, {
  'id': 26,
  'name': 'Prof. Shayne Nader',
  'nickname': 'voluptas',
  'email': 'bosco.shaina@example.net',
  'salary': '9844.00',
  'age': 23
}, {
  'id': 27,
  'name': 'Prof. Kennith Kertzmann',
  'nickname': 'alias',
  'email': 'satterfield.jonathan@example.com',
  'salary': '41950.00',
  'age': 25
}, {
  'id': 28,
  'name': 'Miss Meagan O\'Keefe',
  'nickname': 'corporis',
  'email': 'tracy.barrows@example.com',
  'salary': '41803.00',
  'age': 50
}, {
  'id': 29,
  'name': 'Prof. Edward Pagac MD',
  'nickname': 'quia',
  'email': 'gerhard65@example.org',
  'salary': '22896.00',
  'age': 43
}, {
  'id': 30,
  'name': 'Samantha Weissnat',
  'nickname': 'est',
  'email': 'crystel66@example.net',
  'salary': '18805.00',
  'age': 43
}, {
  'id': 31,
  'name': 'Dr. Gilbert Ward',
  'nickname': 'dolorum',
  'email': 'sandrine06@example.net',
  'salary': '16644.00',
  'age': 32
}, {
  'id': 32,
  'name': 'Mike West',
  'nickname': 'laudantium',
  'email': 'jborer@example.net',
  'salary': '35728.00',
  'age': 42
}, {
  'id': 33,
  'name': 'Prof. Isabell Cruickshank I',
  'nickname': 'recusandae',
  'email': 'ondricka.lurline@example.org',
  'salary': '44574.00',
  'age': 35
}, {
  'id': 34,
  'name': 'Prof. Lonny Rath',
  'nickname': 'nihil',
  'email': 'rfeest@example.net',
  'salary': '19949.00',
  'age': 48
}, {
  'id': 35,
  'name': 'Santina Medhurst MD',
  'nickname': 'suscipit',
  'email': 'ila24@example.net',
  'salary': '36323.00',
  'age': 51
}, {
  'id': 36,
  'name': 'Jeff Lehner',
  'nickname': 'quo',
  'email': 'jarred77@example.com',
  'salary': '48462.00',
  'age': 42
}, {
  'id': 37,
  'name': 'Samanta Pfeffer',
  'nickname': 'officia',
  'email': 'fgoyette@example.net',
  'salary': '19601.00',
  'age': 42
}, {
  'id': 38,
  'name': 'Ofelia Torp',
  'nickname': 'a',
  'email': 'ericka44@example.net',
  'salary': '33149.00',
  'age': 35
}, {
  'id': 39,
  'name': 'Mrs. Margarete Raynor',
  'nickname': 'quia',
  'email': 'jlegros@example.net',
  'salary': '21951.00',
  'age': 40
}, {
  'id': 40,
  'name': 'Mr. Brant Howell V',
  'nickname': 'perspiciatis',
  'email': 'franecki.gerald@example.org',
  'salary': '41552.00',
  'age': 53
}, {
  'id': 41,
  'name': 'Reilly Ruecker DVM',
  'nickname': 'ad',
  'email': 'ldeckow@example.net',
  'salary': '22709.00',
  'age': 42
}, {
  'id': 42,
  'name': 'Zachery McDermott',
  'nickname': 'molestiae',
  'email': 'gladyce84@example.com',
  'salary': '32354.00',
  'age': 25
}, {
  'id': 43,
  'name': 'Heloise Kulas',
  'nickname': 'aut',
  'email': 'kessler.helen@example.net',
  'salary': '45086.00',
  'age': 54
}, {
  'id': 44,
  'name': 'Norma Dibbert',
  'nickname': 'amet',
  'email': 'eudora36@example.net',
  'salary': '15661.00',
  'age': 46
}, {
  'id': 45,
  'name': 'Immanuel Auer',
  'nickname': 'quia',
  'email': 'halvorson.theodora@example.org',
  'salary': '15862.00',
  'age': 39
}, {
  'id': 46,
  'name': 'Lamont Borer',
  'nickname': 'expedita',
  'email': 'trantow.neoma@example.com',
  'salary': '12544.00',
  'age': 25
}, {
  'id': 47,
  'name': 'Brooke Purdy',
  'nickname': 'cupiditate',
  'email': 'bhermiston@example.net',
  'salary': '14457.00',
  'age': 50
}, {
  'id': 48,
  'name': 'Dr. Leo Dach',
  'nickname': 'et',
  'email': 'camila.ward@example.com',
  'salary': '40278.00',
  'age': 49
}, {
  'id': 49,
  'name': 'Krystal Langosh',
  'nickname': 'voluptatum',
  'email': 'pacocha.yesenia@example.org',
  'salary': '9305.00',
  'age': 34
}, {
  'id': 50,
  'name': 'Florence Greenfelder',
  'nickname': 'odit',
  'email': 'kenyatta.oconnell@example.com',
  'salary': '36980.00',
  'age': 38
}]);

/***/ }),

/***/ "JElF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_KEY; });
var API_KEY = 'YOUR_KEY_HERE';

/***/ }),

/***/ "JhHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__ = __webpack_require__("3MeN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__ = __webpack_require__("i/rH");
function injectStyle (ssrContext) {
  __webpack_require__("sk1x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JtN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FraudReports_vue__ = __webpack_require__("DKYE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601709b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FraudReports_vue__ = __webpack_require__("tlj2");
function injectStyle (ssrContext) {
  __webpack_require__("reDM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FraudReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601709b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FraudReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KBTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("TFDq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfcb455a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("uTlS");
function injectStyle (ssrContext) {
  __webpack_require__("pImr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfcb455a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KDMO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Last step!")]),_vm._v(" "),_c('h4',[_vm._v("Provide your billing information and start getting video reviews!")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Company"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"url","placeholder":"Store URL"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password Confirmation"}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"}},[_vm._v("Submit")])])])])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2018 Authentic.net\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KGGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.confirmCode()}}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.username),expression:"model.username"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.username),expression:"modelValidations.username"}],staticClass:"form-control",attrs:{"type":"text","name":"username","placeholder":"Username"},domProps:{"value":(_vm.model.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "username", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.username.invalid),expression:"username.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('username'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.confirmation_code),expression:"model.confirmation_code"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.confirmation_code),expression:"modelValidations.confirmation_code"}],staticClass:"form-control",attrs:{"type":"text","name":"confirmation_code","placeholder":"Confirmation Code"},domProps:{"value":(_vm.model.confirmation_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "confirmation_code", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmation_code.invalid),expression:"confirmation_code.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('confirmation_code'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.confirmCode()}}},[_vm._v("Confirm!")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n                      Confirm!\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Authentic.net")]),_vm._v(" "),_c('h4',[_vm._v("Account Created! Please confirm your email address.")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-success"},[_c('i',{staticClass:"ti ti-check"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Check your email!")]),_vm._v("\n                  A confirmation code should have been sent. Please provide it here.\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2018 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KWr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarRoute_vue__ = __webpack_require__("atjs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f88b2c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarRoute_vue__ = __webpack_require__("bxZR");
function injectStyle (ssrContext) {
  __webpack_require__("J4xn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarRoute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f88b2c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarRoute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kakj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__ = __webpack_require__("77+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__ = __webpack_require__("3TKg");
function injectStyle (ssrContext) {
  __webpack_require__("VEgf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KmoX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("4N3m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ef3f44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("f90e");
function injectStyle (ssrContext) {
  __webpack_require__("LcFQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ef3f44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KtLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('user-card'),_vm._v(" "),_c('members-card')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('edit-profile-form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KyZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [{
        id: 1,
        name: 'Dakota Rice',
        salary: '$36.738',
        country: 'Niger',
        city: 'Oud-Turnhout'
      }, {
        id: 2,
        name: 'Minerva Hooper',
        salary: '$23,789',
        country: 'Curaçao',
        city: 'Sinaai-Waas'
      }, {
        id: 3,
        name: 'Sage Rodriguez',
        salary: '$56,142',
        country: 'Netherlands',
        city: 'Baileux'
      }, {
        id: 4,
        name: 'Philip Chaney',
        salary: '$38,735',
        country: 'Korea, South',
        city: 'Overland Park'
      }, {
        id: 5,
        name: 'Doris Greene',
        salary: '$63,542',
        country: 'Malawi',
        city: 'Feldkirchen in Kärnten'
      }]
    };
  },

  methods: {
    tableRowClassName: function tableRowClassName(row, index) {
      if (index === 0) {
        return 'success';
      } else if (index === 2) {
        return 'info';
      } else if (index === 4) {
        return 'danger';
      } else if (index === 6) {
        return 'warning';
      }
      return '';
    }
  }
});

/***/ }),

/***/ "LBds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scan_vue__ = __webpack_require__("D5II");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b5eb66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scan_vue__ = __webpack_require__("mYT3");
function injectStyle (ssrContext) {
  __webpack_require__("cofp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b5eb66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LQk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LRfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LcFQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LdiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Login")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Login Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M/tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"title"},[_vm._v("XS Grid\n      "),_c('small',[_vm._v("Always Horizontal")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("SM Grid\n      "),_c('small',[_vm._v("Collapsed at 768px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("MD Grid\n      "),_c('small',[_vm._v("Collapsed at 992px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("LG Grid\n      "),_c('small',[_vm._v("Collapsed at 1200px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Mixed Grid\n      "),_c('small',[_vm._v("Showing different sizes on different screens")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Offset Grid\n      "),_c('small',[_vm._v("Adding some space when needed")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-md-offset-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3 col-md-offset-6")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-1")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-2")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-6 col-md-offset-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Paragraphs")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M0iJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468c8a61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("v4Xz");
function injectStyle (ssrContext) {
  __webpack_require__("dXgL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468c8a61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9U0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.reviews),function(review){return _c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('review-card',{attrs:{"review-id":review.id}},[_c('div',{attrs:{"slot":"video-link-thumb"},slot:"video-link-thumb"},[_c('img',{staticStyle:{"display":"block","width":"150px","margin-left":"auto","margin-right":"auto"},attrs:{"src":review.thumbnailUrl,"alt":review.title}})]),_vm._v(" "),_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n          "+_vm._s(review.title)+"\n        ")])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MKF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbellAmazon_vue__ = __webpack_require__("Vmmp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218b3bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbellAmazon_vue__ = __webpack_require__("YBKZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbellAmazon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218b3bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbellAmazon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MR/0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MYWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.gotoInstructions()}}},[_vm._v("View Instruction Guides")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n                      View Instruction Guides\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":"https://cdn.shopify.com/s/files/1/2198/4059/files/524996_Logo_Tagline-Blue_0904191_300x300.png?v=1572905596","alt":"Kegelbell"}}),_vm._v(" "),_c('h2',[_vm._v("Thank you for your purchase!"),_c('br'),_c('small',[_vm._v("Welcome to the Kegelbell family")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e974ff42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("Zu/q");
function injectStyle (ssrContext) {
  __webpack_require__("Uwq9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e974ff42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Authentic.net'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'darkblue',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black', 'darkblue'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'info',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/auth_logo_small_2.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "Mi7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mmn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthAction_vue__ = __webpack_require__("acoA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_151148ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthAction_vue__ = __webpack_require__("zk0O");
function injectStyle (ssrContext) {
  __webpack_require__("cU0y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_151148ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__xkeshi_vue_qrcode__ = __webpack_require__("Ik4r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__xkeshi_vue_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__xkeshi_vue_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_gravatar__ = __webpack_require__("IBsQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_gravatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_gravatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sidebarLinks__ = __webpack_require__("FiZY");





























__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */].use(function (_ref) {
  var ErrorBag = _ref.ErrorBag;

  var first = ErrorBag.prototype.first;
  ErrorBag.prototype.first = function () {
    var msg = first.bind(this).apply(undefined, arguments);

    if (msg) {
      return msg.replace(/^The .+field/i, 'This field');
    }

    return msg;
  };
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_21__sidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_uuid__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('qrcode', __WEBPACK_IMPORTED_MODULE_15__xkeshi_vue_qrcode___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('v-gravatar', __WEBPACK_IMPORTED_MODULE_20_vue_gravatar___default.a);
__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_16__routes_routes__["a" /* default */],
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (rec) {
    return rec.meta.requiresAuth;
  })) {
    var user = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.auth().currentUser;
    if (user) {
      next();
    } else {
      next({ name: 'Login' });
    }
  } else {
    next();
  }
});

var app = null;

__WEBPACK_IMPORTED_MODULE_10_firebase___default.a.auth().onAuthStateChanged(function () {
  if (!app) {
    app = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
      el: '#app',
      render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_8__App_vue__["a" /* default */]);
      },
      router: router
    });
  }
});

/***/ }),

/***/ "NWP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),(false)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search records","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.initialized)?_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_c('el-table-column',{attrs:{"label":"Product"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.imageUrl,"width":"140","height":"140"}})]),_vm._v("\n              "+_vm._s(props.row.product.data.name)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"80","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.status))])]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Qty Requested"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.qty)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Qty Created"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.qtyCreated)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Requested"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.createdAtFriendly)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Printed"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.printedAtFriendly)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"buttons",attrs:{"label":"","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.showPrintBtn(props.row))?_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.printAuthCodeBatch(props.row)}}},[_vm._v("Print Auth Labels")]):_vm._e(),_vm._v(" "),(_vm.showPrintBtnLoading(props.row))?_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})]),_vm._v("\n                "+_vm._s(props.row.status)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.hasAmazonComFnsku(props.row))?_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.printBatchFbaLabels(props.row)}}},[_vm._v("Print FBA Labels")]):_vm._e(),_vm._v(" "),(_vm.showPrintConfirmBtn(props.row))?_c('button',{staticClass:"btn btn-fill btn-warning btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.confirmPrint(props.row)}}},[_vm._v("Confirm Print")]):_vm._e(),_vm._v(" "),(_vm.showPrintConfirmBtnLoading(props.row))?_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button","disabled":"disabled"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})]),_vm._v("\n                Confirm\n              ")]):_vm._e()]}}])})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Records Per Page")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NZzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__("8+e0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159f667a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__("nb01");
function injectStyle (ssrContext) {
  __webpack_require__("YYjv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159f667a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NmHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterPay_vue__ = __webpack_require__("QvUR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8951a7da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterPay_vue__ = __webpack_require__("KDMO");
function injectStyle (ssrContext) {
  __webpack_require__("e0s5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterPay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8951a7da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterPay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NmlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "NoRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.product.ready)?_c('prod-overview-stats',{attrs:{"product":_vm.product}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nrso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please give us more details about your platform.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Your Website")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.website),expression:"modelValidations.website"},{name:"model",rawName:"v-model",value:(_vm.model.website),expression:"model.website"}],staticClass:"form-control",attrs:{"type":"text","name":"website","url":"true","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "website", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.website.invalid),expression:"website.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('website'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Framework Type")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.framework),expression:"model.framework"}],staticClass:"form-control",attrs:{"type":"text","name":"framework","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.framework)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "framework", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Language\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.language),expression:"modelValidations.language"},{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"}],staticClass:"form-control",attrs:{"name":"language"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- language -")]),_vm._v(" "),_c('option',{attrs:{"value":"ms"}},[_vm._v("Bahasa Melayu")]),_vm._v(" "),_c('option',{attrs:{"value":"ca"}},[_vm._v("Català")]),_vm._v(" "),_c('option',{attrs:{"value":"da"}},[_vm._v("Dansk")]),_vm._v(" "),_c('option',{attrs:{"value":"de"}},[_vm._v("Deutsch")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")]),_vm._v(" "),_c('option',{attrs:{"value":"es"}},[_vm._v("Español")]),_vm._v(" "),_c('option',{attrs:{"value":"el"}},[_vm._v("Eλληνικά")]),_vm._v(" "),_c('option',{attrs:{"value":"fr"}},[_vm._v("Français")]),_vm._v(" "),_c('option',{attrs:{"value":"it"}},[_vm._v("Italiano")]),_vm._v(" "),_c('option',{attrs:{"value":"hu"}},[_vm._v("Magyar")]),_vm._v(" "),_c('option',{attrs:{"value":"nl"}},[_vm._v("Nederlands")]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v("Norsk")]),_vm._v(" "),_c('option',{attrs:{"value":"pl"}},[_vm._v("Polski")]),_vm._v(" "),_c('option',{attrs:{"value":"pt"}},[_vm._v("Português")]),_vm._v(" "),_c('option',{attrs:{"value":"fi"}},[_vm._v("Suomi")]),_vm._v(" "),_c('option',{attrs:{"value":"sv"}},[_vm._v("Svenska")]),_vm._v(" "),_c('option',{attrs:{"value":"tr"}},[_vm._v("Türkçe")]),_vm._v(" "),_c('option',{attrs:{"value":"is"}},[_vm._v("Íslenska")]),_vm._v(" "),_c('option',{attrs:{"value":"cs"}},[_vm._v("Čeština")]),_vm._v(" "),_c('option',{attrs:{"value":"ru"}},[_vm._v("Русский")]),_vm._v(" "),_c('option',{attrs:{"value":"th"}},[_vm._v("ภาษาไทย")]),_vm._v(" "),_c('option',{attrs:{"value":"zh"}},[_vm._v("中文 (简体)")]),_vm._v(" "),_c('option',{attrs:{"value":"zh-TW"}},[_vm._v("中文 (繁體)")]),_vm._v(" "),_c('option',{attrs:{"value":"ja"}},[_vm._v("日本語")]),_vm._v(" "),_c('option',{attrs:{"value":"ko"}},[_vm._v("한국어")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.language.invalid),expression:"language.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('language'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Bootstrap Version\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.bootstrapVersion),expression:"modelValidations.bootstrapVersion"},{name:"model",rawName:"v-model",value:(_vm.model.bootstrapVersion),expression:"model.bootstrapVersion"}],staticClass:"form-control",attrs:{"name":"cities"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bootstrapVersion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- version -")]),_vm._v(" "),_c('option',{attrs:{"value":"1.1"}},[_vm._v("Bootstrap 1.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("Bootstrap 2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("Bootstrap 3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("Bootstrap 4.0(alpha)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"text","name":"price","placeholder":"ex: 19.00"},domProps:{"value":(_vm.model.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NtsG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O6e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/***/ }),

/***/ "OH53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Code_vue__ = __webpack_require__("gPlW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7e657c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Code_vue__ = __webpack_require__("jGUO");
function injectStyle (ssrContext) {
  __webpack_require__("1EQp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Code_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7e657c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OWRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extended-forms"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Datetime Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select date and time","picker-options":_vm.pickerOptions1},model:{value:(_vm.dateTimePicker),callback:function ($$v) {_vm.dateTimePicker=$$v},expression:"dateTimePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Date Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Pick a day","picker-options":_vm.pickerOptions1},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Time Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '23:59'
              },"placeholder":"Select time"},model:{value:(_vm.timePicker),callback:function ($$v) {_vm.timePicker=$$v},expression:"timePicker"}})],1)])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Switches")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Default")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOn),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOn", $$v)},expression:"switches.defaultOn"}}),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOff),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOff", $$v)},expression:"switches.defaultOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Plain")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOn),callback:function ($$v) {_vm.$set(_vm.switches, "plainOn", $$v)},expression:"switches.plainOn"}}),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOff),callback:function ($$v) {_vm.$set(_vm.switches, "plainOff", $$v)},expression:"switches.plainOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("With Icons")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOn),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOn", $$v)},expression:"switches.withIconsOn"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOff),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOff", $$v)},expression:"switches.withIconsOff"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Checkboxes")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":false}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":true}},[_vm._v("Checked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":false}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":true}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"1"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"2"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is on")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tags")]),_vm._v(" "),_vm._l((_vm.tags.dynamicTags),function(tag){return _c('el-tag',{key:tag,attrs:{"type":"primary","closable":true,"close-transition":false},on:{"close":function($event){_vm.handleClose(tag)}}},[_vm._v("\n            "+_vm._s(tag)+"\n          ")])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tags.inputValue),expression:"tags.inputValue"}],ref:"saveTagInput",staticClass:"form-control input-new-tag",attrs:{"type":"text","placeholder":"Add new tag","size":"mini"},domProps:{"value":(_vm.tags.inputValue)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleInputConfirm($event)},"blur":_vm.handleInputConfirm,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tags, "inputValue", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Progress Bars")]),_vm._v(" "),_c('p-progress',{attrs:{"value":30}}),_vm._v(" "),_c('p-progress',{attrs:{"value":60,"type":"info"}}),_vm._v(" "),_c('p-progress',{attrs:{"values":[{type:'success', value:35},{type:'warning', value:20}, {type:'danger', value: 10}]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Sliders")]),_vm._v(" "),_c('el-slider',{staticClass:"slider-success",model:{value:(_vm.sliders.simple),callback:function ($$v) {_vm.$set(_vm.sliders, "simple", $$v)},expression:"sliders.simple"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-slider',{staticClass:"slider-info",attrs:{"max":100,"range":""},model:{value:(_vm.sliders.rangeSlider),callback:function ($$v) {_vm.$set(_vm.sliders, "rangeSlider", $$v)},expression:"sliders.rangeSlider"}})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Customisable Select")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-danger",attrs:{"size":"large","placeholder":"Single Select"},model:{value:(_vm.selects.simple),callback:function ($$v) {_vm.$set(_vm.selects, "simple", $$v)},expression:"selects.simple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-danger",attrs:{"value":option.value,"label":option.label}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-primary",attrs:{"multiple":"","size":"large","placeholder":"Multiple Select"},model:{value:(_vm.selects.multiple),callback:function ($$v) {_vm.$set(_vm.selects, "multiple", $$v)},expression:"selects.multiple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropdown")]),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropup")]),_vm._v(" "),_c('drop-down',{attrs:{"slide":"up"}},[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1)])])]),_vm._v(" "),_c('br'),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "OcV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")]),_vm._v(" "),_c('el-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.total > 6),expression:"pagination.total > 6"}],staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":_vm.perPageLabel(item),"value":item}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.total > 6),expression:"pagination.total > 6"}],staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.queriedData),function(batch){return _c('div',{key:_vm.getKey(batch),staticClass:"col-lg-4"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('h4',[_vm._v(_vm._s(_vm.batchStatus(batch)))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"prod-img-container"},[_c('img',{attrs:{"src":batch.imageUrl,"alt":"Image"}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('h5',[_vm._v(_vm._s(batch.product.data.name))])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"140px"}},[(batch.product.data.size)?_c('div',[_c('strong',[_vm._v("Size:")]),_vm._v(" "+_vm._s(batch.product.data.size)+"\n          ")]):_vm._e(),_vm._v(" "),(batch.product.data.color)?_c('div',[_c('strong',[_vm._v("Color:")]),_vm._v(" "+_vm._s(batch.product.data.color)+"\n          ")]):_vm._e(),_vm._v(" "),(batch.product.data.style)?_c('div',[_c('strong',[_vm._v("Style:")]),_vm._v(" "+_vm._s(batch.product.data.style)+"\n          ")]):_vm._e(),_vm._v(" "),(batch.product.data.sku)?_c('div',[_c('strong',[_vm._v("SKU:")]),_vm._v(" "+_vm._s(batch.product.data.sku)+"\n          ")]):_vm._e(),_vm._v(" "),(batch.product.data.upc)?_c('div',[_c('strong',[_vm._v("UPC:")]),_vm._v(" "+_vm._s(batch.product.data.upc)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.showPrintFbaBtn(batch))?_c('div',[_c('strong',[_vm._v("AMZ FBA FNSKU:")]),_vm._v(" "+_vm._s(batch.amzFnsku)+"\n          ")]):_vm._e(),_vm._v(" "),(batch.retailerName)?_c('div',[_c('strong',[_vm._v("Retailer:")]),_vm._v(" "+_vm._s(batch.retailerName)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('h6',[_vm._v("Submitted\n                "),_c('br'),_vm._v(" "),_c('div',{staticClass:"prod-detail-data"},[_vm._v(_vm._s(batch.createdAtFriendly))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h6',[_vm._v("Requested\n                "),_c('br'),_vm._v(" "),_c('div',{staticClass:"prod-detail-data"},[_vm._v(_vm._s(batch.qty))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h6',[_vm._v("Created\n                "),_c('br'),_vm._v(" "),_c('div',{staticClass:"prod-detail-data"},[_vm._v(_vm._s(batch.qtyCreated))])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[(_vm.showPrintBtn(batch))?_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.printAuthCodeBatch(batch)}}},[_vm._v("Print Auth Labels")]):_vm._e(),_vm._v(" "),(_vm.showPrintBtnLoading(batch))?_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(0,true),_vm._v("\n            "+_vm._s(batch.status)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.showPrintFbaBtn(batch))?_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.printBatchFbaLabels(batch)}}},[_vm._v("Print FBA Labels")]):_vm._e(),_vm._v(" "),(_vm.showPrintConfirmBtn(batch))?_c('button',{staticClass:"btn btn-fill btn-warning btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.confirmPrint(batch)}}},[_vm._v("Close")]):_vm._e(),_vm._v(" "),(_vm.showPrintConfirmBtnLoading(batch))?_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1,true),_vm._v("\n            Confirm\n          ")]):_vm._e()])])])})),_vm._v(" "),(false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),(false)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search records","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.initialized)?_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_c('el-table-column',{attrs:{"label":"Product"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.imageUrl,"width":"140","height":"140"}})]),_vm._v("\n                "+_vm._s(props.row.product.data.name)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"80","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.status))])]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Qty Requested"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.qty)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Qty Created"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.qtyCreated)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Requested"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.createdAtFriendly)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Printed"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.printedAtFriendly)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"buttons",attrs:{"label":"","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.showPrintBtn(props.row))?_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.printAuthCodeBatch(props.row)}}},[_vm._v("Print Auth Labels")]):_vm._e(),_vm._v(" "),(_vm.showPrintBtnLoading(props.row))?_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})]),_vm._v("\n                  "+_vm._s(props.row.status)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.showPrintFbaBtn(props.row))?_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.printBatchFbaLabels(props.row)}}},[_vm._v("Print FBA Labels")]):_vm._e(),_vm._v(" "),(_vm.showPrintConfirmBtn(props.row))?_c('button',{staticClass:"btn btn-fill btn-warning btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.confirmPrint(props.row)}}},[_vm._v("Confirm Print")]):_vm._e(),_vm._v(" "),(_vm.showPrintConfirmBtnLoading(props.row))?_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button","disabled":"disabled"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})]),_vm._v("\n                  Confirm\n                ")]):_vm._e()]}}])})],1):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.total > 6),expression:"pagination.total > 6"}],staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Records Per Page")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oepq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ohvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__ = __webpack_require__("AbOu");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },


  components: { QrcodeReader: __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__["QrcodeReader"] },

  methods: {
    onDecode: function onDecode(content) {
      console.log('on decode: ' + content);

      if (content.includes('scan.authentic.net')) {
        var x = content.split('/');
        var code = x[x.length - 1];
        console.log(code);
        this.$router.push({ name: 'Authenticate', params: { code: code } });
      } else if (content.includes('authentic.net')) {
        var _x = content.split('=');
        var _code = _x[_x.length - 1];
        console.log(_code);
        this.$router.push({ name: 'Authenticate', params: { code: _code } });
      }
    },
    onLocate: function onLocate(points) {}
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("+lQa");
function injectStyle (ssrContext) {
  __webpack_require__("AuCi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__ = __webpack_require__("pfXf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__ = __webpack_require__("r2+i");
function injectStyle (ssrContext) {
  __webpack_require__("eFVZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PExn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Days to Wait")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.email_content.invite_wait_period),expression:"business.email_content.invite_wait_period"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.email_content.invite_wait_period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.email_content, "invite_wait_period", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Days to wait after product purchase before sending review request email.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Coupon Code")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.email_content.coupon_code),expression:"business.email_content.coupon_code"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.email_content.coupon_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.email_content, "coupon_code", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Coupon Code as a thank you for leaving a review (please create in shopify).")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Discount Description")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.email_content.discount_text),expression:"business.email_content.discount_text"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.email_content.discount_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.email_content, "discount_text", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Description of discount provided by Coupon Code.")])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.persistBusiness()}}},[_vm._v("Save")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Email Template Variables")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Please update the details below to change your automatic email settings.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Peng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__API_KEY__ = __webpack_require__("JElF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps__);




__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_0__API_KEY__["a" /* API_KEY */];

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initSattelliteMap: function initSattelliteMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 3,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: window.google.maps.MapTypeId.SATELLITE
      };

      var map = new window.google.maps.Map(document.getElementById('satelliteMap'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Satellite Map!'
      });
      marker.setMap(map);
    },
    initRegularMap: function initRegularMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false };

      var map = new window.google.maps.Map(document.getElementById('regularMap'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Regular Map!'
      });

      marker.setMap(map);
    },
    initCustomSkinMap: function initCustomSkinMap(google) {
      var myLatlng = new google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 13,
        center: myLatlng,
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]
      };

      var map = new google.maps.Map(document.getElementById('customSkinMap'), mapOptions);

      var marker = new google.maps.Marker({
        position: myLatlng,
        title: 'Custom Skin & Settings Map!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.load(function (google) {
      _this.initSattelliteMap(google);
      _this.initRegularMap(google);
      _this.initCustomSkinMap(google);
    });
  }
});

/***/ }),

/***/ "Pfw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("bJ0t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("LdiV");
function injectStyle (ssrContext) {
  __webpack_require__("DjVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PhKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-4"},[(_vm.initialized)?_c('user-card',{attrs:{"auth-details":_vm.authDetails}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-8"},[(_vm.initialized)?_c('edit-company-form',{attrs:{"auth-details":_vm.authDetails}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-7"},[_c('plan-details',{attrs:{"auth-details":_vm.authDetails}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-5"},[_c('payment-method'),_vm._v(" "),(_vm.initialized)?_c('edit-mws-form',{attrs:{"auth-details":_vm.authDetails}}):_vm._e(),_vm._v(" "),(false)?_c('members-card'):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PmzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"content"},[_c('div',[_c('div',{staticStyle:{"padding-top":"20px"}},[_vm._t("video-link-thumb")],2)])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 20px 20px 20px","height":"200px"}},[_c('hr'),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd",on:{"click":function($event){_vm.confirmReviewRemove()}}},[_vm._v("Remove")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PuQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus__ = __webpack_require__("O6e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);












/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__["Card"] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData'],
  data: function data() {
    return {
      authDetails: {},
      plans: [{
        loading: false,
        id: 'plan_Gopi1jxLyMAsMT',
        name: 'Business Startup 500'
      }, {
        loading: false,
        id: 'plan_GopjSH0tAGisWr',
        name: 'Small Business 2000'
      }, {
        loading: false,
        id: 'plan_GoplaPMUji3NvW',
        name: 'Growing Professional 8000'
      }],
      loading: {
        all: true
      }
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getAuthDetails().then(function (authDetails) {
                  _this.authDetails = authDetails;
                  _this.loading.all = false;
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    isCurrentPlan: function isCurrentPlan(planIndex) {
      return this.plans[planIndex].id === this.authDetails.account.data.stripePlanId;
    },
    selectPlan: function selectPlan(planIndex) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.authDetails.account.data.status === 'active')) {
                  _context2.next = 6;
                  break;
                }

                console.log('currently active so changing plan', _this2.authDetails);
                _context2.next = 4;
                return _this2.changePlan(planIndex);

              case 4:
                _context2.next = 9;
                break;

              case 6:
                console.log('not active so applying new plan', _this2.authDetails);
                _context2.next = 9;
                return _this2.activatePlan(planIndex);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    activatePlan: function activatePlan(planIndex) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userToken, data, activatePlan;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.plans[planIndex].loading = true;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.getIdToken();

              case 3:
                userToken = _context3.sent;
                data = {
                  userToken: userToken,
                  stripePlanId: _this3.plans[planIndex].id,
                  planName: _this3.plans[planIndex].name
                };
                activatePlan = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.functions().httpsCallable('activatePlan');

                activatePlan(data).then(function (result) {
                  _this3.showNotify('Your plan was changed successfully.', 'success', 'Success');
                  _this3.init();
                  __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* EventBus */].$emit('auth-refreshed');
                  _this3.plans[planIndex].loading = false;
                  _this3.$router.replace({ name: 'Account' });
                }).catch(function (err) {
                  __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                    title: 'Error Changing Plan',
                    text: err.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                  _this3.plans[planIndex].loading = false;
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    changePlan: function changePlan(planIndex) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var userToken, data, changePlan;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.plans[planIndex].loading = true;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.getIdToken();

              case 3:
                userToken = _context4.sent;
                data = {
                  userToken: userToken,
                  stripePlanId: _this4.plans[planIndex].id,
                  planName: _this4.plans[planIndex].name
                };
                changePlan = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.functions().httpsCallable('changePlan');

                changePlan(data).then(function (result) {
                  _this4.showNotify('Your plan was changed successfully.', 'success', 'Success');
                  _this4.init();
                  __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* EventBus */].$emit('auth-refreshed');
                  _this4.plans[planIndex].loading = false;
                  _this4.$router.replace({ name: 'Account' });
                }).catch(function (err) {
                  __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                    title: 'Error Changing Plan',
                    text: err.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                  _this4.plans[planIndex].loading = false;
                });

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    confirmCancel: function confirmCancel() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Cancelling will leave your brand unprotected.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, I am sure!',
        buttonsStyling: false
      }).then(function () {
        _this5.cancel();
      });
    },
    cancel: function cancel() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var userToken, data, cancelPlan;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.getIdToken();

              case 2:
                userToken = _context5.sent;
                data = {
                  userToken: userToken
                };
                cancelPlan = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.functions().httpsCallable('cancelPlan');

                cancelPlan(data).then(function (result) {
                  _this6.showNotify('Your plan was cancelled successfully.', 'success', 'Success');
                  _this6.$router.replace({ name: 'Account' });
                }).catch(function (err) {
                  __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                    title: 'Error Cancelling Plan',
                    text: err.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                });

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    isActive: function isActive() {
      return !this.loading.all && this.authDetails.account.data.status === 'active';
    },
    showActivatePlanBtn: function showActivatePlanBtn(planIndex) {
      return !this.loading.all && !this.plans[planIndex].loading && (!this.isCurrentPlan(planIndex) || !this.isActive());
    },
    showCurrentPlanBtn: function showCurrentPlanBtn(planIndex) {
      return !this.loading.all && !this.plans[planIndex].loading && this.isCurrentPlan(planIndex) && this.isActive();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "PwBp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_vm._m(0),_vm._v(" "),_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":"https://cdn.shopify.com/s/files/1/2198/4059/files/524996_Logo_Tagline-Blue_0904191_300x300.png?v=1572905596","alt":"Kegelbell"}}),_vm._v(" "),_c('h5',[_vm._v("Your feedback is greatly appreciated and helps us support more women.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"0"}},[_c('p',[_vm._v("Should we send you free Kegelbell Shower Holder?")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10",staticStyle:{"margin":"0 auto","float":"none"}},[_c('p-checkbox',{model:{value:(_vm.model.sendShowerHolder),callback:function ($$v) {_vm.$set(_vm.model, "sendShowerHolder", $$v)},expression:"model.sendShowerHolder"}},[_vm._v("Yes!")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"First Name"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('firstName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"Last Name"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('lastName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.birthday),expression:"model.birthday"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.birthday),expression:"modelValidations.birthday"}],staticClass:"form-control",attrs:{"type":"date","name":"birthday","placeholder":"Birth Day"},domProps:{"value":(_vm.model.birthday)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "birthday", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.birthday.invalid),expression:"birthday.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('birthday'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address1),expression:"model.address1"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address1),expression:"modelValidations.address1"}],staticClass:"form-control",attrs:{"type":"text","name":"address1","placeholder":"Addres Line 1"},domProps:{"value":(_vm.model.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address1", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address1.invalid),expression:"address1.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address1'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address2),expression:"model.address2"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address2),expression:"modelValidations.address2"}],staticClass:"form-control",attrs:{"type":"text","name":"address2","placeholder":"Address Line 2"},domProps:{"value":(_vm.model.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address2", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address2.invalid),expression:"address2.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address2'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.city),expression:"model.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":"City"},domProps:{"value":(_vm.model.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "city", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('city'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.state),expression:"model.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.state),expression:"modelValidations.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":"State"},domProps:{"value":(_vm.model.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "state", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.invalid),expression:"state.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('state'))+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.zip),expression:"model.zip"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.zip),expression:"modelValidations.zip"}],staticClass:"form-control",attrs:{"type":"text","name":"zip","placeholder":"Postal Code"},domProps:{"value":(_vm.model.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "zip", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zip.invalid),expression:"zip.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('zip'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.country),expression:"model.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"form-control required",attrs:{"type":"text","name":"country","placeholder":"Country"},domProps:{"value":(_vm.model.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "country", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.country.invalid),expression:"country.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('country'))+"\n                      ")])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Which benefit(s) are you most interested in (can choose more than one)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.model.goals.healthyVagina),callback:function ($$v) {_vm.$set(_vm.model.goals, "healthyVagina", $$v)},expression:"model.goals.healthyVagina"}},[_vm._v("Maintain Vaginal Health")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.postpartumRecovery),callback:function ($$v) {_vm.$set(_vm.model.goals, "postpartumRecovery", $$v)},expression:"model.goals.postpartumRecovery"}},[_vm._v("Postpartum Recovery (even if years after the fact)")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.bladderLeakage),callback:function ($$v) {_vm.$set(_vm.model.goals, "bladderLeakage", $$v)},expression:"model.goals.bladderLeakage"}},[_vm._v("Treat/Prevent Leakage (urine or gas or fecal)")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.organProlapse),callback:function ($$v) {_vm.$set(_vm.model.goals, "organProlapse", $$v)},expression:"model.goals.organProlapse"}},[_vm._v("Treat/Prevent Pelvic Organ Prolapse")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.vaginalRejuvenation),callback:function ($$v) {_vm.$set(_vm.model.goals, "vaginalRejuvenation", $$v)},expression:"model.goals.vaginalRejuvenation"}},[_vm._v("Vaginal Rejuvenation")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.sexualHealth),callback:function ($$v) {_vm.$set(_vm.model.goals, "sexualHealth", $$v)},expression:"model.goals.sexualHealth"}},[_vm._v("Sexual Health")])],1)])]),_vm._v(" "),_c('fieldset',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("I accept email messages about getting the most out of Kegelbell")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.model.optIn),callback:function ($$v) {_vm.$set(_vm.model, "optIn", $$v)},expression:"model.optIn"}},[_vm._v("Yes")])],1)])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._v("Submit & View Instruction Guides")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n                      Submit & View Instruction Guides\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("Thank you for your purchase!"),_c('br'),_vm._v("Welcome to the Kegelbell family.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_vm._v("Complete the form below and we'll send you a"),_c('br'),_c('b',[_vm._v("FREE Kegelbell Shower Holder")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PzXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableData: [{
        name: 'Andrew Mike',
        job: 'Develop',
        salary: '€ 99,225',
        active: false
      }, {
        name: 'John Doe',
        job: 'Design',
        salary: '€ 89,241',
        active: false
      }, {
        name: 'Alex Mike',
        job: 'Design',
        salary: '€ 92,144',
        active: false
      }, {
        name: 'Mike Monday',
        job: 'Marketing',
        salary: '€ 49,990',
        active: true
      }, {
        name: 'Paul dickens',
        job: 'Communication',
        salary: '€ 69,201',
        active: true
      }],
      productsTable: [{
        image: 'static/img/tables/agenda.png',
        title: 'Notebook',
        subTitle: 'Most beautiful agenda for the office.',
        price: 49,
        quantity: 1
      }, {
        image: 'static/img/tables/stylus.jpg',
        title: 'Stylus',
        subTitle: 'Design is not just what it looks like and feels like. Design is how it works.',
        price: 499,
        quantity: 2
      }, {
        image: 'static/img/tables/evernote.png',
        title: 'Evernote iPad Stander',
        subTitle: 'A groundbreaking Retina display. All-flash architecture. Fourth-generation Intel processors.',
        price: 799,
        quantity: 1
      }]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    }
  }
});

/***/ }),

/***/ "Q7zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q8IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Qc+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_functions__ = __webpack_require__("p/MD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      myvariable: 4
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["Card"] },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "Qkzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__ = __webpack_require__("p5r1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__ = __webpack_require__("wMMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    FirstStep: __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__["a" /* default */],
    SecondStep: __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__["a" /* default */]
  },
  methods: {
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire('Good job!', 'You clicked the finish button!', 'success');
    }
  }
});

/***/ }),

/***/ "QvUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "R+zJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9880e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("AwmQ");
function injectStyle (ssrContext) {
  __webpack_require__("R+zJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9880e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R9Ki":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RM11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("S8VE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07338075_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("swfc");
function injectStyle (ssrContext) {
  __webpack_require__("XaJ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07338075_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RUAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vector-map')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RXFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "Rrpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email'])),
  data: function data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        email: ''
      },
      modelValidations: {
        firstName: {
          min: 5
        },
        lastName: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "S4Fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MakeAuthCodes_vue__ = __webpack_require__("FJG0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ce260a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MakeAuthCodes_vue__ = __webpack_require__("5Xkz");
function injectStyle (ssrContext) {
  __webpack_require__("uRwB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MakeAuthCodes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ce260a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MakeAuthCodes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S85j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__("881v");



var config = {
  apiKey: "AIzaSyBeAl7chiRvopwdse_2EGds_17_HQFHfbk",
  authDomain: "authentic-net-dev.firebaseapp.com",
  databaseURL: "https://authentic-net-dev.firebaseio.com",
  projectId: "authentic-net-dev",
  storageBucket: "authentic-net-dev.appspot.com",
  messagingSenderId: "142108495683",
  appId: "1:142108495683:web:3bb254e5769e8f5b"
};

var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* harmony default export */ __webpack_exports__["a"] = (firebaseApp.firestore());

/***/ }),

/***/ "S8VE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "SLHw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SMiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/scan"}},[_vm._v("\n              Scan Code\n            ")])],1),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.code),expression:"model.code"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.code),expression:"modelValidations.code"}],staticClass:"form-control",attrs:{"type":"text","name":"code","placeholder":"Authentic.net Code"},domProps:{"value":(_vm.model.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "code", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.code.invalid),expression:"code.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('code'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"btnSubmit",staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button","id":"validate-submit"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Submit")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(3),_vm._v("\n                      Sign Up!\n                    ")])])])])])])])]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/scan"}},[_vm._v("\n          Scan Code\n        ")])],1),_vm._v(" "),_vm._m(5)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn",attrs:{"href":"https://authentic.net"}},[_vm._v("\n              Home\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Authentic.net")]),_vm._v(" "),_c('h4',[_vm._v("Have a product with an Authentic.net code? Check your code below!")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-lock"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Check Your Product")]),_vm._v("\n                  Submit your Authentic.net Code to check the validity of your product.\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2018 Authentic.net\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://authentic.net"}},[_vm._v("Authentic.net Home")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SUPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__API_KEY__ = __webpack_require__("JElF");




__WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_1__API_KEY__["a" /* API_KEY */];

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initMap: function initMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false };

      var map = new window.google.maps.Map(document.getElementById('map'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Regular Map!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.load(function (google) {
      _this.initMap(google);
    });
  }
});

/***/ }),

/***/ "T0id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authenticate_vue__ = __webpack_require__("4d//");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c5603b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticate_vue__ = __webpack_require__("SMiw");
function injectStyle (ssrContext) {
  __webpack_require__("t1Jt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authenticate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c5603b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Pages_ForgotPassword_vue__ = __webpack_require__("hLIO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_ResetPassword_vue__ = __webpack_require__("v5BP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_AuthAction_vue__ = __webpack_require__("Mmn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_Signup_vue__ = __webpack_require__("NZzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Register_vue__ = __webpack_require__("sMOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Pages_Confirm_vue__ = __webpack_require__("cYn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Pages_RegisterPay_vue__ = __webpack_require__("NmHg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Dashboard_Reviews_vue__ = __webpack_require__("eSYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Dashboard_EmailTemplates_vue__ = __webpack_require__("mzQ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Dashboard_Profile_vue__ = __webpack_require__("KBTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Dashboard_Products_vue__ = __webpack_require__("+S4p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Dashboard_Product_vue__ = __webpack_require__("cSmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Account_Account_vue__ = __webpack_require__("tAA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Dashboard_Validations_vue__ = __webpack_require__("FPsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Dashboard_FraudReports_vue__ = __webpack_require__("JtN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Dashboard_Scan_vue__ = __webpack_require__("LBds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Pages_Scan_vue__ = __webpack_require__("iEkT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Pages_Authenticate_vue__ = __webpack_require__("T0id");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Dashboard_Code_vue__ = __webpack_require__("OH53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Dashboard_MakeAuthCodes_vue__ = __webpack_require__("S4Fe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Validate_Validate_vue__ = __webpack_require__("HApj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Pages_RegisterCode_vue__ = __webpack_require__("3/Fs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_FraudReport_FraudReport_vue__ = __webpack_require__("hpmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Dashboard_Retailers_vue__ = __webpack_require__("yV2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Dashboard_Brands_vue__ = __webpack_require__("zfVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Pages_RegisterKegelbell_vue__ = __webpack_require__("3FiG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Pages_RegisterKegelbellB8ta_vue__ = __webpack_require__("tfoj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Pages_RegisterKegelbellAmazon_vue__ = __webpack_require__("MKF2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Pages_RegisterKegelbellBasic_vue__ = __webpack_require__("fm3Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Dashboard_ProductOverview_vue__ = __webpack_require__("B3Sf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Onboarding_Onboarding_vue__ = __webpack_require__("FqSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Plans_Plans_vue__ = __webpack_require__("zNPX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_ChangePlan_ChangePlan_vue__ = __webpack_require__("YDSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Pages_RegisterCodeConfirmation_vue__ = __webpack_require__("/vUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Amazon_Amazon_vue__ = __webpack_require__("rU3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Dashboard_Stats_vue__ = __webpack_require__("+GID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Pages_UserProfile_vue__ = __webpack_require__("9gNx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_Pages_TimeLinePage_vue__ = __webpack_require__("4d5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_Pages_Lock_vue__ = __webpack_require__("duHq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Components_Buttons_vue__ = __webpack_require__("fP9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Components_GridSystem_vue__ = __webpack_require__("671N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Components_Panels_vue__ = __webpack_require__("i0bx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Components_SweetAlert_vue__ = __webpack_require__("ribu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_Components_Notifications_vue__ = __webpack_require__("+VxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_Components_Icons_vue__ = __webpack_require__("RM11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_Components_Typography_vue__ = __webpack_require__("f6/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_Forms_RegularForms_vue__ = __webpack_require__("PAWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_Forms_ExtendedForms_vue__ = __webpack_require__("5xQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_Forms_ValidationForms_vue__ = __webpack_require__("5Bu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Forms_Wizard_vue__ = __webpack_require__("eSiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_Tables_RegularTables_vue__ = __webpack_require__("yg6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_Tables_ExtendedTables_vue__ = __webpack_require__("jJHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_Tables_PaginatedTables_vue__ = __webpack_require__("Kakj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_Maps_GoogleMaps_vue__ = __webpack_require__("Dwjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_Maps_FullScreenMap_vue__ = __webpack_require__("mj6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_Maps_VectorMapsPage_vue__ = __webpack_require__("ZZNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_Calendar_CalendarRoute_vue__ = __webpack_require__("KWr6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_Charts_vue__ = __webpack_require__("uwQC");










































































var componentsMenu = {
  path: '/components',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/components/buttons',
  children: [{
    path: 'buttons',
    name: 'Buttons',
    component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Components_Buttons_vue__["a" /* default */]
  }, {
    path: 'grid-system',
    name: 'Grid System',
    component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Components_GridSystem_vue__["a" /* default */]
  }, {
    path: 'panels',
    name: 'Panels',
    component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Components_Panels_vue__["a" /* default */]
  }, {
    path: 'sweet-alert',
    name: 'Sweet Alert',
    component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Components_SweetAlert_vue__["a" /* default */]
  }, {
    path: 'notifications',
    name: 'Notifications',
    component: __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_Components_Notifications_vue__["a" /* default */]
  }, {
    path: 'icons',
    name: 'Icons',
    component: __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_Components_Icons_vue__["a" /* default */]
  }, {
    path: 'typography',
    name: 'Typography',
    component: __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_Components_Typography_vue__["a" /* default */]
  }]
};
var formsMenu = {
  path: '/forms',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/forms/regular',
  children: [{
    path: 'regular',
    name: 'Regular Forms',
    component: __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_Forms_RegularForms_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Forms',
    component: __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_Forms_ExtendedForms_vue__["a" /* default */]
  }, {
    path: 'validation',
    name: 'Validation Forms',
    component: __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_Forms_ValidationForms_vue__["a" /* default */]
  }, {
    path: 'wizard',
    name: 'Wizard',
    component: __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Forms_Wizard_vue__["a" /* default */]
  }]
};

var tablesMenu = {
  path: '/table-list',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/table-list/regular',
  children: [{
    path: 'regular',
    name: 'Regular Tables',
    component: __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_Tables_RegularTables_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Tables',
    component: __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_Tables_ExtendedTables_vue__["a" /* default */]
  }, {
    path: 'paginated',
    name: 'Paginated Tables',
    component: __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_Tables_PaginatedTables_vue__["a" /* default */]
  }]
};

var mapsMenu = {
  path: '/maps',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/maps/google',
  children: [{
    path: 'google',
    name: 'Google Maps',
    component: __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_Maps_GoogleMaps_vue__["a" /* default */]
  }, {
    path: 'full-screen',
    name: 'Full Screen Map',
    component: __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_Maps_FullScreenMap_vue__["a" /* default */]
  }, {
    path: 'vector-map',
    name: 'Vector Map',
    component: __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_Maps_VectorMapsPage_vue__["a" /* default */]
  }]
};

var pagesMenu = {
  path: '/pages',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/pages/user',
  children: [{
    path: 'user',
    name: 'User Page',
    component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Pages_UserProfile_vue__["a" /* default */]
  }, {
    path: 'timeline',
    name: 'Timeline Page',
    component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_Pages_TimeLinePage_vue__["a" /* default */]
  }]
};

var validatePage = {
  path: '/validate',
  name: 'Validate',
  component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Validate_Validate_vue__["a" /* default */]
};

var fraudReportPage = {
  path: '/fraud-report',
  name: 'FraudReport',
  component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_FraudReport_FraudReport_vue__["a" /* default */]
};

var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
};

var authActionPage = {
  path: '/auth/action',
  name: 'Auth Action',
  component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_AuthAction_vue__["a" /* default */]
};

var forgotPasswordPage = {
  path: '/forgot-password',
  name: 'Forgot Password',
  component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Pages_ForgotPassword_vue__["a" /* default */]
};

var resetPasswordPage = {
  path: '/reset-password/:oobCode',
  name: 'Reset Password',
  component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_ResetPassword_vue__["a" /* default */]
};

var scanPage = {
  path: '/scan',
  name: 'PubScan',
  component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Pages_Scan_vue__["a" /* default */]
};

var authenticate = {
  path: '/authenticate',
  name: 'Authenticate',
  component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Pages_Authenticate_vue__["a" /* default */]
};

var registerCode = {
  path: '/register-code',
  name: 'RegisterCode',
  component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Pages_RegisterCode_vue__["a" /* default */]
};

var registerCodeConfirmation = {
  path: '/register-code-confirmation',
  name: 'RegisterCodeConfirmation',
  component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Pages_RegisterCodeConfirmation_vue__["a" /* default */]
};

var registerKegelbell = {
  path: '/kegelbell',
  name: 'RegisterKegelbell',
  component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Pages_RegisterKegelbell_vue__["a" /* default */]
};

var registerKegelbellB8ta = {
  path: '/kegelbell-b8ta',
  name: 'RegisterKegelbellB8ta',
  component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Pages_RegisterKegelbellB8ta_vue__["a" /* default */]
};

var registerKegelbellAmazon = {
  path: '/kegelbell-amz',
  name: 'RegisterKegelbellAmazon',
  component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Pages_RegisterKegelbellAmazon_vue__["a" /* default */]
};

var registerKegelbellBasic = {
  path: '/kegelbell-basic',
  name: 'RegisterKegelbellBasic',
  component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Pages_RegisterKegelbellBasic_vue__["a" /* default */]
};

var signup = {
  path: '/signup',
  name: 'Sign Up',
  component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_Signup_vue__["a" /* default */]
};

var confirmPage = {
  path: '/confirm',
  name: 'Confirm',
  component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Pages_Confirm_vue__["a" /* default */]
};

var registerPayPage = {
  path: '/register-pay',
  name: 'Register Step 2',
  component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Pages_RegisterPay_vue__["a" /* default */]
};

var lockPage = {
  path: '/lock',
  name: 'Lock',
  component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_Pages_Lock_vue__["a" /* default */]
};

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/products',
  children: [{
    path: 'calendar',
    name: 'Calendar',
    component: __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_Calendar_CalendarRoute_vue__["a" /* default */]
  }, {
    path: 'charts',
    name: 'Charts',
    component: __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_Charts_vue__["a" /* default */]
  }]
}, componentsMenu, formsMenu, tablesMenu, mapsMenu, pagesMenu, validatePage, fraudReportPage, registerCode, registerCodeConfirmation, registerKegelbell, registerKegelbellB8ta, registerKegelbellAmazon, registerKegelbellBasic, scanPage, authenticate, loginPage, forgotPasswordPage, resetPasswordPage, authActionPage, signup, confirmPage, registerPayPage, lockPage, {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/dashboard',
  children: [{
    path: 'onboarding',
    name: 'Onboarding',
    component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Onboarding_Onboarding_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'plans',
    name: 'Plans',
    component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Plans_Plans_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'change-plan',
    name: 'Change Plan',
    component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_ChangePlan_ChangePlan_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Dashboard_Overview_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'product-dashboard/:id',
    name: 'Product Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Dashboard_ProductOverview_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Dashboard_Stats_vue__["a" /* default */]
  }, {
    path: 'reviews',
    name: 'Reviews',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Dashboard_Reviews_vue__["a" /* default */]
  }, {
    path: 'email-templates',
    name: 'Email Templates',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Dashboard_EmailTemplates_vue__["a" /* default */]
  }, {
    path: 'profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Dashboard_Profile_vue__["a" /* default */]
  }, {
    path: 'products',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Dashboard_Products_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'product/:productId',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Dashboard_Product_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Account_Account_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'amazon',
    name: 'Amazon',
    component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Amazon_Amazon_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'retailers',
    name: 'Retailers',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Dashboard_Retailers_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'brands',
    name: 'Brands',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Dashboard_Brands_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'validations',
    name: 'Registrations',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Dashboard_Validations_vue__["a" /* default */]
  }, {
    path: 'fraud-reports',
    name: 'Fraud Reports',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Dashboard_FraudReports_vue__["a" /* default */]
  }, {
    path: 'scan',
    name: 'Scan',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Dashboard_Scan_vue__["a" /* default */]
  }, {
    path: 'code',
    name: 'Code',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Dashboard_Code_vue__["a" /* default */]
  }, {
    path: 'make-auth-codes/:productId',
    name: 'Make Authentic.net Codes',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Dashboard_MakeAuthCodes_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'make-auth-codes',
    name: 'Make Authentic.net Codes',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Dashboard_MakeAuthCodes_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T254":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T3me":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01726fe1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("7fXD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01726fe1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TA9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TFDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loggedIn: false,
      axios_post_config: {
        headers: {
          'Content-Length': 0,
          'Content-Type': 'text/plain'
        },
        responseType: 'text'
      },
      business: {
        'business_name': '',
        'business_id': '',
        'email_content': {
          'invite_wait_period': '',
          'coupon_code': '',
          'discount_text': ''
        },
        'address': {
          'zipcode': '',
          'state': '',
          'city': '',
          'line2': '',
          'line1': ''
        },
        'other_url': '',
        'business_email': '',
        'business_url': '',
        'shopify_webhook_key': ''
      },
      loading: false
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, getIp, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$recaptcha('authenticate');

              case 2:
                token = _context.sent;
                getIp = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.functions().httpsCallable('getIp');
                _context.next = 6;
                return getIp({ token: token });

              case 6:
                result = _context.sent;

                console.log(result);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        _this2.$emit('on-submit', _this2.registerForm, isValid);
      });
    },

    fetchBusiness: function fetchBusiness(businessUrl) {
      this.$http.get('https://api.vyoo.io/v1/business/?url=' + businessUrl).then(function (response) {
        console.log(response.data);
        this.business = response.data;
      });
    },
    persistBusiness2: function persistBusiness2() {
      this.$http.post('https://api.vyoo.io/v1/business/', this.business).then(function (response) {
        console.log('Success!:', response.message);
        this.loading = false;
      }, function (response) {
        console.log('Error!:', response.data);
        this.loading = false;
      });
    },
    persistBusiness: function persistBusiness() {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://api.vyoo.io/v1/business/', this.business, this.axios_post_config).then(function (response) {
        console.log('saved successfully');
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          title: 'Saved',
          text: 'Your profile has been saved',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__eventBus__ = __webpack_require__("O6e2");
















var NoticeBanner = function NoticeBanner() {
  return {
    component: __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "n2/C"))
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_5__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */],
    NoticeBanner: NoticeBanner
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      userAuth: {},
      user: {},
      account: {},
      showBanner: false,
      trialDaysLeft: 0,
      banner: {
        routerLinkTo: '/admin/plans',
        message: ''
      },
      sidebarLinks: [],
      accountData: {
        authDetails: {},
        brands: [],
        activeBrand: false
      },
      initialized: false,
      keys: {
        topNav: this.$uuid.v4(),
        content: this.$uuid.v4()
      }
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var linksSetup, linksPendingPlan, activeUntil;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.initialized = false;
                _context.next = 3;
                return _this.refreshAccountData();

              case 3:
                _this.keys.topNav = _this.$uuid.v4();
                _this.keys.content = _this.$uuid.v4();
                _this.initialized = true;
                linksSetup = [{
                  name: 'Log Out',
                  icon: 'ti-power-off',
                  path: '/login?logout=true'
                }];
                linksPendingPlan = [{
                  name: 'Dashboard',
                  icon: 'ti-home',
                  path: '/admin/dashboard'
                }, {
                  name: 'Account',
                  icon: 'ti-user',
                  path: '/admin/account'
                }, {
                  name: 'Log Out',
                  icon: 'ti-power-off',
                  path: '/login?logout=true'
                }];

                _this.userAuth = _this.accountData.authDetails.userAuth;
                _this.user = _this.accountData.authDetails.user;
                _this.account = _this.accountData.authDetails.account;
                console.log('dboard got account');
                console.log(_this.account);
                console.log('phone num');
                console.log(_this.userAuth.phoneNumber);
                if (!_this.userAuth.phoneNumber || _this.account.data.status === 'setup') {
                  _this.sidebarLinks = linksSetup;
                  _this.showBanner = false;
                } else if (_this.userAuth.phoneNumber && _this.account.data.status === 'pending-plan') {
                  _this.sidebarLinks = linksPendingPlan;
                  _this.banner.routerLinkTo = '/admin/plans';
                  _this.banner.message = '<i>Please choose a plan and add a credit card to activate your 30 day trial.</i>';
                  _this.showBanner = true;
                } else if (_this.userAuth.phoneNumber && _this.account.data.status === 'active-until') {
                  activeUntil = __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.account.data.activeUntil.seconds * 1000).format('l');

                  _this.sidebarLinks = _this.$sidebar.sidebarLinks;
                  _this.banner.routerLinkTo = '/admin/change-plan';
                  _this.banner.message = '<i>Your account is active until ' + activeUntil + '.</i>';
                  _this.showBanner = true;
                } else {
                  _this.sidebarLinks = _this.$sidebar.sidebarLinks;
                  _this.showBanner = false;
                }

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    listenAccountUpdates: function listenAccountUpdates(accountId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_10__components_firebase_init__["a" /* default */].collection('accounts').doc(accountId).onSnapshot(function (doc) {
                  var account = {
                    id: doc.id,
                    data: doc.data()
                  };
                  _this2.accountData.authDetails.account = account;
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    refreshAccountData: function refreshAccountData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, qs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = {};
                _context3.next = 3;
                return _this3.getAuthDetails();

              case 3:
                data.authDetails = _context3.sent;

                data.brands = [];
                data.activeBrand = false;
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_10__components_firebase_init__["a" /* default */].collection('brands').where('accountId', '==', data.authDetails.account.id).orderBy('name').get();

              case 8:
                qs = _context3.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 12;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  doc = _step.value;

                  data.brands.push({
                    id: doc.id,
                    data: doc.data()
                  });
                  if (data.activeBrand === false || data.authDetails.user.data.activeBrandId === doc.id) {
                    data.activeBrand = {
                      id: doc.id,
                      data: doc.data()
                    };
                  }
                }
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context3.prev = 23;

                if (!_didIteratorError) {
                  _context3.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context3.finish(23);

              case 27:
                return _context3.finish(20);

              case 28:
                _this3.accountData = data;
                console.log('accountData', _this3.accountData);
                _this3.listenAccountUpdates(_this3.accountData.authDetails.account.id);
                console.log('refreshed account data', _this3.accountData);

              case 32:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[12, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    refreshNav: function refreshNav() {
      alert('refreshing nav');
      this.init();
    },
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this4 = this;

      this.init();
      __WEBPACK_IMPORTED_MODULE_12__eventBus__["a" /* EventBus */].$on('auth-refreshed', function () {
        _this4.init();
      });
      __WEBPACK_IMPORTED_MODULE_12__eventBus__["a" /* EventBus */].$on('reload-account-data-silent', function () {
        _this4.refreshAccountData();
      });
    });
  }
});

/***/ }),

/***/ "U6TR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__ = __webpack_require__("5NHr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__ = __webpack_require__("fYtj");
function injectStyle (ssrContext) {
  __webpack_require__("pZL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UQPL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UTB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ummw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{ref:"plans",staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card plan-card not-featured-plan"},[_vm._m(1),_vm._v(" "),(!_vm.plans[0].loading)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.selectPlan(0)}}},[_vm._v("Activate plan")]):_vm._e(),_vm._v(" "),(_vm.plans[0].loading)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n          Activate plan\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-cc-required"},[_vm._v("No credit card required")]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card plan-card featured-plan"},[_vm._m(4),_vm._v(" "),(!_vm.plans[1].loading)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.selectPlan(1)}}},[_vm._v("Activate plan")]):_vm._e(),_vm._v(" "),(_vm.plans[1].loading)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(5),_vm._v("\n          Activate plan\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-cc-required"},[_vm._v("No credit card required")]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card plan-card not-featured-plan"},[_vm._m(7),_vm._v(" "),(!_vm.plans[2].loading)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.selectPlan(2)}}},[_vm._v("Activate plan")]):_vm._e(),_vm._v(" "),(_vm.plans[2].loading)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(8),_vm._v("\n          Activate plan\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-cc-required"},[_vm._v("No credit card required")]),_vm._v(" "),_vm._m(9)])])]),_vm._v(" "),_c('div',{ref:"planPayment",staticClass:"row"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.plan_id),expression:"model.plan_id"}],attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.submit()}}},[_c('div',{staticClass:"card",staticStyle:{"padding":"20px","text-align":"center"}},[_c('h3',[_vm._v("Selected Plan")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.plan.name))]),_vm._v(" "),_c('h6',[_vm._v("$"+_vm._s(_vm.plan.amount)+" per "+_vm._s(_vm.plan.interval)+" - starting "+_vm._s(_vm.plan.startDate))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('card',{staticClass:"stripe-card",class:_vm.stripeSettings.class,style:(_vm.stripeSettings.style),attrs:{"stripe":_vm.stripeSettings.pubKey,"options":_vm.stripeSettings.options},on:{"change":function($event){_vm.complete = $event.complete}}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.coupon),expression:"model.coupon"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Coupon Code"},domProps:{"value":(_vm.model.coupon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "coupon", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading.paymentSubmission)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.submit()}}},[_vm._v("Sign Up!")]):_vm._e(),_vm._v(" "),(_vm.loading.paymentSubmission)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(10),_vm._v("\n            Sign Up!\n          ")]):_vm._e()])])])]),_vm._v(" "),_vm._m(11)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"plan-header-container"}},[_c('h1',[_vm._v("Activate your Authentic.net account")]),_vm._v(" "),_c('p',[_vm._v("The best solution for protecting your brand and gaining trust from your customers, built to scale. Upgrade as you grow or cancel anytime.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Business Startup 500")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("$49.99 PER MONTH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"plan-desc"},[_c('h6',[_vm._v("Business startup essentials")])]),_vm._v(" "),_c('h6',{staticClass:"plan-inc"},[_vm._v("Includes:")]),_vm._v(" "),_c('ul',[_c('li',[_c('div',[_vm._v("Protect products with 500 Authentic labels per month")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Dashboard")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Amazon.com + 1 additional Retailer / Sales Channel")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("1 User")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("1 Brand")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Dymo Printer Integration")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("FBA / Marketplace label printing")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Unlimited Products / Variations")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Ideal for Small Business Startups")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"card-title"},[_vm._v("Small Business 2000")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("$89.99 PER MONTH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"plan-desc"},[_c('h6',[_vm._v("Flexibility for growth")])]),_vm._v(" "),_c('h6',{staticClass:"plan-inc"},[_vm._v("Includes:")]),_vm._v(" "),_c('ul',[_c('li',[_c('div',[_vm._v("Protect products with 2000 Authentic labels per month (1000 per brand)")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Dashboard")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("All Amazon + 2 additional Retailers / Sales Channels")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("2 Users")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("2 Brands")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Dymo Printer Integration")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("FBA / Marketplace label printing")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Unlimited Products / Variations")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Enhanced security & encryption")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Perfect for the growing Small Business")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Growing Professional 8000")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("$199 PER MONTH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"plan-desc"},[_c('h6',[_vm._v("Stability at scale")])]),_vm._v(" "),_c('h6',{staticClass:"plan-inc"},[_vm._v("Includes:")]),_vm._v(" "),_c('ul',[_c('li',[_c('div',[_vm._v("Protect products with 8000 Authentic labels per month (2000 per brand)")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Dashboard")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("All Amazon + 4 additional Retailers / Sales Channels")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("4 Users")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("4 Brands")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Dymo Printer Integration")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("FBA / Marketplace label printing")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Unlimited Products / Variations")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Enhanced security & encryption")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Branded Landing Page")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Registration Warranty Page")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Perfect for the growing Small Business")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row plans-footer"},[_c('p',[_vm._v("Contact us for entrprise level plans and pricing for customized add-ons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uwq9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V+Sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("wJKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__ = __webpack_require__("orbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__("BxWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__ = __webpack_require__("g2bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");



















var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PProgress', __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      enabledRadio: '2',
      disabledRadio: '2',
      switches: {
        defaultOn: true,
        defaultOff: false,
        plainOn: true,
        plainOff: false,
        withIconsOn: true,
        withIconsOff: false
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 50]
      },
      selects: {
        simple: '',
        countries: [{ value: 'Bahasa Indonesia', label: 'Bahasa Indonesia' }, { value: 'Bahasa Melayu', label: 'Bahasa Melayu' }, { value: 'Català', label: 'Català' }, { value: 'Dansk', label: 'Dansk' }, { value: 'Deutsch', label: 'Deutsch' }, { value: 'English', label: 'English' }, { value: 'Español', label: 'Español' }, { value: 'Eλληνικά', label: 'Eλληνικά' }, { value: 'Français', label: 'Français' }, { value: 'Italiano', label: 'Italiano' }, { value: 'Magyar', label: 'Magyar' }, { value: 'Nederlands', label: 'Nederlands' }, { value: 'Norsk', label: 'Norsk' }, { value: 'Polski', label: 'Polski' }, { value: 'Português', label: 'Português' }, { value: 'Suomi', label: 'Suomi' }, { value: 'Svenska', label: 'Svenska' }, { value: 'Türkçe', label: 'Türkçe' }, { value: 'Íslenska', label: 'Íslenska' }, { value: 'Čeština', label: 'Čeština' }, { value: 'Русский', label: 'Русский' }, { value: 'ภาษาไทย', label: 'ภาษาไทย' }, { value: '中文 (简体)', label: '中文 (简体)' }, { value: 'W">中文 (繁體)', label: 'W">中文 (繁體)' }, { value: '日本語', label: '日本語' }, { value: '한국어', label: '한국어' }],
        multiple: 'ARS'
      },
      tags: {
        dynamicTags: ['Tag 1', 'Tag 2', 'Tag 3'],
        inputVisible: false,
        inputValue: ''
      },
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week ago',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      datePicker: '',
      dateTimePicker: '',
      timePicker: ''
    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  }
});

/***/ }),

/***/ "V5Z/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V67u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){_vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VEgf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VL41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ReviewCard_vue__ = __webpack_require__("6oRP");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ReviewCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ReviewCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      reviews: []
    };
  },

  methods: {
    fetchReviews: function fetchReviews(businessId) {
      this.$http.get('https://api.vyoo.io/v1/business/' + businessId + '/reviews').then(function (response) {
        console.log(response.data);
      });
    },
    fetchReviewsPlaceholder: function fetchReviewsPlaceholder(businessId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://jsonplaceholder.typicode.com/photos?albumId=1').then(function (response) {
        console.log(response.data);
        _this.reviews = response.data;
      });
    }
  },
  created: function created() {
    this.fetchReviewsPlaceholder();
  }
});

/***/ }),

/***/ "VN7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      axios_post_config: {
        headers: {
          'Content-Length': 0,
          'Content-Type': 'text/plain'
        },
        responseType: 'text'
      },
      business: {
        email_content: {
          invite_waite_perior: '',
          coupon_code: '',
          discount_text: ''
        }
      },
      loading: false
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    },

    fetchBusiness: function fetchBusiness(businessUrl) {
      this.$http.get('https://api.vyoo.io/v1/business/?url=' + businessUrl).then(function (response) {
        console.log(response.data);
        this.business = response.data;
      });
    },
    persistBusiness2: function persistBusiness2() {
      this.$http.post('https://api.vyoo.io/v1/business/', this.business).then(function (response) {
        console.log('Success!:', response.message);
        this.loading = false;
      }, function (response) {
        console.log('Error!:', response.data);
        this.loading = false;
      });
    },
    persistBusiness: function persistBusiness() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://api.vyoo.io/v1/business/', this.business, this.axios_post_config).then(function (response) {
        console.log('saved successfully');
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
          title: 'Saved',
          text: 'Your email settings have been saved',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.fetchBusiness('angelos-this-n-that.myshopify.com');
    });
  }
});

/***/ }),

/***/ "Vhaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"photo"},[(!!_vm.user.email)?_c('v-gravatar',{attrs:{"email":_vm.user.email,"size":34}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_c('span',[_vm._v("\n           "+_vm._s(this.user.email)+"\n           ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Mp")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("My Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Ep")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Edit Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("S")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Settings")])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vmmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_functions__ = __webpack_require__("p/MD");
















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email', 'birthday', 'address1', 'address2', 'city', 'state', 'zip', 'country'])),
  data: function data() {
    return {
      myvariable: 4,
      modelValidations: {
        email: {
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        country: {
          required: true
        }
      },
      loading: false,
      step: 1,
      complete: false,
      model: {
        firstName: '',
        lastName: '',
        email: '',
        birthday: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        goals: {
          healthyVagina: false,
          postpartumRecovery: false,
          bladderLeakage: false,
          organProlapse: false,
          sexualHealth: false,
          vaginalRejuvenation: false
        },
        sendShowerHolder: true,
        optIn: true
      },
      code: false,
      codeData: false
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__["Card"] },

  methods: {
    init: function init() {
      this.loading = true;
      this.checkCode();
    },
    checkCode: function checkCode() {
      var _this = this;

      var checkCode = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('checkCode');
      checkCode({ code: this.code, doNotValidate: true }).then(function (result) {
        console.log(result);
        if (!result.data.valid) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: 'Not Authentic!',
            text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(function () {
            _this.$router.replace('/authenticate?code=' + _this.model.code);
          });
        } else if (result.data.type === 'external') {
          console.log('external');
        } else {
          console.log('primary');
          _this.codeData = result.data;
          console.log(_this.codeData);
        }
        _this.loading = false;
      }).catch(function (err) {
        console.error(err.message);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Not Authentic!',
          text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this.$router.replace('/authenticate?code=' + _this.model.code);
        });
        _this.loading = false;
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, registerAuthCode, result, msg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = {
                  contactDetails: _this2.model,
                  code: _this2.code
                };
                registerAuthCode = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('registerAuthCode');

                registerAuthCode(data);
                _context.next = 6;
                return registerAuthCode(data);

              case 6:
                result = _context.sent;

                if (!result.data.success) {
                  _this2.$router.replace('/authenticate?code=' + _this2.code);
                }
                console.log(result);
                msg = '';

                if (!_this2.model.sendShowerHolder) msg = 'You will now be sent to the Kegelbell instructions video.';else msg = 'We will send your Kegelbell Shower Holder ASAP! You will now be sent to the Kegelbell instructions video.';
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                  title: 'Thank you!',
                  text: msg,
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                }).then(function () {
                  console.log('sending to kegelbelll.com');
                  location.replace('https://www.kegelbell.com/pages/instructions');
                });
                _this2.loading = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                  title: 'Error',
                  text: 'Sorry! There was an error with your submission. Please contact us at orders@kegelbell.com and let us know.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                }).then(function () {
                  location.replace('https://www.kegelbell.com/pages/instructions');
                });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 15]]);
      }))();
    },
    signup: function signup() {
      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
      }).catch(function (err) {
        console.error(err.message);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this3 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.submit();
        } else {
          _this3.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.params.code) this.code = this.$route.params.code;else if (this.$route.query.code) this.code = this.$route.query.code;
      if (!this.code) this.$router.replace('/authenticate');
      this.init();
    });
  }
});

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['accountData']
});

/***/ }),

/***/ "W8O7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    authDetails: {
      type: Object,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['mwsAuthToken', 'mwsSellerId'])),
  data: function data() {
    return {
      modelValidations: {
        mwsAuthToken: {
          required: true
        },
        mwsSellerId: {
          required: true
        }
      },
      loading: false
    };
  },

  methods: {
    showMwsHelp: function showMwsHelp() {
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
        title: 'Amazon Connection Instructions',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        html: '<a target="_blank" href="https://sellercentral.amazon.com/apps/manage">Manage Your Apps</a> ' + 'in Amazon Seller Central while logged in as the primary user. ' + 'Click <strong>Authorize new developer</strong> and go through the workflow. ' + 'Please use Developer Id <strong>2360-2313-2088</strong> and developer name ' + 'Tech Legends'
      });
    },
    updateMws: function updateMws() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mwsDetails, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                mwsDetails = {
                  mwsSellerId: _this.authDetails.account.data.mwsSellerId,
                  mwsAuthToken: _this.authDetails.account.data.mwsAuthToken
                };
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('accounts').doc(_this.authDetails.account.id).update(mwsDetails);

              case 4:
                result = _context.sent;

                _this.showNotify('Amazon API information saved.', 'success', 'Success');
                if (mwsDetails.mwsAccessKeyId !== null && mwsDetails.mwsAccessKeyId !== '' && mwsDetails.mwsSecretAccessKey !== null && mwsDetails.mwsSecretAccessKey !== '') {
                  _this.refreshAmazonProducts();
                }
                _this.loading = false;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                _this.showNotify(_context.t0, 'danger', 'Failed');
                _this.loading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.updateMws();
        } else {
          _this2.loading = false;
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    refreshAmazonProducts: function refreshAmazonProducts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, accountRefreshAmazonProds, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {};
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.getIdToken();

              case 3:
                data.userToken = _context2.sent;
                accountRefreshAmazonProds = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.functions().httpsCallable('accountRefreshAmazonProds');
                _context2.next = 7;
                return accountRefreshAmazonProds(data);

              case 7:
                result = _context2.sent;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("hJZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaa9827_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("nFN4");
function injectStyle (ssrContext) {
  __webpack_require__("aoR0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaa9827_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ws9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"row-class-name":_vm.tableRowClassName,"data":_vm.tableData}},[_c('el-table-column',{staticClass:"success",attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{staticClass:"danger",attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{staticClass:"info",attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Striped table")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Table on Plain Background")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Regular Table with Colors")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XBX7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__eventBus__ = __webpack_require__("O6e2");













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PProgress: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Progress_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["b" /* mapFields */])(['brandName', 'productName'])),
  data: function data() {
    return {
      initialized: false,
      loading: false,
      userAuth: {
        phoneNumber: null
      },
      user: {},
      profile: {
        loading: false,
        authUser: {
          email: '',
          phoneNumber: ''
        },
        user: {
          data: {
            firstName: '',
            lastName: ''
          }
        },
        account: {
          data: {
            businessName: ''
          }
        }
      },
      account: {
        data: null
      },
      newBrand: {
        logoUrl: '',
        name: ''
      },
      brandLogoUploadProgress: 0,
      brandId: '',
      brand: {
        loading: false,
        data: null
      },
      newProd: {
        name: '',
        imageUrl: ''
      },
      prodImageUploadProgress: 0,
      product: {
        loading: false,
        data: null
      },
      productId: '',
      codeValue: '',
      qrValue: '',
      modelValidations: {
        brandName: {
          required: true
        },
        productName: {
          required: true
        }
      },
      qrInitiated: false,
      qrProgress: 0
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getCurrentUser().then(function (user) {
                  _this.userAuth = {
                    uid: user.uid,
                    phoneNumber: user.phoneNumber,
                    email: user.email
                  };
                  console.log('got user');
                  console.log(_this.user);
                  if (_this.userAuth.phoneNumber) {
                    _this.getAccountDetails();
                  } else {
                    _this.initialized = true;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAccountDetails: function getAccountDetails() {
      var _this2 = this;

      console.log('getting account details');
      this.getAuthDetails().then(function (authDetails) {
        console.log('heres what we got');
        console.log(authDetails);
        _this2.userAuth = authDetails.userAuth;
        console.log('userAuth');
        console.log(_this2.userAuth);
        console.log(_this2.userAuth.phoneNumber);
        _this2.user = authDetails.user;
        _this2.account = authDetails.account;
        _this2.brand.accountId = _this2.user.accountId;
        console.log(_this2.user);
        _this2.getExistingBrand();
        _this2.loading = false;
        _this2.initialized = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getExistingBrand: function getExistingBrand() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('brands').where('accountId', '==', this.user.data.accountId).limit(1).get().then(function (qs) {
        qs.forEach(function (doc) {
          _this3.brandId = doc.id;
          _this3.brand.id = doc.id;
          _this3.brand.data = doc.data();
          _this3.listenForCode();
          _this3.getExistingProduct(doc.id);
        });
      });
    },
    getExistingProduct: function getExistingProduct(brandId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('brands/' + brandId + '/products').limit(1).get().then(function (qs) {
        qs.forEach(function (doc) {
          _this4.productId = doc.id;
          _this4.product.id = doc.id;
          _this4.product.data = doc.data();
        });
        _this4.initialized = true;
      }).catch(function (err) {
        _this4.initialized = true;
        console.log(err);
      });
    },
    listenForCode: function listenForCode() {
      var _this5 = this;

      console.log('listening');
      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('authCodes').where('brandId', '==', this.brand.id).onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          if (change.type === 'added') {
            var doc = change.doc;
            _this5.qrProgress = 100;
            _this5.code = {
              id: doc.id,
              codeValue: '0002' + doc.data().code
            };
            _this5.codeValue = '/authenticate?code=' + _this5.code.codeValue;
            _this5.qrValue = 'https://appdev.authentic.net/authenticate?code=' + _this5.code.codeValue;
            if (doc.data().qtyValidations > 0) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                title: 'Congratulations!',
                text: 'Onboarding is complete. You will now be redirected to your Dashboard. Please select a plan and provide payment info to unlock your 30 day trial and unlock full access to your account.',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success btn-fill',
                type: 'success'
              }).then(function () {
                _this5.finalizeOnboarding();
              }).catch(function (error) {
                console.log(error);
                _this5.finalizeOnboarding();
              });
            }
          }
          if (change.type === 'modified') {
            var _doc = change.doc;
            var data = _doc.data();
            _this5.finalizeOnboarding();
          }
        });
      });
    },
    finalizeOnboarding: function finalizeOnboarding() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('accounts').doc(this.account.id).update({ status: 'pending-plan' }).then(function (docRef) {
        __WEBPACK_IMPORTED_MODULE_9__eventBus__["a" /* EventBus */].$emit('auth-refreshed');
        _this6.$router.replace({ name: 'Dashboard' });
      });
    },
    saveProfile: function saveProfile() {
      var _this7 = this;

      this.profile.loading = true;
      var data = this.profile;
      data.authUser.phoneNumber = '+1' + this.profile.authUser.phoneNumber;
      data.authUser.uid = this.userAuth.uid;
      data.authUser.email = this.userAuth.email;
      var setupAccount = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.functions().httpsCallable('setupAccount');
      setupAccount(data).then(function (result) {
        if (result.data.success) {
          _this7.showNotify('Profile information saved. Please continue to Step 1.', 'success', 'Success');
          _this7.refreshCurrentUser();
          _this7.getAccountDetails();
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'Sorry, there was an error saving your profile',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
          _this7.profile.loading = false;
        }
      }).catch(function (err) {
        console.error(err.message);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Error',
          text: 'Sorry, the following error took place: ' + err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this7.profile.loading = false;
      });
    },
    selectBrandImageFile: function selectBrandImageFile() {
      var imageFile = this.$refs.brandImageFile.files[0];
      this.uploadBrandImageFile(imageFile);
    },
    uploadBrandImageFile: function uploadBrandImageFile(imageFile) {
      var _this8 = this;

      this.brand.loading = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref();
      var filename = this.$uuid.v4() + '.' + imageFile.name.split('.').pop();
      var uploadTask = storageRef.child('brands/' + filename).put(imageFile);

      uploadTask.on(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this8.brandLogoUploadProgress = progress;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.PAUSED:
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.RUNNING:
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Error Uploading Image',
          text: 'Please try a different image and contact support if the problem persists',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this8.brand.loading = false;
        });
        switch (error.code) {
          case 'storage/unauthorized':
            break;

          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          _this8.newBrand.logoUrl = downloadURL;
          _this8.brand.loading = false;
        });
      });
    },
    addBrand: function addBrand() {
      var _this9 = this;

      this.brand.loading = true;
      var brand = {
        name: this.newBrand.name,
        logoUrl: this.newBrand.logoUrl,
        accountId: this.account.id,
        qtyValidations: 0,
        qtyRegistrations: 0
      };
      console.log(brand);
      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('brands').add(brand).then(function (docRef) {
        _this9.brand = {
          id: docRef.id,
          data: {
            name: brand.name,
            logoUrl: brand.logoUrl
          }
        };
        _this9.brand.loading = false;
        _this9.showNotify('Brand saved. Please continue to step 3.', 'success', 'Success');
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Error',
          text: err,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this9.loading = false;
      });
    },
    selectProdImageFile: function selectProdImageFile() {
      var imageFile = this.$refs.prodImageFile.files[0];
      this.uploadProdImageFile(imageFile);
    },
    uploadProdImageFile: function uploadProdImageFile(imageFile) {
      var _this10 = this;

      this.product.loading = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref();
      var filename = this.$uuid.v4() + '.' + imageFile.name.split('.').pop();
      var uploadTask = storageRef.child('products/' + filename).put(imageFile);

      uploadTask.on(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this10.prodImageUploadProgress = progress;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.PAUSED:
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.RUNNING:
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Error Uploading Image',
          text: 'Please try a different image and contact support if the problem persists',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this10.product.loading = false;
        });
        switch (error.code) {
          case 'storage/unauthorized':
            break;

          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          _this10.newProd.imageUrl = downloadURL;
          _this10.product.loading = false;
        });
      });
    },
    addProd: function addProd() {
      var _this11 = this;

      this.product.loading = true;
      var product = {
        name: this.newProd.name,
        imageUrl: this.newProd.imageUrl,
        brandId: this.brand.id,
        qtyValidations: 0,
        qtyRegistrations: 0
      };
      console.log(product);
      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('brands/' + product.brandId + '/products').add(product).then(function (docRef) {
        _this11.product = {
          id: docRef.id,
          data: {
            name: product.name,
            imageUrl: product.imageUrl
          }
        };
        _this11.product.loading = false;
        _this11.showNotify('Product saved. Please validate your first Authentic.net product code once it\'s ready', 'success', 'Success');
        _this11.makeAuthCode();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Error',
          text: err,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this11.loading = false;
      });
    },
    deletePrivateKey: function deletePrivateKey() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Did you actually save your private key? It will be removed from Authentic.net and you won\'t be able to revert this!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, my key is safe!',
        buttonsStyling: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('accounts').doc(_this12.account.id).update({ privateKey: '' }).then(function (result) {
          _this12.account.data.privateKey = '';
          _this12.showNotify('Private key deleted. Please continue to Step 2.', 'success', 'Success');
        });
      });
    },
    makeAuthCode: function makeAuthCode() {
      var _this13 = this;

      this.qrInitiated = true;
      this.qrProgress = 33;
      var batch = {
        status: 'Requested',
        qty: 1,
        qtyCreated: 0,
        accountId: this.account.id,
        productId: this.product.id,
        brandId: this.brand.id,
        retailerId: '',
        createdAt: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore.FieldValue.serverTimestamp()
      };
      console.log(batch);
      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('brands/' + this.accountData.activeBrand.id + '/authCodeBatches').add(batch).then(function (response) {
        _this13.qrProgress = 66;
        _this13.listenForCode();
        _this13.loading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: 'Error',
          text: err,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this13.loading = false;
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "XIFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: true,
      user: {}
    };
  },

  methods: {
    init: function init() {
      this.user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
    },
    toggleMenu: function toggleMenu() {
      this.$router.replace({ name: 'Account' });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
    });
  }
});

/***/ }),

/***/ "XaJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"Jane"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('firstName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"Doe"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('lastName'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"you@domain.com"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Birthday")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.birthday),expression:"model.birthday"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.birthday),expression:"modelValidations.birthday"}],staticClass:"form-control",attrs:{"type":"date","name":"birthday","placeholder":"Birth Day"},domProps:{"value":(_vm.model.birthday)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "birthday", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.birthday.invalid),expression:"birthday.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('birthday'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address1),expression:"model.address1"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address1),expression:"modelValidations.address1"}],staticClass:"form-control",attrs:{"type":"text","name":"address1","placeholder":"123 Main St."},domProps:{"value":(_vm.model.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address1", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address1.invalid),expression:"address1.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address1'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address2),expression:"model.address2"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address2),expression:"modelValidations.address2"}],staticClass:"form-control",attrs:{"type":"text","name":"address2","placeholder":"Apt 2"},domProps:{"value":(_vm.model.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address2", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address2.invalid),expression:"address2.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('address2'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.city),expression:"model.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":"Phoenix"},domProps:{"value":(_vm.model.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "city", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('city'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.state),expression:"model.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.state),expression:"modelValidations.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":"AZ"},domProps:{"value":(_vm.model.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "state", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.invalid),expression:"state.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('state'))+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Zip Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.zip),expression:"model.zip"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.zip),expression:"modelValidations.zip"}],staticClass:"form-control",attrs:{"type":"text","name":"zip","placeholder":"85040"},domProps:{"value":(_vm.model.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "zip", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zip.invalid),expression:"zip.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('zip'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.country),expression:"model.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"form-control required",attrs:{"type":"text","name":"country","placeholder":"US"},domProps:{"value":(_vm.model.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "country", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.country.invalid),expression:"country.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('country'))+"\n                      ")])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Which benefit(s) are you most interested in (you can choose more than one):")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.model.goals.healthyVagina),callback:function ($$v) {_vm.$set(_vm.model.goals, "healthyVagina", $$v)},expression:"model.goals.healthyVagina"}},[_vm._v("Maintain Vaginal Health")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.postpartumRecovery),callback:function ($$v) {_vm.$set(_vm.model.goals, "postpartumRecovery", $$v)},expression:"model.goals.postpartumRecovery"}},[_vm._v("Postpartum Recovery (even if years after the fact)")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.bladderLeakage),callback:function ($$v) {_vm.$set(_vm.model.goals, "bladderLeakage", $$v)},expression:"model.goals.bladderLeakage"}},[_vm._v("Treat/Prevent Leakage (urine, gas or fecal)")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.organProlapse),callback:function ($$v) {_vm.$set(_vm.model.goals, "organProlapse", $$v)},expression:"model.goals.organProlapse"}},[_vm._v("Treat/Prevent Pelvic Organ Prolapse")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.vaginalRejuvenation),callback:function ($$v) {_vm.$set(_vm.model.goals, "vaginalRejuvenation", $$v)},expression:"model.goals.vaginalRejuvenation"}},[_vm._v("Vaginal Rejuvenation")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.goals.sexualHealth),callback:function ($$v) {_vm.$set(_vm.model.goals, "sexualHealth", $$v)},expression:"model.goals.sexualHealth"}},[_vm._v("Sexual Health")])],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('fieldset',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.model.optIn),callback:function ($$v) {_vm.$set(_vm.model, "optIn", $$v)},expression:"model.optIn"}},[_vm._v("Yes, I'd like to recieve more information about getting the most out of Kegelbell")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.sendShowerHolder),callback:function ($$v) {_vm.$set(_vm.model, "sendShowerHolder", $$v)},expression:"model.sendShowerHolder"}},[_vm._v("Yes, please send me a free Kegelbell shower holder")])],1)])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_vm._v("Submit & View Instruction Guides")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n                      Submit & View Instruction Guides\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',{staticClass:"copyright text-center"},[_vm._v("\n        *Free shower holder sent to USA addresses only\n      ")]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":"https://cdn.shopify.com/s/files/1/2198/4059/files/524996_Logo_Tagline-Blue_0904191_300x300.png?v=1572905596","alt":"Kegelbell"}}),_vm._v(" "),_c('h2',[_vm._v("Thank you for your purchase!"),_c('br'),_c('small',[_vm._v("Welcome to the Kegelbell family")])]),_vm._v(" "),_c('h5',[_c('b',[_vm._v("Please leave a review of your Kegelbell experience on Amazon. ")]),_vm._v("Your feedback will help us further educate and inspire other women to start lifting where it counts.")]),_vm._v(" "),_c('h5',[_vm._v("Complete your registration form below and we'll send you a "),_c('b',[_vm._v("FREE Kegelbell Shower Holder")]),_vm._v(".*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YDSW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePlan_vue__ = __webpack_require__("PuQg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40320ed0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePlan_vue__ = __webpack_require__("lIyl");
function injectStyle (ssrContext) {
  __webpack_require__("R9Ki")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40320ed0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePlan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YDyv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_functions__ = __webpack_require__("p/MD");















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      myvariable: 4,
      modelValidations: {
        email: {
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        country: {
          required: true
        }
      },
      loading: false,
      step: 1,
      complete: false,
      model: {
        firstName: '',
        lastName: '',
        email: '',
        birthday: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        goals: {
          healthyVagina: false,
          postpartumRecovery: false,
          bladderLeakage: false,
          organProlapse: false,
          sexualHealth: false,
          vaginalRejuvenation: false
        },
        sendShowerHolder: true,
        optIn: true
      },
      code: false,
      codeData: false
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_3_vue_stripe_elements_plus__["Card"] },

  methods: {
    init: function init() {
      this.loading = true;
      this.checkCode();
    },
    gotoInstructions: function gotoInstructions() {
      location.replace('https://www.kegelbell.com/pages/instructions');
    },
    checkCode: function checkCode() {
      var _this = this;

      var checkCode = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.functions().httpsCallable('checkCode');
      checkCode({ code: this.code, doNotValidate: true }).then(function (result) {
        console.log(result);
        if (!result.data.valid) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Not Authentic!',
            text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(function () {
            _this.$router.replace('/authenticate?code=' + _this.model.code);
          });
        } else if (result.data.type === 'external') {
          console.log('external');
        } else {
          console.log('primary');
          _this.codeData = result.data;
          console.log(_this.codeData);
        }
        _this.loading = false;
      }).catch(function (err) {
        console.error(err.message);
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'Not Authentic!',
          text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this.$router.replace('/authenticate?code=' + _this.model.code);
        });
        _this.loading = false;
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, registerAuthCode, result, msg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = {
                  contactDetails: _this2.model,
                  code: _this2.code
                };
                registerAuthCode = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.functions().httpsCallable('registerAuthCode');

                registerAuthCode(data);
                _context.next = 6;
                return registerAuthCode(data);

              case 6:
                result = _context.sent;

                if (!result.data.success) {
                  _this2.$router.replace('/authenticate?code=' + _this2.code);
                }
                console.log(result);
                msg = '';

                if (!_this2.model.sendShowerHolder) msg = 'You will now be sent to the Kegelbell instructions video.';else msg = 'We will send your Kegelbell Shower Holder ASAP! You will now be sent to the Kegelbell instructions video.';
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                  title: 'Thank you!',
                  text: msg,
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                }).then(function () {
                  console.log('sending to kegelbelll.com');
                  location.replace('https://www.kegelbell.com/pages/instructions');
                });
                _this2.loading = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                  title: 'Error',
                  text: 'Sorry! There was an error with your submission. Please contact us at orders@kegelbell.com and let us know.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                }).then(function () {
                  location.replace('https://www.kegelbell.com/pages/instructions');
                });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 15]]);
      }))();
    },
    signup: function signup() {
      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
      }).catch(function (err) {
        console.error(err.message);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this3 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.submit();
        } else {
          _this3.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ "YNHp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YW5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.productPanel),expression:"!productPanel"}],staticStyle:{"padding":"20px"}},[(!_vm.showingAllProducts)?_c('button',{staticClass:"btn btn-fill btn-info",on:{"click":function($event){$event.preventDefault();_vm.getProducts()}}},[_vm._v("Back to All Products")]):_vm._e(),_vm._v(" "),(_vm.showingAllProducts)?_c('button',{staticClass:"btn btn-fill btn-info",on:{"click":function($event){$event.preventDefault();_vm.addProductPanel()}}},[_vm._v("Add Single Product")]):_vm._e(),_vm._v(" "),(_vm.showingAllProducts)?_c('button',{staticClass:"btn btn-fill btn-amzyellow",on:{"click":function($event){$event.preventDefault();_vm.clickAmzImportBtn()}}},[_vm._v("Import Amazon Products")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4 pull-right"},[_c('div',{staticStyle:{"float":"right"}},[_c('form',{staticClass:"navbar-form navbar-left navbar-search-form",attrs:{"role":"search","_lpchecked":"1"}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"background-color":"#fff"},attrs:{"type":"text","value":"","placeholder":"Search..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.productPanel),expression:"productPanel"}],staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Add Product to "+_vm._s(_vm.accountData.activeBrand.data.name))]),_vm._v(" "),(_vm.prodSlotsRemaining > 0)?_c('p',{staticClass:"category"},[_vm._v("You can add up to X more products on your Authentic.net Starter Plan.")]):_vm._e(),_vm._v(" "),(_vm.prodSlotsRemaining === 0)?_c('p',{staticClass:"text-danger"},[_vm._v("Please upgrade your Authentic.net plan if you wish to add more products.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.prodSlotsRemaining > 0)?_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.name),expression:"newProduct.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.newProduct.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('name'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Size")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.size),expression:"newProduct.size"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.size),expression:"modelValidations.size"}],staticClass:"form-control",attrs:{"type":"text","name":"size"},domProps:{"value":(_vm.newProduct.size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "size", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.size.invalid),expression:"size.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('size'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.color),expression:"newProduct.color"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.color),expression:"modelValidations.color"}],staticClass:"form-control",attrs:{"type":"text","name":"color"},domProps:{"value":(_vm.newProduct.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "color", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.color.invalid),expression:"color.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('color'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Style")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.style),expression:"newProduct.style"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.style),expression:"modelValidations.style"}],staticClass:"form-control",attrs:{"type":"text","name":"style"},domProps:{"value":(_vm.newProduct.style)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "style", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.style.invalid),expression:"style.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('style'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("SKU")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.sku),expression:"newProduct.sku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.sku),expression:"modelValidations.sku"}],staticClass:"form-control",attrs:{"type":"text","name":"sku"},domProps:{"value":(_vm.newProduct.sku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "sku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.sku.invalid),expression:"sku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('sku'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("UPC")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.upc),expression:"newProduct.upc"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.upc),expression:"modelValidations.upc"}],staticClass:"form-control",attrs:{"type":"text","name":"upc"},domProps:{"value":(_vm.newProduct.upc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "upc", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.upc.invalid),expression:"upc.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('upc'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Amazon FNSKUs")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonComFnsku),expression:"newProduct.amazonComFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComFnsku),expression:"modelValidations.amazonComFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComFnsku"},domProps:{"value":(_vm.newProduct.amazonComFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonComFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComFnsku.invalid),expression:"amazonComFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.ca")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonCaFnsku),expression:"newProduct.amazonCaFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCaFnsku),expression:"modelValidations.amazonCaFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCaFnsku"},domProps:{"value":(_vm.newProduct.amazonCaFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonCaFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCaFnsku.invalid),expression:"amazonCaFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCaFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.mx")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonComMxFnsku),expression:"newProduct.amazonComMxFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComMxFnsku),expression:"modelValidations.amazonComMxFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComMxFnsku"},domProps:{"value":(_vm.newProduct.amazonComMxFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonComMxFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComMxFnsku.invalid),expression:"amazonComMxFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComMxFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.cn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonCnFnsku),expression:"newProduct.amazonCnFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCnFnsku),expression:"modelValidations.amazonCnFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCnFnsku"},domProps:{"value":(_vm.newProduct.amazonCnFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonCnFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCnFnsku.invalid),expression:"amazonCnFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCnFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.in")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonInFnsku),expression:"newProduct.amazonInFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonInFnsku),expression:"modelValidations.amazonInFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonInFnsku"},domProps:{"value":(_vm.newProduct.amazonInFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonInFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonInFnsku.invalid),expression:"amazonInFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonInFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.co.jp")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonCoJpFnsku),expression:"newProduct.amazonCoJpFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCoJpFnsku),expression:"modelValidations.amazonCoJpFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCoJpFnsku"},domProps:{"value":(_vm.newProduct.amazonCoJpFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonCoJpFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCoJpFnsku.invalid),expression:"amazonCoJpFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCoJpFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.sg")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonComSgFnsku),expression:"newProduct.amazonComSgFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComSgFnsku),expression:"modelValidations.amazonComSgFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComSgFnsku"},domProps:{"value":(_vm.newProduct.amazonComSgFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonComSgFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComSgFnsku.invalid),expression:"amazonComSgFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComSgFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.tr")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonComTrFnsku),expression:"newProduct.amazonComTrFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComTrFnsku),expression:"modelValidations.amazonComTrFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComTrFnsku"},domProps:{"value":(_vm.newProduct.amazonComTrFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonComTrFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComTrFnsku.invalid),expression:"amazonComTrFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComTrFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.ae")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonAeFnsku),expression:"newProduct.amazonAeFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonAeFnsku),expression:"modelValidations.amazonAeFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonAeFnsku"},domProps:{"value":(_vm.newProduct.amazonAeFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonAeFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonAeFnsku.invalid),expression:"amazonAeFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonAeFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.fr")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonFrFnsku),expression:"newProduct.amazonFrFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonFrFnsku),expression:"modelValidations.amazonFrFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonFrFnsku"},domProps:{"value":(_vm.newProduct.amazonFrFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonFrFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonFrFnsku.invalid),expression:"amazonFrFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonFrFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.de")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonDeFnsku),expression:"newProduct.amazonDeFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonDeFnsku),expression:"modelValidations.amazonDeFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonDeFnsku"},domProps:{"value":(_vm.newProduct.amazonDeFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonDeFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonDeFnsku.invalid),expression:"amazonDeFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonDeFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.it")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonItFnsku),expression:"newProduct.amazonItFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonItFnsku),expression:"modelValidations.amazonItFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonItFnsku"},domProps:{"value":(_vm.newProduct.amazonItFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonItFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonItFnsku.invalid),expression:"amazonItFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonItFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.nl")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonNlFnsku),expression:"newProduct.amazonNlFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonNlFnsku),expression:"modelValidations.amazonNlFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonNlFnsku"},domProps:{"value":(_vm.newProduct.amazonNlFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonNlFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonNlFnsku.invalid),expression:"amazonNlFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonNlFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.es")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonEsFnsku),expression:"newProduct.amazonEsFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonEsFnsku),expression:"modelValidations.amazonEsFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonEsFnsku"},domProps:{"value":(_vm.newProduct.amazonEsFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonEsFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonEsFnsku.invalid),expression:"amazonEsFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonEsFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.co.uk")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonCoUkFnsku),expression:"newProduct.amazonCoUkFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonCoUkFnsku),expression:"modelValidations.amazonCoUkFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonCoUkFnsku"},domProps:{"value":(_vm.newProduct.amazonCoUkFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonCoUkFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonCoUkFnsku.invalid),expression:"amazonCoUkFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonCoUkFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.au")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonComAuFnsku),expression:"newProduct.amazonComAuFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComAuFnsku),expression:"modelValidations.amazonComAuFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComAuFnsku"},domProps:{"value":(_vm.newProduct.amazonComAuFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonComAuFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComAuFnsku.invalid),expression:"amazonComAuFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComAuFnsku'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"fnsku-label"},[_vm._v("amazon.com.br")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.amazonComBrFnsku),expression:"newProduct.amazonComBrFnsku"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.amazonComBrFnsku),expression:"modelValidations.amazonComBrFnsku"}],staticClass:"form-control",attrs:{"type":"text","name":"amazonComBrFnsku"},domProps:{"value":(_vm.newProduct.amazonComBrFnsku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "amazonComBrFnsku", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.amazonComBrFnsku.invalid),expression:"amazonComBrFnsku.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('amazonComBrFnsku'))+"\n                    ")])])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.prodLandingUrlTip),expression:"prodLandingUrlTip"}],staticClass:"ti-help",staticStyle:{"font-size":"1em"}}),_vm._v("\n                  Thank You / Landing Page\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProduct.redirectUrl),expression:"newProduct.redirectUrl"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.redirectUrl),expression:"modelValidations.redirectUrl"}],staticClass:"form-control",attrs:{"type":"text","name":"redirectUrl"},domProps:{"value":(_vm.newProduct.redirectUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "redirectUrl", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.redirectUrl.invalid),expression:"redirectUrl.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('redirectUrl'))+"\n                  ")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Image")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.imageUploaded),expression:"!loading && !imageUploaded"}],staticClass:"btn btn-wd btn-info",attrs:{"type":"button"},on:{"click":_vm.clickImageFile}},[_vm._m(1),_vm._v("\n                    Add Photo\n                  ")]),_vm._v(" "),(_vm.uploading)?_c('div',{staticStyle:{"padding-top":"20px"}},[_c('p-progress',{attrs:{"value":_vm.uploadProgress,"type":"info"}})],1):_vm._e(),_vm._v(" "),(!_vm.uploading && _vm.imageUploaded)?_c('div',{staticStyle:{"padding-top":"10px"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(_vm._s(_vm.imageFileOgName))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"imageFile",attrs:{"type":"file","name":"imageFile","accept":"image/*"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.newProduct.image),expression:"newProduct.image"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.image),expression:"modelValidations.image"}],staticClass:"form-control",attrs:{"type":"text","name":"image"},domProps:{"value":(_vm.newProduct.image)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProduct, "image", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.image.invalid),expression:"image.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('image'))+"\n                  ")])])])]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateAddProduct()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n              Submit\n            ")]):_vm._e()]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.productsTable),function(prod){return _c('div',{key:prod.id,staticClass:"col-lg-3"},[(!prod.isParent)?_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"text-center",staticStyle:{"height":"80px","padding":"0px 10px"}},[_c('h5',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(prod.name),expression:"prod.name"}]},[_vm._v(_vm._s(_vm.limitChars(prod.name)))])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"140px","display":"flex","align-items":"center"}},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{ name: 'Product Dashboard', params: { id: prod.id }}}},[(prod.image)?_c('img',{attrs:{"src":prod.image,"alt":prod.name}}):_vm._e(),_vm._v(" "),(!prod.image)?_c('span',[_vm._v("{NO PRODUCT LOGO}")]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"120px"}},[(prod.size)?_c('div',[_c('strong',[_vm._v("Size:")]),_vm._v(" "+_vm._s(prod.size)+"\n          ")]):_vm._e(),_vm._v(" "),(prod.color)?_c('div',[_c('strong',[_vm._v("Color:")]),_vm._v(" "+_vm._s(prod.color)+"\n          ")]):_vm._e(),_vm._v(" "),(prod.style)?_c('div',[_c('strong',[_vm._v("Style:")]),_vm._v(" "+_vm._s(prod.style)+"\n          ")]):_vm._e(),_vm._v(" "),(prod.sku)?_c('div',[_c('strong',[_vm._v("SKU:")]),_vm._v(" "+_vm._s(prod.sku)+"\n          ")]):_vm._e(),_vm._v(" "),(prod.upc)?_c('div',[_c('strong',[_vm._v("UPC:")]),_vm._v(" "+_vm._s(prod.upc)+"\n          ")]):_vm._e(),_vm._v(" "),(prod.amazonComFnsku)?_c('div',[_c('strong',[_vm._v("AMZ FBA FNSKU:")]),_vm._v(" "+_vm._s(prod.amazonComFnsku)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[_c('router-link',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"tag":"button","to":{ name: 'Product', params: { productId: prod.id }}}},[_vm._v("Edit")]),_vm._v(" "),(!prod.deleting && !prod.isArchived)?_c('button',{staticClass:"btn btn-fill btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.deleteProd(prod)}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(prod.deleting)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(3,true),_vm._v("\n            Deleting...\n          ")]):_vm._e(),_vm._v(" "),(prod.isArchived && !prod.unarchiving)?_c('button',{staticClass:"btn btn-fill btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.unArchiveProduct(prod)}}},[_vm._v("Un-Archive")]):_vm._e(),_vm._v(" "),(prod.unarchiving)?_c('button',{staticClass:"btn btn-fill btn-sm",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(4,true),_vm._v("\n            Un-Archiving...\n          ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fill btn-sm",attrs:{"tag":"button","to":{ name: 'Make Authentic.net Codes', params: { productId: prod.id }}}},[_vm._v("Make Auth Codes")])],1)]):_vm._e(),_vm._v(" "),(prod.isParent)?_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"text-center",staticStyle:{"height":"80px","padding":"0px 10px"}},[_c('h5',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(prod.name),expression:"prod.name"}]},[_vm._v(_vm._s(_vm.limitChars(prod.name)))])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"140px","display":"flex","align-items":"center"}},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{ name: 'Product Dashboard', params: { id: prod.id }}}},[(prod.image)?_c('img',{attrs:{"src":prod.image,"alt":prod.name}}):_vm._e(),_vm._v(" "),(!prod.image)?_c('span',[_vm._v("{NO PRODUCT LOGO}")]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"120px"}},[_vm._v("\n           \n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[_c('button',{staticClass:"btn btn-fill btn-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getVariantProducts(prod.name)}}},[_vm._v("View All Variations")])])]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 pull-right"},[_c('div',{staticStyle:{"float":"right"}},[_c('p',{staticClass:"category"},[_vm._v("Show Archived Products")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.showArchived),callback:function ($$v) {_vm.showArchived=$$v},expression:"showArchived"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YYjv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z450":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-progress',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    value: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("UTB8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZZNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VectorMapsPage_vue__ = __webpack_require__("GdNa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d65b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VectorMapsPage_vue__ = __webpack_require__("RUAa");
function injectStyle (ssrContext) {
  __webpack_require__("5uDj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VectorMapsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d65b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VectorMapsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZbAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title",staticStyle:{"text-align":"center"}},[_vm._v("Amazon Connection Details")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showMwsHelp()}}},[_vm._v("Where do I get this?")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("MWS Auth Token")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.mwsAuthToken),expression:"authDetails.account.data.mwsAuthToken"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.mwsAuthToken),expression:"modelValidations.mwsAuthToken"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"mwsAuthToken","placeholder":"MWS Auth Token"},domProps:{"value":(_vm.authDetails.account.data.mwsAuthToken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "mwsAuthToken", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.mwsAuthToken.invalid),expression:"mwsAuthToken.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('mwsAuthToken'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Seller ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.mwsSellerId),expression:"authDetails.account.data.mwsSellerId"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.mwsSellerId),expression:"modelValidations.mwsSellerId"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"mwsSellerId","placeholder":"Selller ID"},domProps:{"value":(_vm.authDetails.account.data.mwsSellerId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "mwsSellerId", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.mwsSellerId.invalid),expression:"mwsSellerId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('mwsSellerId'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("\n          Save\n        ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit","disabled":"disabled"}},[_vm._m(0),_vm._v("\n          Save\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zu/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.lipsum.com/"}},[_vm._v("\n            Privacy Policy\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"copyright pull-right"},[_vm._v("\n      © Copyright 2018 Authentic.net\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a8eF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      defaultPagination: 3,
      infoPagination: 5
    };
  }
});

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aE9v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "acoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      authMode: ''
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      console.log(this.$route.query);
      this.authMode = this.$route.query.mode;
      if (this.authMode === 'resetPassword') {
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().verifyPasswordResetCode(this.$route.query.oobCode).then(function (email) {
          _this.$router.replace('/reset-password/' + _this.$route.query.oobCode);
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            title: 'Error',
            text: error.message + ' Please attempt to reset your password again if needed or contact support.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'error'
          }).then(function () {
            _this.loading = false;
            _this.$router.replace('/login');
          });
        });
      } else if (this.authMode === 'signIn') {
        if (__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().isSignInWithEmailLink(window.location.href)) {
          var email = window.localStorage.getItem('emailForSignIn');
          if (!email) {
            email = window.prompt('Please provide your email for confirmation');
          }

          __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().signInWithEmailLink(email, window.location.href).then(function (result) {
            console.log('sign in worked');
            console.log(result);

            window.localStorage.removeItem('emailForSignIn');

            if (!result.user.phoneNumber) {
              _this.$router.replace({ name: 'Onboarding' });
            } else {
              _this.$router.replace({ name: 'Dashboard' });
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    createAccount: function createAccount(userId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, setupAccount;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  data = {
                    uid: userId,
                    model: _this2.model
                  };
                  setupAccount = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.functions().httpsCallable('setupAccount');

                  setupAccount(data).then(function (result) {
                    if (result.data.success) _this2.$router.replace(_this2.$route.query.redirect || { name: 'Onboarding' });else {
                      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                        title: 'Error',
                        text: 'Sorry, the following error took place: ' + err.message,
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                      });
                      _this2.loading = false;
                    }
                  }).catch(function (err) {
                    console.error(err.message);
                  });
                } catch (err) {
                  __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: 'Sorry, the following error took place: ' + err.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  }).then(function () {
                    _this2.loading = false;
                  });
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    next();
  }
});

/***/ }),

/***/ "altj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"text-align":"center"}},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planName)),_c('br'),_vm._v(" "),_c('small',[_vm._v("$"+_vm._s(_vm.authDetails.account.data.planPrice)+" "+_vm._s(_vm.authDetails.account.data.planInterval))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();_vm.goChangePlan()}}},[_vm._v("Change Plan")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('div',[_vm._v("Plan Limits")]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planConstraints.maxCodesPerMonth)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Codes/Month")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planConstraints.maxCustomRetailers)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Retailers")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planConstraints.maxUsers)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Users")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planConstraints.maxBrands)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Brands")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('div',[_vm._v("Plan Usage for "+_vm._s(_vm.thisMonth)+" "+_vm._s(_vm.thisYear))]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planUsageQtyCodesThisMonth)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Codes")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planUsageQtyCustomRetailers)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Retailers")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planUsageQtyUsers)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Users")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(_vm.authDetails.account.data.planUsageQtyBrands)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Brands")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title",staticStyle:{"text-align":"center"}},[_vm._v("Current Plan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aoR0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "asr8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "atjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");



var Calendar = function Calendar() {
  return {
    component: __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "dYRv")),
    loading: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 100
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Calendar: Calendar
  }
});

/***/ }),

/***/ "bJ0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "bPcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.businessName),expression:"authDetails.account.data.businessName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.businessName),expression:"modelValidations.businessName"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"businessName","placeholder":"Business Name"},domProps:{"value":(_vm.authDetails.account.data.businessName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "businessName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.businessName.invalid),expression:"businessName.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('businessName'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.country),expression:"authDetails.account.data.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"country","placeholder":"Country"},domProps:{"value":(_vm.authDetails.account.data.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "country", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.country.invalid),expression:"country.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('country'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.address),expression:"authDetails.account.data.address"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address),expression:"modelValidations.address"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"address","placeholder":"Address Line 1"},domProps:{"value":(_vm.authDetails.account.data.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "address", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.address.invalid),expression:"address.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('address'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.address2),expression:"authDetails.account.data.address2"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.address2),expression:"modelValidations.address2"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"address2","placeholder":"Address Line 2"},domProps:{"value":(_vm.authDetails.account.data.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "address2", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.city),expression:"authDetails.account.data.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"city","placeholder":"City"},domProps:{"value":(_vm.authDetails.account.data.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "city", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('city'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.state),expression:"authDetails.account.data.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.state),expression:"modelValidations.state"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"state","placeholder":"State"},domProps:{"value":(_vm.authDetails.account.data.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "state", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.invalid),expression:"state.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('state'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Postal Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.account.data.postalCode),expression:"authDetails.account.data.postalCode"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.postalCode),expression:"modelValidations.postalCode"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"postalCode","placeholder":"ZIP Code"},domProps:{"value":(_vm.authDetails.account.data.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.account.data, "postalCode", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.postalCode.invalid),expression:"postalCode.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('postalCode'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("\n          Save\n        ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit","disabled":"disabled"}},[_vm._m(1),_vm._v("\n          Save\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title",staticStyle:{"text-align":"center"}},[_vm._v("Business Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bTbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bpD8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bqeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_EditCompanyForm_vue__ = __webpack_require__("3JE3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_EditProfileForm_vue__ = __webpack_require__("FG1V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_EditMwsForm_vue__ = __webpack_require__("4nIF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_PlanDetails_vue__ = __webpack_require__("vF/M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_UserCard_vue__ = __webpack_require__("666H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_MembersCard_vue__ = __webpack_require__("tTPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_PaymentMethod__ = __webpack_require__("gh99");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__eventBus__ = __webpack_require__("O6e2");
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditCompanyForm: __WEBPACK_IMPORTED_MODULE_4__partials_EditCompanyForm_vue__["a" /* default */],
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_5__partials_EditProfileForm_vue__["a" /* default */],
    EditMwsForm: __WEBPACK_IMPORTED_MODULE_6__partials_EditMwsForm_vue__["a" /* default */],
    PlanDetails: __WEBPACK_IMPORTED_MODULE_7__partials_PlanDetails_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_8__partials_UserCard_vue__["a" /* default */],
    MembersCard: __WEBPACK_IMPORTED_MODULE_9__partials_MembersCard_vue__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_10__partials_PaymentMethod__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      authDetails: {},
      initialized: false
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getAuthDetails();

              case 2:
                _this.authDetails = _context.sent;

                _this.initialized = true;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this2 = this;

      this.init();
      __WEBPACK_IMPORTED_MODULE_12__eventBus__["a" /* EventBus */].$on('auth-refreshed', function () {
        _this2.init();
      });
    });
  }
});

/***/ }),

/***/ "bwdy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1591e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("C3H9");
function injectStyle (ssrContext) {
  __webpack_require__("ybj4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1591e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bx0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task_vue__ = __webpack_require__("fm0D");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Task: __WEBPACK_IMPORTED_MODULE_1__Task_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tasks: [{
        title: 'Sign contract for "What are conference organizers afraid of?"'
      }, {
        title: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
      }, {
        title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
      }, {
        title: 'Create 4 Invisible User Experiences you Never Knew About'
      }, {
        title: 'Read "Following makes Medium better"'
      }, {
        title: 'Unfollow 5 enemies from twitter'
      }]
    };
  },

  methods: {
    handleTaskEdit: function handleTaskEdit(index) {
      alert('You want to edit task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    },
    handleTaskDelete: function handleTaskDelete(index) {
      alert('You want to delete task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    }
  }
});

/***/ }),

/***/ "bxZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendar')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c+YU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Tables_users__ = __webpack_require__("J8BY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_papaparse__ = __webpack_require__("afOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_algoliasearch__ = __webpack_require__("ZqOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_algoliasearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_algoliasearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");




























__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
var algolia = __WEBPACK_IMPORTED_MODULE_23_algoliasearch___default()('RQUCV3WZ1Q', '1f59c67aacc900322f92fb575c71e5c0');
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  props: ['accountData'],
  mixins: [__WEBPACK_IMPORTED_MODULE_24__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: {
    queriedData: function queriedData() {
      return this.tableData;
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      return this.pagination.total;
    }
  },
  data: function data() {
    return {
      user: {},
      initialized: false,
      isSearch: false,
      csvLoading: false,
      pagination: {
        perPage: 12,
        currentPage: 1,
        perPageOptions: [6, 12, 24, 48],
        total: 0,
        startAfter: false,
        endBefore: false,
        isLastPage: false,
        pageCursors: []
      },
      searchQuery: '',
      propsToSearch: ['authCode', 'email', 'firstName'],
      tableColumns: [{
        prop: 'authCode',
        label: 'Auth Code',
        minWidth: 250
      }, {
        prop: '',
        label: 'Auth Code ID',
        minWidth: 100
      }, {
        prop: 'city',
        label: 'City',
        minWidth: 120
      }],
      tableData: [],
      regDocMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      products: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      retailers: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      watchPerPage: 12,
      authCodes: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      authCodeBatches: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getCurrentUser();

              case 2:
                _this.user = _context.sent;

                _this.queryData(false);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    queryData: function queryData(useCursor) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, ref, qs, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, regDoc, obj;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.isEmpty(_this2.user)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', []);

              case 2:

                _this2.initialized = false;
                _this2.isSearch = false;
                _this2.tableData = [];

                data = {};
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.auth().currentUser.getIdToken();

              case 8:
                data.userToken = _context2.sent;

                data.accountId = _this2.user.accountId;
                data.perPage = _this2.pagination.perPage;
                data.pageNum = _this2.pagination.currentPage;
                data.brandId = _this2.accountData.activeBrand.id;

                ref = __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + _this2.accountData.activeBrand.id + '/authCodeRegistrations');

                if (useCursor === 'next') {
                  console.log('startAfter');
                  _this2.pagination.currentPage = _this2.pagination.currentPage + 1;
                  ref = ref.orderBy('createdAt', 'desc').startAfter(_this2.pagination.pageCursors[_this2.pagination.currentPage - 2].startAfter).limit(_this2.pagination.perPage + 1);
                } else if (useCursor === 'prev') {
                  _this2.pagination.currentPage = _this2.pagination.currentPage - 1;
                  ref = ref.orderBy('createdAt', 'desc').startAt(_this2.pagination.pageCursors[_this2.pagination.currentPage - 1].startAt).limit(_this2.pagination.perPage + 1);
                } else {
                  ref = ref.orderBy('createdAt', 'desc').limit(_this2.pagination.perPage + 1);
                  _this2.pagination.currentPage = 1;
                }
                if (_this2.pagination.pageCursors.length < _this2.pagination.currentPage) {
                  _this2.pagination.pageCursors.push({
                    startAt: false,
                    startAfter: false
                  });
                }
                _this2.pagination.startAfter = false;
                _this2.pagination.startBefore = false;
                _context2.next = 20;
                return ref.get();

              case 20:
                qs = _context2.sent;
                i = 0;

                _this2.pagination.isLastPage = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 26;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs);

              case 28:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 48;
                  break;
                }

                regDoc = _step.value;

                i++;

                if (!(i > _this2.pagination.perPage)) {
                  _context2.next = 34;
                  break;
                }

                _this2.pagination.isLastPage = false;
                return _context2.abrupt('break', 48);

              case 34:
                if (_this2.pagination.pageCursors[_this2.pagination.currentPage - 1].startAt === false) _this2.pagination.pageCursors[_this2.pagination.currentPage - 1].startAt = regDoc;
                _this2.pagination.pageCursors[_this2.pagination.currentPage - 1].startAfter = regDoc;
                obj = regDoc.data();

                obj.productId = regDoc.data().productId;
                obj.id = regDoc.id;
                obj.productLoaded = false;

                obj.friendlyDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()(regDoc.data().createdAtMillis).format('LL');
                _this2.tableData.push(obj);
                _this2.regDocMap.set(obj.id, _this2.tableData.length - 1);
                _this2.loadProduct(regDoc.id, regDoc.data().brandId, regDoc.data().productId);
                _this2.loadAuthCodeAndBatch(regDoc.id, regDoc.data().brandId, regDoc.data().authCodeId);

              case 45:
                _iteratorNormalCompletion = true;
                _context2.next = 28;
                break;

              case 48:
                _context2.next = 54;
                break;

              case 50:
                _context2.prev = 50;
                _context2.t0 = _context2['catch'](26);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 54:
                _context2.prev = 54;
                _context2.prev = 55;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 57:
                _context2.prev = 57;

                if (!_didIteratorError) {
                  _context2.next = 60;
                  break;
                }

                throw _iteratorError;

              case 60:
                return _context2.finish(57);

              case 61:
                return _context2.finish(54);

              case 62:
                console.log(_this2.tableData);
                _this2.initialized = true;

              case 64:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[26, 50, 54, 62], [55,, 57, 61]]);
      }))();
    },
    loadProduct: function loadProduct(regId, brandId, prodId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var prodDoc, img;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this3.products.get(prodId) === undefined)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + brandId + '/products').doc(prodId).get();

              case 3:
                prodDoc = _context3.sent;
                _context3.next = 6;
                return _this3.prodImgUrl(prodDoc.id, prodDoc.data(), '140x140x');

              case 6:
                img = _context3.sent;

                _this3.products.set(prodDoc.id, {
                  name: prodDoc.data().name,
                  imageUrl: img,
                  data: prodDoc.data()
                });

              case 8:
                _this3.tableData[_this3.regDocMap.get(regId)].imageUrl = _this3.products.get(prodId).imageUrl;
                _this3.tableData[_this3.regDocMap.get(regId)].productName = _this3.products.get(prodId).name;
                _this3.tableData[_this3.regDocMap.get(regId)].productLoaded = true;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadAuthCodeAndBatch: function loadAuthCodeAndBatch(regId, brandId, authCodeId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, authCode, batchDoc;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.authCodes.get(regId) === undefined)) {
                  _context4.next = 16;
                  break;
                }

                console.log('getting authCode');
                console.log('authCodeId', authCodeId, "https://api1-dev.authentic.net/v1");
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_22_axios___default.a.get("https://api1-dev.authentic.net/v1" + '/auth-code-alt/' + authCodeId);

              case 5:
                response = _context4.sent;

                console.log('authCodeResponse in loadAuthCodeAndBatch', response);
                authCode = {
                  id: response.data.data.alt_id,
                  data: response.data.data
                };

                console.log('setting authCode', authCode);
                _this4.authCodes.set(regId, authCode);

                if (!(_this4.authCodeBatches.get(_this4.authCodes.get(regId).data.auth_code_batch_id) === undefined)) {
                  _context4.next = 16;
                  break;
                }

                console.log('loading up batch id in brand', _this4.authCodes.get(regId).data.auth_code_batch_id, brandId);
                _context4.next = 14;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + brandId + '/authCodeBatches').doc(_this4.authCodes.get(regId).data.auth_code_batch_id).get();

              case 14:
                batchDoc = _context4.sent;

                if (!batchDoc.exists) {
                  console.log('failed to load batch from db: batchId, brand', _this4.authCodes.get(regId).data.auth_code_batch_id, brandId);
                } else {
                  console.log('got batch: batchDoc, reg, batch', batchDoc, regId, _this4.authCodes.get(regId).data.auth_code_batch_id, batchDoc.data());
                  _this4.authCodeBatches.set(_this4.authCodes.get(regId).data.auth_code_batch_id, {
                    id: batchDoc.id,
                    data: batchDoc.data()
                  });
                }

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    prettyAddress: function prettyAddress(regRecord) {
      var address = '';
      if (regRecord.address1) address += regRecord.address1;
      if (regRecord.address2) address += '<br>' + regRecord.address2;
      if (regRecord.city || regRecord.state || regRecord.zip || regRecord.country) {
        var region = '';
        if (regRecord.city) region += regRecord.city;
        if (regRecord.state) {
          if (region === '') region += regRecord.state;else region += ', ' + regRecord.state;
        }
        if (regRecord.zip) {
          if (region === '') region += regRecord.zip;else region += ' ' + regRecord.zip;
        }
        if (regRecord.country) {
          if (region === '') region += regRecord.country;else region += ' ' + regRecord.country;
        }
        if (region !== '') region = '<br>' + region;
        address += region;
      }
      return address;
    },
    addressRegion: function addressRegion(regRecord) {
      var region = '';
      if (regRecord.city) region += regRecord.city;
      if (regRecord.state) {
        if (region === '') region += regRecord.state;else region += ', ' + regRecord.state;
      }
      return region;
    },
    downloadRegCsv: function downloadRegCsv() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var brands, products, authCodes, authCodeBatches, retailers, data, getRegistrationsRaw, result, regArray, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, regDoc, prodDoc, brandDoc, response, authCode, retailerName, retailerDoc, reg, csvString, filename;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.csvLoading = true;

                brands = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                products = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                authCodes = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                authCodeBatches = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                retailers = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                data = {};
                _context5.next = 9;
                return __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.auth().currentUser.getIdToken();

              case 9:
                data.userToken = _context5.sent;

                data.accountId = _this5.user.accountId;
                getRegistrationsRaw = __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.functions().httpsCallable('getRegistrationsRaw');
                _context5.next = 14;
                return getRegistrationsRaw(data);

              case 14:
                result = _context5.sent;
                regArray = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 19;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.data.authCodeRegistrations);

              case 21:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context5.next = 59;
                  break;
                }

                regDoc = _step2.value;

                if (!(products.get(regDoc.data.productId) === undefined)) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 26;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands/' + regDoc.data.brandId + '/products').doc(regDoc.data.productId).get();

              case 26:
                prodDoc = _context5.sent;

                products.set(prodDoc.id, prodDoc.data());

              case 28:
                if (!(brands.get(regDoc.data.brandId) === undefined)) {
                  _context5.next = 33;
                  break;
                }

                _context5.next = 31;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('brands').doc(regDoc.data.brandId).get();

              case 31:
                brandDoc = _context5.sent;

                brands.set(brandDoc.id, brandDoc.data());

              case 33:
                if (!(authCodes.get(regDoc.data.authCodeId) === undefined)) {
                  _context5.next = 39;
                  break;
                }

                _context5.next = 36;
                return __WEBPACK_IMPORTED_MODULE_22_axios___default.a.get("https://api1-dev.authentic.net/v1" + '/auth-code-alt/' + regDoc.data.authCodeId);

              case 36:
                response = _context5.sent;
                authCode = {
                  id: response.data.data.alt_id,
                  data: response.data.data
                };

                _this5.authCodes.set(regId, authCode);

              case 39:
                retailerName = '';

                if (!authCodes.get(regDoc.data.authCodeId).data.retailer_id) {
                  _context5.next = 54;
                  break;
                }

                if (!(retailers.get(authCodes.get(regDoc.data.authCodeId).data.retailer_id) === undefined)) {
                  _context5.next = 53;
                  break;
                }

                retailerDoc = null;

                if (!(authCodes.get(regDoc.data.authCodeId).data.retailer_id.substring(0, 4) === 'glo_')) {
                  _context5.next = 49;
                  break;
                }

                _context5.next = 46;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('globalRetailers').doc(authCodes.get(regDoc.data.authCodeId).data.retailer_id).get();

              case 46:
                retailerDoc = _context5.sent;
                _context5.next = 52;
                break;

              case 49:
                _context5.next = 51;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('accounts/' + _this5.user.accountId + '/retailers').doc(authCodes.get(regDoc.data.authCodeId).data.retailer_id).get();

              case 51:
                retailerDoc = _context5.sent;

              case 52:
                retailers.set(retailerDoc.id, retailerDoc.data());

              case 53:
                retailerName = retailers.get(authCodes.get(regDoc.data.authCodeId).data.retailer_id).name;

              case 54:
                reg = {
                  product: products.get(regDoc.data.productId).name,
                  brand: brands.get(regDoc.data.brandId).name,
                  retailer: retailerName,
                  first_name: regDoc.data.firstName,
                  last_name: regDoc.data.lastName,
                  email: regDoc.data.email,
                  address1: regDoc.data.address1,
                  address2: regDoc.data.address2,
                  city: regDoc.data.city,
                  state: regDoc.data.state,
                  zip: regDoc.data.zip,
                  country: regDoc.data.country,
                  created_at: __WEBPACK_IMPORTED_MODULE_17_moment___default()(regDoc.data.createdAtMillis).format('LL')
                };

                regArray.push(reg);

              case 56:
                _iteratorNormalCompletion2 = true;
                _context5.next = 21;
                break;

              case 59:
                _context5.next = 65;
                break;

              case 61:
                _context5.prev = 61;
                _context5.t0 = _context5['catch'](19);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 65:
                _context5.prev = 65;
                _context5.prev = 66;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 68:
                _context5.prev = 68;

                if (!_didIteratorError2) {
                  _context5.next = 71;
                  break;
                }

                throw _iteratorError2;

              case 71:
                return _context5.finish(68);

              case 72:
                return _context5.finish(65);

              case 73:
                csvString = __WEBPACK_IMPORTED_MODULE_21_papaparse___default.a.unparse(regArray);
                filename = 'registrations_' + __WEBPACK_IMPORTED_MODULE_17_moment___default()().format('MM-DD-YYYY') + '.csv';

                _this5.downloadCsv(csvString, filename);
                _this5.csvLoading = false;

              case 77:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[19, 61, 65, 73], [66,, 68, 72]]);
      }))();
    },
    perPageLabel: function perPageLabel(item) {
      return item + ' per page';
    },
    regDetailsPopup: function regDetailsPopup(regRecord) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var product, authCode, batch, prodDetailsHtml, retailerDoc;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                product = _this6.products.get(regRecord.productId);
                authCode = _this6.authCodes.get(regRecord.id);
                batch = _this6.authCodeBatches.get(authCode.data.auth_code_batch_id);

                console.log('get batch', batch);
                prodDetailsHtml = '<b>Registration Date:</b> ' + regRecord.friendlyDate;

                if (product.data.size) prodDetailsHtml += '<br><b>Size:</b> ' + product.data.size;
                if (product.data.color) prodDetailsHtml += '<br><b>Color:</b> ' + product.data.color;
                if (product.data.style) prodDetailsHtml += '<br><b>Style:</b> ' + product.data.style;
                if (product.data.upc) prodDetailsHtml += '<br><b>UPC:</b> ' + product.data.upc;
                if (product.data.sku) prodDetailsHtml += '<br><b>SKU:</b> ' + product.data.sku;
                if (product.data.amazonComFnsku) prodDetailsHtml += '<br><b>AMZ FBA FNSKU:</b> ' + product.data.amazonComFnsku;

                if (!regRecord.retailerId) {
                  _context6.next = 25;
                  break;
                }

                if (!(_this6.retailers.get(regRecord.retailerId) === undefined)) {
                  _context6.next = 24;
                  break;
                }

                retailerDoc = null;

                if (!(regRecord.retailerId.substring(0, 4) === 'glo_')) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 17;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('globalRetailers').doc(regRecord.retailerId).get();

              case 17:
                retailerDoc = _context6.sent;
                _context6.next = 23;
                break;

              case 20:
                _context6.next = 22;
                return __WEBPACK_IMPORTED_MODULE_20__components_firebase_init__["a" /* default */].collection('accounts/' + _this6.user.accountId + '/retailers').doc(regRecord.retailerId).get();

              case 22:
                retailerDoc = _context6.sent;

              case 23:
                _this6.retailers.set(retailerDoc.id, retailerDoc.data());

              case 24:
                prodDetailsHtml += '<br><b>Retailer:</b> ' + _this6.retailers.get(regRecord.retailerId).name;

              case 25:
                if (batch.data.lotNum) {
                  prodDetailsHtml += '<br><b>Batch / Lot Num:</b> ' + batch.data.lotNum;
                }
                prodDetailsHtml += '<br>';
                if (regRecord.firstName) prodDetailsHtml += '<br><b>First Name:</b> ' + regRecord.firstName;
                if (regRecord.lastName) prodDetailsHtml += '<br><b>Last Name:</b> ' + regRecord.lastName;
                if (regRecord.email) prodDetailsHtml += '<br><b>Email:</b> ' + regRecord.email;
                if (regRecord.address1) prodDetailsHtml += '<br><b>Address 1:</b> ' + regRecord.address1;
                if (regRecord.address2) prodDetailsHtml += '<br><b>Address 2:</b> ' + regRecord.address2;
                if (regRecord.city) prodDetailsHtml += '<br><b>City:</b> ' + regRecord.city;
                if (regRecord.state) prodDetailsHtml += '<br><b>State:</b> ' + regRecord.state;
                if (regRecord.zip) prodDetailsHtml += '<br><b>Zip:</b> ' + regRecord.zip;
                if (regRecord.country) prodDetailsHtml += '<br><b>Country:</b> ' + regRecord.country;
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.fire({
                  title: '<strong>Product Registration Details</strong>',
                  html: '<b>Product:</b> ' + regRecord.productName + '<br>' + prodDetailsHtml,
                  showCancelButton: true,
                  showConfirmButton: false,
                  cancelButtonText: 'Close'
                });

              case 37:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    limitChars: function limitChars(x) {
      if (x.length > 20) return x.substring(0, 17) + '...';
      return x;
    },
    searchRegistrations: function searchRegistrations(query) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var iString, index, _result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, docData, obj;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(query === '')) {
                  _context7.next = 4;
                  break;
                }

                _this7.queryData(false);
                _context7.next = 32;
                break;

              case 4:
                _this7.isSearch = true;
                iString = 'brands_' + _this7.accountData.activeBrand.id + '_authCodeRegistrations';

                console.log('algolia index', iString);
                index = algolia.initIndex(iString);
                _context7.next = 10;
                return index.search(query);

              case 10:
                _result = _context7.sent;


                _this7.tableData = [];
                _this7.regDocMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context7.prev = 16;
                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_result.hits); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  docData = _step3.value;
                  obj = docData;

                  obj.id = docData.objectID;
                  obj.productLoaded = false;
                  obj.friendlyDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()(docData.createdAtMillis).format('LL');
                  _this7.tableData.push(obj);
                  _this7.regDocMap.set(obj.id, _this7.tableData.length - 1);
                  _this7.loadProduct(obj.id, obj.brandId, obj.productId);
                  _this7.loadAuthCodeAndBatch(obj.id, obj.brandId, obj.authCodeId);
                }
                _context7.next = 24;
                break;

              case 20:
                _context7.prev = 20;
                _context7.t0 = _context7['catch'](16);
                _didIteratorError3 = true;
                _iteratorError3 = _context7.t0;

              case 24:
                _context7.prev = 24;
                _context7.prev = 25;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 27:
                _context7.prev = 27;

                if (!_didIteratorError3) {
                  _context7.next = 30;
                  break;
                }

                throw _iteratorError3;

              case 30:
                return _context7.finish(27);

              case 31:
                return _context7.finish(24);

              case 32:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[16, 20, 24, 32], [25,, 27, 31]]);
      }))();
    }
  },
  watch: {
    watchPerPage: function watchPerPage(newFrom, oldFrom) {
      this.pagination.perPage = this.watchPerPage;
      this.queryData();
    },
    searchQuery: function searchQuery(newFrom, oldFrom) {
      this.searchRegistrations(newFrom);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "c3eM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_algoliasearch__ = __webpack_require__("ZqOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_algoliasearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_algoliasearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");



























var algolia = __WEBPACK_IMPORTED_MODULE_22_algoliasearch___default()('RQUCV3WZ1Q', '1f59c67aacc900322f92fb575c71e5c0');

__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({
    PSwitch: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__["a" /* default */],
    PProgress: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Progress_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a),
  props: ['accountData'],
  mixins: [__WEBPACK_IMPORTED_MODULE_23__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vee_validate__["b" /* mapFields */])(['image', 'name', 'size', 'color', 'style', 'amazonComFnsku', 'amazonCaFnsku', 'amazonComMxFnsku', 'amazonCnFnsku', 'amazonInFnsku', 'amazonCoJpFnsku', 'amazonComSgFnsku', 'amazonComTrFnsku', 'amazonAeFnsku', 'amazonFrFnsku', 'amazonDeFnsku', 'amazonItFnsku', 'amazonNlFnsku', 'amazonEsFnsku', 'amazonCoUkFnsku', 'amazonComAuFnsku', 'amazonComBrFnsku', 'sku', 'upc', 'redirectUrl'])),
  data: function data() {
    return {
      user: {
        email: '',
        token: ''
      },
      newProduct: {
        image: '',
        name: '',
        brandIndex: '',
        size: '',
        color: '',
        style: '',
        sku: '',
        upc: '',
        redirectUrl: ''
      },
      imageFile: '',
      imageFileOgName: '',
      imageUploaded: false,
      uploadProgress: 0,
      uploading: false,
      loading: false,
      prodSlotsRemaining: 2,
      modelValidations: {
        image: {
          required: false,
          url: true
        },
        name: {
          required: true,
          max: 26
        },
        size: {
          required: false
        },
        color: {
          required: false
        },
        style: {
          required: false
        },
        amazonComFnsku: {
          required: false
        },
        amazonCaFnsku: {
          required: false
        },
        amazonComMxFnsku: {
          required: false
        },
        amazonCnFnsku: {
          required: false
        },
        amazonInFnsku: {
          required: false
        },
        amazonCoJpFnsku: {
          required: false
        },
        amazonComSgFnsku: {
          required: false
        },
        amazonComTrFnsku: {
          required: false
        },
        amazonAeFnsku: {
          required: false
        },
        amazonFrFnsku: {
          required: false
        },
        amazonDeFnsku: {
          required: false
        },
        amazonItFnsku: {
          required: false
        },
        amazonNlFnsku: {
          required: false
        },
        amazonEsFnsku: {
          required: false
        },
        amazonCoUkFnsku: {
          required: false
        },
        amazonComAuFnsku: {
          required: false
        },
        amazonComBrFnsku: {
          required: false
        },
        sku: {
          required: false
        },
        upc: {
          required: false
        },
        redirectUrl: {
          required: false,
          url: {
            require_protocol: true
          }
        }
      },
      productsTable: [],
      prodIdIndexMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
      productsTableKey: this.$uuid.v4(),
      brands: [],
      showArchived: false,
      productPanel: false,
      showingAllProducts: true,
      newProdId: this.$uuid.v4(),
      prodLandingUrlTip: 'If provided, then anyone who submits a registration for this product will be redirected to this URL after submission.',
      searchQuery: ''
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.brands = _this.accountData.brands;
                _this.user = _this.accountData.authDetails.user;
                _this.getProducts();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    limitChars: function limitChars(x) {
      if (x.length > 90) return x.substring(0, 87) + '...';
      return x;
    },
    clickImageFile: function clickImageFile() {
      this.$refs.imageFile.click();
    },
    addProductPanel: function addProductPanel() {
      this.productPanel = true;
    },
    selectFile: function selectFile() {
      this.imageFile = this.$refs.imageFile.files[0];
      this.imageFileOgName = this.imageFile.name;
      this.uploadFile();
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      this.loading = true;
      this.uploading = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.storage().ref();
      var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop();
      var uploadTask = storageRef.child('brands/' + this.accountData.activeBrand.id + '/products/' + this.newProdId + '/' + filename).put(this.imageFile);

      uploadTask.on(__WEBPACK_IMPORTED_MODULE_19_firebase___default.a.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this2.uploadProgress = progress;
        if (progress === 100) {
          _this2.imageUploaded = true;
        }
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.storage.TaskState.PAUSED:
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.storage.TaskState.RUNNING:
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default.a.fire({
          title: 'Error Uploading Image',
          text: 'Please try a different image and contact support if the problem persists',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this2.loading = false;
          _this2.uploading = false;
        });
        switch (error.code) {
          case 'storage/unauthorized':
            break;

          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          _this2.newProduct.image = downloadURL;
          _this2.loading = false;
          _this2.uploading = false;
        });
      });
    },
    getProducts: function getProducts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var path, qs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, prod, samePrevProd, product;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.showingAllProducts = true;
                _this3.productsTable = [];
                _this3.prodIdIndexMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                path = 'brands/' + _this3.accountData.activeBrand.id + '/products';
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection(path).orderBy('name').get();

              case 6:
                qs = _context2.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 10;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs);

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 31;
                  break;
                }

                prod = _step.value;

                if (!(!_this3.showArchived && prod.data().isArchived)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt('continue', 28);

              case 16:
                samePrevProd = __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.find(_this3.productsTable, { name: prod.data().name });

                if (!(samePrevProd !== undefined)) {
                  _context2.next = 21;
                  break;
                }

                samePrevProd.isParent = true;
                _context2.next = 28;
                break;

              case 21:
                product = prod.data();

                product.id = prod.id;
                _context2.next = 25;
                return _this3.prodImgUrl(prod.id, prod.data(), '140x140');

              case 25:
                product.image = _context2.sent;

                _this3.productsTable.push(product);
                _this3.prodIdIndexMap.set(prod.id, _this3.productsTable.length - 1);

              case 28:
                _iteratorNormalCompletion = true;
                _context2.next = 12;
                break;

              case 31:
                _context2.next = 37;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t0 = _context2['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 37:
                _context2.prev = 37;
                _context2.prev = 38;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 40:
                _context2.prev = 40;

                if (!_didIteratorError) {
                  _context2.next = 43;
                  break;
                }

                throw _iteratorError;

              case 43:
                return _context2.finish(40);

              case 44:
                return _context2.finish(37);

              case 45:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[10, 33, 37, 45], [38,, 40, 44]]);
      }))();
    },
    getVariantProducts: function getVariantProducts(productName) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var path, qs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, prod, product;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.showingAllProducts = false;
                _this4.productsTable = [];
                _this4.prodIdIndexMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                path = 'brands/' + _this4.accountData.activeBrand.id + '/products';
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection(path).where('name', '==', productName).get();

              case 6:
                qs = _context3.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 10;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(qs.docs);

              case 12:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 26;
                  break;
                }

                prod = _step2.value;

                if (!(!_this4.showArchived && prod.data().isArchived)) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt('continue', 23);

              case 16:
                product = prod.data();

                product.id = prod.id;
                _context3.next = 20;
                return _this4.prodImgUrl(prod.id, prod.data(), '140x140');

              case 20:
                product.image = _context3.sent;

                _this4.productsTable.push(product);
                _this4.prodIdIndexMap.set(prod.id, _this4.productsTable.length - 1);

              case 23:
                _iteratorNormalCompletion2 = true;
                _context3.next = 12;
                break;

              case 26:
                _context3.next = 32;
                break;

              case 28:
                _context3.prev = 28;
                _context3.t0 = _context3['catch'](10);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 32:
                _context3.prev = 32;
                _context3.prev = 33;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 35:
                _context3.prev = 35;

                if (!_didIteratorError2) {
                  _context3.next = 38;
                  break;
                }

                throw _iteratorError2;

              case 38:
                return _context3.finish(35);

              case 39:
                return _context3.finish(32);

              case 40:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[10, 28, 32, 40], [33,, 35, 39]]);
      }))();
    },
    addProduct: function addProduct() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var product;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                product = _this5.newProduct;

                product.imageUrl = _this5.newProduct.image;
                product.brandId = _this5.accountData.activeBrand.id;
                product.qtyCertified = 0;
                product.qtyValidated = 0;
                product.qtyFraudReports = 0;
                _context4.prev = 6;
                _context4.next = 9;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection('brands/' + _this5.accountData.activeBrand.id + '/products').doc(_this5.newProdId).set(product);

              case 9:
                product.id = _this5.newProdId;
                _context4.next = 12;
                return _this5.prodImgUrl(_this5.newProdId, product, '140x140');

              case 12:
                product.image = _context4.sent;

                _this5.productsTable.push(product);
                _this5.loading = false;
                _this5.productPanel = false;
                _this5.newProduct = {
                  image: '',
                  name: '',
                  brandIndex: '',
                  size: '',
                  color: '',
                  style: '',
                  sku: '',
                  upc: '',
                  amazonComFnsku: '',
                  redirectUrl: ''
                };
                _this5.newProdId = _this5.$uuid.v4();
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4['catch'](6);

                __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default.a.fire({
                  title: 'Error',
                  text: _context4.t0,
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                });
                _this5.loading = false;

              case 24:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[6, 20]]);
      }))();
    },
    validateAddProduct: function validateAddProduct() {
      var _this6 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this6.addProduct();
        } else {
          _this6.loading = false;
        }
      });
    },
    pushProduct: function pushProduct() {
      var newProduct = {
        image: this.newProduct.image,
        title: this.newProduct.title,
        certified_qty: 0,
        validated_qty: 0,
        fruad_reports: 0
      };
      this.productsTable.unshift(newProduct);
      this.newProduct.image = '';
      this.newProduct.title = '';
      this.prodSlotsRemaining--;
      __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default.a.fire({
        title: 'Added',
        text: newProduct.title,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'success'
      });
    },
    deleteProd: function deleteProd(prod) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var prodId, data, accountDeleteProduct, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                prodId = prod.id;

                prod.deleting = true;
                _this7.productsTableKey = _this7.$uuid.v4();
                data = {};
                _context6.next = 7;
                return __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.auth().currentUser.getIdToken();

              case 7:
                data.userToken = _context6.sent;

                data.accountId = _this7.user.accountId;
                data.brandId = _this7.accountData.activeBrand.id;
                data.productId = prodId;
                accountDeleteProduct = __WEBPACK_IMPORTED_MODULE_19_firebase___default.a.functions().httpsCallable('accountDeleteProduct');
                _context6.next = 14;
                return accountDeleteProduct(data);

              case 14:
                result = _context6.sent;

                prod.deleting = false;
                _this7.showNotify('Product ' + prod.name + ' deleted.', 'success', 'Success');
                _this7.productsTable.splice(_this7.prodIdIndexMap.get(prodId), 1);
                _context6.next = 26;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0);
                prod.deleting = false;
                _this7.productsTableKey = _this7.$uuid.v4();
                __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default.a.fire({
                  title: 'Cannot Be Deleted',
                  text: 'This product cannot be deleted as it contains existing Authentic.net codes. Would you like to archive it instead?',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-info btn-fill',
                  cancelButtonClass: 'btn btn-danger btn-fill',
                  confirmButtonText: 'Yes, archive it!',
                  buttonsStyling: false
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(result) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!result.value) {
                              _context5.next = 3;
                              break;
                            }

                            _context5.next = 3;
                            return _this7.archiveProduct(prod);

                          case 3:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this7);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 26:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 20]]);
      }))();
    },
    archiveProduct: function archiveProduct(product) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection('brands/' + _this8.accountData.activeBrand.id + '/products').doc(product.id).update({ isArchived: true });

              case 2:
                product.isArchived = true;
                if (!_this8.showArchived) _this8.productsTable.splice(_this8.prodIdIndexMap.get(product.id), 1);
                _this8.showNotify('Product ' + product.name + ' archived.', 'success', 'Success');

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    unArchiveProduct: function unArchiveProduct(product) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('unarchiving');
                product.unarchiving = true;
                _this9.productsTableKey = _this9.$uuid.v4();
                _context8.next = 5;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection('brands/' + _this9.accountData.activeBrand.id + '/products').doc(product.id).update({ isArchived: false });

              case 5:
                product.isArchived = false;
                product.unarchiving = false;
                if (_this9.showArchived) _this9.productsTable.splice(_this9.prodIdIndexMap.get(product.id), 1);
                _this9.productsTableKey = _this9.$uuid.v4();
                _this9.showNotify('Product ' + product.name + ' un-archived.', 'success', 'Success');

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this10 = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this10.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    },
    clickAmzImportBtn: function clickAmzImportBtn() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var path, qs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                path = 'accounts/' + _this11.accountData.authDetails.account.id + '/amzProducts';

                console.log('getting amzProduct', path);
                _context9.next = 4;
                return __WEBPACK_IMPORTED_MODULE_18__components_firebase_init__["a" /* default */].collection(path).limit(1).get();

              case 4:
                qs = _context9.sent;

                if (qs.empty) {
                  __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default.a.fire({
                    title: 'Amazon Not Connected',
                    text: 'Please add your Amazon API details to your account page.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  }).then(function () {
                    _this11.$router.replace({ name: 'Account' });
                  });
                } else {
                  _this11.$router.replace({ name: 'Amazon' });
                }

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    searchProducts: function searchProducts(query) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var index, result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, prodData, samePrevProd, product;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(query === '')) {
                  _context10.next = 4;
                  break;
                }

                _this12.getProducts();
                _context10.next = 49;
                break;

              case 4:
                index = algolia.initIndex('brands_' + _this12.accountData.activeBrand.id + '_products');
                _context10.next = 7;
                return index.search(query);

              case 7:
                result = _context10.sent;

                _this12.showingAllProducts = true;
                _this12.productsTable = [];
                _this12.prodIdIndexMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context10.prev = 14;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.hits);

              case 16:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context10.next = 35;
                  break;
                }

                prodData = _step3.value;

                if (!(!_this12.showArchived && prodData.isArchived)) {
                  _context10.next = 20;
                  break;
                }

                return _context10.abrupt('continue', 32);

              case 20:
                samePrevProd = __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.find(_this12.productsTable, { name: prodData.name });

                if (!(samePrevProd !== undefined)) {
                  _context10.next = 25;
                  break;
                }

                samePrevProd.isParent = true;
                _context10.next = 32;
                break;

              case 25:
                product = prodData;

                product.id = prodData.objectID;
                _context10.next = 29;
                return _this12.prodImgUrl(prodData.objectID, prodData, '140x140');

              case 29:
                product.image = _context10.sent;

                _this12.productsTable.push(product);
                _this12.prodIdIndexMap.set(prodData.objectID, _this12.productsTable.length - 1);

              case 32:
                _iteratorNormalCompletion3 = true;
                _context10.next = 16;
                break;

              case 35:
                _context10.next = 41;
                break;

              case 37:
                _context10.prev = 37;
                _context10.t0 = _context10['catch'](14);
                _didIteratorError3 = true;
                _iteratorError3 = _context10.t0;

              case 41:
                _context10.prev = 41;
                _context10.prev = 42;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 44:
                _context10.prev = 44;

                if (!_didIteratorError3) {
                  _context10.next = 47;
                  break;
                }

                throw _iteratorError3;

              case 47:
                return _context10.finish(44);

              case 48:
                return _context10.finish(41);

              case 49:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[14, 37, 41, 49], [42,, 44, 48]]);
      }))();
    }
  },
  watch: {
    showArchived: function showArchived(newFrom, oldFrom) {
      this.getProducts();
    },
    searchQuery: function searchQuery(newFrom, oldFrom) {
      this.searchProducts(newFrom);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cQ5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])(['password', 'passwordConfirm'])),
  data: function data() {
    return {
      loading: false,
      model: {
        password: '',
        passwordConfirm: ''
      },
      modelValidations: {
        password: {
          required: true,
          confirmed: 'passwordConfirm'
        },
        passwordConfirm: {
          required: true
        }
      },
      oobCode: ''
    };
  },

  methods: {
    init: function init() {
      this.oobCode = this.$route.params.oobCode;
    },
    validateThenSubmit: function validateThenSubmit() {
      var _this = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.submit();
        } else {
          _this.loading = false;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().confirmPasswordReset(this.oobCode, this.model.password).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
          title: 'Success!',
          text: 'Your password was reset. Please proceed to login.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(function () {
          _this2.loading = false;
          _this2.$router.replace('/login');
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
          title: 'Error',
          text: error.message + ' Please try to reset your password again or contact support.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this2.loading = false;
          _this2.$router.replace('/login');
        });
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "cSmf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__("t/3K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d541dab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__("/LT4");
function injectStyle (ssrContext) {
  __webpack_require__("NtsG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d541dab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cU0y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cYn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__ = __webpack_require__("saoD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7149b39c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__ = __webpack_require__("KGGw");
function injectStyle (ssrContext) {
  __webpack_require__("sj6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7149b39c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cofp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dF6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.brands),function(brand){return _c('div',{key:brand.id},[_c('brand-overview-stats',{attrs:{"brand":brand}}),_vm._v(" "),_c('hr')],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dXgL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("XIFX");
function injectStyle (ssrContext) {
  __webpack_require__("YNHp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "duHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__ = __webpack_require__("RXFM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__ = __webpack_require__("qQLU");
function injectStyle (ssrContext) {
  __webpack_require__("Mi7u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e0s5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216356f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("E8iM");
function injectStyle (ssrContext) {
  __webpack_require__("+pYx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216356f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eFVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eSYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__ = __webpack_require__("VL41");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e687522_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__ = __webpack_require__("M9U0");
function injectStyle (ssrContext) {
  __webpack_require__("rtAg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e687522_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eSiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__ = __webpack_require__("gww+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cddf9a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__ = __webpack_require__("md9a");
function injectStyle (ssrContext) {
  __webpack_require__("jpoA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cddf9a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "edqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized)?_c('div',[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card",staticStyle:{"text-align":"center","padding":"50px"}},[_c('h1',[_vm._v("Welcome to Authentic.net")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.5em"}},[_vm._v("\n          Let's take 2 minutes to get you settled in. Provide your account details below.\n        ")]),_vm._v(" "),(_vm.userAuth.phoneNumber)?_c('p',{staticClass:"text-success"},[_vm._v("DONE. Profile details completed.")]):_vm._e(),_vm._v(" "),(!_vm.userAuth.phoneNumber)?_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.user.data.firstName),expression:"profile.user.data.firstName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.profile.user.data.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.user.data, "firstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.user.data.lastName),expression:"profile.user.data.lastName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.profile.user.data.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.user.data, "lastName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.authUser.phoneNumber),expression:"profile.authUser.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.profile.authUser.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.authUser, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.account.data.businessName),expression:"profile.account.data.businessName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.profile.account.data.businessName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.account.data, "businessName", $event.target.value)}}})]),_vm._v(" "),(!_vm.profile.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.profile.loading)?_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(0),_vm._v("\n            Submit\n          ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card",staticStyle:{"text-align":"center","padding":"50px"}},[_c('h2',[_vm._v("1. Security for your products")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.5em"}},[_vm._v("\n          Your private key is below. Please copy it and store it in a very safe place where it cannot be lost.\n          Your unique-in-the-world Authentic.net product codes are encrypted and nobody, not even Authentic.net, will be able\n          to decrypt them for you without this key. Normal Authentic.net operation does not require decrypting product\n          codes, but should you need to export your codes in bulk in the future then they will only be useful with this key.\n        ")]),_vm._v(" "),(!_vm.userAuth.phoneNumber)?_c('p',{staticClass:"text-danger"},[_vm._v("Please complete your account details first.")]):_vm._e(),_vm._v(" "),(_vm.userAuth.phoneNumber)?_c('div',[(!_vm.account.data.privateKey)?_c('p',{staticClass:"text-success"},[_vm._v("DONE. Private Key Deleted.")]):_vm._e(),_vm._v(" "),(_vm.account.data.privateKey)?_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Your Private Key")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.account.data.privateKey))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){$event.preventDefault();_vm.deletePrivateKey()}}},[_vm._v("I Saved My Private Key")])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card",staticStyle:{"text-align":"center","padding":"50px"}},[_c('h2',[_vm._v("2. Add your first brand")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.5em"}},[_vm._v("\n          Please provide your brand name and logo. If you are a startup and you do not yet have an official brand name\n          then provide whatever label you want to categorize your first product(s) under.\n        ")]),_vm._v(" "),(!_vm.userAuth.phoneNumber || _vm.account.data.privateKey)?_c('p',{staticClass:"text-danger"},[_vm._v("Before adding your first brand please finish step 1.")]):_vm._e(),_vm._v(" "),(_vm.userAuth.phoneNumber && !_vm.account.data.privateKey && _vm.brand.data)?_c('p',{staticClass:"text-success"},[_vm._v("DONE. Brand added.")]):_vm._e(),_vm._v(" "),(_vm.userAuth.phoneNumber && !_vm.account.data.privateKey && !_vm.brand.data)?_c('div',[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Brand Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBrand.name),expression:"newBrand.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.newBrand.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBrand, "name", $event.target.value)}}})])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Logo (image file)")]),_vm._v(" "),_c('input',{ref:"brandImageFile",attrs:{"type":"file","name":"brandImageFile","accept":"image/*"},on:{"change":_vm.selectBrandImageFile}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-control",attrs:{"type":"text","name":"logoUrl"}}),_vm._v(" "),_c('p-progress',{attrs:{"value":_vm.brandLogoUploadProgress,"type":"info"}})],1)]),_vm._v(" "),(!_vm.loading && !_vm.brand.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){$event.preventDefault();return _vm.addBrand($event)}}},[_vm._v("Add Brand")]):_vm._e(),_vm._v(" "),(_vm.loading || _vm.brand.loading)?_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n            Add Brand\n          ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card",staticStyle:{"text-align":"center","padding":"50px"}},[_c('h2',[_vm._v("3. Add your first product")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.5em"}},[_vm._v("\n          Please provide your product name and image. We will then immediately create your first Authentic.net product code!\n        ")]),_vm._v(" "),(!_vm.brand.data)?_c('p',{staticClass:"text-danger"},[_vm._v("Before adding your first product please finish step 2.")]):_vm._e(),_vm._v(" "),(_vm.brand.data && _vm.product.data)?_c('p',{staticClass:"text-success"},[_vm._v("DONE. Product added.")]):_vm._e(),_vm._v(" "),(_vm.brand.data && !_vm.product.data)?_c('div',[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Product Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProd.name),expression:"newProd.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.newProd.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newProd, "name", $event.target.value)}}})])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Product Image (image file)")]),_vm._v(" "),_c('input',{ref:"prodImageFile",attrs:{"type":"file","name":"prodImageFile","accept":"image/*"},on:{"change":_vm.selectProdImageFile}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-control",attrs:{"type":"text","name":"logoUrl"}}),_vm._v(" "),_c('p-progress',{attrs:{"value":_vm.prodImageUploadProgress,"type":"info"}})],1)]),_vm._v(" "),(!_vm.loading && !_vm.product.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){$event.preventDefault();return _vm.addProd($event)}}},[_vm._v("Add Product")]):_vm._e(),_vm._v(" "),(_vm.loading || _vm.product.loading)?_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n            Add Product\n          ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card",staticStyle:{"text-align":"center","padding":"50px"}},[_c('h2',[_vm._v("Try validating your first Authentic.net product code!")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.5em"}},[_vm._v("\n          The link below as well as the QR code display both contain your first Authentic.net product code.\n          Click the link or scan the code below to initiate the product validation process.\n          Once you get confirmation that your code is authentic you will be redirected back here.\n        ")]),_vm._v(" "),(!_vm.product.data)?_c('p',{staticClass:"text-danger"},[_vm._v("Please finish step 3 to generate your first Authentic.net product code.")]):_vm._e(),_vm._v(" "),(_vm.qrInitiated && !_vm.codeValue)?_c('div',[_c('p',[_vm._v("Generating Authentic.net product code...")]),_vm._v(" "),_c('p-progress',{staticStyle:{"width":"50%","margin-left":"auto","margin-right":"auto"},attrs:{"value":_vm.qrProgress,"type":"info"}})],1):_vm._e(),_vm._v(" "),(_vm.product.data && _vm.codeValue)?_c('div',[_c('p',{staticStyle:{"font-size":"1.5em","font-weight":"bold"}},[_c('a',{attrs:{"href":_vm.codeValue}},[_vm._v("Click Here")])]),_vm._v(" "),_c('p',[_vm._v("-OR-")]),_vm._v(" "),_c('p',[_vm._v("Scan:")]),_vm._v(" "),(!!_vm.qrValue)?_c('qrcode',{attrs:{"value":_vm.qrValue,"options":{ size: 200 }}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n            *Under normal circumstances your unique Authentic.net product codes will be printed directly\n            to labels using your Dymo printer, but we are displaying this one on screen so you can quickly test it.\n          ")])],1):_vm._e()])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eh+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Where did you get this product?")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Website URL")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.websiteUrl),expression:"modelValidations.websiteUrl"},{name:"model",rawName:"v-model",value:(_vm.model.websiteUrl),expression:"model.websiteUrl"}],staticClass:"form-control",attrs:{"type":"text","name":"websiteUrl","url":"true","placeholder":"ex: https://www.ebay.com"},domProps:{"value":(_vm.model.websiteUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "websiteUrl", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.websiteUrl.invalid),expression:"websiteUrl.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('websiteUrl'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Seller/Store Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.sellerName),expression:"modelValidations.sellerName"},{name:"model",rawName:"v-model",value:(_vm.model.sellerName),expression:"model.sellerName"}],staticClass:"form-control",attrs:{"type":"text","name":"sellerName","placeholder":"Seller username or name of physical store"},domProps:{"value":(_vm.model.sellerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "sellerName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.sellerName.invalid),expression:"sellerName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('sellerName'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          City\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.sellerCity),expression:"model.sellerCity"}],staticClass:"form-control",attrs:{"type":"text","name":"sellerCity"},domProps:{"value":(_vm.model.sellerCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "sellerCity", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          State\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.sellerState),expression:"model.sellerState"}],staticClass:"form-control",attrs:{"type":"text","name":"sellerState"},domProps:{"value":(_vm.model.sellerState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "sellerState", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.sellerCountry),expression:"model.sellerCountry"}],staticClass:"form-control",attrs:{"type":"text","name":"sellerCountry","placeholder":"ex: USA"},domProps:{"value":(_vm.model.sellerCountry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "sellerCountry", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eseW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationsCards_vue__ = __webpack_require__("c+YU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36995ace_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationsCards_vue__ = __webpack_require__("keRZ");
function injectStyle (ssrContext) {
  __webpack_require__("8S5e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationsCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36995ace_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationsCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f4B7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f6/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__ = __webpack_require__("0Bz4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__ = __webpack_require__("+mNl");
function injectStyle (ssrContext) {
  __webpack_require__("LRfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f90e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("What product did you purchase?")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Brand\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.brand),expression:"modelValidations.brand"},{name:"model",rawName:"v-model",value:(_vm.model.brand),expression:"model.brand"}],staticClass:"form-control",attrs:{"type":"text","name":"brand","placeholder":"ex: Nike"},domProps:{"value":(_vm.model.brand)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "brand", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.brand.invalid),expression:"brand.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('brand'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Product\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.product),expression:"modelValidations.product"},{name:"model",rawName:"v-model",value:(_vm.model.product),expression:"model.product"}],staticClass:"form-control",attrs:{"type":"text","name":"product","placeholder":"ex: Air Presto"},domProps:{"value":(_vm.model.product)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "product", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.product.invalid),expression:"product.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('product'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fP9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__ = __webpack_require__("a8eF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__ = __webpack_require__("BYD1");
function injectStyle (ssrContext) {
  __webpack_require__("bTbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fYtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("badge",[_c('div',{staticClass:"timeline-badge",class:_vm.badgeType},[_c('i',{class:_vm.badgeIcon})])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"timeline-body"},[_vm._t("body")],2),_vm._v(" "),_c('h6',[_vm._t("footer")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fm0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__("iGuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__("CRWE");
function injectStyle (ssrContext) {
  __webpack_require__("IWrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fm3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbellBasic_vue__ = __webpack_require__("YDyv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef2ea52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbellBasic_vue__ = __webpack_require__("MYWa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbellBasic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef2ea52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbellBasic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gP6t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gPlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      proposed_code_value: '',
      code_value: ''
    };
  },

  methods: {
    makeQrcode: function makeQrcode() {
      this.code_value = this.proposed_code_value;
    }
  }
});

/***/ }),

/***/ "gh99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("lITe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d894f82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("3Pfw");
function injectStyle (ssrContext) {
  __webpack_require__("Q7zI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d894f82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gww+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__ = __webpack_require__("jPKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__ = __webpack_require__("oE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    FirstStep: __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__["a" /* default */],
    SecondStep: __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__["a" /* default */]
  },
  methods: {
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire('Good job!', 'You clicked the finish button!', 'success');
    }
  }
});

/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hJZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_firebase_init__ = __webpack_require__("S85j");













/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  data: function data() {
    return {
      loading: false,
      recaptcha: {
        verifier: null,
        confirmationResult: null,
        widgetId: null
      },
      user: {
        email: '',
        name: '',
        id: '',
        accountId: ''
      },
      model: {
        emailphone: ''
      },
      modelValidations: {
        emailphone: {
          required: true
        }
      }
    };
  },

  methods: {
    init: function init() {
      if (this.$route.query.logout) this.logout();
      this.setupRecaptcha();
    },
    setupRecaptcha: function setupRecaptcha() {
      var _this = this;

      var self = this;

      this.recaptcha.verifier = new __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth.RecaptchaVerifier('submit-btn', {
        size: 'invisible',
        callback: function callback(response) {
          console.log('solved ' + response);
          _this.login();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'There was a problem validating captcha',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }
      });

      this.recaptcha.verifier.render().then(function (widgetId) {
        _this.recaptcha.widgetId = widgetId;
      });
    },
    resetRecaptcha: function resetRecaptcha() {
      window.grecaptcha.reset(this.recaptcha.widgetId);
    },
    login: function login() {
      if (this.model.emailphone.includes('@')) this.loginEmail();else this.loginPhone();
    },
    loginEmail: function loginEmail() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var signingMethods, actionCodeSettings;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().fetchSignInMethodsForEmail(_this2.model.emailphone);

              case 2:
                signingMethods = _context.sent;

                if (signingMethods.indexOf('emailLink') === -1) {
                  __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: 'An account with that email address was not found.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                } else {
                  actionCodeSettings = {
                    url: "http://localhost:8000" + '/admin/dashboard',

                    handleCodeInApp: true
                  };

                  __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().sendSignInLinkToEmail(_this2.model.emailphone, actionCodeSettings).then(function () {
                    window.localStorage.setItem('emailForSignIn', _this2.model.emailphone);
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                      imageUrl: 'static/img/auth_logo_small_2.png',
                      imageWidth: 84,
                      imageHeight: 84,
                      imageAlt: 'Authentic.net logo',
                      title: 'Login Link Sent',
                      text: 'Please check your email and click the provided link to login.',
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-success btn-fill'
                    });
                  }).catch(function (error) {
                    console.log(error);
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    loginPhone: function loginPhone() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var phone, phoneUserExists, existsResult, recaptchaVerifier;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                phone = '+1' + _this3.model.emailphone;
                phoneUserExists = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.functions().httpsCallable('phoneUserExists');
                _context2.next = 4;
                return phoneUserExists({ phoneNumber: phone });

              case 4:
                existsResult = _context2.sent;

                if (!existsResult.data.success) {
                  __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: 'Phone number not found.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                  _this3.resetRecaptcha();
                } else {
                  recaptchaVerifier = _this3.recaptcha.verifier;

                  __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signInWithPhoneNumber(phone, recaptchaVerifier).then(function (confirmationResult) {
                    console.log('code sent, result:');
                    console.log(confirmationResult);
                    _this3.requestSmsCode(confirmationResult);
                  }).catch(function (error) {
                    console.log('error sending phone to firebase');
                    console.log(error);
                  });
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    login2: function login2() {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signInWithEmailAndPassword(this.model.email, this.model.password).then(function (cred) {
        _this4.user.email = cred.user.email;
        _this4.user.id = cred.user.uid;
        return __WEBPACK_IMPORTED_MODULE_9__components_firebase_init__["a" /* default */].collection('users').doc(cred.user.uid).get();
      }).then(function (doc) {
        _this4.user.name = doc.data().name;
        _this4.user.accountId = doc.data().accountId;
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].setUser(_this4.user);
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this4.apiBaseUrl + 'getClientIp');
      }).then(function (response) {
        if (!response.data.success) return false;else return __WEBPACK_IMPORTED_MODULE_9__components_firebase_init__["a" /* default */].collection('users').doc(_this4.user.id).update({ lastLoginIp: response.data.ipAddress });
      }).then(function (docRef) {
        return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'SMS Verification',
          text: 'Please provide your mobile number:',
          type: 'question',
          input: 'text',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false,
          inputPlaceholder: 'Mobile Number'
        });
      }).then(function (result) {
        console.log('phone input');
        console.log(result);
        var phone = result.value;
        var recaptchaVerifier = _this4.recaptcha.verifier;
        __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signInWithPhoneNumber(phone, recaptchaVerifier).then(function (confirmationResult) {
          console.log('code sent, result:');
          console.log(confirmationResult);
          _this4.requestSmsCode(confirmationResult);
        }).catch(function (error) {
          console.log('error sending phone to firebase');
          console.log(error);
        });
      }).catch(function (err) {
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'Error',
          text: err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this4.loading = false;
        _this4.resetRecaptcha();
      });
    },
    requestSmsCode: function requestSmsCode(confirmationResult) {
      var _this5 = this;

      console.log('in requestSmsCode');
      console.log(confirmationResult);
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
        imageUrl: 'static/img/auth_logo_small_2.png',
        imageWidth: 84,
        imageHeight: 84,
        imageAlt: 'Authentic.net logo',
        title: 'SMS Verification',
        text: 'Please provide the code sent to your mobile device:',
        input: 'text',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false,
        inputPlaceholder: 'Mobile Number'
      }).then(function (inputResult) {
        confirmationResult.confirm(inputResult.value).then(function (result) {
          _this5.$router.replace(_this5.$route.query.redirect || { name: 'Dashboard' });
        }).catch(function (error) {
          console.log(error);
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Error',
            text: error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        });
      });
    },
    logout: function logout() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signOut().then(function () {}).catch(function (error) {
        var errMsg = error.message;
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'Error',
          text: errMsg,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this6.loading = false;
        _this6.resetRecaptcha();
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "hLIO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("0YV8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064f4a4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("oEyC");
function injectStyle (ssrContext) {
  __webpack_require__("9l7r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064f4a4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hfQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventBus__ = __webpack_require__("O6e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");












/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    authDetails: {
      type: Object,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* mapFields */])(['firstName', 'lastName'])),
  data: function data() {
    return {
      modelValidations: {
        firstName: {
          required: true
        },
        lastName: {
          required: true
        }
      },
      loading: false,
      details: [{
        title: '...',
        subTitle: 'Protected Products'
      }, {
        title: '...',
        subTitle: 'Validated Products'
      }, {
        title: '...',
        subTitle: 'Registered Products'
      }],
      recaptcha: {
        verifier: null,
        confirmationResult: null,
        widgetId: null
      }
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('authDetails');
                console.log(_this.authDetails);
                _this.details[0].title = _this.authDetails.account.data.qtyCertified;
                _this.details[1].title = _this.authDetails.account.data.qtyValidated;
                _this.details[2].title = _this.authDetails.account.data.qtyRegistrations;
                _this.setupRecaptcha();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setupRecaptcha: function setupRecaptcha() {
      var _this2 = this;

      this.recaptcha.verifier = new __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth.RecaptchaVerifier('update-phone', {
        size: 'invisible',
        callback: function callback(response) {
          console.log('solved ' + response);
          _this2.updatePhone();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'There was a problem validating captcha',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }
      });

      this.recaptcha.verifier.render().then(function (widgetId) {
        _this2.recaptcha.widgetId = widgetId;
      });
    },
    resetRecaptcha: function resetRecaptcha() {
      window.grecaptcha.reset(this.recaptcha.widgetId);
    },
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    },
    updateEmail: function updateEmail() {
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
        title: 'New Email Address',
        text: 'Please provide your new email address below. Note that a notification of the change will be sent to the current address.',
        type: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false,
        inputPlaceholder: 'user@domain.com'
      }).then(function (newEmailInputResult) {
        return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.updateEmail(newEmailInputResult.value);
      }).then(function () {
        console.log('emitting');
        __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* EventBus */].$emit('auth-refreshed');
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'Saved',
          text: 'Your email address was updated.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      }).catch(function (error) {
        console.log(error);
        if (error.code === 'auth/requires-recent-login') {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'Sorry, changing your email requires recently logging in. Please log out and log in then try again.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Error',
            text: 'There was a problem updating your email address. Please try again and contact support if it persists. Details: ' + error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    updatePhone: function updatePhone() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
        title: 'New Mobile Number',
        text: 'Please provide the new mobile number:',
        type: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false,
        inputPlaceholder: '5556667777'
      }).then(function (newPhoneInputResult) {
        var newPhone = '+1' + newPhoneInputResult.value;
        var provider = new __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth.PhoneAuthProvider();
        return provider.verifyPhoneNumber(newPhone, _this3.recaptcha.verifier);
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(verificationId) {
          var inputResult;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                    title: 'SMS Verification',
                    text: 'An authentication code was sent to your new phone number. Please provide it below:',
                    type: 'question',
                    input: 'text',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false,
                    inputPlaceholder: 'SMS Auth Code'
                  });

                case 2:
                  inputResult = _context2.sent;
                  return _context2.abrupt('return', {
                    verificationId: verificationId,
                    phone: inputResult.value
                  });

                case 4:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).then(function (result) {
        console.log('verificationId');
        console.log(result);
        return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth.PhoneAuthProvider.credential(result.verificationId, result.phone);
      }).then(function (phoneCredential) {
        return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.updatePhoneNumber(phoneCredential);
      }).then(function () {
        console.log('emitting');
        __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* EventBus */].$emit('auth-refreshed');
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'Saved',
          text: 'Your phone number was updated.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      }).catch(function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
          title: 'Error',
          text: 'There was a problem updating your phone number. Please try again and contact support if it persists. Details: ' + error.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this3.resetRecaptcha();
      });
    },
    updateUser: function updateUser() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__components_firebase_init__["a" /* default */].collection('users').doc(this.authDetails.user.id).update(this.authDetails.user.data).then(function () {
        _this4.showNotify('User information saved.', 'success', 'Success');
        _this4.loading = false;
      }).catch(function (error) {
        _this4.showNotify(error, 'danger', 'Failed');
        _this4.loading = false;
      });
    },
    submit: function submit() {
      var _this5 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.updateUser();
        } else {
          _this5.loading = false;
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this6.init();

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
});

/***/ }),

/***/ "hpmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FraudReport_vue__ = __webpack_require__("2TRN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f701e702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FraudReport_vue__ = __webpack_require__("/onm");
function injectStyle (ssrContext) {
  __webpack_require__("xBWl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FraudReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f701e702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FraudReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hzu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-info btn-xs btn-icon like",on:{"click":function($event){_vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-warning btn-xs btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-danger btn-xs btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row table-full-width"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-shopping",staticStyle:{"width":"100%"},attrs:{"summary-method":_vm.getSummaries,"show-summary":"","data":_vm.productsTable}},[_c('el-table-column',{attrs:{"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.image,"alt":"Agenda"}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(props.row.subTitle))])]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-price",attrs:{"min-width":"80","label":"Price"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.price)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"150","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.quantity)+"\n                "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity > 0 ? props.row.quantity-- : 0}}},[_c('i',{staticClass:"ti-minus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity++}}},[_c('i',{staticClass:"ti-plus"})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.quantity * props.row.price)+" ")])]}}])})],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Links")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Switches")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With some subtitle")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table Big Boy")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("A table for content management")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/rH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"row",attrs:{"id":"loading"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0bx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__ = __webpack_require__("sTXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__ = __webpack_require__("Hyh/");
function injectStyle (ssrContext) {
  __webpack_require__("M0iJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i5GK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"title":"Personal details","before-change":_vm.validateFirstStep,"icon":"ti-user"}},[_c('first-step',{ref:"firstStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Additional Info","before-change":_vm.validateSecondStep,"icon":"ti-settings"}},[_c('second-step',{ref:"secondStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Last step","icon":"ti-check"}},[_c('h2',{staticClass:"text-center text-space"},[_vm._v("Yuhuuu!\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Click on \""),_c('b',[_vm._v("Finish")]),_vm._v("\" to join our community")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finish")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iBV3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iEkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scan_vue__ = __webpack_require__("Ohvx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f715784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scan_vue__ = __webpack_require__("m/1O");
function injectStyle (ssrContext) {
  __webpack_require__("asr8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f715784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iGuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    task: {
      type: Object,
      default: function _default() {
        return {
          title: ''
        };
      }
    },
    index: Number
  },
  methods: {
    handleEditClick: function handleEditClick() {
      this.$emit('on-edit', this.index);
    },
    handleDeleteClick: function handleDeleteClick() {
      this.$emit('on-delete', this.index);
    }
  }
});

/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "ifSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84602f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("Vhaa");
function injectStyle (ssrContext) {
  __webpack_require__("4Urk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84602f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "iogT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jBHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email'])),
  data: function data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        email: ''
      },
      modelValidations: {
        firstName: {
          min: 5
        },
        lastName: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "jGUO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"#"},on:{"submit":function($event){$event.preventDefault();}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("QR Code Value")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proposed_code_value),expression:"proposed_code_value"}],staticClass:"form-control",attrs:{"type":"text","name":"proposed_code_value"},domProps:{"value":(_vm.proposed_code_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.proposed_code_value=$event.target.value}}})])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.makeQrcode()}}},[_vm._v("Make QR Code")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(!!_vm.code_value)?_c('qrcode',{attrs:{"value":_vm.code_value,"options":{ size: 200 }}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("QR Code Generator")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jJHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__ = __webpack_require__("PzXG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__ = __webpack_require__("hzu0");
function injectStyle (ssrContext) {
  __webpack_require__("LQk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jPKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("Rrpr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("uOOa");
function injectStyle (ssrContext) {
  __webpack_require__("UQPL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jcvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      details: [{
        title: '12',
        subTitle: 'Files'
      }, {
        title: '2GB',
        subTitle: 'Used'
      }, {
        title: '24,6$',
        subTitle: 'Spent'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    }
  }
});

/***/ }),

/***/ "jpoA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k8VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__ = __webpack_require__("HHnu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__ = __webpack_require__("A+TP");
function injectStyle (ssrContext) {
  __webpack_require__("qAgR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kEU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("rgxH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd6c35e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("eh+s");
function injectStyle (ssrContext) {
  __webpack_require__("T254")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd6c35e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kKCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['website', 'language', 'bootstrapVersion'])),
  data: function data() {
    return {
      model: {
        website: '',
        frameworkType: '',
        language: '',
        bootstrapVersion: '',
        price: ''
      },
      modelValidations: {
        website: {
          url: true,
          required: true
        },
        language: {
          required: true
        },
        bootstrapVersion: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "kMQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please tell us more about yourself.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          First Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"},{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"ex: Mike"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('firstName'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Last Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"},{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"ex: Andrew"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('lastName'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("+2Xc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "keRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isSearch && _vm.queriedData.length == 0)?_c('div',{staticClass:"row"},[(_vm.initialized)?_c('h4',[_vm._v("No registrations exist for "+_vm._s(_vm.accountData.activeBrand.data.name)+".")]):_vm._e(),_vm._v(" "),(!_vm.initialized)?_c('h4',[_vm._v("Loading...")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isSearch || _vm.queriedData.length > 0)?_c('div',{staticClass:"row"},[(!_vm.isSearch)?_c('div',{staticClass:"pull-right"},[(!_vm.csvLoading)?_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();_vm.downloadRegCsv()}}},[_vm._v("Download CSV")]):_vm._e(),_vm._v(" "),(_vm.csvLoading)?_c('button',{staticClass:"btn btn-sm",staticStyle:{"margin-top":"5px"},attrs:{"type":"button","disabled":"disabled"}},[_vm._m(0),_vm._v("\n        Processing...\n      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-4 pagination-info"},[(!_vm.isSearch)?_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.watchPerPage),callback:function ($$v) {_vm.watchPerPage=$$v},expression:"watchPerPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":_vm.perPageLabel(item),"value":item}})})):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('form',{staticClass:"navbar-form navbar-left navbar-search-form",attrs:{"role":"search","_lpchecked":"1"}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"background-color":"#fff"},attrs:{"type":"text","value":"","placeholder":"Search..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[(!_vm.isSearch)?_c('div',{staticClass:"pull-right"},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.pagination.currentPage === 1}},[(_vm.pagination.currentPage !== 1)?_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":function($event){_vm.queryData('prev')}}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.pagination.currentPage === 1)?_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous","href":"javascript:void(0);"}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.pagination.isLastPage}},[(!_vm.pagination.isLastPage)?_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":function($event){_vm.queryData('next')}}},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.pagination.isLastPage)?_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next","href":"javascript:void(0);"}},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})]):_vm._e()])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.queriedData.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.queriedData),function(reg){return _c('div',{key:reg.id,staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"img-container"},[(reg.productLoaded)?_c('img',{attrs:{"src":reg.imageUrl,"width":"140","height":"140"}}):_vm._e(),_vm._v(" "),(!reg.productLoaded)?_c('span',[_vm._v("loading...")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[(reg.productLoaded)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.limitChars(reg.productName)))])]):_vm._e(),_vm._v(" "),(!reg.productLoaded)?_c('p',[_c('strong',[_vm._v("loading...")])]):_vm._e(),_vm._v("\n              "+_vm._s(reg.firstName)+" "+_vm._s(reg.lastName)),_c('br'),_vm._v("\n              "+_vm._s(reg.email)),_c('br'),_vm._v("\n              "+_vm._s(_vm.addressRegion(reg))),_c('br'),_vm._v("\n              "+_vm._s(reg.country)+" \n            ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('i',{staticClass:"ti-time"}),_vm._v(" "+_vm._s(reg.friendlyDate)+"\n          "),_c('button',{staticClass:"btn btn-fill btn-sm pull-right",on:{"click":function($event){$event.preventDefault();_vm.regDetailsPopup(reg)}}},[_vm._v("View Details")])])])])})):_vm._e(),_vm._v(" "),(!_vm.isSearch && _vm.queriedData.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.watchPerPage),callback:function ($$v) {_vm.watchPerPage=$$v},expression:"watchPerPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":_vm.perPageLabel(item),"value":item}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.pagination.currentPage === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":function($event){_vm.queryData('prev')}}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.pagination.isLastPage}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":function($event){_vm.queryData('next')}}},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lITe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__["Card"] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      stripeSettings: {
        pubKey: "pk_test_6X1FCIrK5VRo2DrAZW4GsO5u",
        options: {
          classes: {
            base: 'form-control'
          }
        },
        class: {
          complete: false
        },
        style: {
          base: {
            color: 'yellow',
            fontFamily: 'inherit',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      },
      creditCard: {
        display: 'Loading...',
        update: false,
        loadingSubmit: false,
        stripeToken: ''
      }
    };
  },

  methods: {
    init: function init() {
      this.getCreditCard();
    },
    getCreditCard: function getCreditCard() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userToken, data, getAccountStripeCustomer, result, ccData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.getIdToken();

              case 2:
                userToken = _context.sent;
                data = {
                  userToken: userToken
                };
                getAccountStripeCustomer = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.functions().httpsCallable('getAccountStripeCustomer');
                _context.next = 7;
                return getAccountStripeCustomer(data);

              case 7:
                result = _context.sent;

                console.log(result);
                ccData = result.data.customer.sources.data[0];

                _this.creditCard.display = ccData.brand + ': x' + ccData.last4;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateCard: function updateCard() {
      this.creditCard.update = true;
    },
    submit: function submit() {
      var _this2 = this;

      this.creditCard.loadingSubmit = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        if (data.error) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Error',
            text: data.error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
          _this2.creditCard.loadingSubmit = false;
        } else {
          console.log('stripe token');
          console.log(data.token.id);
          _this2.creditCard.stripeToken = data.token.id;
          _this2.submitCardUpdate();
        }
      });
    },
    submitCardUpdate: function submitCardUpdate() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, updateAccountStripeCard;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('updating card');
                data = {};
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.getIdToken();

              case 4:
                data.userToken = _context2.sent;

                data.stripeToken = _this3.creditCard.stripeToken;
                updateAccountStripeCard = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.functions().httpsCallable('updateAccountStripeCard');

                updateAccountStripeCard(data).then(function (result) {
                  console.log(result);
                  var ccData = result.data.customer.sources.data[0];
                  _this3.creditCard.display = ccData.brand + ': x' + ccData.last4;
                  _this3.creditCard.update = false;
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: 'Success!',
                    text: 'Your credit card was changed',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                  }).then(function () {});
                }).catch(function (err) {
                  console.error(err.message);
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "lIyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{ref:"plans",staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card plan-card not-featured-plan"},[_vm._m(1),_vm._v(" "),(_vm.showActivatePlanBtn(0))?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.selectPlan(0)}}},[_vm._v("Activate plan")]):_vm._e(),_vm._v(" "),(_vm.showCurrentPlanBtn(0))?_c('button',{staticClass:"btn btn-default btn-fill",attrs:{"disabled":"disabled"}},[_vm._v("Current plan")]):_vm._e(),_vm._v(" "),(!_vm.showActivatePlanBtn(0) && !_vm.showCurrentPlanBtn(0))?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n          Activate plan\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-cc-required"},[_vm._v("No credit card required")]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card plan-card featured-plan"},[_vm._m(4),_vm._v(" "),(_vm.showActivatePlanBtn(1))?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.selectPlan(1)}}},[_vm._v("Activate plan")]):_vm._e(),_vm._v(" "),(_vm.showCurrentPlanBtn(1))?_c('button',{staticClass:"btn btn-default btn-fill",attrs:{"disabled":"disabled"}},[_vm._v("Current plan")]):_vm._e(),_vm._v(" "),(!_vm.showActivatePlanBtn(1) && !_vm.showCurrentPlanBtn(1))?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(5),_vm._v("\n          Activate plan\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-cc-required"},[_vm._v("No credit card required")]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card plan-card not-featured-plan"},[_vm._m(7),_vm._v(" "),(_vm.showActivatePlanBtn(2))?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.selectPlan(2)}}},[_vm._v("Activate plan")]):_vm._e(),_vm._v(" "),(_vm.showCurrentPlanBtn(2))?_c('button',{staticClass:"btn btn-default btn-fill",attrs:{"disabled":"disabled"}},[_vm._v("Current plan")]):_vm._e(),_vm._v(" "),(!_vm.showActivatePlanBtn(2) && !_vm.showCurrentPlanBtn(2))?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(8),_vm._v("\n          Activate plan\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-cc-required"},[_vm._v("No credit card required")]),_vm._v(" "),_vm._m(9)])])]),_vm._v(" "),_c('div',{staticClass:"row plans-footer"},[_c('p',[_vm._v("Contact us for entrprise level plans and pricing for customized add-ons")]),_vm._v(" "),(_vm.isActive())?_c('p',[_vm._v("Need to cancel your plan? "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.confirmCancel()}}},[_vm._v("Click here")]),_vm._v(".")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"plan-header-container"}},[_c('h1',[_vm._v("Change Your Authentic.net Plan Anytime")]),_vm._v(" "),_c('p',[_vm._v("The best solution for protecting your brand and gaining trust from your customers, built to scale. Upgrade as you grow.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Business Startup 500")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("$49.99 PER MONTH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"plan-desc"},[_c('h6',[_vm._v("Business startup essentials")])]),_vm._v(" "),_c('h6',{staticClass:"plan-inc"},[_vm._v("Includes:")]),_vm._v(" "),_c('ul',[_c('li',[_c('div',[_vm._v("Protect products with 500 Authentic labels per month")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Dashboard")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Amazon.com + 1 additional Retailer / Sales Channel")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("1 User")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("1 Brand")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Dymo Printer Integration")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("FBA / Marketplace label printing")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Unlimited Products / Variations")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Ideal for Small Business Startups")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"card-title"},[_vm._v("Small Business 2000")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("$89.99 PER MONTH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"plan-desc"},[_c('h6',[_vm._v("Flexibility for growth")])]),_vm._v(" "),_c('h6',{staticClass:"plan-inc"},[_vm._v("Includes:")]),_vm._v(" "),_c('ul',[_c('li',[_c('div',[_vm._v("Protect products with 2000 Authentic labels per month")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Dashboard")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("All Amazon + 2 additional Retailers / Sales Channels")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("2 Users")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("2 Brands")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Dymo Printer Integration")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("FBA / Marketplace label printing")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Unlimited Products / Variations")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Enhanced security & encryption")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Perfect for the growing Small Business")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Growing Professional 8000")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("$199 PER MONTH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"plan-desc"},[_c('h6',[_vm._v("Stability at scale")])]),_vm._v(" "),_c('h6',{staticClass:"plan-inc"},[_vm._v("Includes:")]),_vm._v(" "),_c('ul',[_c('li',[_c('div',[_vm._v("Protect products with 8000 Authentic labels per month")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Dashboard")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("All Amazon + 4 additional Retailers / Sales Channels")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("4 Users")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("4 Brands")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Dymo Printer Integration")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("FBA / Marketplace label printing")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Unlimited Products / Variations")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Enhanced security & encryption")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Branded Landing Page")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Digital Registration Warranty Page")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Perfect for the growing Small Business")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lOEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    authDetails: {
      type: Object,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* mapFields */])(['firstName', 'lastName'])),
  data: function data() {
    return {
      modelValidations: {
        firstName: {
          required: true
        },
        lastName: {
          required: true
        }
      },
      loading: false
    };
  },

  methods: {
    updateUser: function updateUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__components_firebase_init__["a" /* default */].collection('users').doc(this.authDetails.user.id).update(this.authDetails.user.data).then(function () {
        _this.showNotify('User information saved.', 'success', 'Success');
        _this.loading = false;
      }).catch(function (error) {
        _this.showNotify(error, 'danger', 'Failed');
        _this.loading = false;
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.updateUser();
        } else {
          _this2.loading = false;
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
});

/***/ }),

/***/ "lS3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Required text")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.requiredText),expression:"modelValidations.requiredText"},{name:"model",rawName:"v-model",value:(_vm.model.requiredText),expression:"model.requiredText"}],staticClass:"form-control",attrs:{"type":"text","name":"requiredText"},domProps:{"value":(_vm.model.requiredText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "requiredText", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredText.invalid),expression:"requiredText.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('requiredText'))+"\n            ")])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('email'))+"\n            ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.number),expression:"modelValidations.number"},{name:"model",rawName:"v-model",value:(_vm.model.number),expression:"model.number"}],staticClass:"form-control",attrs:{"type":"number","name":"number"},domProps:{"value":(_vm.model.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "number", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.number.invalid),expression:"number.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('number'))+"\n            ")])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Url")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.url),expression:"modelValidations.url"},{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"type":"url","name":"url"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.url.invalid),expression:"url.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('url'))+"\n            ")])]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("\n            Equal to\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idSource),expression:"modelValidations.idSource"},{name:"model",rawName:"v-model",value:(_vm.model.idSource),expression:"model.idSource"}],staticClass:"form-control",attrs:{"name":"idSource","placeholder":"#idSource","type":"text"},domProps:{"value":(_vm.model.idSource)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idSource", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idSource.invalid),expression:"idSource.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idSource'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idDestination),expression:"modelValidations.idDestination"},{name:"model",rawName:"v-model",value:(_vm.model.idDestination),expression:"model.idDestination"}],staticClass:"form-control",attrs:{"name":"idDestination","placeholder":"#idDestination","type":"text"},domProps:{"value":(_vm.model.idDestination)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idDestination", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idDestination.invalid),expression:"idDestination.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idDestination'))+"\n            ")])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Validate inputs")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("required:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("email:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("decimal:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("url:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("confirmed : 'idSource'")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lUqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sweet Alert 2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-sweet-alerts"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Basic example")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('basic')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A title with a text under")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('title-and-text')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A success message")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('success-message')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Custom HTML description")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('custom-html')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A warning message, with a function attached to the \"Confirm\" Button...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('warning-message-and-confirmation')}}},[_vm._v("\n              Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("...and by passing a parameter, you can execute something else for \"Cancel\"")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('warning-message-and-cancel')}}},[_vm._v("Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A message with auto close timer set to 2 seconds")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('auto-close')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Modal window with input field")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showswal.fire('input-field')}}},[_vm._v("Try me!")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("A beautiful plugin, that replace the classic alert, Handcrafted by our friend "),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/t4t5"}},[_vm._v("Tristan Edwards")]),_vm._v(". Please check out the "),_c('a',{attrs:{"href":"http://limonte.github.io/sweetalert2/","target":"_blank"}},[_vm._v("full documentation.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lzK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'review-card',
  props: ['ReviewId'],
  methods: {
    confirmReviewRemove: function confirmReviewRemove() {
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Removing a review is permanent!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, remove it!',
        buttonsStyling: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: 'Removed!',
          text: 'The review was successfully removed.',
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        });
      });
    }
  }
});

/***/ }),

/***/ "m/1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('qrcode-reader',{on:{"decode":_vm.onDecode,"locate":_vm.onLocate}})],1)])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center",staticStyle:{"padding-top":"20px"}},[_c('router-link',{staticClass:"btn",attrs:{"to":"/authenticate"}},[_vm._v("\n              Enter Code Manually\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"https://authentic.net"}},[_vm._v("Authentic.net Home")])],1),_vm._v(" "),_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2018 Authentic.net\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v("Authentic.net Scanner")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mYT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('qrcode-reader',{on:{"decode":_vm.onDecode,"locate":_vm.onLocate}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Scanner")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "md9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"title":"Personal details","before-change":_vm.validateFirstStep,"icon":"ti-user"}},[_c('first-step',{ref:"firstStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Additional Info","before-change":_vm.validateSecondStep,"icon":"ti-settings"}},[_c('second-step',{ref:"secondStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Last step","icon":"ti-check"}},[_c('h2',{staticClass:"text-center text-space"},[_vm._v("Yuhuuu!\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Click on \""),_c('b',[_vm._v("Finish")]),_vm._v("\" to join our community")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finish")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("V67u");
function injectStyle (ssrContext) {
  __webpack_require__("J0Sr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mi5c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mj6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullScreenMap_vue__ = __webpack_require__("SUPC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3bbf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullScreenMap_vue__ = __webpack_require__("z48K");
function injectStyle (ssrContext) {
  __webpack_require__("ryiV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullScreenMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3bbf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullScreenMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mmP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      $Chartist: null
    };
  },

  methods: {
    initPerformanceChart: function initPerformanceChart() {
      var dataPerformance = {
        labels: ['6pm', '9pm', '11pm', '2am', '4am', '8am', '2pm', '5pm', '8pm', '11pm', '4am'],
        series: [[1, 6, 8, 7, 4, 7, 8, 12, 16, 17, 14, 13]]
      };

      var optionsPerformance = {
        showPoint: false,
        lineSmooth: true,
        axisX: {
          showGrid: false,
          showLabel: true
        },
        axisY: {
          offset: 40

        },
        low: 0,
        high: 16,
        height: '250px'
      };

      this.$Chartist.Line('#chartPerformance', dataPerformance, optionsPerformance);
    },
    initActivityChart: function initActivityChart() {
      var data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895], [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]]
      };

      var options = {
        seriesBarDistance: 10,
        axisX: {
          showGrid: false
        },
        height: '250px'
      };

      var responsiveOptions = [['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return value[0];
          }
        }
      }]];

      this.$Chartist.Bar('#chartActivity', data, options, responsiveOptions);
    },
    initStockChart: function initStockChart() {
      var dataStock = {
        labels: ['\'07', '\'08', '\'09', '\'10', '\'11', '\'12', '\'13', '\'14', '\'15'],
        series: [[22.20, 34.90, 42.28, 51.93, 62.21, 80.23, 62.21, 82.12, 102.50, 107.23]]
      };
      var optionsStock = {
        lineSmooth: false,
        axisY: {
          offset: 40,
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '$' + value;
          }
        },
        low: 10,
        height: '250px',
        high: 110,
        classNames: {
          point: 'ct-point ct-green',
          line: 'ct-line ct-green'
        }
      };
      this.$Chartist.Line('#chartStock', dataStock, optionsStock);
    },
    initViewsChart: function initViewsChart() {
      var dataViews = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
      };
      var optionsViews = {
        seriesBarDistance: 10,
        classNames: {
          bar: 'ct-bar'
        },
        axisX: {
          showGrid: false
        },
        height: '250px'
      };
      var responsiveOptionsViews = [['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return value[0];
          }
        }
      }]];
      this.$Chartist.Bar('#chartViews', dataViews, optionsViews, responsiveOptionsViews);
    },
    initCharts: function initCharts() {
      this.initPerformanceChart();
      this.initStockChart();
      this.initViewsChart();
      this.initActivityChart();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "715g"));

            case 2:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initCharts();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "mzQ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplates_vue__ = __webpack_require__("VN7e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b520e26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplates_vue__ = __webpack_require__("PExn");
function injectStyle (ssrContext) {
  __webpack_require__("SLHw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b520e26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nFN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"blue","data-image":"static/img/background/architecture-barge-bay-beach-161764.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email Address or Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.emailphone),expression:"model.emailphone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.emailphone),expression:"modelValidations.emailphone"}],staticClass:"form-control input-no-border",attrs:{"type":"text","name":"emailphone","placeholder":"user@email.com / 5556667777"},domProps:{"value":(_vm.model.emailphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "emailphone", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('emailphone'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit","id":"submit-btn"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd ",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n                      Submit\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"signup-link"},[_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("\n                        No Authentic.net Account? Sign Up!\n                      ")])],1)])])])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/architecture-barge-bay-beach-161764.jpg)"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Sign Up")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","padding-top":"20px","padding-bottom":"10px"}},[_c('a',{attrs:{"href":"https://authentic.net"}},[_c('img',{attrs:{"src":"static/img/authentic_net_lt.png","width":"200","alt":"Authentic.net"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Login")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nb01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit()}}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button","id":"submit-btn"},on:{"click":function($event){$event.preventDefault();_vm.activateLoading()}}},[_vm._v("Sign Up!")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(1),_vm._v("\n                      Sign Up!\n                    ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_vm._v(" ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('img',{attrs:{"src":"static/img/authentic_net_lt_color.png","width":"400","alt":"Authentic.net"}}),_vm._v(" "),_c('h4',[_vm._v("Try FREE for the first 30 days!")]),_vm._v(" "),_c('h3',[_vm._v("Provide your email address to get started")]),_vm._v(" "),_c('hr')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"100px"}},[_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Protect Your Customers!")]),_vm._v("\n                  Give your valued customers the tools they need to verify that the products they purchase are genuine.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-package"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Protect Your Brand & Products")]),_vm._v("\n                  Make it impossible for counterfeiters to pretend their products are authentic.\n                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "negu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Team members',
      members: [{
        image: 'static/img/faces/face-0.jpg',
        name: 'Dj Khaled',
        status: 'Offline'
      }, {
        image: 'static/img/faces/face-1.jpg',
        name: 'Creative Tim',
        status: 'Available'
      }, {
        image: 'static/img/faces/face-3.jpg',
        name: 'Flume',
        status: 'Busy'
      }]
    };
  },

  methods: {
    getStatusClass: function getStatusClass(status) {
      switch (status) {
        case 'Offline':
          return 'text-muted';
        case 'Available':
          return 'text-success';
        case 'Busy':
          return 'text-danger';
        default:
          return 'text-success';
      }
    }
  }
});

/***/ }),

/***/ "oE/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("qeuK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("Nrso");
function injectStyle (ssrContext) {
  __webpack_require__("f4B7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oEyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('router-link',{attrs:{"to":"/signup","tag":"li"}},[_c('a',[_vm._v("Sign Up")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control input-no-border",attrs:{"type":"email","name":"email","placeholder":"Username"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateThenSubmit()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-wd ",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(2),_vm._v("\n                      Submit\n                    ")]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/background-2.jpg)"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Sign Up")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"https://authentic.net"}},[_c('img',{attrs:{"src":"static/img/authentic_net_lt.png","width":"200","alt":"Authentic.net"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Password Reset")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oHle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p5r1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("jBHl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5117ee0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("kMQ6");
function injectStyle (ssrContext) {
  __webpack_require__("iBV3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5117ee0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pImr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pZL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pa/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("bx0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("whIq");
function injectStyle (ssrContext) {
  __webpack_require__("YcmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      radios: {
        radio1: '1',
        radio2: '2',
        radio3: '2'
      },
      checkboxes: {
        first: false,
        second: false,
        a: false,
        b: false,
        c: false,
        unchecked: false,
        checked: true,
        disabledUnchecked: false,
        disabledChecked: true
      }
    };
  }
});

/***/ }),

/***/ "psw9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAgR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qQLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/admin"}},[_vm._v("Paper Dashboard PRO")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page lock-page",staticStyle:{"background-image":"url('static/img/background/background-5.png')"},attrs:{"data-color":"green","data-image":"static/img/background/background-5.png"}},[_c('div',{staticClass:"content"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-lock"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}})]),_vm._v(" "),_c('h4',[_vm._v("Chet Faker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter Password"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd",attrs:{"type":"button"}},[_vm._v("Unlock")])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qWDN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-fill btn-info btn-auto",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.importSelected($event)}}},[_vm._v("Import Selected Amazon Products")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-info btn-auto",attrs:{"type":"button","disabled":"disabled"}},[_vm._m(0),_vm._v("\n        Loading...\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4 pull-right"},[_c('div',{staticStyle:{"float":"right"}},[_c('p',{staticClass:"category"},[_vm._v("Import All")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.importAll),callback:function ($$v) {_vm.importAll=$$v},expression:"importAll"}})],1)])]),_vm._v(" "),(_vm.initialized)?_c('div',{staticClass:"row"},_vm._l((_vm.amzProducts),function(amzProd){return _c('div',{key:amzProd.id,staticClass:"col-lg-4"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('h4',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(amzProd.data.AttributeSets.ItemAttributes.Title),expression:"amzProd.data.AttributeSets.ItemAttributes.Title"}]},[_vm._v(_vm._s(_vm.limitChars(amzProd.data.AttributeSets.ItemAttributes.Title)))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center prod-img-container"},[_c('img',{attrs:{"src":amzProd.data.AttributeSets.ItemAttributes.SmallImage.URL,"alt":"Image"}})]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Brand ("+_vm._s(amzProd.data.AttributeSets.ItemAttributes.Brand)+")")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-primary",attrs:{"size":"large","placeholder":"Single Select"},on:{"change":function($event){_vm.brandChanged(amzProd)}},model:{value:(amzProd.brandIndex),callback:function ($$v) {_vm.$set(amzProd, "brandIndex", $$v)},expression:"amzProd.brandIndex"}},_vm._l((_vm.brands),function(option,index){return _c('el-option',{key:option.name,staticClass:"select-danger",attrs:{"value":index,"label":option.name}})}))],1)]),_vm._v(" "),(amzProd.data.AttributeSets.ItemAttributes.Size)?_c('div',{staticClass:"row"},[_c('strong',[_vm._v("Size:")]),_vm._v(" "+_vm._s(amzProd.data.AttributeSets.ItemAttributes.Size)+"\n          ")]):_vm._e(),_vm._v(" "),(amzProd.data.AttributeSets.ItemAttributes.Color)?_c('div',{staticClass:"row"},[_c('strong',[_vm._v("Color:")]),_vm._v(" "+_vm._s(amzProd.data.AttributeSets.ItemAttributes.Color)+"\n          ")]):_vm._e(),_vm._v(" "),(amzProd.data.FNSKU)?_c('div',[_c('strong',[_vm._v("FNSKU:")]),_vm._v(" "+_vm._s(amzProd.data.FNSKU)+"\n          ")]):_vm._e(),_vm._v(" "),(amzProd.id)?_c('div',[_c('strong',[_vm._v("SKU:")]),_vm._v(" "+_vm._s(amzProd.id)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"40px"}},[(amzProd.loading)?_c('div',[_vm._v(_vm._s(amzProd.status))]):_vm._e(),_vm._v(" "),(!amzProd.loading)?_c('div',[_c('span',[_vm._v("Import")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"YES","off-text":"NO"},model:{value:(amzProd.import),callback:function ($$v) {_vm.$set(amzProd, "import", $$v)},expression:"amzProd.import"}})],1):_vm._e()])])])})):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['website', 'language', 'bootstrapVersion'])),
  data: function data() {
    return {
      model: {
        website: '',
        frameworkType: '',
        language: '',
        bootstrapVersion: '',
        price: ''
      },
      modelValidations: {
        website: {
          url: true,
          required: true
        },
        language: {
          required: true
        },
        bootstrapVersion: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "qjBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("24 Hours Performance")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Line Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartPerformance"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("NASDAQ: AAPL")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Line Chart with Points")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartStock"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Views")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bar Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartViews"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Activity")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Multiple Bars Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartActivity"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r1po":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r2+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{attrs:{"method":"#","action":"#"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("Submit")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('p-checkbox',{staticClass:"col-md-9"},[_vm._v("Remember me")])],1)]),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Checkboxes and radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.first),callback:function ($$v) {_vm.$set(_vm.checkboxes, "first", $$v)},expression:"checkboxes.first"}},[_vm._v("First checkbox")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.second),callback:function ($$v) {_vm.$set(_vm.checkboxes, "second", $$v)},expression:"checkboxes.second"}},[_vm._v("Second checkbox")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("First Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("Second Radio")])],1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Inline checkboxes")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.a),callback:function ($$v) {_vm.$set(_vm.checkboxes, "a", $$v)},expression:"checkboxes.a"}},[_vm._v("a")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.b),callback:function ($$v) {_vm.$set(_vm.checkboxes, "b", $$v)},expression:"checkboxes.b"}},[_vm._v("b")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.c),callback:function ($$v) {_vm.$set(_vm.checkboxes, "c", $$v)},expression:"checkboxes.c"}},[_vm._v("c")])],1)])]),_vm._v(" "),_c('fieldset',[_c('legend',[_vm._v("Input Variants")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Custom Checkboxes & radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-sm-offset-1"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.unchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "unchecked", $$v)},expression:"checkboxes.unchecked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.checked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "checked", $$v)},expression:"checkboxes.checked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledUnchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledUnchecked", $$v)},expression:"checkboxes.disabledUnchecked"}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledChecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledChecked", $$v)},expression:"checkboxes.disabledChecked"}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is on")])],1)])]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Stacked Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Horizontal Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("\n                Sign in\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Form Elements")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("With help")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("A block of help text that breaks onto a new line.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","name":"password"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Placeholder")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"placeholder"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Disabled")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Disabled input here...","disabled":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Static control")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p',{staticClass:"form-control-static"},[_vm._v("hello@creative-tim.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-success"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with success")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Success"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-error"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with error")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Error"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Column sizing")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-3"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-4"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-5"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input groups")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("@")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Username"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Textarea")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Here can be your nice text","rows":"3"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rP9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__ = __webpack_require__("9597");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__ = __webpack_require__("v98p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__ = __webpack_require__("4qt1");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__["a" /* default */],
    MembersCard: __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "rU3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amazon_vue__ = __webpack_require__("2TG0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5175ddb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amazon_vue__ = __webpack_require__("qWDN");
function injectStyle (ssrContext) {
  __webpack_require__("T3me")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amazon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5175ddb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amazon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "reDM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rgxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['websiteUrl', 'sellerName', 'sellerCity', 'sellerState', 'sellerCountry'])),
  data: function data() {
    return {
      model: {
        websiteUrl: '',
        sellerName: '',
        sellerCity: '',
        sellerState: '',
        sellerCountry: ''
      },
      modelValidations: {
        websiteUrl: {
          url: true
        },
        sellerName: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "ribu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__ = __webpack_require__("/ZBZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c9c64e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__ = __webpack_require__("lUqL");
function injectStyle (ssrContext) {
  __webpack_require__("bwdy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c9c64e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rpQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







var ProdOverviewStats = function ProdOverviewStats() {
  return {
    component: __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "jo+v"))
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProdOverviewStats: ProdOverviewStats
  },
  props: ['accountData'],
  data: function data() {
    return {
      user: {},
      product: {
        ready: false
      }
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__["a" /* default */].collection('brands/' + _this.accountData.activeBrand.id + '/products').doc(_this.$route.params.id).get();

              case 2:
                doc = _context.sent;

                _this.product.id = doc.id;
                _this.product.data = doc.data();
                _this.product.validationData = [];
                _this.product.registrationData = [];
                _this.product.totalValidations = 0;
                _this.product.totalRegistrations = 0;
                _this.product.validationDataReady = false;
                _this.product.registrationDataReady = false;
                _this.product.ready = true;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "rtAg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ruMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus__ = __webpack_require__("O6e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);












/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__["Card"] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      stripeSettings: {
        pubKey: "pk_test_6X1FCIrK5VRo2DrAZW4GsO5u",
        options: {
          classes: {
            base: 'form-control'
          }
        },
        class: {
          complete: false
        },
        style: {
          base: {
            color: 'yellow',
            fontFamily: 'inherit',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      },
      complete: false,
      model: {
        coupon: '',
        stripe_token: '',
        plan_id: '',
        plan_name: ''
      },
      plan: {
        name: '',
        startDate: ''
      },
      plans: [{
        loading: false,
        id: 'plan_G3oWEPmzSSsUvb',
        name: 'Business Startup'
      }, {
        loading: false,
        id: 'plan_FhkDbC6KWmoI3W',
        name: 'Small Business'
      }, {
        loading: false,
        id: 'plan_FhkE565lgB0J87',
        name: 'Professional'
      }],
      loading: {
        paymentSubmission: false,
        plan1: false,
        plan2: false,
        plan3: false
      }
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    selectPlan: function selectPlan(planIndex) {
      var _this2 = this;

      this.plans[planIndex].loading = true;
      var planId = this.plans[planIndex].id;
      var getStripePlan = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.functions().httpsCallable('getStripePlan');
      getStripePlan({ planId: planId }).then(function (plan) {
        console.log(plan);
        _this2.model.plan_id = planId;
        _this2.plan.name = plan.data.name;
        _this2.plan.amount = plan.data.amount / 100;
        _this2.plan.interval = plan.data.interval;
        _this2.plan.startDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(30, 'days').format('MMM Do');
        console.log(_this2.plan);
        _this2.plans[planIndex].loading = false;
        _this2.model.plan_id = planId;
        _this2.model.plan_name = _this2.plans[planIndex].name;
        _this2.$refs.planPayment.scrollIntoView();
      }).catch(function (err) {
        alert(err.message);
      });
    },
    submit: function submit() {
      var _this3 = this;

      this.loading.paymentSubmission = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        if (data.error) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
            title: 'Error',
            text: data.error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
          _this3.loading.paymentSubmission = false;
        } else {
          console.log('stripe token');
          console.log(data.token.id);
          _this3.model.stripe_token = data.token.id;
          _this3.submitPayment();
        }
      });
    },
    submitPayment: function submitPayment() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var activatePayment;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('signing up');
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.getIdToken();

              case 3:
                _this4.model.userToken = _context2.sent;

                console.log(_this4.model.userToken);
                activatePayment = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.functions().httpsCallable('activatePayment');

                activatePayment(_this4.model).then(function (result) {
                  console.log(result);
                  __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                    title: 'Welcome!',
                    text: 'Your account was successfully created!',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                  }).then(function () {
                    _this4.loading.paymentSubmission = false;
                    __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* EventBus */].$emit('auth-refreshed');
                    _this4.$router.replace({ name: 'Dashboard' });
                  });
                }).catch(function (err) {
                  console.error(err.message);
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "ryiV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s5Vg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sMOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("wfBj");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90dc5b5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("Bs4G");
function injectStyle (ssrContext) {
  __webpack_require__("GD9b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90dc5b5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sTXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__);











__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: 'first'
    };
  }
});

/***/ }),

/***/ "saoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])(['username', 'confirmation_code'])),
  data: function data() {
    return {
      modelValidations: {
        username: {
          required: true
        },
        confirmation_code: {
          required: true
        }
      },
      loading: false,
      model: {
        username: '',
        confirmation_code: ''
      }
    };
  },


  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    confirmCode: function confirmCode() {
      var _this = this;

      this.loading = true;
      this.$cognitoAuth.confirmRegistration(this.model.username, this.model.confirmation_code, function (err, result) {
        if (err) {
          _this.error = err;
          console.error(err);
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
            title: 'Error',
            text: err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          _this.$router.replace('/login');
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
            title: 'Confirmed!',
            text: 'Your account was confirmed! Please continue to login.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          }).then(function () {
            this.$router.replace('/login');
          });
        }
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.query.username) this.model.username = this.$route.query.username;
    });
  }
});

/***/ }),

/***/ "sbDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__("Z450");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__("+WI1");
function injectStyle (ssrContext) {
  __webpack_require__("gP6t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sj6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sk1x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "swfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("320+ Themify Icons")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Handcrafted by our friends from\n          "),_c('a',{attrs:{"target":"_blank","href":"https://themify.me/"}},[_vm._v("Themify")]),_vm._v(".")])]),_vm._v(" "),_c('div',{staticClass:"card-content all-icons"},[_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Arrows & Direction Icons ")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-vertical")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-horizontal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-horizontal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-move"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-move")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-fullscreen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-fullscreen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-corner"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-corner")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-h"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-h")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-exchange-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-exchange-vertical")])])]),_vm._v(" "),_c('h3',[_vm._v("Web App Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wand"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wand")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-user"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-user")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-link"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-link")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlink"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlink")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trash"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trash")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-target"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-target")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-desktop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-desktop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tablet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tablet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mobile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mobile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-email"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-email")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-star"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-star")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-spray"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-spray")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-signal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-signal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-settings")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-search"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-search")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-in"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-in")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-out"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-out")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cut"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cut")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-minus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-minus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-close"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-close")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-roller"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-roller")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-bucket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-bucket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-na"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-na")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-lock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-lock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-arrow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-arrow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-key"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-key")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart-broken"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart-broken")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-open"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-open")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-drag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-drag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eye"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eye")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-import"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-import")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-export"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-export")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cup"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cup")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-crown"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-crown")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thought"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thought")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check-box"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check-box")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-announcement"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-announcement")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-palette"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-palette")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-briefcase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-briefcase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-blackboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-blackboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-world"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-world")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wheelchair"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wheelchair")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-car"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-car")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-truck"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-truck")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-timer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-timer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ticket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ticket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shine"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shine")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shield"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shield")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-notepad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-notepad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-server"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-server")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pulse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pulse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-printer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-printer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-power-off"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-power-off")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plug"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plug")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pie-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pie-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-panel"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-panel")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-package"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-package")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-money"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-money")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-light-bulb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-light-bulb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-infinite"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-infinite")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-id-badge"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-id-badge")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hummer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hummer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-home"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-home")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrives"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrives")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gift"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gift")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-game"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-game")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-filter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-filter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-files"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-files")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-file"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-file")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-folder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-folder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-envelope"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-envelope")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dashboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dashboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clipboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clipboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-calendar"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-calendar")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-book"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-book")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bell")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-basketball"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-basketball")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-archive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-archive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-anchor"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-anchor")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alert"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alert")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alarm-clock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alarm-clock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-agenda"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-agenda")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-write"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-write")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wallet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wallet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-clapper"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-clapper")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vector"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vector")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-support"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-support")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stamp"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stamp")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-slice"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-slice")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shortcode"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shortcode")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-receipt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-receipt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eraser"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eraser")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-magnet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-magnet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-double"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-double")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dotted"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dotted")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dashed"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dashed")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ink-pen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ink-pen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gallery"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gallery")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-smile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-smile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-sad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-sad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-credit-card"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-credit-card")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments-smiley"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments-smiley")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-time"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-time")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rocket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rocket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-new-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-new-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Control Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-shuffle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-shuffle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-play"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-play")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-pause"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-pause")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-volume"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-volume")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-record"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-record")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-eject"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-eject")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Text Editor")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paragraph"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paragraph")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-uppercase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-uppercase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-underline"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-underline")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-text"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-text")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-Italic"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-Italic")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-smallcap"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-smallcap")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list-ol"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list-ol")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-justify"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-justify")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-left")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Layout Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-min"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-min")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-none"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-none")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-placeholder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-placeholder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-post"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-post")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-large-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-large-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-line-solid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-line-solid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-merged"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-merged")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widgetized"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widgetized")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-grid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-grid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-upload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-upload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-download"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-download")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-loop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-loop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Brand Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-instagram"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-instagram")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-google"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-google")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-github"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-github")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-facebook"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-facebook")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dribbble"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dribbble")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-apple"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-apple")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-android"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-android")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-yahoo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-yahoo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trello"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trello")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stack-overflow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stack-overflow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-soundcloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-soundcloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reddit"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reddit")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linux"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linux")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-jsfiddle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-jsfiddle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-joomla"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-joomla")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-html5"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-html5")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-css3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-css3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-drupal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-drupal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wordpress"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wordpress")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-skype"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-skype")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-youtube"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-youtube")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linkedin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linkedin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-logo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-logo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon-alt")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t+GP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Team members',
      members: [{
        image: 'static/img/faces/face-0.jpg',
        name: 'Casey Danford',
        status: 'Active'
      }, {
        image: 'static/img/faces/face-1.jpg',
        name: 'Jeremy Bohr',
        status: 'Active'
      }, {
        image: 'static/img/faces/face-3.jpg',
        name: 'John Serafano',
        status: 'Active'
      }]
    };
  },

  methods: {
    getStatusClass: function getStatusClass(status) {
      switch (status) {
        case 'Offline':
          return 'text-muted';
        case 'Available':
          return 'text-success';
        case 'Busy':
          return 'text-danger';
        default:
          return 'text-success';
      }
    }
  }
});

/***/ }),

/***/ "t/3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");
























__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
    PSwitch: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__["a" /* default */],
    PProgress: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a),
  mixins: [__WEBPACK_IMPORTED_MODULE_19__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["b" /* mapFields */])(['name', 'amazonComFnsku', 'amazonCaFnsku', 'amazonComMxFnsku', 'amazonCnFnsku', 'amazonInFnsku', 'amazonCoJpFnsku', 'amazonComSgFnsku', 'amazonComTrFnsku', 'amazonAeFnsku', 'amazonFrFnsku', 'amazonDeFnsku', 'amazonItFnsku', 'amazonNlFnsku', 'amazonEsFnsku', 'amazonCoUkFnsku', 'amazonComAuFnsku', 'amazonComBrFnsku', 'image', 'size', 'color', 'style', 'sku', 'upc', 'redirectUrl'])),
  data: function data() {
    return {
      user: {
        email: '',
        token: ''
      },
      product: {
        id: '',
        data: {}
      },
      newProduct: {
        image: '',
        name: '',
        brandIndex: ''
      },
      imageFile: '',
      imageUrl: '',
      uploadProgress: 0,
      loading: true,
      prodSlotsRemaining: 2,
      modelValidations: {
        name: {
          required: true
        },
        amazonComFnsku: {
          required: false
        },
        amazonCaFnsku: {
          required: false
        },
        amazonComMxFnsku: {
          required: false
        },
        amazonCnFnsku: {
          required: false
        },
        amazonInFnsku: {
          required: false
        },
        amazonCoJpFnsku: {
          required: false
        },
        amazonComSgFnsku: {
          required: false
        },
        amazonComTrFnsku: {
          required: false
        },
        amazonAeFnsku: {
          required: false
        },
        amazonFrFnsku: {
          required: false
        },
        amazonDeFnsku: {
          required: false
        },
        amazonItFnsku: {
          required: false
        },
        amazonNlFnsku: {
          required: false
        },
        amazonEsFnsku: {
          required: false
        },
        amazonCoUkFnsku: {
          required: false
        },
        amazonComAuFnsku: {
          required: false
        },
        amazonComBrFnsku: {
          required: false
        },
        redirectUrl: {
          required: false,
          url: {
            require_protocol: true
          }
        }
      },
      prodLandingUrlTip: 'If provided, then anyone who submits a registration for this product will be redirected to this URL after submission.'
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      this.getCurrentUser().then(function (result) {
        _this.user = result;

        console.log('got user from store');
        console.log(_this.user);
      });
      this.product.id = this.$route.params.productId;
      console.log('productId');
      console.log(this.product.id);
      this.loadProduct(this.product.id);
    },
    selectFile: function selectFile() {
      this.imageFile = this.$refs.imageFile.files[0];
      this.uploadFile();
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      this.loading = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_17_firebase___default.a.storage().ref();
      var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop();
      var uploadTask = storageRef.child('brands/' + this.product.data.brandId + '/products/' + filename).put(this.imageFile);

      uploadTask.on(__WEBPACK_IMPORTED_MODULE_17_firebase___default.a.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this2.uploadProgress = progress;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_17_firebase___default.a.storage.TaskState.PAUSED:
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_17_firebase___default.a.storage.TaskState.RUNNING:
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.fire({
          title: 'Error Uploading Image',
          text: 'Please try a different image and contact support if the problem persists',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this2.loading = false;
        });
        switch (error.code) {
          case 'storage/unauthorized':
            break;

          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(downloadURL) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    console.log('File available at', downloadURL);
                    _this2.product.data.imageUrl = downloadURL;
                    _context.next = 4;
                    return _this2.prodImgUrl(_this2.product.id, _this2.product.data, '140x140');

                  case 4:
                    _this2.imageUrl = _context.sent;

                    _this2.loading = false;

                  case 6:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    loadProduct: function loadProduct(productId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var productDoc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__components_firebase_init__["a" /* default */].collection('brands/' + _this3.accountData.activeBrand.id + '/products').doc(productId).get();

              case 2:
                productDoc = _context2.sent;

                _this3.product.data = productDoc.data();
                _context2.next = 6;
                return _this3.prodImgUrl(_this3.product.id, _this3.product.data, '140x140');

              case 6:
                _this3.imageUrl = _context2.sent;

                _this3.loading = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getBrandsAndProducts: function getBrandsAndProducts() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_16__components_firebase_init__["a" /* default */].collection('brands').where('accountId', '==', this.user.accountId).get().then(function (qs) {
        qs.forEach(function (doc) {
          var brand = doc.data();
          brand.id = doc.id;
          _this4.brands.push(brand);
          _this4.getBrandProducts(brand.id, brand.name);
        });
      });
    },
    validateSaveProduct: function validateSaveProduct() {
      var _this5 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.saveProduct();
        } else {
          _this5.loading = false;
        }
      });
    },
    saveProduct: function saveProduct() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__components_firebase_init__["a" /* default */].collection('brands/' + _this6.accountData.activeBrand.id + '/products').doc(_this6.product.id).update(_this6.product.data);

              case 2:
                _this6.showNotify('Product saved.', 'success', 'Success');
                _this6.loading = false;
                _this6.$router.replace({ name: 'Products' });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this7 = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this7.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "t1Jt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tAA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("bqeX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aec6c1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("PhKr");
function injectStyle (ssrContext) {
  __webpack_require__("iogT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aec6c1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tTPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__ = __webpack_require__("t+GP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54257cce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__ = __webpack_require__("viZt");
function injectStyle (ssrContext) {
  __webpack_require__("1Nqp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54257cce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tfoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbellB8ta_vue__ = __webpack_require__("3/nc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36687fbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbellB8ta_vue__ = __webpack_require__("PwBp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKegelbellB8ta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36687fbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKegelbellB8ta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tlj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-shopping",staticStyle:{"width":"100%"},attrs:{"data":_vm.fraudReportsTable}},[_c('el-table-column',{attrs:{"min-width":"140","label":"Product"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.product.imageUrl,"alt":"Agenda"}})]),_vm._v("\n                "+_vm._s(props.row.product.name)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"140","label":"Purchased From"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.sellerName))]),_c('br'),_vm._v("\n                "+_vm._s(props.row.websiteUrl)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"80","label":"Code"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.code)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Purchased By","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.buyerName)),_c('br'),_vm._v("\n                "+_vm._s(props.row.buyerEmail)+"\n              ")]}}])})],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Existing Fraud Reports")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password', 'confirm'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        },
        confirmPassword: {
          required: true,
          confirmed: 'password'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "u9kn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b7f047b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("dF6u");
function injectStyle (ssrContext) {
  __webpack_require__("aE9v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b7f047b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uOOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please tell us more about yourself.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          First Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"},{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"ex: Mike"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('firstName'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Last Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"},{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"ex: Andrew"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('lastName'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uRwB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTlS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Email Address")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_email),expression:"business.business_email"}],staticClass:"form-control",attrs:{"type":"email"},domProps:{"value":(_vm.business.business_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "business_email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Plese provide your contact email address for this business.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Business Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_name),expression:"business.business_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "business_name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Plese provide your business name.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Website Domain/URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_url),expression:"business.business_url"}],staticClass:"form-control",attrs:{"type":"url"},domProps:{"value":(_vm.business.business_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "business_url", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide the domain for your Shopify store, ie \"mystore.com\".")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Shopify Webhook")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.shopify_webhook_key),expression:"business.shopify_webhook_key"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.shopify_webhook_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "shopify_webhook_key", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide your Shopify webhook key.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Street Address")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.address.line1),expression:"business.address.line1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.address.line1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.address, "line1", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide your street address.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Apt/Suite")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.address.line2),expression:"business.address.line2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.address.line2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.address, "line2", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide your apartment/suite number if you have one.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("City")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.address.city),expression:"business.address.city"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.address, "city", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide your city.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("State")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.address.state),expression:"business.address.state"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.address.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.address, "state", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide your state.")])])])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Zip Code")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.address.zipcode),expression:"business.address.zipcode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.address.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.address, "zipcode", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Please provide your zip code.")])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.persistBusiness()}}},[_vm._v("Save")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Your Account Details")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Please make sure the details below are accurate for your business.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uwQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__ = __webpack_require__("mmP5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1719a15b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Charts_vue__ = __webpack_require__("qjBI");
function injectStyle (ssrContext) {
  __webpack_require__("BItS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1719a15b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    lastPage: function lastPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.totalPages);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    },
    firstPage: function firstPage() {
      if (this.value > 1) {
        this.$emit('input', 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "v4Xz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v5BP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("cQ5s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4757b525_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("3Cg0");
function injectStyle (ssrContext) {
  __webpack_require__("8ZDc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4757b525_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v71F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Company","disabled":true,"placeholder":"Paper dashboard"},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username"},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"email","label":"Username","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"First Name","placeholder":"First Name"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Last Name","placeholder":"Last Name"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Address","placeholder":"Home Address"},model:{value:(_vm.user.address),callback:function ($$v) {_vm.$set(_vm.user, "address", $$v)},expression:"user.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"City","placeholder":"City"},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Country","placeholder":"Country"},model:{value:(_vm.user.country),callback:function ($$v) {_vm.$set(_vm.user, "country", $$v)},expression:"user.country"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","label":"Postal Code","placeholder":"ZIP Code"},model:{value:(_vm.user.postalCode),callback:function ($$v) {_vm.$set(_vm.user, "postalCode", $$v)},expression:"user.postalCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("About Me")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.aboutMe),expression:"user.aboutMe"}],staticClass:"form-control border-input",attrs:{"rows":"5","placeholder":"Here can be your description"},domProps:{"value":(_vm.user.aboutMe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "aboutMe", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_vm._v("\n          Update Profile\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Edit Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v98p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("jcvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("FQVD");
function injectStyle (ssrContext) {
  __webpack_require__("oHle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vAr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please give us more details about your platform.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Your Website")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.website),expression:"modelValidations.website"},{name:"model",rawName:"v-model",value:(_vm.model.website),expression:"model.website"}],staticClass:"form-control",attrs:{"type":"text","name":"website","url":"true","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "website", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.website.invalid),expression:"website.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('website'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Framework Type")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.framework),expression:"model.framework"}],staticClass:"form-control",attrs:{"type":"text","name":"framework","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.framework)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "framework", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Language\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.language),expression:"modelValidations.language"},{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"}],staticClass:"form-control",attrs:{"name":"language"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- language -")]),_vm._v(" "),_c('option',{attrs:{"value":"ms"}},[_vm._v("Bahasa Melayu")]),_vm._v(" "),_c('option',{attrs:{"value":"ca"}},[_vm._v("Català")]),_vm._v(" "),_c('option',{attrs:{"value":"da"}},[_vm._v("Dansk")]),_vm._v(" "),_c('option',{attrs:{"value":"de"}},[_vm._v("Deutsch")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")]),_vm._v(" "),_c('option',{attrs:{"value":"es"}},[_vm._v("Español")]),_vm._v(" "),_c('option',{attrs:{"value":"el"}},[_vm._v("Eλληνικά")]),_vm._v(" "),_c('option',{attrs:{"value":"fr"}},[_vm._v("Français")]),_vm._v(" "),_c('option',{attrs:{"value":"it"}},[_vm._v("Italiano")]),_vm._v(" "),_c('option',{attrs:{"value":"hu"}},[_vm._v("Magyar")]),_vm._v(" "),_c('option',{attrs:{"value":"nl"}},[_vm._v("Nederlands")]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v("Norsk")]),_vm._v(" "),_c('option',{attrs:{"value":"pl"}},[_vm._v("Polski")]),_vm._v(" "),_c('option',{attrs:{"value":"pt"}},[_vm._v("Português")]),_vm._v(" "),_c('option',{attrs:{"value":"fi"}},[_vm._v("Suomi")]),_vm._v(" "),_c('option',{attrs:{"value":"sv"}},[_vm._v("Svenska")]),_vm._v(" "),_c('option',{attrs:{"value":"tr"}},[_vm._v("Türkçe")]),_vm._v(" "),_c('option',{attrs:{"value":"is"}},[_vm._v("Íslenska")]),_vm._v(" "),_c('option',{attrs:{"value":"cs"}},[_vm._v("Čeština")]),_vm._v(" "),_c('option',{attrs:{"value":"ru"}},[_vm._v("Русский")]),_vm._v(" "),_c('option',{attrs:{"value":"th"}},[_vm._v("ภาษาไทย")]),_vm._v(" "),_c('option',{attrs:{"value":"zh"}},[_vm._v("中文 (简体)")]),_vm._v(" "),_c('option',{attrs:{"value":"zh-TW"}},[_vm._v("中文 (繁體)")]),_vm._v(" "),_c('option',{attrs:{"value":"ja"}},[_vm._v("日本語")]),_vm._v(" "),_c('option',{attrs:{"value":"ko"}},[_vm._v("한국어")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.language.invalid),expression:"language.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('language'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Bootstrap Version\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.bootstrapVersion),expression:"modelValidations.bootstrapVersion"},{name:"model",rawName:"v-model",value:(_vm.model.bootstrapVersion),expression:"model.bootstrapVersion"}],staticClass:"form-control",attrs:{"name":"cities"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bootstrapVersion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- version -")]),_vm._v(" "),_c('option',{attrs:{"value":"1.1"}},[_vm._v("Bootstrap 1.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("Bootstrap 2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("Bootstrap 3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("Bootstrap 4.0(alpha)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"text","name":"price","placeholder":"ex: 19.00"},domProps:{"value":(_vm.model.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vF/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanDetails_vue__ = __webpack_require__("1gfC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b5c99c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanDetails_vue__ = __webpack_require__("altj");
function injectStyle (ssrContext) {
  __webpack_require__("Oepq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b5c99c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vIES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vVLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"btn btn-primary btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.name))]),_vm._v(" "),_c('div',{staticClass:"navbar-left",staticStyle:{"margin-top":"20px"}},[_c('drop-down',[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n            "+_vm._s(_vm.accountData.activeBrand.data.name)+"\n            "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_vm._l((_vm.accountData.brands),function(brand){return _c('li',{key:brand.id},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();_vm.selectBrand(brand.id)}}},[_vm._v(_vm._s(brand.data.name))])])})],2)],1)]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('form',{staticClass:"navbar-form navbar-left navbar-search-form",attrs:{"role":"search"}},[_c('div',{staticClass:"input-group"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "viZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"list-unstyled team-members"},[_c('li',_vm._l((_vm.members),function(member){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":member.image,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_vm._v("\n            "+_vm._s(member.name)+"\n            "),_c('br'),_vm._v(" "),_c('span',{class:_vm.getStatusClass(member.status)},[_c('small',[_vm._v(_vm._s(member.status))])])]),_vm._v(" "),_vm._m(0,true)])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3 text-right"},[_c('button',{staticClass:"btn btn-sm btn-success btn-icon"},[_c('i',{staticClass:"fa fa-envelope"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w9P+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");






















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */],
    PProgress: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Progress_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_17__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  props: ['accountData'],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* mapFields */])(['logoUrl', 'name']), {
    maxReached: function maxReached() {
      var reached = this.accountData.authDetails.account.data.planUsageQtyBrands >= this.accountData.authDetails.account.data.planConstraints.maxBrands;
      return reached;
    },
    brandSlotsRemaining: function brandSlotsRemaining() {
      var maxBrands = this.accountData.authDetails.account.data.planConstraints.maxBrands;
      var qtyBrands = this.accountData.authDetails.account.data.planUsageQtyBrands;
      var remaining = maxBrands - qtyBrands;
      remaining = Math.max(remaining, 0);
      return remaining;
    }
  }),
  data: function data() {
    return {
      user: {
        email: '',
        token: ''
      },
      newBrand: {
        logoUrl: '',
        name: ''
      },
      imageFile: '',
      uploadProgress: 0,
      loading: false,
      modelValidations: {
        logoUrl: {
          required: true,
          url: true
        },
        name: {
          required: true
        }
      },
      brandsTable: [],
      brandIdIndexMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
      selects: {
        simple: '',
        multiple: 'ARS'
      },
      showArchived: false
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      this.getCurrentUser().then(function (result) {
        _this.user = result;
        _this.getBrands();
      });
    },
    selectFile: function selectFile() {
      this.imageFile = this.$refs.imageFile.files[0];
      this.uploadFile();
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      this.loading = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage().ref();
      var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop();
      var uploadTask = storageRef.child('brands/' + filename).put(this.imageFile);

      uploadTask.on(__WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this2.uploadProgress = progress;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage.TaskState.PAUSED:
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.storage.TaskState.RUNNING:
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
          title: 'Error Uploading Image',
          text: 'Please try a different image and contact support if the problem persists',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this2.loading = false;
        });
        switch (error.code) {
          case 'storage/unauthorized':
            break;

          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          _this2.newBrand.logoUrl = downloadURL;
          _this2.loading = false;
        });
      });
    },
    archiveBrand: function archiveBrand(brand) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('brands').doc(brand.id).update({ isArchived: true });

              case 2:
                _this3.showNotify('Brand ' + brand.name + ' archived.', 'success', 'Success');
                _this3.getBrands();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    unArchiveBrand: function unArchiveBrand(brand) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                brand.unarchiving = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('brands').doc(brand.id).update({ isArchived: false });

              case 3:
                brand.key = _this4.$uuid.v4();
                brand.unarchiving = false;
                _this4.showNotify('Brand ' + brand.name + ' un-archived.', 'success', 'Success');
                _this4.getBrands();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getBrands: function getBrands() {
      var _this5 = this;

      this.brandsTable = [];
      this.brandIdIndexMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      var ref = __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('brands').where('accountId', '==', this.user.accountId);
      ref.onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(change) {
            var doc, data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(change.type === 'added')) {
                      _context3.next = 13;
                      break;
                    }

                    doc = change.doc;

                    if (!(_this5.showArchived || doc.data().isArchived !== true)) {
                      _context3.next = 13;
                      break;
                    }

                    _context3.t0 = doc.id;
                    _context3.t1 = doc.data().name;
                    _context3.next = 7;
                    return _this5.brandImgUrl(doc.id, doc.data(), '140x140');

                  case 7:
                    _context3.t2 = _context3.sent;
                    _context3.t3 = _this5.$uuid.v4();
                    _context3.t4 = doc.data().isArchived;
                    data = {
                      id: _context3.t0,
                      name: _context3.t1,
                      logoUrl: _context3.t2,
                      key: _context3.t3,
                      isArchived: _context3.t4
                    };

                    _this5.brandsTable.push(data);
                    _this5.brandIdIndexMap.set(doc.id, _this5.brandsTable.length - 1);

                  case 13:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this5);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    addBrand: function addBrand() {
      var _this6 = this;

      var brand = {
        name: this.newBrand.name,
        logoUrl: this.newBrand.logoUrl,
        accountId: this.user.accountId,
        qtyValidations: 0,
        qtyRegistrations: 0
      };
      __WEBPACK_IMPORTED_MODULE_14__components_firebase_init__["a" /* default */].collection('brands').add(brand).then(function (response) {
        _this6.loading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
          title: 'Error',
          text: err,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        _this6.loading = false;
      });
    },
    validateAddBrand: function validateAddBrand() {
      var _this7 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this7.addBrand();
        } else {
          _this7.loading = false;
        }
      });
    },
    deleteBrand: function deleteBrand(brand) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var brandId, data, accountDeleteBrand, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                brandId = brand.id;

                brand.deleting = true;
                brand.key = _this8.$uuid.v4();
                data = {};
                _context5.next = 7;
                return __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.auth().currentUser.getIdToken();

              case 7:
                data.userToken = _context5.sent;

                data.accountId = _this8.user.accountId;
                data.brandId = brandId;
                accountDeleteBrand = __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.functions().httpsCallable('accountDeleteBrand');
                _context5.next = 13;
                return accountDeleteBrand(data);

              case 13:
                result = _context5.sent;

                brand.deleting = false;
                brand.key = _this8.$uuid.v4();
                _this8.showNotify('Brand ' + brand.name + ' deleted.', 'success', 'Success');
                _this8.brandsTable.splice(_this8.brandIdIndexMap.get(brandId), 1);
                _context5.next = 25;
                break;

              case 20:
                _context5.prev = 20;
                _context5.t0 = _context5['catch'](0);

                brand.deleting = false;
                brand.key = _this8.$uuid.v4();
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  title: 'Cannot Be Deleted',
                  text: 'This brand cannot be deleted as it contains existing Authentic.net codes. Would you like to archive it instead?',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-info btn-fill',
                  cancelButtonClass: 'btn btn-danger btn-fill',
                  confirmButtonText: 'Yes, archive it!',
                  buttonsStyling: false
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!result.value) {
                              _context4.next = 3;
                              break;
                            }

                            _context4.next = 3;
                            return _this8.archiveBrand(brand);

                          case 3:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this8);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 25:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 20]]);
      }))();
    },
    isDeleting: function isDeleting(brand) {
      return brand.deleting;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    }
  },
  watch: {
    showArchived: function showArchived(newFrom, oldFrom) {
      this.getBrands();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.init();
    });
  }
});

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("GJqE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wMMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("kKCY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_571abd7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("vAr+");
function injectStyle (ssrContext) {
  __webpack_require__("0xa1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_571abd7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wSR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wfBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_uuid__ = __webpack_require__("fzx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_functions__ = __webpack_require__("p/MD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mixins_toolboxMixin__ = __webpack_require__("yZkG");












/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* mapFields */])(['businessName', 'email', 'name', 'password', 'password_confirmation'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_9__components_mixins_toolboxMixin__["a" /* toolboxMixin */]],
  data: function data() {
    return {
      myvariable: 4,
      modelValidations: {
        businessName: {
          required: true
        },
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true
        }
      },
      stripe_plan_fetched: false,
      loading: false,
      step: 1,
      complete: false,
      stripe_customer_id: '',
      model: {
        businessName: '',
        name: '',
        email: '',
        coupon: '',
        password: '',
        password_confirmation: '',
        stripe_token: '',
        plan_id: '',
        stripeCustomerId: ''
      },
      plan: {
        id: 'plan_EcLp2TZFiDcRdB',
        name: '',
        amount: '',
        interval: ''
      },
      stripePubKey: "pk_test_6X1FCIrK5VRo2DrAZW4GsO5u",
      stripeOptions: {
        classes: {
          base: 'form-control'
        }
      },
      apiBaseUrl: "https://us-central1-authentic-net-dev.cloudfunctions.net/"
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__["Card"] },

  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    submit: function submit() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        if (data.error) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Error',
            text: data.error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
          _this.loading = false;
        } else {
          console.log('stripe token');
          console.log(data.token.id);
          _this.model.stripe_token = data.token.id;

          _this.signup();
        }
      });
    },
    signup: function signup() {
      var _this2 = this;

      console.log('signing up');
      var signup = __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.functions().httpsCallable('signup');
      signup(this.model).then(function (result) {
        console.log(result);
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          title: 'Welcome!',
          text: 'Your account was successfully created! Please proceed to login.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(function () {
          _this2.loading = false;
          _this2.$router.replace('/login');
        });
      }).catch(function (err) {
        console.error(err.message);
      });
    },
    fetchStripePlan: function fetchStripePlan(planId) {
      var _this3 = this;

      var getStripePlan = __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.functions().httpsCallable('getStripePlan');
      getStripePlan({ planId: planId }).then(function (plan) {
        console.log(plan);
        _this3.model.plan_id = planId;
        _this3.plan.name = plan.data.name;
        _this3.plan.amount = plan.data.amount / 100;
        _this3.plan.interval = plan.data.interval;
        _this3.stripe_plan_fetched = true;
      }).catch(function (err) {
        alert(err.message);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this4 = this;

      this.loading = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.submit();
        } else {
          _this4.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.$route.query.p) this.plan.id = this.$route.query.p;
      this.fetchStripePlan(this.plan.id);
    });
  }
});

/***/ }),

/***/ "whIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-full-width table-tasks"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tasks),function(task,index){return _c('task',{key:task.title,attrs:{"task":task,"index":index},on:{"on-edit":_vm.handleTaskEdit,"on-delete":_vm.handleTaskDelete}})}))])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wnqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthCodeBatchesCards_vue__ = __webpack_require__("/V9b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c242a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthCodeBatchesCards_vue__ = __webpack_require__("OcV7");
function injectStyle (ssrContext) {
  __webpack_require__("ETQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthCodeBatchesCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c242a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthCodeBatchesCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xBWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xHTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

__webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "p4sG"));

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xXKw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xp4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2015 Sales")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" BMW 5 Series\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.usersChart.data,"chart-options":_vm.usersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("24 hours performance")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n          "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.subscriptionsChart.data,"chart-options":_vm.subscriptionsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("169")]),_vm._v(" "),_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        -14%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total subscriptions "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 7 days\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View all members\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-angle-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.downloadsChart.data,"chart-options":_vm.downloadsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("8,960")]),_vm._v(" "),_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        ~51%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total downloads "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 6 years\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View more details\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-info"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('task-list'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('time-line',{attrs:{"type":"simple"}},[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n          11 hours ago via Twitter\n        ")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"success","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-info",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"info","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n            Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n            What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-chat"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Chat")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With Tania Andrew")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ol',{staticClass:"chat"},[_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Hola!\n                How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:20")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Puff...\n                I'm alright. How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:22")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])]),_vm._v(" "),_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                I'm ok too!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:24")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Well, it was nice hearing from you.\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"no-avatar"})]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                OK, bye-bye\n                See you!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"send-message"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})]),_vm._v(" "),_c('input',{staticClass:"form-control textarea",attrs:{"type":"text","placeholder":"Type here!"}}),_vm._v(" "),_c('div',{staticClass:"send-button"},[_c('button',{staticClass:"btn btn-primary btn-fill"},[_vm._v("Send")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yKB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"list-unstyled team-members"},[_c('li',_vm._l((_vm.members),function(member){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":member.image,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_vm._v("\n            "+_vm._s(member.name)+"\n            "),_c('br'),_vm._v(" "),_c('span',{class:_vm.getStatusClass(member.status)},[_c('small',[_vm._v(_vm._s(member.status))])])]),_vm._v(" "),_vm._m(0,true)])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3 text-right"},[_c('button',{staticClass:"btn btn-sm btn-success btn-icon"},[_c('i',{staticClass:"fa fa-envelope"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yNZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Notifications\n        "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn-rotate",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Settings\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yV2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Retailers_vue__ = __webpack_require__("GX5T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6258204a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Retailers_vue__ = __webpack_require__("/PBK");
function injectStyle (ssrContext) {
  __webpack_require__("FfnH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Retailers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6258204a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Retailers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yZkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toolboxMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__ = __webpack_require__("S85j");



var firebase = __webpack_require__("kxiW");
var axios = __webpack_require__("mtWM");

var toolboxMixin = {
  data: function data() {
    return {
      geoIpDbKey: "42e6a770-b3ac-11e9-80ca-c95181800da7"
    };
  },

  methods: {
    refreshCurrentUser: function refreshCurrentUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                user = firebase.auth().currentUser;
                _context.next = 3;
                return user.reload();

              case 3:
                _context.next = 5;
                return user.getIdTokenResult(true);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCurrentUser: function getCurrentUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var user, tokenResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                user = firebase.auth().currentUser;
                _context2.next = 3;
                return user.getIdTokenResult();

              case 3:
                tokenResult = _context2.sent;

                console.log('tokenResult');
                console.log(tokenResult);
                user.accountId = tokenResult.claims.accountId;
                return _context2.abrupt('return', user);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getCurrentUserDetails: function getCurrentUserDetails() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var user, doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getCurrentUser();

              case 2:
                user = _context3.sent;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__["a" /* default */].collection('users').doc(user.uid).get();

              case 5:
                doc = _context3.sent;
                return _context3.abrupt('return', {
                  data: doc.data(),
                  id: doc.id
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getCurrentAccount: function getCurrentAccount() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var user, doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.getCurrentUserDetails();

              case 2:
                user = _context4.sent;

                console.log('in getCurrentUser function');
                console.log(user);
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__["a" /* default */].collection('accounts').doc(user.accountId).get();

              case 7:
                doc = _context4.sent;
                return _context4.abrupt('return', {
                  data: doc.data(),
                  id: doc.id
                });

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getAuthDetails: function getAuthDetails() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var authDetails, userDoc, accountDoc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                authDetails = {
                  userAuth: null,
                  user: null,
                  account: null
                };

                authDetails.userAuth = firebase.auth().currentUser;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__["a" /* default */].collection('users').doc(authDetails.userAuth.uid).get();

              case 4:
                userDoc = _context5.sent;

                console.log('userDoc in toolbox');
                console.log(userDoc);

                if (!userDoc.data()) {
                  _context5.next = 14;
                  break;
                }

                console.log('we think user doc exists');
                authDetails.user = {
                  id: userDoc.id,
                  data: userDoc.data()
                };
                _context5.next = 12;
                return __WEBPACK_IMPORTED_MODULE_2__components_firebase_init__["a" /* default */].collection('accounts').doc(userDoc.data().accountId).get();

              case 12:
                accountDoc = _context5.sent;

                authDetails.account = {
                  id: accountDoc.id,
                  data: accountDoc.data()
                };

              case 14:
                return _context5.abrupt('return', authDetails);

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    prettyV2Code: function prettyV2Code(code) {
      var fullCode = '0002' + code;
      var prettyCode = [fullCode.slice(0, 9), '-', fullCode.slice(9, 18), '-', fullCode.slice(18, 27), '-', fullCode.slice(27)].join('');
      return prettyCode;
    },
    getClientIp: function getClientIp() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var ipData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return axios.get("https://us-central1-authentic-net-dev.cloudfunctions.net/" + 'getClientIp');

              case 2:
                ipData = _context6.sent;

                console.log(ipData);
                return _context6.abrupt('return', ipData.data.ipAddress);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getClientIpData: function getClientIpData() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var ipApiResult, geoipDbResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this7.getClientIpDataIpApi();

              case 3:
                ipApiResult = _context7.sent;

                console.log(ipApiResult);
                _context7.next = 7;
                return _this7.getClientIpDataGeoipDb();

              case 7:
                geoipDbResult = _context7.sent;

                console.log(geoipDbResult);
                return _context7.abrupt('return', ipApiResult);

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](0);
                return _context7.abrupt('return', null);

              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 12]]);
      }))();
    },
    getClientIpDataIpApi: function getClientIpDataIpApi() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var result, clientIpData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return axios.get('http://ip-api.com/json');

              case 2:
                result = _context8.sent;

                if (!(result === null)) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt('return', null);

              case 5:
                clientIpData = {
                  IpV4: result.data.query,
                  lat: result.data.lat,
                  lon: result.data.lon,
                  country: result.data.country,
                  countryCode: result.data.countryCode,
                  regionState: result.data.region,
                  regionStateName: result.data.regionName,
                  city: result.data.city,
                  zip: result.data.zip,
                  isp: result.data.isp,
                  timezone: result.data.timezone
                };
                return _context8.abrupt('return', clientIpData);

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    getClientIpDataGeoipDb: function getClientIpDataGeoipDb() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var result, clientIpData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return axios.get('https://geoip-db.com/json/' + _this9.geoIpDbKey);

              case 2:
                result = _context9.sent;

                if (!(result === null)) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt('return', null);

              case 5:
                clientIpData = {
                  IpV4: result.data.IPv4,
                  lat: result.data.latitude,
                  lon: result.data.longitude,
                  country: result.data.country_name,
                  countryCode: result.data.country_code,
                  regionState: null,
                  regionStateName: result.data.state,
                  city: result.data.city,
                  zip: result.data.postal,
                  isp: null,
                  timezone: null
                };
                return _context9.abrupt('return', clientIpData);

              case 7:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    showNotify: function showNotify(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var verticalAlign = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'top';
      var horizontalAlign = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'right';

      var msg = title === '' ? '<span>' + message + '</span>' : '<span><b>' + title + ' - </b>' + message + '</span>';
      this.$notify({
        component: {
          template: msg
        },
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type === '' ? 'info' : type
      });
    },
    firestoreTimeNow: function firestoreTimeNow() {
      return firebase.firestore.FieldValue.serverTimestamp();
    },
    prodImgUrl: function prodImgUrl(prodId, prodData, sizeString) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var fsString, fsPieces, fileParts, ext, fullPath, storageRef;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log('getting prod image url size ', sizeString);
                _context10.prev = 1;

                if (!sizeString) {
                  _context10.next = 16;
                  break;
                }

                fsString = prodData.imageUrl.split('/').pop();
                fsPieces = fsString.split('%2F');

                fsPieces[fsPieces.length - 1] = fsPieces[fsPieces.length - 1].split('?').shift();
                fileParts = fsPieces[fsPieces.length - 1].split('.');
                ext = fileParts.pop();

                fsPieces[fsPieces.length - 1] = fileParts.join('.') + '_' + sizeString + '.' + ext;
                console.log('parts', fsPieces);
                fullPath = fsPieces.join('/');

                console.log('fullPath', fullPath);
                storageRef = firebase.storage().ref();
                return _context10.abrupt('return', storageRef.child(fullPath).getDownloadURL().then(function (foundUrl) {
                  console.log('image found, returning', foundUrl);
                  return foundUrl;
                }, function (error) {
                  console.log(error);
                  return prodData.imageUrl;
                }));

              case 16:
                console.log('sizeString determined to not be provided so returning default url');
                return _context10.abrupt('return', prodData.imageUrl);

              case 18:
                _context10.next = 24;
                break;

              case 20:
                _context10.prev = 20;
                _context10.t0 = _context10['catch'](1);

                console.log(_context10.t0);
                return _context10.abrupt('return', prodData.imageUrl);

              case 24:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[1, 20]]);
      }))();
    },
    brandImgUrl: function brandImgUrl(brandId, brandData, sizeString) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var fsString, fsPieces, fileParts, ext, fullPath, storageRef;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                console.log('getting brand image url size ', sizeString);
                _context11.prev = 1;

                if (!sizeString) {
                  _context11.next = 16;
                  break;
                }

                fsString = brandData.logoUrl.split('/').pop();
                fsPieces = fsString.split('%2F');

                fsPieces[fsPieces.length - 1] = fsPieces[fsPieces.length - 1].split('?').shift();
                fileParts = fsPieces[fsPieces.length - 1].split('.');
                ext = fileParts.pop();

                fsPieces[fsPieces.length - 1] = fileParts.join('.') + '_' + sizeString + '.' + ext;
                console.log('parts', fsPieces);
                fullPath = fsPieces.join('/');

                console.log('fullPath', fullPath);
                storageRef = firebase.storage().ref();
                return _context11.abrupt('return', storageRef.child(fullPath).getDownloadURL().then(function (foundUrl) {
                  console.log('image found, returning', foundUrl);
                  return foundUrl;
                }, function (error) {
                  console.log(error);
                  return brandData.logoUrl;
                }));

              case 16:
                console.log('sizeString determined to not be provided so returning default url');
                return _context11.abrupt('return', brandData.logoUrl);

              case 18:
                _context11.next = 24;
                break;

              case 20:
                _context11.prev = 20;
                _context11.t0 = _context11['catch'](1);

                console.log(_context11.t0);
                return _context11.abrupt('return', brandData.logoUrl);

              case 24:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[1, 20]]);
      }))();
    },
    retailerImgUrl: function retailerImgUrl(retailerId, retailerData, sizeString) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var fsString, fsPieces, fileParts, ext, fullPath, storageRef;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log('getting retailer image url size ', sizeString);
                _context12.prev = 1;

                if (!sizeString) {
                  _context12.next = 16;
                  break;
                }

                fsString = retailerData.logoUrl.split('/').pop();
                fsPieces = fsString.split('%2F');

                fsPieces[fsPieces.length - 1] = fsPieces[fsPieces.length - 1].split('?').shift();
                fileParts = fsPieces[fsPieces.length - 1].split('.');
                ext = fileParts.pop();

                fsPieces[fsPieces.length - 1] = fileParts.join('.') + '_' + sizeString + '.' + ext;
                console.log('parts', fsPieces);
                fullPath = fsPieces.join('/');

                console.log('fullPath', fullPath);
                storageRef = firebase.storage().ref();
                return _context12.abrupt('return', storageRef.child(fullPath).getDownloadURL().then(function (foundUrl) {
                  console.log('image found, returning', foundUrl);
                  return foundUrl;
                }, function (error) {
                  console.log(error);
                  return retailerData.logoUrl;
                }));

              case 16:
                console.log('sizeString determined to not be provided so returning default url');
                return _context12.abrupt('return', retailerData.logoUrl);

              case 18:
                _context12.next = 24;
                break;

              case 20:
                _context12.prev = 20;
                _context12.t0 = _context12['catch'](1);

                console.log(_context12.t0);
                return _context12.abrupt('return', retailerData.logoUrl);

              case 24:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12, [[1, 20]]);
      }))();
    },
    downloadCsv: function downloadCsv(csvString, saveAsName) {
      var blob = new Blob([csvString]);
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, saveAsName);
      } else {
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob, { type: 'text/plain' });
        a.download = saveAsName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    productNameForLabel: function productNameForLabel(productData) {
      var str = productData.name;
      if (productData.size) {
        str = str + ' ' + productData.size;
      }
      if (productData.color) {
        str = str + ' ' + productData.color;
      }
      if (productData.style) {
        str = str + ' ' + productData.style;
      }
      if (str.length > 35) {
        str = str.substring(0, 35);
      }
      return str;
    }
  }
};

/***/ }),

/***/ "ybj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yg6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__ = __webpack_require__("KyZi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__ = __webpack_require__("Ws9Q");
function injectStyle (ssrContext) {
  __webpack_require__("IsOm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yqcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z48K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Full Screen Map")])]),_vm._v(" "),_c('div',{staticClass:"full-screen-map",attrs:{"id":"map"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zD5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.user.data.firstName),expression:"authDetails.user.data.firstName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"firstName","placeholder":"First Name"},domProps:{"value":(_vm.authDetails.user.data.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.user.data, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('firstName'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.authDetails.user.data.lastName),expression:"authDetails.user.data.lastName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"}],staticClass:"form-control border-input",attrs:{"type":"text","name":"lastName","placeholder":"Last Name"},domProps:{"value":(_vm.authDetails.user.data.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.authDetails.user.data, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('lastName'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(!_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("\n          Save\n        ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit","disabled":"disabled"}},[_vm._m(1),_vm._v("\n          Save\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("User Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zNPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plans_vue__ = __webpack_require__("ruMI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1cf0b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plans_vue__ = __webpack_require__("Ummw");
function injectStyle (ssrContext) {
  __webpack_require__("EZ2z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1cf0b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventBus__ = __webpack_require__("O6e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__ = __webpack_require__("S85j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);











/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['accountData'],
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a),
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    selectBrand: function selectBrand(brandId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.accountData.activeBrand.id === brandId)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__components_firebase_init__["a" /* default */].collection('users').doc(_this.accountData.authDetails.user.id).update({ activeBrandId: brandId });

              case 4:
                __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* EventBus */].$emit('auth-refreshed');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "zfVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brands_vue__ = __webpack_require__("w9P+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff0300b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brands_vue__ = __webpack_require__("20JI");
function injectStyle (ssrContext) {
  __webpack_require__("bpD8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff0300b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zk0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('img',{attrs:{"src":"static/img/authentic_net_lt_color.png","width":"400","alt":"Authentic.net"}}),_vm._v(" "),_c('h3',[_vm._v("Please wait. You will be redirected...")]),_vm._v(" "),_c('hr')])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Copyright 2019 Authentic.net\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zmm5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1ba025c700ef662c633d.js